
(function () {
  'use strict';

angular.module('filters-module', [])
.filter('trustAsResourceUrl', ['$sce', function($sce) {
    return function(val) {
        return $sce.trustAsResourceUrl(val);
    };
}])

  angular.module('BlurAdmin.pages', [
    'ui.router',
    'ngCookies',
    'BlurAdmin.pages.utils',
    'BlurAdmin.pages.dashboard',
    'BlurAdmin.pages.inventory',
    'BlurAdmin.pages.sales',
    'BlurAdmin.pages.benchmark',
    'BlurAdmin.pages.workorders',
    'BlurAdmin.pages.export',
    'BlurAdmin.pages.demos',
    'BlurAdmin.pages.settings',
    'selectize',
    'filters-module',
    'angular-flexslider',
    'color.picker',
    'angularMoment',
    'BlurAdmin.pages.profile',
    'BlurAdmin.pages.auth',
    'BlurAdmin.pages.home'
  ]).config(routeConfig).run(runConfig);

  /** @ngInject */
  function routeConfig($urlRouterProvider, $httpProvider, $injector,  baSidebarServiceProvider, cfpLoadingBarProvider) {

    $urlRouterProvider.otherwise('/');
    cfpLoadingBarProvider.includeSpinner = false;
    $httpProvider.interceptors.push(function($q, $injector) {
        return {
            request: function(config) {
                config.headers = config.headers || {};
                config.headers["X-Using"]=$injector.get('$cookieStore').get('alias');
                config.headers["X-PROMOID"]=$injector.get('$cookieStore').get('promo_id');
                config.headers["X-Domain"]=$injector.get('$cookieStore').get('domain');
                return config;
            },

            response: function(response) {
                return response || $q.when(response);
            },

            responseError: function(rejection){
                if (rejection.status === 401) {
                    $injector.get('AuthService').logout(function() {
                      $injector.get('$state').go("auth");
                    }, function() {
                      $rootScope.error = "Failed to logout";
                    });
                }
                return $q.reject(rejection);
            }
        };
    });

  }

  function runConfig($rootScope, $state, $stateParams,  $http,  $location,  $timeout, $window, AuthService) {
    // $http.defaults.withCredentials = true;
    // $http.defaults.useXDomain = true;
    // delete $http.defaults.headers.common['X-Requested-With'];

    //   var original = $location.path;
    // $location.path = function (path, reload) {
    //     if (reload === false) {
    //         var lastRoute = $state.current;
    //         var un = $rootScope.$on('$locationChangeSuccess', function () {
    //             $state.current = lastRoute;
    //             un();
    //         });
    //     }
    //     return original.apply($location, [path]);
    // };

    $http.defaults.useXDomain = false;
    delete $http.defaults.headers.common['X-Requested-With'];

    $rootScope.$on("$stateChangeStart", function (event, toState, toParams, fromState, fromParams) {
      $rootScope.next=toState.name;
      $rootScope.nextParams=toParams;
      $rootScope.innerPage=$rootScope.next.indexOf("auth") !== -1;
      if (toState.name === 'anon.register' && fromState.ref) {
      }
      if (!('data' in toState) || !('access' in toState.data)) {
          $rootScope.error = 'Access undefined for this state';
          event.preventDefault();
      } else if (!AuthService.authorize(toState.data.access)) {
          event.preventDefault();
          if(fromState.url === '^') {
            if(AuthService.isLoggedIn()) {
              $state.go('home.dashboard');
            } else {
              AuthService.clear();
              $rootScope.error = null;
              $state.go('auth');
            }
          }
      }
      
      // console.log("REPARAR ACCESS PERMISSIONS");
      // REPARAR ACCESS PERMISSIONS
      // var group=AuthService.user.groups[0];
      // if(group.name=="root"){
      //   $state.go("home.dashboard");
      // }

    });

    $rootScope.$on("$stateChangeSuccess", function (event, to, toParams, from, fromParams){
       // $rootScope.$previousState = from;
       // $rootScope.previous=from.name;
    });

    $rootScope.$on("$stateChangeError", function (event, current, previous, rejection){
    
    });
  }

})();

/**
 * @author v.lugovsky
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme', [
      'toastr',
      'chart.js',
      'angular-chartist',
      'angular.morris-chart',
      'textAngular',
      'BlurAdmin.theme.components',
      'BlurAdmin.theme.inputs'
  ]);

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('home.dashboard', {
          url: '/dashboard?id&dealer&dimension&type',
          controller:'DashboardCtrl',
          templateUrl: 'app/pages/dashboard/dashboard.html',
          title: 'Dashboard',
          onEnter: function($state,$rootScope, AuthService, $q) {
            var group=AuthService.user.main_group;            
            $rootScope.userinfo=AuthService.user;
            $rootScope.show_sel="Selected: ";
          },
          onExit: function($state,$rootScope, AuthService, toastr, toastrConfig) {
            $rootScope.show_sel="";
          },
          sidebarMeta: {
            icon: 'ion-android-home',
            order: 0,
          },
        });
  }



  
  

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.profile', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('home.profile', {
          url: '/profile',
          title: 'Profile',
          templateUrl: 'app/pages/profile/profile.html',
          controller: 'ProfilePageCtrl',
        });
  }

})();


(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components', []);

})();

/**
 * @author v.lugovsky
 * created on 10.12.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.inputs', []);

})();

'use strict';

angular.module('BlurAdmin', [
  'ngAnimate',
  'ui.bootstrap',
  'ui.sortable',
  'ui.router',
  'ngTouch',
  'ngResource',
  'pasvaz.bindonce',
  'toastr',
  'angular-loading-bar',
  "xeditable",
  'infinite-scroll',
  'ui.slimscroll',
  'angular-progress-button-styles',
  'app.constants',
  'ui.sortable',
  'json-tree',
  'BlurAdmin.theme',
  'BlurAdmin.pages'
]);

angular.module('app.constants', [])

.constant('APP', {version:'2.0'})
.constant("HOST", {
        LDEV: "http://localhost:8080/pentaho/plugin/cda/api/",
        PDEV: "https://smart-reports.wehaa.net/pentaho/plugin/cda/api/",
        LQA: "",
        PQA: "",
        LPRO: "",
        PPRO: "",
        ENV: "PPRO"
 })
.constant("API", {
        LDEV: "http://localhost:8001/",
        PDEV: "https://smart-reports.wehaa.net/",
        LQA: "",
        PQA: "https://smart-reports.wehaa.net/",
        LPRO: "",
        PPRO: "https://smart-reports.wehaa.net/",
        ENV: "PPRO"
 })
.constant("ANALYTICS", {
        LDEV: "http://localhost/analytics-backend/",
        PDEV: "https://apigoogle.wehaaserver.com/",
        PDEV2: "https://wcpanel.com/backend/",
        LQA: "",
        PQA: "",
        LPRO: "",
        PPRO: "https://wcpanel.com/backend/",
        ENV: "PPRO"
 });


(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .config(config);

  /** @ngInject */
  function config(baConfigProvider, colorHelper, $provide) {
    $provide.decorator('$uiViewScroll', uiViewScrollDecorator);
    //baConfigProvider.changeTheme({blur: true});
    //
    // baConfigProvider.changeColors({
    //  default: 'rgba(#000000, 0.2)',
    //  defaultText: '#ffffff',
    //  dashboard: {
    //    white: '#ffffff',
    //  },
    // });
  }

  /** @ngInject */
  function uiViewScrollDecorator($delegate, $anchorScroll, baUtil) {
    return function (uiViewElement) {
      if (baUtil.hasAttr(uiViewElement, "autoscroll-body-top")) {
        $anchorScroll();
      } else {
        $delegate(uiViewElement);
      }
    };
  }
})();

/**
 * Created by k.danovsky on 13.05.2016.
 */

(function () {
  'use strict';

  var basic = {
    default: '#ffffff',
    defaultText: '#666666',
    border: '#dddddd',
    borderDark: '#aaaaaa',
  };

  // main functional color scheme
  var colorScheme = {
    primary: '#209e91',
    info: '#2dacd1',
    success: '#90b900',
    warning: '#dfb81c',
    danger: '#e85656',
  };

  // dashboard colors for charts
  var dashboardColors = {
    blueStone: '#065CC0',
    surfieGreen: '#0977f7',
    silverTree: '#6eba8c',
    gossip: '#b9f2a1',
    white: '#10c4b5',
  };

  angular.module('BlurAdmin.theme')
    .provider('baConfig', configProvider);

  /** @ngInject */
  function configProvider(colorHelper) {
    var conf = {
      theme: {
        blur: false,
      },
      colors: {
        default: basic.default,
        defaultText: basic.defaultText,
        border: basic.border,
        borderDark: basic.borderDark,

        primary: colorScheme.primary,
        info: colorScheme.info,
        success: colorScheme.success,
        warning: colorScheme.warning,
        danger: colorScheme.danger,

        primaryLight: colorHelper.tint(colorScheme.primary, 30),
        infoLight: colorHelper.tint(colorScheme.info, 30),
        successLight: colorHelper.tint(colorScheme.success, 30),
        warningLight: colorHelper.tint(colorScheme.warning, 30),
        dangerLight: colorHelper.tint(colorScheme.danger, 30),

        primaryDark: colorHelper.shade(colorScheme.primary, 15),
        infoDark: colorHelper.shade(colorScheme.info, 15),
        successDark: colorHelper.shade(colorScheme.success, 15),
        warningDark: colorHelper.shade(colorScheme.warning, 15),
        dangerDark: colorHelper.shade(colorScheme.danger, 15),

        dashboard: {
          blueStone: dashboardColors.blueStone,
          surfieGreen: dashboardColors.surfieGreen,
          silverTree: dashboardColors.silverTree,
          gossip: dashboardColors.gossip,
          white: dashboardColors.white,
        },
      }
    };

    conf.changeTheme = function(theme) {
      angular.merge(conf.theme, theme)
    };

    conf.changeColors = function(colors) {
      angular.merge(conf.colors, colors)
    };

    conf.$get = function () {
      delete conf.$get;
      return conf;
    };
    return conf;
  }
})();

/**
 * @author v.lugovsky
 * created on 15.12.2015
 */
(function () {
  'use strict';

  var IMAGES_ROOT = 'assets/img/';

  angular.module('BlurAdmin.theme')
    .constant('layoutSizes', {
      resWidthCollapseSidebar: 1200,
      resWidthHideSidebar: 500
    })
    .constant('layoutPaths', {
      images: {
        root: IMAGES_ROOT,
        profile: IMAGES_ROOT + 'app/profile/',
        amMap: 'assets/img/theme/vendor/ammap//dist/ammap/images/',
        amChart: 'assets/img/theme/vendor/amcharts/dist/amcharts/images/'
      }
    })
    .constant('colorHelper', {
      tint: function(color, weight) {
        return mix('#ffffff', color, weight);
      },
      shade: function(color, weight) {
        return mix('#000000', color, weight);
      },
    });

  function shade(color, weight) {
    return mix('#000000', color, weight);
  }

  function tint(color, weight) {
    return mix('#ffffff', color, weight);
  }

  //SASS mix function
  function mix(color1, color2, weight) {
    // convert a decimal value to hex
    function d2h(d) {
      return d.toString(16);
    }
    // convert a hex value to decimal
    function h2d(h) {
      return parseInt(h, 16);
    }

    var result = "#";
    for(var i = 1; i < 7; i += 2) {
      var color1Part = h2d(color1.substr(i, 2));
      var color2Part = h2d(color2.substr(i, 2));
      var resultPart = d2h(Math.floor(color2Part + (color1Part - color2Part) * (weight / 100.0)));
      result += ('0' + resultPart).slice(-2);
    }
    return result;
  }
})();


(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .run(themeRun);

  /** @ngInject */
  function themeRun($timeout, $rootScope, layoutPaths, preloader, $q, baSidebarService, themeLayoutSettings) {
    
    var whatToWait = [
      // preloader.loadAmCharts(),
      $timeout(150)
    ];

    var theme = themeLayoutSettings;
    if (theme.blur) {
      if (theme.mobile) {
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg-mobile.jpg'));
      } else {
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg5.jpg'));
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg-blurred.jpg'));
      }
    }

    $q.all(whatToWait).then(function () {
      $rootScope.$pageFinishedLoading = true;
    });

    $timeout(function () {
      if (!$rootScope.$pageFinishedLoading) {
        $rootScope.$pageFinishedLoading = true;
      }
    }, 500);

    $rootScope.$baSidebarService = baSidebarService;
  }
})();
/**
 * Created by k.danovsky on 12.05.2016.
 */

(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .service('themeLayoutSettings', themeLayoutSettings);

  /** @ngInject */
  function themeLayoutSettings(baConfig) {
    var isMobile = (/android|webos|iphone|ipad|ipod|blackberry|windows phone/).test(navigator.userAgent.toLowerCase());
    var mobileClass = isMobile ? 'mobile' : '';
    var blurClass = baConfig.theme.blur ? 'blur-theme' : '';
    angular.element(document.body).addClass(mobileClass).addClass(blurClass);

    return {
      blur: baConfig.theme.blur,
      mobile: isMobile,
    }
  }

})();

(function () {
  'use strict';

  angular.module('BlurAdmin.pages.auth', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('auth', {
          url: '/',
          templateUrl: 'app/pages/auth/index.html',
          controller: 'AuthCtrl',
          data: {
              access: '*',
              title: ' '
          }
        });
  }

  angular.module('BlurAdmin.pages.auth').
  directive('initialStyle', initialStyle);


function initialStyle(layoutPaths, baConfig) {
    return {
      restrict: 'A',
      scope: {
      },
      link: function (scope, element, attr) {
        var bg=["blur-bg", "blur-bg1",  "blur-bg2", "blur-bg3", "blur-bg4", "blur-bg5"];
        var random=Math.floor(Math.random() * (5 - 0 + 1)) + 0;   
        $("body").css("background-image", "url(assets/img/"+"blue-bg"+".jpg)");
        $("body").css("background-size", "cover");
        $("body").css("height", "100%");
        $("html").css("height", "100%");
      }
    };
  }

})();



(function () {
  'use strict';

  angular.module('BlurAdmin.pages.auth')
      .controller('AuthCtrl', AuthCtrl);

  /** @ngInject */
  function AuthCtrl($scope, $rootScope, $cookies, baConfig, colorHelper, $state, AuthService) {

      $scope.transparent = baConfig.theme.blur;
      var dashboardColors = baConfig.colors.dashboard;
      
      $scope.user={};
      $scope.msgError="";

      $scope.$watch('user.username', function (value) {
        if(value!=''){
          $scope.msgError='';
        }
      });

      $scope.$watch('user.password', function (value) {
        if(value!=''){
          $scope.msgError='';
        }
      });

      $scope.login=function(form) {
        if (form.$valid){
            $scope.msgError="";
            AuthService.login({
                username: $scope.user.username,
                password: $scope.user.password
            },
            function(res) {
                $rootScope.app_name = ($cookies.get('app_name'))?$cookies.get('app_name').replace(/\"/g, ''):"AI Reports";
                $state.go("home.dashboard");
            },
            function(err) {
                $scope.flagError=true; 
                // $rootScope.error = "Failed to login";
                console.log(err);
                if(!err){
                  $scope.msgError="Please, verify your connection to internet.";
                }else{
                  $scope.msgError="Username / password incorrect";
                }
            });
        }else{
          $scope.flagError=true
          if(!$scope.user.username){
            $scope.msgError="Please enter a valid username";
          }else if(!$scope.user.password){
            $scope.msgError="Please enter a valid password";
          }
        }
      }

      // dashboardColors.white,
      // dashboardColors.blueStone,
      // dashboardColors.surfieGreen,
      // dashboardColors.silverTree,
      // dashboardColors.gossip
  }
})();

(function () {
  'use strict';

  angular.module('BlurAdmin.pages.benchmark', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('home.benchmark', {
          url: '/benchmark?id&dealer&body&dimension&year',
          templateUrl: 'app/pages/benchmark/benchmark.html',
          title: 'Benchmark',
          controller: 'BenchmarkCtrl',
          resolve: {
            isGroup: function($rootScope, $state, $q, $timeout,AuthService) {
              var group=AuthService.user.groups[0];
              if($rootScope.domain==""){
                try{
                  $timeout(function() { $state.go("home.dashboard"); });
                  return $q.reject("rejection message");
                }catch(err){
                  console.log(err);
                }
              }
            }
          },
          onExit: function(inventoryService, $state){

          },
          data: {
              access: 'logged',
              title: ' '
          },
          sidebarMeta: {
            icon: 'ion-stats-bars',
            order: 0,
          },
          params: { 
            hiddenParam: 'YES'
          }
        });
        // .state('home.metrics', {
        //   url: '/metrics',
        //   templateUrl: 'app/pages/inventory/metrics.html',
        //   controller: 'MetricsCtrl',
        //   data: {
        //       access: 'logged',
        //   }
          
        // });
  }





})();


(function () {
  'use strict';

  angular.module('BlurAdmin.pages.benchmark')
      .controller('BenchmarkCtrl', BenchmarkCtrl);

  /** @ngInject */
  function BenchmarkCtrl($scope, $rootScope, fileFactory, $stateParams, $cookies, Projects, $q, $state, $filter, layoutPaths, $location, $window, $anchorScroll, baConfig, colorHelper, $timeout, inventoryService, dataService, salesService, themeLayoutSettings, AuthService, toastr, toastrConfig, API) {

    inventoryService.cancel();

    $scope.group=AuthService.user.groups[0];
    $rootScope.userinfo=AuthService.user;

    function groupBy( array , f )
    {
      var groups = {};
      array.forEach( function( o )
      {
        var group = JSON.stringify( f(o) );
        groups[group] = groups[group] || [];
        groups[group].push( o );  
      });
      return Object.keys(groups).map( function( group )
      {
        return groups[group]; 
      })
    }

    $scope.configSelect = {
      plugins:['remove_button'],
      persist:true,
      valueField: 'value',
      labelField: 'text'
    };
    $scope.configSingleOne = {
      maxItems: 1,
      persist:true, 
      valueField: 'value',
      labelField: 'text'
    };

   $scope.configSingleOneYear = {
      maxItems: 1,
      persist:true, 
      valueField: 'value',
      labelField: 'text',
      sortField: [
          {
              field: 'text',
              direction: 'desc'
          }
      ]
    };

    $scope.completeLoad = false;
    $scope.items = [];
    $scope.dataType = ["New", "Used"];
    $scope.dimensions = [{"value":"body_style", "text": "Body Style"}, {"value":"model", "text": "Model"}, {"value":"make", "text": "Make"}];
    $scope.dimension = "body_style";

    $scope.certified = [0, 1];
    $scope.report = "benchmark";
    $scope.type = "all";
    $scope.dealer = []; $scope.adealer = []; $scope.dealers = [];    $scope.years = [];    
    $scope.rtitle = "";
    $scope.opacity = false;
    $scope.flagInit = false;
    $scope.info;
    $scope.title_details;
    $scope.loadDealers = false;
    $scope.page = undefined;
    $scope.loading = undefined;

    $scope.fullresults = [];
    $scope.items = [];

    $scope.datasetOverride = {
      borderWidth:3
    };

    $scope.baroptions = {
      legend: { 
        labels:{
          fontSize: 15
        },
        display: true 
      },
      scales: {
        xAxes: [{
          stacked: true,
        }],
        yAxes: [{
          stacked: true,
        }]
      }
    };
    
    $scope.initialize = function(){ 
      inventoryService.getDealers($scope.group.name, dataService.getParams("dealers")).then(function(response){
        if ($stateParams.dealer){
          $scope.dealers.push(response.data.resultset.map(function(x) { return { value: x.section_id,  text: x.section_name};}));
        }else{
          $scope.dealers = response.data.resultset.map(function(x) { return { value: x.section_id,  text: x.section_name};});
        }

          var paramsYears=dataService.getParams("years");
          inventoryService.getYears($scope.group.name, paramsYears).then(function(response){
            $scope.years = response.data.resultset.filter(function(x){ return x.year!="UNKNOWN";}).map(function(x) { return { value: x.year,  text: x.year};});
            $scope.years.push({value: "none",  text: "None"});
            $scope.year = "none";
            $scope.completeLoad = true;
          }, function (response) {
            $scope.completeLoad = true;
            toastr.warning('<span class="toast-description"> Unable to access data mining. Please check your connection, then try again <span>', '<strong class="toast-titles"> Access Server </strong>');
          });
        $scope.flagInit = true;
        $scope.loadDealers = true;
        $scope.opacity = false;
        
        }, function (response) {
          $scope.completeLoad = true;
          toastr.warning('<span class="toast-description"> Unable to access data mining. Please check your connection, then try again <span>', '<strong class="toast-titles"> Access Server </strong>');          
      });

    }

    $scope.printPdf = function (data) {

      // var dealer = $scope.dealers.find((item) => { return item.value == $scope.adealer });
      var dealer = $scope.dealers.find(function (item) { return item.value == $scope.adealer });
      var payload = {};
      payload["name"] = dealer.text;
      payload["dealers"] = data;
      payload["type"] = "benchmark";

      // console.log(JSON.stringify(payload));
      fileFactory.downloadFile(API[API.ENV]+"api/v1/metricspdf", "post", {data:payload, "type": "benchmark"}, "export_"+ new Date(), false, function (response) {
        });
    }

    $scope.openOportunity = function (dealer, prop) {
      var project = {};
      project["alias"] = ($cookies.get("promo_id"))? $cookies.get("alias").replace(/\"/g, '') + "_promoid_" + $cookies.get("promo_id").replace(/\"/g, ''):$cookies.get("alias").replace(/\"/g, '');
      
      if(prop!='model'){
        project['name'] = dealer.name + " - " + dealer.body_style + "  " + $filter("date")(new Date(), 'medium');
      }else{
        project['name'] = dealer.name + " - " + dealer.model + "  " + $filter("date")(new Date(), 'medium');
      }
      dealer['entity'] = prop;
      project['temp'] = true; 
      Projects.save(project, function (response) {  
        $state.go('home.export.index', {id:response.id, oportunity: {project: response, dealer:dealer}});
      },function (response) {
          toastr.warning('<span class="toast-description"> Trey with another project name. <span>', '<strong class="toast-titles"> Already exist this export project!</strong>');
      });

      dealer['entity'] = prop;
      dealer[prop] = dimname;
      $state.go('home.demos', {id:null, oportunity: {project: null, dealer:dealer}});
    }


     $scope.openOrder = function (dealer, prop) {
      var project = {};
      project["alias"] = ($cookies.get("promo_id"))? $cookies.get("alias").replace(/\"/g, '') + "_promoid_" + $cookies.get("promo_id").replace(/\"/g, ''):$cookies.get("alias").replace(/\"/g, '');
      
      if(prop!='model'){
        project['name'] = dealer.name + " - " + dealer.body_style + "  " + $filter("date")(new Date(), 'medium');
      }else{
        if(prop=="make"){
          project['name'] = dealer.name + " - " + dealer.make + "  " + $filter("date")(new Date(), 'medium');
        }else{
          project['name'] = dealer.name + " - " + dealer.model + "  " + $filter("date")(new Date(), 'medium');
        }
      }

      dealer['entity'] = prop;
      project['temp'] = true; 

      $state.go('home.neworder', {id:null, oportunity: {project: null, dealer:dealer}});

    }

    $scope.toggleType = function(value) {
      $scope.completeLoad=false;
      $scope.loadDealers = false;
      $scope.opacity=true;
      $scope.dealer=[];
      switch(value){
        case "all":
          dataService.setTypes(["New", "Used"]);
          dataService.setCertified([0, 1]);
          $scope.dataType = dataService.getTypes();
          $scope.certified = dataService.getCertified();
          $rootScope.$emit('refreshCondition', dataService.getParams("types"));
          $scope.initialize();
          break;
        case "new":
          dataService.setTypes(["New"]);
          dataService.setCertified([0]);
          $scope.dataType = dataService.getTypes();
          $scope.certified = dataService.getCertified();
          $rootScope.$emit('refreshCondition', dataService.getParams("types"));    
          $scope.initialize();
          break;
        case "used":
          dataService.setTypes(["Used"]);
          dataService.setCertified([0,1]);
          $scope.dataType = dataService.getTypes();
          $scope.certified = dataService.getCertified();
          $rootScope.$emit('refreshCondition', dataService.getParams("types"));    
          $scope.initialize();
          break;
        case "certified":
          dataService.setTypes(["Used"]);
          dataService.setCertified([1]);
          $scope.dataType = dataService.getTypes();
          $scope.certified = dataService.getCertified();
          $rootScope.$emit('refreshCondition', dataService.getParams("types"));    
          $scope.initialize();
          break;
      }
    }

    var selectionCompose = function(selects){
      var newarray = [];
      for (idx in selects){
        if (typeof(selects[idx])=="string"){
          var sel = selects[idx].match(/\.\[(.*?)\]/i);
          newarray.push(sel);
        }
      }

      return newarray;

    }
    

    var titleCompose = function(name, topic){
      $scope.title_details = "CARS FOR " + topic + " SELECTED · <b class='title'>" + name + "</b>";
    }

    $scope.toggleReport=function(value){
      $scope.opacity=true;
      $scope.report=value;
      if ($scope.adealer.length && !$scope.dealer.length){
        $scope.dealer = [$scope.adealer];
        dataService.setDealers($scope.dealer);
        $scope.initialize();
      }
    }

    

    $scope.$watch('dimension', function (value) {
      $scope.opacity=true;
    });

    $scope.$watch('adealer', function (value) {
        if($scope.flagInit){
          $scope.completeLoad = false;
          $scope.opacity = true;
          dataService.setDealers([value]);
          var paramsYears = dataService.getParams("years");
          inventoryService.getYears($scope.group.name, paramsYears).then(function(response){
            $scope.years = response.data.resultset.filter(function(x){ return x.year != "UNKNOWN";}).map(function(x) { return { value: x.year,  text: x.year};});
            $scope.years.push({value: "none",  text: "None"});
            $scope.year = "none";
            $scope.completeLoad = true;
          }, function (response) {
            $scope.completeLoad = true;
            toastr.warning('<span class="toast-description"> Unable to access data mining. Please check your connection, then try again <span>', '<strong class="toast-titles"> Access Server </strong>');
          });
        }
    });

     function parseDataMainChart(data){
      var list=[];
      angular.forEach(data, function (value, key) {
        list.push({dealer:value[0], make:value[1], 
            body:value[2], model:value[3], quantity:value[4]
        });
      });

      var resultData = groupBy(list, function(item)
      {
        return [item.dealer, item.make, item.body];
      });

      var results=[];
      var Colors = [];
      for(var i = 0; i < resultData.length; i++) {
        var Labels=[]; var Values=[]; var Title; var Total=0; var Id;
        for(var j = 0; j < resultData[i].length; j++) {
          Labels.push(resultData[i][j].model);
          Values.push(resultData[i][j].quantity);
          Total+=resultData[i][j].quantity;
          Title=resultData[i][j].dealer+" - "+resultData[i][j].make+" - "+resultData[i][j].body;
          Id=resultData[i][j].dealer;
        }
        if(resultData[i].length>5){
          var Height=(resultData[i].length*25).toString()+"px";
        }else{
          switch(resultData[i].length){
            case 1:
              var Height="50px"; break;
            case 2:
              var Height="75px"; break;
            case 3:
              var Height="100px"; break;
            case 4:
              var Height="125px"; break;
            case 5:
              var Height="150px"; break;
          }
        }
              
        results.push({labels:Labels, data:[Values], title:Title,  dealer:Id, height:Height, total:Total});
        
        }
        return results;
    }

    $scope.getReport = function() {

      $scope.opacity=false;      
      var deferred = $q.defer();
      var data={};
      $scope.items = [];
      $scope.page = null;
      $scope.info;
      $scope.best_results = []; $scope.benchmark_results = [];
      $scope.data = []; $scope.series = []; $scope.labels = [];
      $scope.loading = true;
      $scope.benchfound = "";
      
      // setters 
      data["public[]"]=1;

      switch($scope.report){
        case "benchmark":

          if(!$scope.adealer.length){
            toastr.info('<span class="toast-description"> You must select a dealer to get the benchmark. <span>', '<strong class="toast-titles"> Select a Dealer </strong>');
            $scope.loading = false;
            return;
          }

          $scope.rtitle = "- Benchmark";
          
          data["section_id"] = $scope.adealer;
          data["dimension"] = $scope.dimension;
          data["path"] = "reports/benchmark";

          var dealer_name = $scope.dealers.find(function(obj){ return obj.value == $scope.adealer});
          
          var year = undefined;
          if ($scope.year){
            if ($scope.year != 'none'){
              data["year"] = $scope.year;
              var year = dataService.getBuildParams($scope.years, [$scope.year]);
              year = year[0];
            }
          }
          
          inventoryService.getReport($scope.group.name, data).then(function(response){ 
            try{  
                  $scope.loading = false;
                    var data = response.data.resultset;
                    $scope.benchmark_results = data;
                    if (!$scope.benchmark_results.length){
                        $scope.benchfound = "No comparable dealers could be found.";        
                    }

                    console.log("dealer_name", dealer_name);
                    $scope.dealersel = dealer_name["text"];
                    $scope.yearsel = year;
                    $state.go("home.benchmark", {id : dealer_name["value"], year:year, dealer:dealer_name["text"], dimension:$scope.dimension}, {location: "replace", notify: false});
                   
                    setTimeout(function () {
                      $anchorScroll();
                      $location.hash('results'); 
                    });
                   
                    $scope.opacity = false;            
                   
                    deferred.resolve(response);
                }catch(err){
                    console.log(err);
                    deferred.resolve();
                }

            }, function (response) {
              $scope.loading = false;
              toastr.warning('<span class="toast-description"> Unable to access data mining. Please check your connection, then try again <span>', '<strong class="toast-titles"> Access Server </strong>');
              deferred.resolve();
            });


          break;
       
      }

      return deferred.promise;
    };

     if ($stateParams.dealer){
      var dealer = $stateParams.dealer;
      $scope.dealers.push({value: $stateParams.id, text: dealer});
      $scope.adealer =  $stateParams.id;

      if( $stateParams.dimension){
        $scope.dimension = $stateParams.dimension;
      }else{
        $scope.dimension = "body_style";
      }

      if( $stateParams.year){
        $scope.years.push({value: $stateParams.year, text: $stateParams.year});
        $scope.year =  $stateParams.year;
      }else{
        $scope.year = "none";
      }

      $scope.loadDealers = true;
      $scope.getReport();
      // return;
    }

    $scope.goBack = function () {
      $scope.items=[];
      $scope.page=null;
      $scope.loading=false;
      $scope.info;
      inventoryService.cancel();
    }


    $scope.loadMore = function () {
      if($scope.page && !$scope.loading){
        if($scope.report!="best"){
          $scope.selectBar($scope.info);
        }else{
          $scope.selectRow($scope.info);
        }
      }


      if($(window).scrollTop() + $(window).height() == $(document).height()) {
        if (!$scope.items.length && $scope.fullresults.length){
          $scope.limitChart += 5; 
        }  
      }

    }

    $scope.limitChart = 5;

    dataService.initialize();
     // var dateParam=dataService.getDates();
    $scope.initialize();
     
   
  }
})();


(function () {
  'use strict';


  angular.module('BlurAdmin.pages.benchmark')
      .service('metricsServices', metricsServices);
  /** @ngInject */
   function metricsServices($resource, API) {
    return $resource(API[API.ENV]+"api/v1/inventories/metrics", {}, {save: {
                method: 'POST',
                // ignoreLoadingBar: true
            }});
   }

})();

(function () {
  'use strict';

  angular.module('BlurAdmin.pages.demos', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('home.demos', {
          url: '/demos?dealer&body&dimension&mode',
          templateUrl: 'app/pages/demos/new.html',
          title: 'Demos',
          controller: 'ExportCtrl',
          resolve: {
            isGroup: function($rootScope, $state, $q, $timeout,AuthService) {
              var group=AuthService.user.groups[0];
              if($rootScope.domain==""){
                try{
                  $timeout(function() { $state.go("home.dashboard"); });
                  return $q.reject("rejection message");
                }catch(err){
                  console.log(err);
                }
              }
            }
          },
          onExit: function(inventoryService, $state){

          },
          data: {
              access: 'logged',
              title: ' '
          },
          sidebarMeta: {
            icon: 'ion-ios-paper',
            order: 0,
          },
          params: { 
            oportunity:null,
            hiddenParam: 'YES'
          }
        })
  }


})();


(function () {
  'use strict';

  angular.module('BlurAdmin.pages.demos')
      .controller('DemosCtrl', DemosCtrl);

  /** @ngInject */
  function DemosCtrl($scope, $rootScope, Worksorders, templatesService, Projects, $cookies, SearchsServices, fileFactory, fileReader, baProgressModal, $stateParams, filtersService, promakesService, bodysService, promodelsService, sectionsService, $q, $state, $filter, layoutPaths, $location, $window, $anchorScroll, baConfig, colorHelper, $timeout, inventoryService, dataService, salesService, themeLayoutSettings, AuthService, toastr, toastrConfig, API) {

    // $scope.sections = JSON.parse(localStorage.getItem("sections"));
    
    $("#iframe-container iframe")[0].setAttribute("height", 1460);
    
    $scope.options = {
      required: true,
      placeholder: 'Hex',
      inputClass: 'picker-color',
      // validation
      restrictToFormat:true,
      allowEmpty:true,
      // color
      format: 'hex',
      case: 'lower',
      // sliders
      hue: true,
      alpha: false,
      dynamicSaturation: true,
      dynamicLightness: true,
      dynamicAlpha: false,
      pos: 'bottom left'
    };

    $scope.configSingle = {
      maxItems: 1,
      persist:true, 
      valueField: 'value',
      labelField: 'text'
      
    };

    $scope.loadTemplates = false;


    $scope.solution={reverse:true, bannerxl:true, bannerl:true, bannermd:true, bannersm:true, email:true, facebook:true, instagram:true};
    $scope.status = [{"value":"progress", "text": "In Progress"},  {"value":"closed", "text": "Closed"}];
    $scope.conf = {};
    $scope.preInit = true;
    $scope.create = false;
    $scope.templateNew = {shared:true};
    $scope.soltemplate= undefined;

    $scope.newOrder = function () {
      $scope.solu = {email:true, social_media: true, banner300x50:true,  banner300x250:true, banner300x600:true, banner728x90:true, banner970x250:true, banner1280x250:true,  banner1280x220:true,  banner1280x600:true};
      $scope.status = [{"value":"progress", "text": "In Progress"},  {"value":"closed", "text": "Closed"}];
      $state.go("home.neworder", {order_id:undefined}, {location: "replace", notify: false});
      $scope.$emit('someEvent', []);
      localStorage.setItem("sections", JSON.stringify([]));
    }


    $scope.editorTemplate = function(template){ 
        $scope.create = true;
    }

    $scope.toggleEditor = function(editor){
      if ($scope.editor){
        $("#frameview").removeClass("col-lg-12 col-md-12 col-sm-12");
        $("#frameview").addClass("col-lg-9 col-md-9 col-sm-12");
      }else{
        $("#frameview").addClass("col-lg-12 col-md-12 col-sm-12");
        $("#frameview").removeClass("col-lg-9 col-md-9 col-sm-12");
      }
    }

    $scope.genHTML = function(){
      var project = {};
      project["alias"] = ($cookies.get("promo_id"))? $cookies.get("alias").replace(/\"/g, '') + "_promoid_" + $cookies.get("promo_id").replace(/\"/g, ''):$cookies.get("alias").replace(/\"/g, '');
      project['name'] = "temp" + $filter("date")(new Date(), 'medium');
      project['temp'] = true; 
      Projects.save(project, function (respon) {  
        Projects.update({id:respon.id, sections: $scope.sections}, function (response) {  
          var w = window.open(API[API.ENV] + "api/v1/solutions?tem=" + $scope.soltemplate + "&alias=" + project["alias"] +"&pro=" + respon.id, "_blank");
        }, function (response) {
        
        });
      },function (response) {
          toastr.warning('<span class="toast-description"> Trey with another project name. <span>', '<strong class="toast-titles"> Already exist this export project!</strong>');
      });
    }

 $scope.uploadPictureSolution = function (id) {
      var fileInput = document.getElementById(id);
      fileInput.value="";
      fileInput.click();
    };

    $scope.uploadPictureFooter = function () {
      var fileInput = document.getElementById("fileFooter");
      fileInput.value="";
      fileInput.click();
    };

    $scope.uploadPictureHeader = function () {
      var fileInput = document.getElementById("fileHeader");
      fileInput.value="";
      fileInput.click();
    };

    $scope.section_id=null;
    
    $scope.uploadPictureSection = function () {
      var fileInput = document.getElementById("fileSection");
      fileInput.value="";
      fileInput.click();
    };

    $scope.uploadPictureDealer = function (section_id) {
      $scope.section_id=section_id;
      var fileInput = document.getElementById("sectionImage");
      fileInput.value="";
      fileInput.click();
    };

      function create_UUID(){
          var dt = new Date().getTime();
          var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
              var r = (dt + Math.random()*16)%16 | 0;
              dt = Math.floor(dt/16);
              return (c=='x' ? r :(r&0x3|0x8)).toString(16);
          });
          return uuid;
      }

    $scope.getFile = function (file, id) {
      
      fileReader.readAsDataUrl(file, $scope)
          .then(function (result) {
            $scope.picture = result;
            baProgressModal.open();
             var url = API[API.ENV]+"api/v1/exports";
            if ($scope.template.ttype=="dynamic"){
              url = API[API.ENV]+"api/v1/solutions";
            }

            if (id=="sectionImage"){
              var data={base64: result, id:$scope.template.name, name:id, section_id:$scope.section_id, pid:$stateParams.pid};
              fileFactory.uploadFileSection(data, function(response){
                $scope.conf["sections"]=response.sections;
                for (var i = $scope.sections.length - 1; i >= 0; i--) {
                  if ($scope.sections[i].id==$scope.section_id){
                    $scope.sections[i].section_image=response.image_url;
                     $("#dealer_image"+$scope.section_id.toString()).attr('src', response.image_url+"?cache="+create_UUID());
                  }
                }
                if (response.success){ 
                  fileFactory.downloadFile(url, "post", $scope.conf, "export_"+ new Date(), true, function (response) {
                      $scope.pdfUrl=response;
                    });
                  $scope.$apply();
                }
              }, function(response){
              });
            }else{
              var data={base64: result, id:$scope.template.name, name:id};
              fileFactory.uploadFile2(data, function(response){
                if (response.success){
                  if(id=="footer"){
                    $scope.template["footer_img"]=response.image_url;
                  }else{
                    console.log(id);
                    if(id=="section"){
                      $scope.template["section_img"]=response.image_url;
                    }else{
                      if(id=="header"){
                        $scope.template["header_img"] = response.image_url;
                      }else{
                        $scope.template.images[id] = response.image_url;
                      }
                    }
                  }

                  fileFactory.downloadFile(url, "post", $scope.conf, "export_"+ new Date(), true, function (response) {
                      $scope.pdfUrl=response;
                    });
                  $scope.$apply();
                }
              }, function(response){
              });
            }

          });
    };


    $scope.createTemplate = function () {
        if (!$scope.templateNew.name){
            toastr.warning('<span class="toast-description">   Enter right data   <span>', '<strong class="toast-titles"> Enter a valid template name.</strong>');   
          return;
        }
        var data = { name:$scope.templateNew.name, shared:$scope.templateNew.shared, clone_name:"Template Solutions" };
        templatesService.save(data,function (response) {
          $scope.templates.push({ value: response.id,  text: response.name});
          $scope.dataTemplates.push(response);
          $scope.template = response;
          $scope.soltemplate = response.id;
          $scope.templateNew = {shared:true};
          $scope.conf["template"] = response.name;
          $scope.create = false;
          $("#iframe-container iframe")[0].setAttribute("height", 1460);
        }, function (response) {
            toastr.warning('<span class="toast-description">  Check it with support  <span>', '<strong class="toast-titles"> Something went wrong. </strong>');   
        });

    };

    $scope.fromselected = false;

    $scope.toggleDemos = function(value, label) {
      $scope.type_export = value;
      $scope.label_export = label;
      switch(value){
        case "select":
          $scope.fromselected = true;
          break;
        case "demos":
          if($scope.templates.length){
            $scope.create = false;
          }else{
            $scope.create = true;
          }
          
          if ($scope.sections.length){
            $scope.conf["sections"] = $scope.sections;
            if ($scope.fromselected){
              $scope.reload();
            }
          }

          break;
        default:
      }

      $state.go("home.demos", {mode:value}, {location: "replace", notify: false});
    }

    $scope.reload = function(){
      if ($scope.sections.length){
        if (!$scope.soltemplate){
          templatesService.query({name:"Template Solutions"}, function (response) {
            $scope.template = response[0];
            templatesService.update($scope.template, function (response) {
              $scope.template = response;
              $scope.conf.limit = $scope.limit; 
              $scope.conf["solution"] = $scope.solution;
              var url = API[API.ENV]+"api/v1/solutions";
              fileFactory.downloadFile(url, "post", $scope.conf, "export_"+ new Date(), true, function (response) {
                  $scope.pdfUrl=response;
              });
            });
          });
        }else{
          console.log($scope.template);
            templatesService.update($scope.template, function (response) {
              $scope.conf["template"]=$scope.soltemplate;
              $scope.conf["solution"]=$scope.solution;
              $scope.conf.limit=$scope.limit;
              var url = API[API.ENV]+"api/v1/solutions";
              fileFactory.downloadFile(url, "post", $scope.conf, "export_"+ new Date(), true, function (response) {
                  $scope.pdfUrl=response;
              });
            });
        }
      }

    }


    $scope.updateShared = function(value){
      $scope.template["shared"] = value;
      templatesService.update($scope.template, function (response) {
      });
    }

    $scope.$watch("soltemplate", function(newValue, oldValue) {
      if(!$scope.preInit && $scope.loadTemplates){
        if(newValue){
          for (var i = 0; i < $scope.dataTemplates.length; i++) {
            if(newValue == $scope.dataTemplates[i].id){
              $scope.selectedTemplate = $scope.dataTemplates[i];
            }
          }
          templatesService.update($scope.selectedTemplate, function (response) {
              $scope.template = response;
              $scope.selectedTemplate = response;
              $scope.reload();
          });
        
        }
      }
    });

    $scope.getTemplates = function(deftemp){
      templatesService.query(function (response) {
          $scope.templates = response.filter(function(x){ return x.ttype=="dynamic";}).map(function(x) { return { value: x.id,  text: x.name};});        
          $scope.dataTemplates = response;

          if ($scope.templates.length){
            if (!deftemp){
              $scope.soltemplate = $scope.templates[0].value;
            }else{
              var seltemp = $scope.templates.find(function(x){ return x.text.toLowerCase() == deftemp.toLowerCase();});
              if(seltemp){
                $scope.soltemplate = seltemp.value;
              }else{
                $scope.soltemplate = $scope.templates[0].value;
              }
            }
          }

          for (var i = 0; i < $scope.dataTemplates.length; i++) {
            if($scope.soltemplate==$scope.dataTemplates[i].id){
              $scope.selectedTemplate=$scope.dataTemplates[i];
              $scope.template = $scope.selectedTemplate;
            }
          }
          if (!$scope.templates.length){
            $scope.create = true;
          }else{
            $scope.create = false;
          }

          $timeout(function() {
            $scope.loadTemplates = true;
            $scope.reload();
          }, 10);
      
      }, function (response){});
    
    }

    $scope.init = function() {
      if ($stateParams.oportunity){
      
      var dealer = $stateParams.oportunity.dealer;
      var payload = { limit : 1 };
      payload["sf_" + dealer["entity"]] = dealer[dealer["entity"]];
      SearchsServices.get(payload, function (response) {
        if(response.results.length){
          var paramdim;
          if (dealer["entity"] == "body_style"){
            paramdim = response.results[0]["sf_bodyStyle"];
          }else{
            paramdim = response.results[0]["sf_make"];
          }
          $scope.getTemplates(paramdim);    
        }else{
          $scope.getTemplates();    
        }
      }, function (response){});
    }else{
      $scope.getTemplates();    
    }
      // body...
    }
    
      

    var  loadSections = $rootScope.$on('loadSections', function(event, args) {
        event.preventDefault(); event.stopPropagation();
        if ($scope.preInit){
          try{
            $( "#addDealer" ).click();
          }catch(e){

          }
          $scope.toggleDemos("demos", "Demos");
          $scope.preInit = false;
          $timeout(function(){
            $anchorScroll();
            $location.hash('resultpdf');
             $scope.init();
          },350);
          
        }

    });

    $rootScope.$on('$destroy', loadSections);
   
  }

  
})();


(function () {
  'use strict';



   angular.module('BlurAdmin.pages.demos')
      .service('Worksorders', Worksorders);
  /** @ngInject */
   function Worksorders($resource, API) {
    return $resource(API[API.ENV]+"api/v1/worksorders/:id", {id:'@id'}, {save: {
                method: 'POST'
            },
           update: { method:'PUT'}});
   }


   angular.module('BlurAdmin.pages.demos')
      .service('SearchsServices', SearchsServices);
  /** @ngInject */
   function SearchsServices($resource, API) {
    return $resource(API[API.ENV]+"api/v1/cars/searchs", {id:'@id'}, {save: {
                method: 'POST'
            },
           update: { method:'PUT'}});
   }

})();

(function () {
  'use strict';

angular.module('BlurAdmin.pages.dashboard').service('CronService', function() {
    this.toString = function(cronExpression) {
        try {
            return cronstrue.toString(cronExpression);
        } catch (e) {
            // Handle invalid cron expressions
            return "Invalid cron expression";
        }
    };
  });

angular.module('BlurAdmin.pages.auth')
  .factory('Alias', ['$resource', 'API', function ($resource, API) {
    return $resource(API[API.ENV]+"api/v1/alias/:id", {id:'@id'}, {
        update: {method: 'PUT'}
      });
}])

.factory('DashService', DashService);  

  /** @ngInject */
  function DashService($http, $window, $rootScope, $stateParams, $cookieStore, $cookies, API, AuthService) {
    var loggedUser; var usr;
  
    return {
        getSites: function(group, groups, success, error){

          try{

            $rootScope.group_name = group.name;
            if ($rootScope.group_name == "root"){
              var url = API[API.ENV]+"api/v1/alias?export=true";
            }else{
              var queryparams = groups.join(",");
              var url = API[API.ENV]+"api/v1/alias"+"?group="+queryparams;
            }
          }catch(e){
            var queryparams = group;
            var url = API[API.ENV]+"api/v1/alias"+"?group="+queryparams;
          }
          $http.get(url,
          {
            headers: {'Authorization': AuthService.user.atok},
          }).then(
         function(response) {
            $rootScope.sites = [];
            $rootScope.fullsites = response.data;
            angular.forEach(response.data, function (value, key) {
                if ($rootScope.group_name=="root"){
                      var site = $rootScope.sites.find(function(item){ return item.unique == value.alias; });
                      value['multisite'] = false;
                      value['title'] = value.host;
                      value['url'] = value.host;
                      value['unique'] = value.alias;

                      if (!value.hasOwnProperty("extras")){
                        value["extras"] = {};
                      }
                      
                      if (!site){
                        $rootScope.sites.push(value);
                      }
                      if (value.promotions.length){
                        angular.forEach(value.promotions, function (v, k) {
                          if (v.hasOwnProperty("export") && v.export ){
                            var extras = {};
                            try{
                              extras = v.extras;
                              // const mergedObj = Object.assign(obj1, obj2);
                              }catch(e){
                                console.log("Error assing extras", e);
                              } 
                              var site = $rootScope.sites.find(function(item){ return item.unique == value.alias + v.id; });
                              if (!site){
                                extras = (!extras)?{}:extras;
                                if (v.name.includes('-')) {
                                  var nameUrl = v.name.split(' - ');
                                  var vname = nameUrl[0];
                                  var url = nameUrl[1];
                                } else {
                                  var vname = v.name;
                                  var url = v.name;
                                }
                                $rootScope.sites.push({"id":value.id, "host":value.host, 'export': value.export, 'extras': extras, 'multisite': true, 'url': url, 'title': vname, 'alias': value.alias, 'promo_id':v.id, 'report':v.group, 'unique' : value.alias + v.id});
                              }
                            }
                        });
                      }
                }
                else{
                  if(groups.includes(value.report)){
                    value['multisite'] = false;
                    value['title'] = value.host;
                    $rootScope.sites.push(value);
                  }
                  if (value.promotions.length){
                      angular.forEach(value.promotions, function (v, k) {
                          if(groups.includes(v.group)) {
                            var extras = {};
                            try{
                              extras = v.extras;
                            }catch(e){} 

                            extras = (!extras)?{}:extras;
                            if (v.name.includes('-')) {
                              var nameUrl = v.name.split(' - ');
                              var vname = nameUrl[0];
                              var url = nameUrl[1];
                            } else {
                              var vname = v.name;
                              var url = v.name;
                            }

                            $rootScope.sites.push({"id":value.id, "host":value.host, 'export': value.export, 'extras': extras, 'multisite': true, 'url': url, 'title': vname, 'alias': value.alias, 'promo_id':v.id, 'report':v.group});
                          }
                      });
                  }
                
                }
            })

            success($rootScope.sites);

          }, function (response) {
                error();
          });
            
        },
        setSite: function(item){

          var index;
        index = $rootScope.sites.indexOf(item);
        AuthService.user.email="info@"+item.host;
        AuthService.updateUser(AuthService.user);
        $rootScope.export=$rootScope.sites[index].export;
        $rootScope.title=$rootScope.sites[index].title;
        if (!item.multisite){ 
          $rootScope.promotion=$rootScope.sites[index].promotions.length;
          $rootScope.promotions=$rootScope.sites[index].promotions;
          $cookieStore.put("promotion", $rootScope.sites[index].promotions.length);
          $cookieStore.put("promotions", $rootScope.sites[index].promotions);
          $cookieStore.put("promo_id", undefined);
        }else{
          $cookieStore.put("promo_id", item.promo_id);

        }
        $rootScope.domain=$rootScope.sites[index].host;
        $cookieStore.put("domain", $rootScope.sites[index].host);
        $cookieStore.put("alias", $rootScope.sites[index].alias);
        $cookieStore.put("title", $rootScope.sites[index].title);        
        $cookieStore.put("export", $rootScope.sites[index].export);          

        try{
          $cookieStore.put("extras", $rootScope.sites[index].extras);
          $cookieStore.put("metrics", $rootScope.sites[index].extras.permissions.metrics);
          $rootScope.metrics = $rootScope.sites[index].extras.permissions.metrics;
          $rootScope.extras = $rootScope.sites[index].extras;
        }catch(e){
          $cookieStore.put("metrics", false);
          $rootScope.metrics = false;
        }

          
        },
      unsetSite: function(){   
        try{
          $cookies.remove("promotion");
          $cookies.remove("promotions");
          $cookies.remove("promo_id");
          $cookies.remove("domain");
          $cookies.remove("alias");
          $cookies.remove("title");        
          $cookies.remove("export");          
          $cookies.remove("metrics");          
          $cookies.remove("extras");
        }catch(e){
          console.log("Error on clear site.");
        }
      },
    };
    }

})();

(function () {
  'use strict';

  angular.module('BlurAdmin.pages.export', [])
      .config(routeConfig).run(runConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('home.export', {
          url: '/export',
          template: '<div class="ui-view"> </div>',
          title: 'Reverse Publishing',
          resolve: {
            isGroup: function($rootScope, $state, $q, $timeout,AuthService) {
              var group=AuthService.user.groups[0];
              if($rootScope.domain==""){
                try{
                  $timeout(function() { $state.go("home.dashboard"); });
                  return $q.reject("rejection message");
                }catch(err){
                  console.log(err);
                }
              }
            }
          },
          data: {
              access: 'logged',
              title: '',
              redirect: 'home.export.new'
          },
          sidebarMeta: {
            icon: 'ion-printer',
            order: 0,
          }
        }).state('home.export.index', {
          url: '/index/:id?mode',
          templateUrl: 'app/pages/export/index.html',
          title: 'Editor',
          controller: 'ExportCtrl',
          resolve: {
          },
          data: {
              access: 'logged',
              title: '',
              redirect: false
          },
           params: { 
            template_id:null,
            template:null,
            conf:null,
            oportunity:null,
            hiddenParam: 'YES'
          }
        }).state('home.export.editor', {
          url: '/editor/:template_id?pid&mode',
          templateUrl: 'app/pages/export/editor/index.html',
          title: 'Editor',
          controller: 'EditorCtrl',
          resolve: {
          },
          data: {
              access: 'logged',
              title: '',
              redirect: false
          },
          params: { 
            templates:{array:true},
            conf:null,
            create:{array:true},
            hiddenParam: 'YES'
          }
        }).state('home.export.new', {
          url: '/new/:data_id',
          templateUrl: 'app/pages/export/new.html',
          title: 'Export',
          controller: 'projectsCtrl',
          resolve: {
          },
          data: {
              access: 'logged',
              title: '',
              redirect: false
          },
          params: { 
            templates:{array:true},
            conf:null,
            create:null,
            hiddenParam: 'YES'
          }
        });


  }

  // perfect redirect 
  function runConfig($rootScope, $state) {
      $rootScope.$on('$stateChangeStart', function(event, toState, toParams){
        if(toState.data && toState.data.redirect){
          event.preventDefault();
          $state.go(toState.data.redirect, toParams);
        }
      });
  }



angular.module('BlurAdmin.pages.export')
.directive('stringToNumber', function() {
  return {
    require: 'ngModel',
    link: function(scope, element, attrs, ngModel) {
      ngModel.$parsers.push(function(value) {
        return '' + value;
      });
      ngModel.$formatters.push(function(value) {
        return parseFloat(value);
      });
    }
  };
});

angular.module('BlurAdmin.pages.export').directive('allowPattern', [allowPatternDirective]);

function allowPatternDirective() {
    return {
        restrict: "A",
        compile: function(tElement, tAttrs) {
            return function(scope, element, attrs) {
        // I handle key events
                element.bind("keypress", function(event) {
                    var keyCode = event.which || event.keyCode; // I safely get the keyCode pressed from the event.
                    var keyCodeChar = String.fromCharCode(keyCode); // I determine the char from the keyCode.

          // If the keyCode char does not match the allowed Regex Pattern, then don't allow the input into the field.
                    if (!keyCodeChar.match(new RegExp(attrs.allowPattern, "i"))) {
            event.preventDefault();
                        return false;
                    }

                });
            };
        }
    };
}


angular.module('BlurAdmin.pages.export')
.directive('autofocus', ['$timeout', function($timeout) {
  return {
    restrict: 'A',
    link : function($scope, $element) {
      $timeout(function() {
        $element[0].focus();
      });
    }
  }
}]);
angular.module('BlurAdmin.pages.export')
.directive('onLongPress', ['$parse', '$timeout', function ($parse, $timeout) {
    return {
        restrict: 'A',
        link: function ($scope, $elm, $attrs) {
            var timer;
            var timerDuration = (!isNaN($attrs.longPressDuration) && parseInt($attrs.longPressDuration)) || 600;
            // By default we prevent long press when user scrolls
            var preventLongPressOnScroll = ($attrs.preventOnscrolling ? $attrs.preventOnscrolling === 'true' : true)
            // Variable used to prevent long press while scrolling
            var touchStartY;
            var touchStartX;
            var MAX_DELTA = 15;
            // Bind touch, mouse and click event
            $elm.bind('touchstart', onEnter);
            $elm.bind('touchend', onExit);

            $elm.bind('mousedown', onEnter);
            $elm.bind('mouseup', onExit);

            $elm.bind('click', onClick);
            // For windows mobile browser
            $elm.bind('pointerdown', onEnter);
            $elm.bind('pointerup', onExit);
            if (preventLongPressOnScroll) {
                // Bind touchmove so that we prevent long press when user is scrolling
                $elm.bind('touchmove', onMove);
            }

            function onEnter(evt) {
                var functionHandler = $parse($attrs.onLongPress);
                // For tracking scrolling
                if ((evt.originalEvent || evt).touches) {
                    touchStartY = (evt.originalEvent || evt).touches[0].screenY;
                    touchStartX = (evt.originalEvent || evt).touches[0].screenX;
                }
                //Cancel existing timer
                $timeout.cancel(timer);
                //To handle click event properly
                $scope.longPressSent = false;
                // We'll set a timeout for 600 ms for a long press
                timer = $timeout(function () {
                    $scope.longPressSent = true;
                    // If the touchend event hasn't fired,
                    // apply the function given in on the element's on-long-press attribute
                    $scope.$apply(function () {
                        functionHandler($scope, {
                            $event: evt
                        });
                    });
                }, timerDuration);

            }

            function onExit(evt) {
                var functionHandler = $parse($attrs.onTouchEnd);
                // Prevent the onLongPress event from firing
                $timeout.cancel(timer);
                // If there is an on-touch-end function attached to this element, apply it
                if ($attrs.onTouchEnd) {
                    $scope.$apply(function () {
                        functionHandler($scope, {
                            $event: evt
                        });
                    });
                }

            }

            function onClick(evt) {
                //If long press is handled then prevent click
                if ($scope.longPressSent && (!$attrs.preventClick || $attrs.preventClick === "true")) {
                    evt.preventDefault();
                    evt.stopPropagation();
                    evt.stopImmediatePropagation();
                }

            }

            function onMove(evt) {
                var yPosition = (evt.originalEvent || evt).touches[0].screenY;
                var xPosition = (evt.originalEvent || evt).touches[0].screenX;

                // If we scrolled, prevent long presses
                if (touchStartY !== undefined && touchStartX !== undefined &&
                    (Math.abs(yPosition - touchStartY) > MAX_DELTA) || Math.abs(xPosition - touchStartX) > MAX_DELTA) {
                    $timeout.cancel(timer);
                }

            }
        }
    };
}]);
})();


(function () {
  'use strict';

  angular.module('BlurAdmin.pages.export')
      .controller('ExportCtrl', ExportCtrl);

  /** @ngInject */
  function ExportCtrl($scope, bodysService, xmlFilesService, quantityService, $http, $cookies, xmlexportsService, tempbaseService, xmlconfigsService, xmltemplatesService, $state, $rootScope, $q, $filter, layoutPaths, $stateParams, $location, $window, $anchorScroll, baConfig, colorHelper, $timeout, $uibModal, inventoryService, dataService, themeLayoutSettings, AuthService, toastr, toastrConfig, sectionsService, filtersService, exportsService, editableOptions, editableThemes, fileFactory, fileReader, API, baProgressModal, prosectionsService, templatesService, promakesService, promodelsService, proyearsService, Projects) {
      
     var vm = this;
     if ($stateParams.type_export){
        $scope.type_export = $stateParams.type_export;
     }else{
        $scope.type_export = "select";
     }     

    $scope.project_id = $stateParams.id;    
    $scope.apienv = API[API.ENV]; 

    $scope.options = {
      required: true,
      placeholder: 'Hex',
      inputClass: 'picker-color',
      // validation
      restrictToFormat:true,
      allowEmpty:true,
      // color
      format: 'hex',
      case: 'lower',
      // sliders
      hue: true,
      alpha: false,
      dynamicSaturation: true,
      dynamicLightness: true,
      dynamicAlpha: false,
      pos: 'bottom left'
    };

    $scope.preInit = true;
    $scope.group = AuthService.user.groups[0];
    $rootScope.group_name = $scope.group.name;
    $scope.solution = {reverse:true, bannerxl:true, bannerl:true, bannermd:true, bannersm:true, email:true, facebook:true, instagram:true};
    $scope.results = [];
    $scope.make = [];  $scope.year = [];  $scope.model = []; $scope.body = []; $scope.dealer = [];
    $scope.positions = [];
    $scope.sections = [];
    $scope.mode = "normal";
    $scope.cond = "all";
    $scope.excphimages = 1;
    $scope.templateNew = {shared:false};

    $scope.create = false;


    $scope.typeOf = function(value) {
        if(value === null) {
            return "null";
        }
        if(Array.isArray(value)) {
            return "array";
        }
        return typeof value; 
    };

     var  someEvent = $scope.$on('someEvent', function(event, args) {
      event.preventDefault(); event.stopPropagation();
      $scope.sections = args;
      console.log($scope.sections);
     });

     $scope.$on('$destroy', someEvent);

    $scope.uploadPicture = function (id) {
      var fileInput = document.getElementById("file"+id);
       fileInput.value="";
      fileInput.click();
    };

    $scope.soltemplates = [];
    $scope.specialtemplates = [];
    $scope.templates = [];
    $scope.seltemplate = undefined;

    $scope.selTarget = function () {
      var selectTarget=$uibModal.open({
        animation: true,
        templateUrl: "app/pages/modals/modalTemplates/smallModal.html",
        size: "sm",
        scope:$scope,
        backdrop : 'static',
        windowClass: 'modal-top',
        controller: function ($scope, $uibModalInstance) {
          $scope.setGlobal = function(info) {
            $scope.selpromo=info;
            info["promo"]=false;
            $uibModalInstance.close(info);
          }
          $scope.setPromo = function(info) {
            info["promo"]=true;
            $scope.selpromo=info;
            $uibModalInstance.close(info);
          }
        },
        resolve: {
          items: function () {
            return $scope.items;
          }
        }
      }).result.then(function (info) {
        if(info['promo']){
          prosectionsService.save({extra:info.extra}, function (response) {
            $scope.dealers=response.map(function(x) { return { value: x.id,  text: x.section_name};});
          }, function (response) {
          });
        }else{
          $scope.initialize();
        }
      });
    }; 

      $scope.newTemplate = function () {
        $scope.create=true;
        tempbaseService.query(function (response) {
          $scope.bases = response;
        }, function (response) {
        });
      };

    $scope.createTemplate = function () {
      if (!$scope.templateNew.name){
          toastr.warning('<span class="toast-description">   Enter right data   <span>', '<strong class="toast-titles"> Enter a valid template name.</strong>');   
        return;
      }
      if (!$scope.selectedTemplate){
          toastr.warning('<span class="toast-description">  Enter right data  <span>', '<strong class="toast-titles"> You must select a base template.  </strong>');   
        return;
      }

      var data = {name:$scope.templateNew.name, clone:$scope.selectedTemplate};
      templatesService.save(data,function (response) {
        $scope.template = response;
        $scope.templateNew = {shared:false};
        $scope.templates.push({ value: response.id,  text: response.name});
        $scope.dataTemplates.push(response);
        $scope.seltemplate = response.id;
        $scope.conf["template"] = response.name;
        $scope.create = false;
        $("#iframe-container iframe")[0].setAttribute("height", 1460);

        Projects.get({id:$stateParams.pid}, function(response){
          $scope.sections=response.sections;
          $scope.conf["sections"]=response.sections;
           templatesService.update($scope.template, function (response) {
                $scope.conf.limit = $scope.limit;
                $scope.template = response;
                fileFactory.downloadFile(API[API.ENV]+"api/v1/exports", "post", $scope.conf, "export_"+ new Date(), true, function (response) {
                  $scope.init_project = 1;
                  $scope.pdfUrl = response;
                });
              });
        });      
          
      }, function (response) {
          toastr.warning('<span class="toast-description">  Check it with support  <span>', '<strong class="toast-titles"> Something went wrong. </strong>');   
        
      });
    };

    $rootScope.userinfo=AuthService.user;
    $rootScope.domain = $rootScope.userinfo.email.substring($rootScope.userinfo.email.lastIndexOf("@") +1);

    $scope.selTemplate = function (id) {
      $scope.seltemplate = id;
    };

    $scope.selectTemplate = function (id) {
      $scope.selectedTemplate = id;
    };

    function groupBy( array , f )
    {
      var groups = {};
      array.forEach( function( o )
      {
        var group = JSON.stringify( f(o) );
        groups[group] = groups[group] || [];
        groups[group].push( o );  
      });
      return Object.keys(groups).map( function( group )
      {
        return groups[group]; 
      })
    }

    function secondsToStr(milliseconds) {
        function numberEnding (number) {
            return (number > 1) ? 's' : '';
        }
        var temp = Math.floor(milliseconds / 60);
        var days = Math.floor((temp %= 525600) / 1440);
        if (days) {
            return days;
        }
        var hours = Math.floor((temp %= 1440) / 60);
        if (hours) {
            return hours;
        }
        var minutes = temp % 60;
        if (minutes) {
            return minutes;
        }
        return '1 day';
    }

    $scope.stocksOptions=[];

    var delimiter1 = ",";
    var delimiter2 = " ";

    $scope.configSelect = {
      persist : true,
      delimiter : delimiter1,
      plugins : ['remove_button'],
      create : function(input) {
          return {
              value : input,
              text : input
          }
      },
      onInitialize : function(selectize){
      },
      onType: function(str) {
        if (str.slice(-1) === delimiter2) { 
          this.createItem(str.slice(0, -1))
          this.removeItem(delimiter2) // in case user enters just the delimiter
        }
      }
    };

    $scope.configSingleOne = {
      maxItems: 1,
      persist:true, 
      valueField: 'value',
      labelField: 'text',
       sortField: [
          {
              field: 'text',
              direction: 'asc'
          }
      ]
    };

    $scope.configSingle = {
      plugins:['remove_button'],
      valueField: 'value',
      labelField: 'text',
      sortField: [
          {
              field: 'text',
              direction: 'asc'
          }
      ]
    };

    $scope.completeLoad=false;
    $scope.completeLoadExtra=true;

    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';

    $scope.items=[];
    $scope.make=[];    
    $scope.dealers=[];    
    $scope.rtitle="";
    $scope.opacity=false;
    $scope.flagInit=false;
    $scope.pageStart=0;
    $scope.pageSize=20;
    $scope.pageLast=0;
    
    if($state.current.name == "home.demos"){
      $scope.numLimit = 36;
      $scope.conf = {numLimit:36};
    }else{
      $scope.numLimit = undefined;
      $scope.conf = {numLimit:undefined};
    }

    $scope.info;
    $scope.type="random";
    $scope.label_type="Random";
    $scope.seltag = undefined;
    $scope.projectload = false;
    
    // $scope.update=false;
    $scope.stocks=[];
    $scope.excludes=[];
    // $scope.preset=undefined;

    if ($stateParams.id){
      Projects.get({id:$stateParams.id}, function (resp) {          
        $scope.sections = resp.sections;    
        $scope.title_pro = resp.name;
        $scope.project = resp;
        templatesService.query(function (response) {
              
              $scope.templates = response.filter(function(x){ return x.ttype!="dynamic" && x.name.includes(".base");}).map(function(x) { return { value: x.id,  text: x.name};});        
              $scope.dataTemplates = response;
              $scope.specialtemplates = response.filter(function(x){ 
                // console.log(x);
                if(x.project){
                  return x.project.search($stateParams.id)>-1;
                }else{
                  return false;
                }

              });        

              if (resp.template){
                console.log(resp.template);
                var template_code = resp.template.match(/\('(.*?)'\)/);
                template_code = template_code[1];
              }

              $scope.specialtemplates.map(function(x) { x["name"] = x["name"].replace($scope.title_pro, "").replace("-", ""); return x["name"];  });        

              for (var i = 0; i < $scope.dataTemplates.length; i++) {
                if(template_code == $scope.dataTemplates[i].id){
                  $scope.selectedTemplate = $scope.dataTemplates[i];
                  $scope.template = $scope.dataTemplates[i];
                  $scope.seltemplate = template_code; 
                }
              }

              if ($scope.type_export == "pdf"){
                console.log($scope.templates);
                if($scope.templates.length){
                  $scope.create = false;
                }else{
                   tempbaseService.query(function (response) {
                    $scope.bases = response;
                  }, function (response) {
                  });
                  $scope.create = true;
                }

                if ($scope.sections.length && !$scope.pdfUrl){
                  $scope.conf["sections"]=$scope.sections;
                  $scope.reload();
                }
                
              }

              $scope.projectload = true;

              $timeout(function() {
                $scope.preInit = false;
              }, 150);
              
            }, function (response){

            });    
        }, function (response) {
          $scope.sections=[];
          $scope.preInit = false;
        });
    }else{

      $scope.sections=[];
      $scope.dataTemplates=[];
      if ($state.current.name!="home.neworder" && $state.current.name!="home.demos" && !$stateParams.order_id){ 
        templatesService.query(function (response) {
          $scope.templates = response.filter(function(x){ return x.ttype!="dynamic";}).map(function(x) { return { value: x.id,  text: x.name};});        
          $scope.soltemplates = response.filter(function(x){ return x.ttype=="dynamic";}).map(function(x) { return { value: x.id,  text: x.name};});        

          $scope.dataTemplates = response;
          
          if($stateParams.template_id){
            $scope.template = $stateParams.template_id;
          }else{
            $scope.template = $scope.templates[0].value;
          }

          for (var i = 0; i < $scope.dataTemplates.length; i++) {
            if($scope.template==$scope.dataTemplates[i].id){
              $scope.selectedTemplate=$scope.dataTemplates[i];
            }
          }

          $scope.preInit = false;

        }, function (response){

        });    
      }
    }
    if ($stateParams.conf){
      // var conf={sections: $scope.sections, limit: $scope.conf.numLimit, template:template_name};
      var conf=$stateParams.conf;
      $scope.sections=conf.sections;
    }
    
    $scope.initialize=function(){ 
      if ($stateParams.oportunity){

        if($state.current.name != "home.demos"){
          $scope.conf.numLimit = 5*6;
        }else{
          $scope.conf.numLimit = 100;
        }
        
        var oportunity = $stateParams.oportunity;
        var sections = [];


        for (var i = 0; i < $scope.dealers.length; i++) {
          if ($scope.dealers[i].value == parseInt($scope.dealer[j])) {
            var dealer=$scope.dealers[i];
          }
        }

        if ("stocks" in oportunity.dealer){
          $scope.type = "all";
          $scope.stocks = oportunity.dealer["stocks"];
          // $scope.conf.numLimit =  0;
        }

        $scope.dealers.push({value: oportunity.dealer.id, text: oportunity.dealer.name, name: oportunity.dealer.name});
        $scope.dealer.push(oportunity.dealer.id);

        var dealer = {value: oportunity.dealer.id, text: oportunity.dealer.name};

        var body = [];
        var model = [];
        var payload = {};
        if (!"stocks" in oportunity.dealer){   
          if (oportunity.dealer.entity == 'model'){
            model.push(oportunity.dealer.model);          
          }else{
            body.push(oportunity.dealer.body_style);
          }
        }

        if ($scope.cond != "all"){
          payload = { type : $scope.cond };
        }

        sections.push({stocks:$scope.stocks, excludes: [], makes:[], models:model, bodys:body, limit: $scope.conf.numLimit, section:dealer, type:$scope.type});
        $scope.filterData(sections, true,  function () {
          sectionsService.query(payload,function(response){
              $scope.dealers=response.map(function(x) { return { value: x.id,  name: x.section_name, text: x.section_name + " (" + x.total + ") Units.", total: x.total};});
              $scope.completeLoad = true;
              $scope.addOportunity();
            }, function (response) {
              $scope.completeLoad=true;
              // toastr.info('<span class="toast-description"> Has occurred a problem. Please check with system support, then try again <span>', '<strong class="toast-titles"> Data Access  </strong>');          
          });
        });

      }else{
        var payload = {};
        if ($scope.cond != "all"){
          payload = { type : $scope.cond };
        }

        sectionsService.query(payload, function(response){
            $scope.dealers=response.map(function(x) { return { value: x.id,  name: x.section_name, text: x.section_name + " (" + x.total + ") Units.", total: x.total };});
            $scope.completeLoad=true;
          }, function (response) {
            $scope.completeLoad=true;
            // toastr.info('<span class="toast-description"> Has occurred a problem. Please check with system support, then try again <span>', '<strong class="toast-titles"> Data Access  </strong>');          
        });
      }

      $scope.presets_options = [];
      if ($state.current.name!="home.neworder" && $state.current.name!="home.demos" && !$stateParams.order_id){
      xmlconfigsService.query(function(response){
          $scope.tags = response[0].tags;
          $scope.styles = response[0].styles.map(function(x) { return { value: x,  text: x};});
          
          var properties = [];
          var imgs_properties = [];

          angular.forEach(response[0].properties, function (value, index) {
            if (!/Image/.test(Object.keys(value)[0])){
              properties.push(value);
            }else{
              imgs_properties.push(value);
            }
          });

          $scope.properties = properties.map(function(x) { return {
            // console.log(x);
           value: Object.keys(x),  text: Object.keys(x)};});

          $scope.imgs_properties = imgs_properties.map(function(x) { return {
            // console.log(x);
           value: Object.keys(x),  text: Object.keys(x)};});
          $scope.completeLoad = true;

          xmlFilesService.query(function(response){
            $scope.files = response;
          }, function (response) {
            $scope.completeLoad = true;
            // toastr.info('<span class="toast-description"> Has occurred a problem. Please check with system support, then try again <span>', '<strong class="toast-titles"> Data Access </strong>');          
          });

          
          xmltemplatesService.query(function(response){
            $scope.presets_options = response.map(function(x) { return { value: x.id,  text: x.name};});
            $scope.presets = response;
            $scope.completeLoad = true;
            $scope.preset = {"name": "", "alias": "default", "combinations":[]};
            $scope.combinations = [];

            angular.forEach($scope.tags, function (value, index) {
                $scope.preset.combinations.push({"select": false, "tag": value, "property": undefined, "style": "Style1"});
                $scope.combinations.push({"select": false, "tag": value, "property": undefined, "style": "Style1"});
            });
            // $scope.flagInit = true;
          
          }, function (response) {
            $scope.completeLoad = true;
            // toastr.info('<span class="toast-description"> Has occurred a problem. Please check with system support, then try again <span>', '<strong class="toast-titles"> Data Access </strong>');          
          });

        }, function (response) {
          $scope.completeLoad = true;
          // toastr.info('<span class="toast-description"> Has occurred a problem. Please check with system support, then try again <span>', '<strong class="toast-titles"> Data Access </strong>');          
      });
      }

    }


    $scope.getProperties = function(tag) {
      if (/Image/.test(tag)){
        return $scope.imgs_properties;
      }else{
        return $scope.properties;
      }
    }
    
    $scope.newTemplateXML = function() {
      
      $scope.preset_selected = undefined;
      $scope.seltag = undefined;
      $scope.preset = {"name": "", "alias": "default", "combinations":[]};

      $scope.combinations = [];
      angular.forEach($scope.tags, function (value, index) {
          $scope.preset.combinations.push({"select": false, "tag": value, "property": undefined, "style": undefined});
          $scope.combinations.push({"select": false, "tag": value, "property": undefined, "style": undefined});
      });

    }

    var updateProject = function() {
      $scope.seltemplate=undefined;
      $scope.template=undefined;
       Projects.update({id:$stateParams.id, sections: $scope.sections, template_id:null}, function (response) {  
        }, function (response) {
      });
    }

    $scope.postProject = function() {
       Projects.update({id:$stateParams.id, tmp:false, sections: $scope.sections}, function (response) {  
          $scope.project.temp = response.temp;
        }, function (response) {
      });
    }

    $scope.deleteTemplate = function(item, templates) {
      $scope.deleteModal({ id: item}, [templates, $scope.dataTemplates], templatesService, "Template", updateProject);
    }

    $scope.copy=false;
    $scope.copyTemplate = function() {

      if (!$scope.siteid){
          toastr.warning('<span class="toast-description">   Select site   <span>', '<strong class="toast-titles"> Enter a valid site.</strong>');   
        return;
      }

      if (!$scope.templateNew.name){
          toastr.warning('<span class="toast-description">   Enter right data   <span>', '<strong class="toast-titles"> Enter a valid template name.</strong>');   
        return;
      }

      templatesService.save({"clone": $scope.seltemplate, "alias":$scope.siteid, "name": $scope.templateNew.name}, function (response) {
          $scope.templateNew.name = undefined;
          $scope.siteid = undefined;
          $scope.copy = false;
      }, function (response) {
        toastr.warning('<span class="toast-description">  Check it with support  <span>', '<strong class="toast-titles"> Something went wrong, check if name already exist. </strong>');   
      });
    
    }
    
    $scope.cancelCopy = function() {
      $scope.templateNew.name = undefined;
      $scope.siteid = undefined;
      $scope.copy = false;
    }

    $scope.setTemplate = function(item, templates) {
      $scope.copy=true;
      try{
        if ($rootScope.group_name=="root"){
          var url = API[API.ENV]+"api/v1/alias?export=true";
        }else{
          var queryparams = $scope.groups.join(",");
          var url = API[API.ENV]+"api/v1/alias"+"?group="+queryparams;
        }
      }catch(e){
        var queryparams = $scope.group;
        var url = API[API.ENV]+"api/v1/alias"+"?group="+queryparams;
      }

      $http.get(url,
        {
          headers: {'Authorization': AuthService.user.atok},
        }).then(
       function(response) {
          $scope.sites=[];
          angular.forEach(response.data, function (value, key) {
                  value['multisite'] = false;
                  value['title'] = value.host;
                  $scope.sites.push({"value": value.alias, "text": value.host});
                  if (value.promotions.length){
                    angular.forEach(value.promotions, function (v, k) {
                      var extras = {};
                      try{
                        extras = v.extras;
                      }catch(e){} 
                      var alias = value.alias + "_promoid_" + v.id;
                      $scope.sites.push({"value": alias, "text": v.name });
                    });
                  }
            
          });
    }, function (response) {
    });
    
    }

    $scope.deleteFileXML = function(item) {
      $scope.deleteModal(item, [$scope.files], xmlFilesService, "Log", $scope.newTemplateXML);
    }

    $scope.deleteModal = function(item, list, service, entity, callback) {
      $uibModal.open({
        animation: true,
        templateUrl: "app/pages/modals/modalTemplates/warningModal.html",
        size: "sm",
        scope:$scope,
        resolve: {
           data: {
              item: item,
              list: list,
              service: service,
              entity: entity
            }
        },
        controller:function($uibModalInstance, data) {
          $scope.title = data.entity;
          console.log(data);
          $scope.close=function() {
            $uibModalInstance.dismiss('no');
          }
          $scope.ok=function() {
            $uibModalInstance.close('yes');
            data.service.delete({id:item.id}, function (response) {

              angular.forEach(data.list, function (list, ind) {
                angular.forEach(list, function (value, index) {
                   var id = (value.hasOwnProperty("id"))?value.id:value.value;  
                   if (id == item.id){
                     list.splice(index, 1); 
                   }
                });
              });

              callback();
              toastr.info('<span class="toast-description">  <span>', '<strong class="toast-titles"> The '+ data.entity +' was removed rightly. </strong>');   
            }, function (response) {
              $scope.completeLoad=true;
              toastr.warning('<span class="toast-description"> Unable to access data mining. Please check your admin, then try again <span>', '<strong class="toast-titles"> Data Access </strong>');
            });

          }
        }
      }).closed.then(function(){
        // $scope.selectedBox=null;
      });

    }

    $scope.deleteTemplateXMLModal = function(item) {
      $scope.deleteModal($scope.preset, [$scope.presets_options], xmltemplatesService, "Preset");
    }

    $scope.saveTemplateXML = function() {

      angular.forEach($scope.combinations, function (value, index) {
        if (value.select){
          $scope.seltag = true;
        }
      });

      if (!$scope.seltag){
        $scope.seltag = false;
        return;
      }

      $scope.preset.name = $scope.preset_name;
      $scope.preset.combinations = $scope.combinations;

      xmltemplatesService.save($scope.preset, function (response) {
        $scope.preset_name = undefined;
        $scope.presets.push(response);
        $scope.presets_options.push({"value":response.id, "text":response.name});
        
        $scope.newTemplateXML();
        toastr.info('<span class="toast-description">  <span>', '<strong class="toast-titles"> The preset template was saved rightly. </strong>');   
      }, function (response) {
        $scope.completeLoad=true;
        toastr.warning('<span class="toast-description"> Has occurred a problem. Please check with system support, then try again <span>', '<strong class="toast-titles"> Data Access </strong>');
      });
    }
        

    $scope.getExportXML = function() {
      
      angular.forEach($scope.combinations, function (value, index) {
        if (value.select){
          $scope.seltag = true;
        }
      });

      if (!$scope.seltag){
        $scope.seltag = false;
        return;
      }

      xmlexportsService.save({sections: $scope.sections, preset:$scope.preset, name:$scope.xml_name}, function (response) {
          $scope.files.push(response);
          window.location = response.url;
        toastr.info('<span class="toast-description">  <span>', '<strong class="toast-titles"> The export was generate rightly. </strong>');   

      }, function (response) {
        console.log(response);
        $scope.completeLoad=true;

        if(response.hasOwnProperty("data")){

          if (response.data.hasOwnProperty("non_field_errors")){
            // response["non_field_errors"]
            toastr.warning('<span class="toast-description"> Exist a export with that name <span>', '<strong class="toast-titles"> Export XML </strong>');
          }else{
            toastr.warning('<span class="toast-description"> Has occurred a problem. Please check with system support, then try again <span>', '<strong class="toast-titles"> Data Access </strong>');
          }
        }else{
            toastr.warning('<span class="toast-description"> Has occurred a problem. Please check with system support, then try again <span>', '<strong class="toast-titles"> Data Access </strong>');
        }
        
      });
    }

    $scope.getExport = function() {
      $scope.opacity=false;
      var exist=false;
      for (var i = 0; i < $scope.dataTemplates.length; i++) {
        if($scope.template.id == $scope.dataTemplates[i].id){
          exist=true;
        }
      }

      if (!exist){
          toastr.warning('<span class="toast-description"> You must select almost a template for export. <span>', '<strong class="toast-titles"> Choose template for Export </strong>');
          return;
      }

      // if(!$scope.template){
      //     toastr.warning('<span class="toast-description"> You must select almost a template for export. <span>', '<strong class="toast-titles"> Choose template for Export </strong>');
      //     return;
      // }else if(!$scope.template.length){
      //     toastr.warning('<span class="toast-description"> You must select almost a template for export. <span>', '<strong class="toast-titles"> Choose template for Export </strong>');
      //     return;
      // }

      if(!$scope.sections){
          toastr.warning('<span class="toast-description"> You must select almost a dealer for export. <span>', '<strong class="toast-titles"> Add Dealers for Export </strong>');
          return;
      }else if(!$scope.sections.length){
          toastr.warning('<span class="toast-description"> You must select almost a dealer for export. <span>', '<strong class="toast-titles"> Add Dealers for Export </strong>');
          return;
      }

      for (var i = 0; i < $scope.dataTemplates.length; i++) {
        if($scope.template.id == $scope.dataTemplates[i].id){
          var template_name = $scope.dataTemplates[i].name;
        }
      }
      
      console.log(JSON.stringify($scope.sections)); 
      var deferred = $q.defer();
      fileFactory.downloadFile(API[API.ENV]+"api/v1/exports", "post", {sections: $scope.sections, limit: $scope.conf.numLimit, size_w: $scope.conf.size_w, size_h: $scope.conf.size_h, template:template_name}, "export_"+ new Date(), false, function (response) {
      });
      deferred.resolve({});      
      return deferred.promise;
    };


    $scope.printDemo = function(template) {
      var ondemand = false;
      angular.forEach($scope.solution, function(value, index){
        if (value){
          ondemand = true;
        }
      });

      if (!ondemand){
        angular.forEach($scope.solution, function(value, index){
          $scope.solution[index] = true;
        });
      }

      $scope.opacity=false;
      var exist=false;
     
      if(!$scope.sections){
          toastr.warning('<span class="toast-description"> You must select almost a dealer for export. <span>', '<strong class="toast-titles"> Add Dealers for Export </strong>');
          return;
      }else if(!$scope.sections.length){
          toastr.warning('<span class="toast-description"> You must select almost a dealer for export. <span>', '<strong class="toast-titles"> Add Dealers for Export </strong>');
          return;
      }

      for (var i = 0; i < $scope.dataTemplates.length; i++) {
        if(template==$scope.dataTemplates[i].id){
          var template_name=$scope.dataTemplates[i].name;
        }
      }
      
      var deferred = $q.defer();
      
      // console.log(JSON.stringify({sections: $scope.sections, solution: $scope.solution, limit: $scope.conf.numLimit, size_w: $scope.conf.size_w, size_h: $scope.conf.size_h, template:template_name}));

      fileFactory.downloadFile(API[API.ENV]+"api/v1/solutions", "post", {solution: $scope.solution, sections: $scope.sections, limit: $scope.conf.numLimit, size_w: $scope.conf.size_w, size_h: $scope.conf.size_h, template:template_name}, "export_"+ new Date(), false, function (response) {
      });
      deferred.resolve({});      
      return deferred.promise;
    };


    $scope.refreshResults = function(id){


      $scope.opacity = false;
      $scope.type_export = 'select';
      var section;
      $scope.results=[];
      for (var i = 0; i < $scope.sections.length; i++) {
          if($scope.sections[i].id==id){  
            section=$scope.sections[i];
            break;
          }
      }

      $scope.results.push({id:section.id, section_image:section.section_image, image_normal:section.image_normal, phone:section.phone, items:section.items});
      $scope.dealers.push({value:section.id,  text:section.name});      
      
      if ($scope.dealer.length){
        $scope.dealer[0]=section.id.toString();
      }else{
        $scope.dealer.push(section.id.toString());
      }

      for (var i = 0; i < section.items.length; i++) {
          if(section.items[i].section_id==id){  
            $scope.stocks.push(section.items[i].stock);
            break;
          }
      }
      
      if($scope.dealer.length){
          var sections=$scope.dealer.map(function(x) { return parseInt(x)});
      }else{
          var sections=$scope.dealers.map(function(x) { return parseInt(x.value)});
      }

      dealerload($scope.dealer);
      $scope.opacity=false;
      $scope.completeLoad=true;
      $scope.mode="normal";
    };

    $scope.changeMode = function () {
      $scope.mode="solutions";
    }

      
    $scope.modeNormal = function () {
      $scope.mode="normal";
    }

    $scope.sortableOptions = {
      update: function(e, ui) {
        Projects.update({id:$stateParams.id, sections: $scope.sections}, function (response) {  
        }, function (response) {
        });
      }
    };

    $scope.addOportunity = function () {
      angular.forEach($scope.results, function (value, key) {
          var flagexist=false;
          for (var i = 0; i < $scope.sections.length; i++) {
            if (value.id==$scope.sections[i].id){
              flagexist=true;
              var index=i;
            }
          }
          if(!flagexist){
            $scope.sections.push({eid:value.id, linear:false, section_image:value.section_image,  image_normal:value.image_normal, phone:value.phone, name:value.section_name, id:value.id, items:value.items});   

          }else{
            if ("linear" in $scope.sections[index]){
              var line=$scope.sections[index].linear;
            }else{
              var line=false;
            }
            $scope.sections[index]={eid:value.id, linear:line, section_image:value.section_image,  image_normal:value.image_normal, phone:value.phone, name:value.section_name, id:value.id, items:value.items};
          }
        
        });

        for (var i = 0; i < $scope.dataTemplates.length; i++) {
          if($scope.template==$scope.dataTemplates[i].id){
          var template_id=$scope.dataTemplates[i].id;
          }
        }

        Projects.update({id:$stateParams.id, sections: $scope.sections}, function (response) {  
        }, function (response) {
        });
    }

    $scope.addDealer = function() {

        var items=[];
        $scope.available=undefined;
        $scope.signal_add=true;
        if ($state.current.name!="home.demos"){
          if(!$scope.dealer || !$scope.results.length){
              toastr.info('<span class="toast-description"> You must complete all form selections options. <span>', '<strong class="toast-titles"> Add Dealer For Export </strong>');
              return;
          }
        }

        angular.forEach($scope.results, function (value, key) {
          var flagexist=false;
          for (var i = 0; i < $scope.sections.length; i++) {
            if (value.id==$scope.sections[i].id){
              flagexist=true;
              var index=i;
            }
          }
          if(!flagexist){
            $scope.sections.push({eid:value.id, linear:false, section_image:value.section_image,  image_normal:value.image_normal, phone:value.phone, name:value.section_name, id:value.id, items:value.items});   

          }else{
            if ("linear" in $scope.sections[index]){
              var line=$scope.sections[index].linear;
            }else{
              var line=false;
            }
            $scope.sections[index]={eid:value.id, linear:line, section_image:value.section_image,  image_normal:value.image_normal, phone:value.phone, name:value.section_name, id:value.id, items:value.items};
          }
        
        });

        for (var i = 0; i < $scope.dataTemplates.length; i++) {
          if($scope.template==$scope.dataTemplates[i].id){
          var template_id=$scope.dataTemplates[i].id;
          }
        }

        Projects.update({ id:$stateParams.id, sections: $scope.sections}, function (response) {  
        }, function (response) {
        });

        if ($state.current.name=="home.neworder"){
          localStorage.setItem("sections", JSON.stringify($scope.sections));
          $rootScope.$emit('updateOrder', $scope.sections);
        }

      var dealer_id=$scope.dealer;
      $scope.dealer=[];
      $scope.body=[];
      $scope.make=[];
      $scope.year=[];
      $scope.model=[];
      $scope.stocks=[];
      $scope.results=[];

    };

    $scope.linear=function (eid, status) {
      for (var i = 0; i < $scope.dataTemplates.length; i++) {
          if($scope.template==$scope.dataTemplates[i].id){
          var template_id=$scope.dataTemplates[i].id;
          }
      }

      for (var i = 0; i < $scope.sections.length; i++) {
          if($scope.sections[i].eid==eid){  
              $scope.sections[i].linear=status;
              console.log($scope.sections[i]);
              Projects.update({ id:$stateParams.id, sections: $scope.sections}, function (response) {  
              }, function (response) {
              });
              break;
          }
      }
    }

    $scope.discard = function(eid) {
      for (var i = 0; i < $scope.sections.length; i++) {
          if($scope.sections[i].eid==eid){  
              $scope.sections.splice(i, 1);
              break;
          }
      }

      for (var i = 0; i < $scope.dataTemplates.length; i++) {
          if($scope.template==$scope.dataTemplates[i].id){
          var template_id=$scope.dataTemplates[i].id;
          }
        }
        Projects.update({id:$stateParams.id, sections: $scope.sections}, function (response) {  
        }, function (response) {
        });
      // $scope.update=false;

       if ($state.current.name=="home.neworder"){
          localStorage.setItem("sections", JSON.stringify($scope.sections));
          $rootScope.$emit('updateOrder', $scope.sections);
        }
    };

    $scope.deleteItem = function(id, sec_id, index) {

      for (var i = 0; i < $scope.results.length; i++) {
        for (var j = 0; j < $scope.results[i].items.length; j++) {
          if($scope.results[i].items[j].id==id){
              $scope.excludes.push({id:$scope.results[i].items[j].id, section_id:sec_id});  
              $scope.positions.push(index);
              $scope.results[i].items.splice(j, 1);
              break;
          }
        }
      }
    
    };

    $scope.resetDealer=function(section_id){

      for (var i = $scope.excludes.length - 1; i >= 0; i--) {
        if($scope.excludes[i].section_id==section_id){  
          $scope.excludes.splice(i, 1);
        }
      }

      $scope.positions=[];
      $scope.results=[];
    }
    
    $scope.getDealerName=function (section_id) {

      for (var i = 0; i < $scope.sections.length; i++) {
        if ($scope.sections[i].id==section_id){
          return $scope.sections[i].name;
        }
      }

      for (var i = 0; i < $scope.dealers.length; i++) {
        if ($scope.dealers[i].value==section_id){
          return $scope.dealers[i].name;
        }
      }

    }

    $scope.getDealerQty=function (section_id) {
      for (var i = 0; i < $scope.dealers.length; i++) {
        if ($scope.dealers[i].value==section_id){
          return $scope.dealers[i].total;
        }
      }

    }

    $scope.resetAll=function(){
      for (var i = $scope.excludes.length - 1; i >= 0; i--) {  
          $scope.excludes.splice(i, 1);
      }
      $scope.results=[];
      $scope.positions=[];
    }

    $scope.showFlex = function(item) {
      // console.log(item.images)
      if (!item.slider){
        item.slider=true;
      }
    }

    $scope.loadCars = function(reload, qty)
     {

        if(!qty){
          $scope.loading=true;
        }
        if(!$scope.conf.numLimit){
          console.log("No limit!");
        }else if($scope.conf.numLimit<1){
          toastr.warning('<span class="toast-description"> You must select limit greater than zero. <span>', '<strong class="toast-titles"> Limit Items By Row </strong>');
            return;
        }
        
        if ($scope.type=="all"){
          if(!$scope.dealer.length || !$scope.stocks.length){
              if(!qty){
                toastr.warning('<span class="toast-description"> You must select some options parameters. <span>', '<strong class="toast-titles"> Incomplete From </strong>');
              }
              return;
          }
        }else{
          // console.log($scope.dealer);
          if ($scope.dealer){ 
            if(!$scope.dealer.length){
                if(!qty){
                  toastr.warning('<span class="toast-description"> You must select some options parameters. <span>', '<strong class="toast-titles"> Incomplete Form</strong>');
                }
                return;
            }
          }else{
            toastr.warning('<span class="toast-description"> You must select some options parameters.  <span>', '<strong class="toast-titles"> Incomplete From </strong>');
            return;
          }
        }

      var sections=[];
      var payload={sections:[], excludes:[], makes:[], years:[], models:[], stocks:[]};

      for (var j=0; j<$scope.dealer.length; j++){
        var models=[];
        var makes=[];
        var bodys=[];
        var years=[];
        
        var relength=0;
        for (var i = 0; i < $scope.dealers.length; i++) {
          if ($scope.dealers[i].value == parseInt($scope.dealer[j])) {
            var dealer=$scope.dealers[i];
          }
        }

        if($scope.make.length){
          for (var k = 0; k < $scope.make.length; k++) {
            makes.push($scope.make[k]);
          }
        }

        if($scope.body.length){
          for (var l = 0; l < $scope.body.length; l++) {
            bodys.push($scope.body[l]);
          }
        }

        if ($scope.model.length){ 
          for (var q = 0; q < $scope.model.length; q++) {
            models.push($scope.model[q]); 
          }
        }
        
        if ($scope.year.length){
          for (var z = 0; z < $scope.year.length; z++) {
            years.push(parseInt($scope.year[z])); 
          }
        }

        if ($scope.type=="all"){
          var stocks_numbers=[];
          for (var j = 0; j < $scope.stocks.length; j++) {
            var flag_exit=false;

          angular.forEach($scope.results, function(value, key){
            for (var i = 0; i < value.length; i++) {
              if($scope.stocks[j]==value[i].sf_stock){
                var flag_exit=true;
              }
            }
          });

            if(!flag_exit){
                stocks_numbers.push($scope.stocks[j]);
            }
          }

          var excludes_ids=[];
          for (var i = 0; i < $scope.excludes.length; i++) {
            if($scope.dealer[j]==$scope.excludes[i].sec_id){
              excludes_ids.push($scope.excludes[i].id);
            }
          }

          var limitTotal=$scope.conf.numLimit;

        }else{

          angular.forEach($scope.results, function(value, key){
            for (var i = 0; i < value.items.length; i++) {
              $scope.excludes.push({id:value.items[i].id, section_id:value.items[i].section_id});
            }
          });

          var excludes_ids=[];
          for (var i = 0; i < $scope.excludes.length; i++) {
            if(parseInt($scope.dealer[j])==$scope.excludes[i].section_id){
              excludes_ids.push($scope.excludes[i].id);
            }
          }

          angular.forEach($scope.results, function(value, key){
            if (value.id==$scope.dealer[j]){
              if(($scope.conf.numLimit-value.items.length)<1){
                  if (reload){
                    // $scope.excludes=[];
                    excludes_ids=[];
                    value.items=[];
                    relength=value.items.length;
                  }else{
                    relength=$scope.conf.numLimit;
                  }
              }else{
                relength=value.items.length;
              }
            }
          });
        }

        var limitTotal=($scope.conf.numLimit-relength);
        if ($scope.conf.price_max==null){
          $scope.conf.price_max=undefined;
        }

        if ($scope.conf.price_min==null){
          $scope.conf.price_min=undefined;
        }

        if (!qty){
          sections.push({excludes: excludes_ids, makes:makes, models:models, years:years, bodys:bodys, limit: limitTotal, section:dealer, stocks:stocks_numbers, price_min:$scope.conf.price_min, price_max:$scope.conf.price_max, type:$scope.type});
        }else{          
          payload.sections.push(dealer.value);
          payload.stocks.concat(stocks_numbers);
          payload.excludes.concat(excludes_ids);
          payload["makes"] = makes; 
          payload["models"] = models; 
          payload["bodys"] = bodys;
          payload["years"] = years;
          payload["price_min"] = $scope.conf.price_min; payload["price_max"] = $scope.conf.price_max;
          payload["type"] = $scope.type;
          payload["excphimages"] = $scope.excphimages;
        }

      }

      if (!qty){
        $scope.filterData(sections, reload, function () {
        });
      }else{
        quantityService.save(payload, function(response){
          $scope.available = response.total;
        }, function (response) {});
      }

      $scope.stocks=[];

    };

    $scope.filterData = function(sections, reload, callback){      
      filtersService.save({excphimages : $scope.excphimages, sections : sections}, function(response){
          $scope.loading=false;
          
          if(!response.length){
            if (!$scope.results.length){
              toastr.info('<span class="toast-description"> Try with other params. <span>', '<strong class="toast-titles">No cars found</strong>');
            }else{
              toastr.info('<span class="toast-description">To load more cars change the search parameters or click the "Reset List" button and load them again <span>', '<strong class="toast-titles">Cars already loaded!</strong>');
            }
          }

          if(response.length){
            var carsln=0;
            angular.forEach(response, function (value, key) {
              carsln+=value.items.length
            });
            if ($scope.results.length){
              toastr.info('<span class="toast-description">  <span>', '<strong class="toast-titles">'+carsln+' cars added to the list</strong>');
            }else{
              toastr.info('<span class="toast-description">  <span>', '<strong class="toast-titles">'+carsln+' cars added to the list</strong>');
            }
          }


          if($scope.type=="all"){
            angular.forEach(response, function(value, key) {
              var flag=false;
              for (var i = 0; i < $scope.results.length; i++) {
                  if (value.id==$scope.results[i].id){
                    flag=true;
                    angular.forEach(value.items, function(val, ky) {
                      $scope.results[i].items.splice(0,0, val);
                    });
                  } 
              }
              if (!flag){
                $scope.results.push(value);
              }
            });
          }else{
            angular.forEach(response, function(value, key) {
              var flag=false;
              for (var i = 0; i < $scope.results.length; i++) {
                  if (value.id==$scope.results[i].id){
                    flag=true;
                    angular.forEach(value.items, function(val, ky) {
                      if ($scope.positions.length){
                        var pos = $scope.positions.shift();
                        $scope.results[i].items.splice(pos,0, val);
                      }else{
                        $scope.results[i].items.splice(0,0, val);
                      }

                    });
                  } 
              }
              if (!flag){
                $scope.results.push(value);
              }
            });
  
          }

          for (var i = 0; i < $scope.results.length; i++) {
            $scope.results[i].items = $filter('orderBy')($scope.results[i].items, $scope.sort, $scope.reverse);
          }

          // $scope.section_loaded=response.section;
          $scope.completeLoad=true;
          $scope.opacity=false;

          if ($state.current.name=="home.demos"){
             $timeout(function () {
              $rootScope.$emit('loadSections', {});
             },200);
          }else{
            if (reload){
              $anchorScroll();
              $location.hash('results');
            }
          }
          // console.log(JSON.stringify($scope.results));
          callback();

        }, function (response) {
          $scope.loading=false;
          $scope.completeLoad=true;
          toastr.info('<span class="toast-description"> Unable to access data mining. Please try, most later <span>', '<strong class="toast-titles"> Data Access </strong>');          
      });
    }


    $scope.goBack2 = function(){
      $scope.create=false;
    }

    $scope.goBack = function () {
      $scope.items=[];
      $scope.pageStart=0;
      $scope.pageSize=20;
      $scope.pageLast=0;
      $scope.info;
    }
   
    function arr_diff (a1, a2) {
        var a = [], diff = [];
        for (var i = 0; i < a1.length; i++) {
            a[a1[i]] = true;
        }
        for (var i = 0; i < a2.length; i++) {
            if (a[a2[i]]) {
                delete a[a2[i]];
            } else {
                a[a2[i]] = true;
            }
        }
        for (var k in a) {
            diff.push(k);
        }
        return diff;
    };

   $scope.$watch('excphimages', function (newValue) {
      $scope.loadCars(true,true);
   });


   $scope.$watch('template.limit', function (newValue) {
      if (newValue){
            $scope.conf.numLimit = newValue;
          }else{
            if ($state.current.name == "home.demos"){
              $scope.numLimit = 36;
              $scope.conf = {numLimit:36};
            }else{
              $scope.numLimit = undefined;
              $scope.conf = { numLimit : undefined };
            }
        }      
    });

   $scope.copystock = false;
    $scope.copyStock = function($event){ 
      var stocksstring = "";
      var count = 0;
      angular.forEach($scope.sections, function (value, index) {
        angular.forEach(value.items, function (val, idx) {
          if (val.sf_stock && val.sf_stock != ""){
            stocksstring += val.sf_stock + ",";
            count++;
          }
        });
      });
      if($event){
        $event.stopPropagation();
        $event.preventDefault();
      }
      
      var textArea = document.createElement("textarea");
      textArea.value = stocksstring.replace(/,\s*$/, "");
      document.body.appendChild(textArea);
      textArea.select();
      textArea.setSelectionRange(0, 99999); 
      document.execCommand("Copy");
      textArea.remove();

      $scope.copystockmsg =  count.toString() + " stocks copied!"
      $scope.copystock = true;
      $timeout(function() {
        $scope.copystock = false;
      }, 750);

      return;
    }

   $scope.expXls = function($event){ 
      
      var count = 0;
      var data = [];

      angular.forEach($scope.sections, function (value, index) {
        angular.forEach(value.items, function (val, idx) {
          var obj = {url: "", stock: ""};
          if (val.hyperlink){
            obj["url"] = val.hyperlink;
            if (val.sf_stock){
              obj["stock"] = val.sf_stock;
            }
            data.push(obj);
            count++;
          }
        });
      });

      var url = API[API.ENV]+"api/v1/exports/xls";
      $scope.xlsexport = true;
      fileFactory.downloadFile(url, "post", data, "urls_"+ new Date(), false, function (response) {
        $scope.xlsexport = false;
      }, ".xls");

    }


   if ($state.current.name!="home.neworder" && $state.current.name!="home.demos" && !$stateParams.order_id){
     $scope.$watch("seltemplate", function(newValue, oldValue) {
      if(!$scope.preInit){
        console.log($scope.preInit);
        if(newValue){
          for (var i = 0; i < $scope.dataTemplates.length; i++) {
            if(newValue == $scope.dataTemplates[i].id){
              $scope.selectedTemplate = $scope.dataTemplates[i];
              $scope.template = $scope.dataTemplates[i];
            }
          }
 
          Projects.update({template_id:$scope.template.id,  id:$stateParams.id, sections: $scope.sections}, function (response) {  
          }, function (response) {
          });
          $scope.reload();
        
        }
      }
    });

      $scope.$watch('preset_selected', function (newValue) {
              // $scope.completeLoad = false;
              // $scope.opacity=true;
              if (newValue){
                // console.log("two");
                var idx;
                angular.forEach($scope.presets, function(value, index){
                  if (value.id == newValue){
                    idx = index;
                  }
                });
                $scope.preset = $scope.presets[idx];
                $scope.combinations = $scope.preset.combinations;
                console.log("preset");
                console.log($scope.preset);
              }else{
              }
      });
    }

    function dealerload(newValue, oldValue) {
      
      if(!$scope.sections){
        $scope.sections=[];
      }
      if(newValue){
        if($scope.dealer.length){
            if(!$stateParams.oportunity){
              $scope.opacity=true;
            }

            $scope.loadCars(true,true);
            angular.forEach(newValue, function(value, key) {
              for (var i = 0; i < $scope.sections.length; i++) {
                  if ($scope.sections[i].id==parseInt(value)){ 
                    var index=null;
                    var section=$scope.sections[i];
                    for (var j = 0; j < $scope.results.length; j++) {
                      if ($scope.results[j].id == parseInt(value)) {
                        index=j;
                      }
                    }
                    if(index==null){
                      console.log("section");
                      console.log(section);
                      $scope.results.push({id:section.id, section_image:section.section_image,  image_normal:section.image_normal, phone:section.phone, items:section.items});
                    }else{
                      $scope.results[index]={id:section.id, section_image:section.section_image,  image_normal:section.image_normal, phone:section.phone, items:section.items};
                    }
                  }
              }
            });

           if (newValue.length){
              var sections=newValue.map(function(x) { return parseInt(x)});
            }else{
              var sections=$scope.dealers.map(function(x) { return parseInt(x.value)});
            }
          
          $scope.completeLoadExtra=false;  

          promakesService.save({sections:sections}, function (response) {
              $scope.makes=response.map(function(x) { return { value: x.sf_make,  text: x.sf_make};});
              var makes=response.map(function(x) { return x.sf_make;});
              bodysService.save({sections:sections, makes:makes}, function (response) {
                $scope.bodys=response.map(function(x) { return { value: x.sf_bodyStyle,  text: x.sf_bodyStyle};});
                var bodys=response.map(function(x) { return x.sf_bodyStyle;});
                
                if($stateParams.oportunity){
                  if($stateParams.oportunity.dealer.entity=='body_style'){
                    var oportunity = $stateParams.oportunity;
                    var body = $scope.bodys.find(function(item) { console.log(item.text.toUpperCase()); return item.text.toUpperCase() == oportunity.dealer.body_style.toUpperCase(); });
                    if (body){
                      $scope.body.push(body.text);
                    }
                    bodys = [];
                    bodys.push(body);
                  }
                }

                promodelsService.save({sections:sections, makes:makes, bodys:bodys}, function (response) {
                  $scope.models = response.map(function(x) { return { value: x.sf_model,  text: x.sf_model};});
                  var models = response.map(function(x) { return x.sf_model;});
                  $scope.completeLoadExtra=true;
                  $scope.flagInit=true;
                  if($stateParams.oportunity){
                  if($stateParams.oportunity.dealer.entity=='model'){
                    var oportunity = $stateParams.oportunity;
                    var model = $scope.models.find(function(item) { return item.text.toUpperCase() == oportunity.dealer.model.toUpperCase(); });
                    if (model){
                      $scope.model.push(model.text);
                    }
                  }
                }
                
                proyearsService.save({sections:sections, makes:makes, models:models, bodys:bodys}, function (response) {
                   $scope.years = response.map(function(x) { return { value: x.sf_year,  text: x.sf_year};})
                }, function (response) {});

                }, function (response) {
                  $scope.completeLoadExtra=true;
                  toastr.info('<span class="toast-description"> Has occurred a problem. Please check with system support, then try again <span>', '<strong class="toast-titles"> Data Access </strong>');
                });
              }, function (response) {
                $scope.completeLoadExtra=true;
                toastr.info('<span class="toast-description"> Has occurred a problem. Please check with system support, then try again <span>', '<strong class="toast-titles"> Data Access </strong>');
              });
            
            }, function (response) {
              $scope.completeLoadExtra=true;
              toastr.info('<span class="toast-description"> Has occurred a problem. Please check with system support, then try again <span>', '<strong class="toast-titles"> Data Access </strong>');
            });

        }
      }

        for (var i = 0; i < $scope.results.length; i++) {
          var index=null;
          for (var j = 0; j < newValue.length; j++) {
            if ($scope.results[i].id==parseInt(newValue[j])){
              index=i;
            }
          }
          if(index==null) {
            $scope.results.splice(i, 1);
          }
        }

    }

    $scope.$watch("dealer", dealerload);
    $scope.$watch('combinations', function(newValue, oldValue) {
            if ($scope.preset_selected){
              $scope.preset.combinations = newValue;
              xmltemplatesService.update($scope.preset, function (response) {
                // toastr.info('<span class="toast-description">  <span>', '<strong class="toast-titles"> The template was saved rightly. </strong>');   
              }, function (response) {
                $scope.completeLoad=true;
                toastr.info('<span class="toast-description"> Has occurred a problem. Please check with system support, then try again <span>', '<strong class="toast-titles"> Data Access </strong>');
              });
            }
          
    }, true);        

    $scope.$watch('body', function (value) {
        if($scope.flagInit){
            $scope.completeLoad=false;
            $scope.opacity=true;
            
            if ($scope.dealer.length){
              var sections=$scope.dealer.map(function(x) { return parseInt(x);});
            }else{
              var sections=$scope.dealers.map(function(x) { return parseInt(x.value);});
            }          

            if ($scope.make.length){
              var makes=$scope.make.map(function(x) { return x;});
            }else{
              var makes=$scope.makes.map(function(x) { return x.value;});
            }            

            if (value.length){
              var bodys=value.map(function(x) { return x;});
            }else{
              var bodys=$scope.bodys.map(function(x) { return x.text;});
            }
            $scope.loadCars(true,true);

            promodelsService.save({sections:sections, makes:makes, bodys:bodys}, function (response) {
              $scope.models=response.map(function(x) { return { value: x.sf_model,  text: x.sf_model};});
              $scope.completeLoad=true;
              $scope.flagInit=true;
              var models=response.map(function(x) { return x.sf_model;});
                proyearsService.save({sections:sections, makes:makes, models:models, bodys:bodys}, function (response) {
                   $scope.years = response.map(function(x) { return { value: x.sf_year,  text: x.sf_year};})
                }, function (response) {
                
                });
            }, function (response) {
              $scope.completeLoad=true;
              toastr.info('<span class="toast-description"> Has occurred a problem. Please check with system support, then try again <span>', '<strong class="toast-titles"> Data Access </strong>');
            });

        }
    });

    $scope.$watch('make', function (value) {
        if($scope.flagInit){
            $scope.completeLoad=false;
            $scope.opacity=true;
            
            if ($scope.dealer.length){
              var sections=$scope.dealer.map(function(x) { return parseInt(x);});
            }else{
              var sections=$scope.dealers.map(function(x) { return parseInt(x.value);});
            }            

            if (value.length){
              var makes=value.map(function(x) { return x;});
            }else{
              console.log($scope.makes);
              var makes=$scope.makes.map(function(x) { return x.text;});
            }
            $scope.loadCars(true,true);
            bodysService.save({sections:sections, makes:makes}, function (response) {
              $scope.bodys=response.map(function(x) { return { value: x.sf_bodyStyle,  text: x.sf_bodyStyle};});
              var bodys=response.map(function(x) { return x.sf_bodyStyle;});
              promodelsService.save({sections:sections, makes:makes, bodys:bodys}, function (response) {
                $scope.models=response.map(function(x) { return { value: x.sf_model,  text: x.sf_model};});
                $scope.completeLoad=true;
                $scope.flagInit=true;

                var models=response.map(function(x) { return x.sf_model;});
                proyearsService.save({sections:sections, makes:makes, models:models, bodys:bodys}, function (response) {
                   $scope.years = response.map(function(x) { return { value: x.sf_year,  text: x.sf_year};})
                }, function (response) {
                
                });

              }, function (response) {
                $scope.completeLoad=true;
                toastr.info('<span class="toast-description"> Has occurred a problem. Please check with system support, then try again <span>', '<strong class="toast-titles"> Data Access </strong>');
              });
            }, function (response) {
              $scope.completeLoad=true;
              toastr.info('<span class="toast-description"> Has occurred a problem. Please check with system support, then try again <span>', '<strong class="toast-titles"> Data Access </strong>');
            });
        }
    });

    $scope.$watch('model', function (value) {
        if($scope.flagInit){
          $scope.opacity=true;

          if ($scope.dealer.length){
            var sections=$scope.dealer.map(function(x) { return parseInt(x);});
          }else{
            var sections=$scope.dealers.map(function(x) { return parseInt(x.value);});
          }          

          if ($scope.make.length){
            console.log($scope.make);
            var makes=$scope.make.map(function(x) { return x;});
          }else{
            var makes=$scope.makes.map(function(x) { return x.value;});
          }            

          if ($scope.body.length){
            var bodys=$scope.body.map(function(x) { return x;});
          }else{
            var bodys=$scope.bodys.map(function(x) { return x.text;});
          }

          if (value.length){
              var models=value.map(function(x) { return x;});
          }else{
              var models=$scope.models.map(function(x) { return x.text;});
          }

          proyearsService.save({sections:sections, makes:makes, models:models, bodys:bodys}, function (response) {
             $scope.years = response.map(function(x) { return { value: x.sf_year,  text: x.sf_year};})
          }, function (response) {
          
          });          
          $scope.loadCars(true,true);
        }
    });

    $scope.$watch('year', function (value) {
        if($scope.flagInit){
          $scope.opacity=true; 
          $scope.loadCars(true,true);
        }
    });

    $scope.setPhoto = function (id, section_id) {

      var active_index = $("#"+id).find('.flex-active-slide img').attr('data-index');
      angular.forEach($scope.results, function(value, key){
        for (var i = 0; i < value.items.length; i++) {
            if(value.items[i].id==id){ 
              value.items[i].sel_img=active_index; 
              break;
            }
        }
      });
    
    }

    $scope.sort="random";
    $scope.label_sort="Random";
    $scope.reverse=0;
    
    if ($stateParams.mode){
      $scope.type_export  = $stateParams.mode;
    }

    $scope.toggleExport = function(value, label) {
      $scope.type_export = value;
      $scope.label_export = label;

      switch(value){
        case "pdf":
          if($scope.templates.length){
            $scope.create = false;
          }else{
             tempbaseService.query(function (response) {
              $scope.bases = response;
            }, function (response) {
            });
            $scope.create = true;
          }
          
          console.log($scope.sections.length);
          if ($scope.sections.length && !$scope.pdfUrl){
            $scope.conf["sections"]=$scope.sections;
            $scope.reload();
          }else{
            // if (){
              $scope.conf["sections"]=$scope.sections;
              $scope.reload();
            // }
          }

          break;
        default:
      }

      $state.go("home.export.index", {mode:value}, {location: "replace", notify: false});
    }


    $scope.toggleEditor = function(editor){
      $scope.editor=editor;
      if (editor){
        $("#frameview").removeClass("col-lg-12 col-md-12 col-sm-12");
        $("#frameview").addClass("col-lg-9 col-md-9 col-sm-12");
      }else{
        $("#frameview").addClass("col-lg-12 col-md-12 col-sm-12");
        $("#frameview").removeClass("col-lg-9 col-md-9 col-sm-12");
      }
    }

    $scope.toggleEditor(true);
    setTimeout(function () {
      $("#toggleEditor").addClass('active');
    },500);

    $scope.toggleType = function(value, label) {
      $scope.type = value;
      $scope.label_type = label;
      console.log($scope.type, $scope.label_type);
    }

    $scope.toggleReverse = function(value) {
        value=0;
        for (var i = 0; i < $scope.results.length; i++) {
          $scope.results[i].items = $filter('orderBy')($scope.results[i].items, $scope.sort, value);
        }

    }

    $scope.toggleCond = function(value) {
      // $scope.completeLoad=false;
      $scope.loadDealers = false;
      $scope.dealer=[];
      $scope.make=[];
      $scope.body=[];
      $scope.model=[];
      $scope.year=[];
      $scope.cond = value;

    }
    
    $scope.toggleOrder = function(value, label) {
      $scope.sort=value;
      $scope.label_sort=label;

      for (var i = 0; i < $scope.results.length; i++) {
        $scope.results[i].items = $filter('orderBy')($scope.results[i].items, $scope.sort, $scope.reverse);
      }
      // $scope.resetAll();
    }

    $scope.reload = function(){ 
      if ($scope.template){
          $scope.conf["sections"] = $scope.sections
          $scope.conf["template"]=$scope.template.name;
          templatesService.update($scope.template, function (response) {
            // $scope.template=response;
            $scope.conf.limit=$scope.limit;
            var url = API[API.ENV]+"api/v1/exports";
            fileFactory.downloadFile(url, "post", $scope.conf, "export_"+ new Date(), true, function (response) {
                $scope.pdfUrl=response;
            });

          });
      }
      
    }

     $scope.uploadPictureSolution = function (id) {
      var fileInput = document.getElementById(id);
      fileInput.value="";
      fileInput.click();
    };

    $scope.uploadPictureFooter = function () {
      var fileInput = document.getElementById("fileFooter");
      fileInput.value="";
      fileInput.click();
    };

    $scope.uploadPictureHeader = function () {
      var fileInput = document.getElementById("fileHeader");
      fileInput.value="";
      fileInput.click();
    };

    $scope.section_id=null;
    
    $scope.uploadPictureSection = function () {
      var fileInput = document.getElementById("fileSection");
      fileInput.value="";
      fileInput.click();
    };

    $scope.uploadPictureDealer = function (section_id) {
      $scope.section_id=section_id;
      var fileInput = document.getElementById("sectionImage");
      fileInput.value="";
      fileInput.click();
    };

      function create_UUID(){
          var dt = new Date().getTime();
          var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
              var r = (dt + Math.random()*16)%16 | 0;
              dt = Math.floor(dt/16);
              return (c=='x' ? r :(r&0x3|0x8)).toString(16);
          });
          return uuid;
      }

    function get_extension(filename) {
      return filename.slice((filename.lastIndexOf('.') - 1 >>> 0) + 2);
    }

    $scope.getFile = function (file, id) {
       
        if (id.indexOf("item-")==-1){

                fileReader.readAsDataUrl(file, $scope)
            .then(function (result) {
              $scope.picture = result;
              baProgressModal.open();
               var url = API[API.ENV]+"api/v1/exports";
              if ($scope.template.ttype=="dynamic"){
                url = API[API.ENV]+"api/v1/solutions";
              }
              if (id=="sectionImage"){
                var data={base64: result, id:$scope.template.name, name:id, section_id:$scope.section_id, pid:$stateParams.id};
                fileFactory.uploadFileSection(data, function(response){
                  $scope.conf["sections"]=response.sections;
                  for (var i = $scope.sections.length - 1; i >= 0; i--) {
                    if ($scope.sections[i].id==$scope.section_id){
                      $scope.sections[i].section_image=response.image_url;
                       $("#dealer_image"+$scope.section_id.toString()).attr('src', response.image_url+"?cache="+create_UUID());
                    }
                  }
                  if (response.success){ 
                    fileFactory.downloadFile(url, "post", $scope.conf, "export_"+ new Date(), true, function (response) {
                        $scope.pdfUrl=response;
                      });
                    $scope.$apply();
                  }
                }, function(response){
                });
              }else{
                var data={base64: result, id:$scope.template.name, name:id};
                fileFactory.uploadFile2(data, function(response){
                  if (response.success){
                    if(id=="footer"){
                      $scope.template["footer_img"]=response.image_url;
                    }else{
                      console.log(id);
                      if(id=="section"){
                        $scope.template["section_img"]=response.image_url;
                      }else{
                        if(id=="header"){
                          $scope.template["header_img"] = response.image_url;
                        }else{
                          $scope.template.images[id] = response.image_url;
                        }
                      }
                    }

                    fileFactory.downloadFile(url, "post", $scope.conf, "export_"+ new Date(), true, function (response) {
                        $scope.pdfUrl=response;
                      });
                    $scope.$apply();
                  }
                }, function(response){
                });
              }
            });

        }else{
          var ext = get_extension(file.name);
          ext = ".jpg";
          // ext = (ext!="")? "." + ext : ".jpg";
          id = id.split("-")[1];
             fileReader.readAsDataUrl(file, $scope)
          .then(function (result) {
            $scope.picture = result;
            var data={base64: result, id:id, name: "default-carinv" + ext};
            baProgressModal.open();
            fileFactory.uploadFile(data, function(response){
              angular.forEach($scope.results, function(value, key){
                  for (var i = 0; i < value.items.length; i++) {
                    if (value.items[i].id==id){
                      var url = response["urlChange"];
                      if (!/\.\w{3,4}$/.test(url)) {
                        url = (/\.$/.test(url))?url+"jpg":url+".jpg";
                      }
                      $scope.results[key].items[i].images.unshift({"orden":"0", "name": response["name"], "urlChange":url});
                      $scope.results[key].items[i].slider = false;
                      
                    }
                  }  
              });
            }, function(response){
              console.log(response);
            });

          });
        }

    };

    dataService.initialize();
    $scope.initialize();

    if ($state.current.name=="home.neworder" && !$stateParams.order_id){
      $scope.sections = JSON.parse(localStorage.getItem("sections"));
    }
  }


  angular.module('BlurAdmin.pages.export')
    .controller('projectsCtrl', projectsCtrl);

  /** @ngInject */
  function projectsCtrl($scope, $cookies,  Projects, toastr, $uibModal) {
    // $scope.link = '';
    $scope.project={};
    $scope.projects=[];
    $scope.status={isopen:0};

    $scope.ok = function () {
      $uibModalInstance.close();
    };

    $scope.openConfirm = function () {
      $uibModal.open({
        animation: true,
        templateUrl: "app/pages/modals/modalTemplates/warningModal.html",
        size: "sm",
        scope:$scope,
        controller:function($uibModalInstance, Projects) {
          $scope.title ="Project";

          $scope.close=function() {
            $uibModalInstance.dismiss('no');
          }
          $scope.ok=function() {
            $uibModalInstance.close('yes');
            Projects.delete({id:$scope.selectedBox}, function (response) {
              var index = $scope.projects.indexOf($scope.selectedItem);
              $scope.projects.splice(index, 1);
            }, function (response) {
            });
          }
        }
      }).closed.then(function(){
        $scope.selectedBox=null;
      });
    }

    $scope.selectedBox=null;
    $scope.onLongPress = function(item) {
      console.log('Long press');
      $scope.selectedBox=item.id;
      $scope.selectedItem=item;
      $scope.openConfirm();
    }

    $scope.onTouchEnd = function(id) {
      console.log('Touch end');
    }

    
    Projects.query($scope.project, function (response) {
      $scope.projects=response;
    },function (response) {
    });

    $scope.openNew=function () {
      $scope.status.isopen=true;
    }
    $scope.saveProject=function (form) {
      $scope.project["alias"] =($cookies.get("promo_id"))? $cookies.get("alias").replace(/\"/g, '') + "_promoid_" + $cookies.get("promo_id").replace(/\"/g, ''):$cookies.get("alias").replace(/\"/g, '');
      Projects.save($scope.project, function (response) {
        $scope.status.isopen=0;
        $scope.project.name="";
        $scope.projects.unshift(response);
      },function (response) {
          toastr.warning('<span class="toast-description"> Try with another project name. <span>', '<strong class="toast-titles"> Already exist this export project!</strong>');
      });
    }

  }

  angular.module('BlurAdmin.pages.export')
    .controller('templateCtrl', templateCtrl);

  /** @ngInject */
  function templateCtrl($scope, $uibModalInstance) {
    // $scope.link = '';
    $scope.ok = function () {
      // $uibModalInstance.close($scope.link);
      $uibModalInstance.close();
    };

  }


})();


(function () {
  'use strict';

  angular.module('BlurAdmin.pages.export')
      .service('sectionsService', sectionsService);
  /** @ngInject */
   function sectionsService($resource, API) {
    return $resource(API[API.ENV]+"api/v1/sections");
   }

  angular.module('BlurAdmin.pages.export')
      .service('bodysService', bodysService);
  /** @ngInject */
   function bodysService($resource, API) {
    return $resource(API[API.ENV]+"api/v1/bodys", {}, {save: {
                method: 'POST',
                isArray: true
            }});
   }

  angular.module('BlurAdmin.pages.export')
      .service('tempbaseService', tempbaseService);
  /** @ngInject */
   function tempbaseService($resource, API) {
    return $resource(API[API.ENV]+"api/v1/templates/bases");
   }


   angular.module('BlurAdmin.pages.export')
      .service('templatesService', templatesService);
  /** @ngInject */
   function templatesService($resource, API) {
    return $resource(API[API.ENV]+"api/v1/templates/:id", {id:'@id'}, {save: {
                method: 'POST'
            },
           update: { method:'PUT'}});
   }

   angular.module('BlurAdmin.pages.export')
      .service('Projects', Projects);
  /** @ngInject */
   function Projects($resource, API) {
    return $resource(API[API.ENV]+"api/v1/projects/:id", {id:'@id'}, {save: {
                method: 'POST'
            },
           update: { method:'PUT'}});
   }

   angular.module('BlurAdmin.pages.export')
   .factory('debounce', function($timeout) {
    return function(callback, interval) {
        var timeout = null;
        return function() {
            $timeout.cancel(timeout);
            timeout = $timeout(function () { 
                var args = Array.prototype.slice.call(arguments);
                callback.apply(this, args); 
                }, interval);
            };
        }; 
    });

  angular.module('BlurAdmin.pages.export')
      .service('filtersService', filtersService);
  /** @ngInject */
   function filtersService($resource, API) {
    return $resource(API[API.ENV]+"api/v1/filters", {}, {save: {
                method: 'POST',
                isArray:true
            }});
   }

  angular.module('BlurAdmin.pages.export')
      .service('quantityService', quantityService);
  /** @ngInject */
   function quantityService($resource, API) {
    return $resource(API[API.ENV]+"api/v1/filters/counts", {}, {save: {
                method: 'POST',
                isArray:false
            }});
   }

angular.module('BlurAdmin.pages.export')
    .service('xmlFilesService', xmlFilesService);
/** @ngInject */
 function xmlFilesService($resource, API) {
  return $resource(API[API.ENV]+"api/v1/xmlfiles/:id", {id:'@id'});
 }

angular.module('BlurAdmin.pages.export')
    .service('exportsService', exportsService);
/** @ngInject */
 function exportsService($resource, API) {
  return $resource(API[API.ENV]+"api/v1/exports");
 }

angular.module('BlurAdmin.pages.export')
    .service('xmlconfigsService', xmlconfigsService);
/** @ngInject */
 function xmlconfigsService($resource, API) {
  return $resource(API[API.ENV]+"api/v1/xmlconfigs");
 }

angular.module('BlurAdmin.pages.export')
    .service('xmltemplatesService', xmltemplatesService);
/** @ngInject */
 function xmltemplatesService($resource, API) {
  return $resource(API[API.ENV]+"api/v1/xmltemplates/:id", {id:'@id'}, {save: {
                method: 'POST'
            },
           update: { method:'PUT'}});
   }

 angular.module('BlurAdmin.pages.export')
    .service('xmlexportsService', xmlexportsService);
/** @ngInject */
 function xmlexportsService($resource, API) {
  return $resource(API[API.ENV]+"api/v1/xmlexports");
 }



  angular.module('BlurAdmin.pages.export')
      .service('prosectionsService', prosectionsService);
  /** @ngInject */
   function prosectionsService($resource, API) {
    return $resource(API[API.ENV]+"api/v1/sections/promo", {}, {save: {
                method: 'POST',
                isArray: true
            }});
   }

  angular.module('BlurAdmin.pages.export')
      .service('promakesService', promakesService);
  /** @ngInject */
   function promakesService($resource, API) {
    return $resource(API[API.ENV]+"api/v1/makes", {}, {save: {
                method: 'POST',
                isArray: true
            }});
   }

  angular.module('BlurAdmin.pages.export')
      .service('promodelsService', promodelsService);
  /** @ngInject */
   function promodelsService($resource, API) {
    return $resource(API[API.ENV]+"api/v1/models", {}, {save: {
                method: 'POST',
                isArray: true
            }});
   }
  
  angular.module('BlurAdmin.pages.export')
      .service('proyearsService', proyearsService);
  /** @ngInject */
   function proyearsService($resource, API) {
    return $resource(API[API.ENV]+"api/v1/years", {}, {save: {
                method: 'POST',
                isArray: true
            }});
   }
   
   angular.module('BlurAdmin.pages.export')
      .service('promotionsService', function($http, ANALYTICS) {
      var myService = {
      get: function(data, token) {

        // $http returns a promise, which has a then function, which also returns a promise
        var promise = $http.get(ANALYTICS[ANALYTICS.ENV]+"api/v1/promotions/clicks",
          {
            params:data, 
            headers:
            {
              "Authorization":"Bearer "+token,
            }
          }).then(function (response) {
          // The then function here is an opportunity to modify the response
          console.log(response);
          // The return value gets picked up by the then in the controller.
          return response.data;
        });
        // Return the promise to the controller
        return promise;
      }
      };
      return myService;
  });



  angular.module('BlurAdmin.pages.export')
      .service('fileFactory', fileFactory);
  /** @ngInject */
    function fileFactory($timeout, $rootScope, API, $http, $window, $cookies, baProgressModal) {
    return {
        downloadFile: function (url, method, data, filename, inline, callback, type) {
            return $http(
                {
                    method: method,
                    url: url,
                    data: data,
                    headers: {
                      "Accept": "*/*"
                    },
                    responseType: "arraybuffer"
                  }).success(function(data, status, headers, config) {
                      // console.log(data);
                      // var w = window.open("about:blank");
                      // w.document.open();
                      // w.document.write(data);
                      // w.document.close();

                    type = typeof type !== 'undefined' ? type : '.pdf';
                    if(!inline){ 
                      var file = new Blob([data], { type: 'application/binary' });
                      var fileURL = URL.createObjectURL(file);
                      var link=document.createElement('a');
                      link.href=fileURL;
                      link.target="_blank";
                      link.download=filename + type;
                      link.click();
                      callback("success");
                    }else{
                      var file = new Blob([data], {type: "application/pdf"});
                      var fileURL = URL.createObjectURL(file);
                      callback(fileURL);
                    }
                  }).error(function(data, status, headers, config) {
                });
        },
        uploadFile: function (data, success, error) {
            console.log(data);
            var formData = new FormData();
            formData.append("id", data.id);
            formData.append("base64_string", data.base64);
            formData.append("imagename", data.name);
            formData.append("content_type_id", 1);
            baProgressModal.setProgress(0);
            
             $.ajax({
                url: "https://"+$rootScope.domain+"/web/loadimage.php",
                // url: "http://carsscope.com/web/loadimage.php",
                type: 'POST',
                data: formData,
                async: true,
                success: function (data) {
                  success(data);
                },
                error: function (data) {
                  baProgressModal.close();
                },
                xhr: function(){
                  // get the native XmlHttpRequest object
                  var xhr = $.ajaxSettings.xhr() ;
                  // set the onprogress event handler
                  xhr.upload.onprogress = function(evt){ 
                    baProgressModal.setProgress((evt.loaded/evt.total*100).toFixed(0));
                    console.log('progress', (evt.loaded/evt.total*100).toFixed(1))
                  };
                  // set the onload event handler
                  xhr.upload.onload = function(){
                    baProgressModal.setProgress(100); 
                    $timeout(function (argument) {
                      baProgressModal.close();
                    },750)
                  };
                  // return the customized object
                  return xhr;
                },
                cache: false,
                contentType: false,
                processData: false
            });
           
        },
        uploadFile2: function (data, success, error) {
            console.log(data);
            var formData = new FormData();
            formData.append("id", data.id);
            formData.append("image", data.base64);
            formData.append("imagename", data.name);
            formData.append("content_type_id", 1);


            baProgressModal.setProgress(0);
            var using = ($cookies.get("promo_id"))? $cookies.get("alias").replace(/\"/g, '') + "_promoid_" + $cookies.get("promo_id").replace(/\"/g, ''):$cookies.get("alias").replace(/\"/g, '');
            
             $.ajax({
                url: API[API.ENV]+"api/v1/images",
                // url: "http://carsscope.com/web/loadimage.php",
                type: 'POST',
                data: formData,
                async: true,
                headers: {
                  'Authorization': $http.defaults.headers.common.Authorization,
                  'X-Using': using
                },
                success: function (data) {
                  success(data);
                },
                error: function (data) {
                  baProgressModal.close();
                },
                xhr: function(){
                  // get the native XmlHttpRequest object
                  var xhr = $.ajaxSettings.xhr() ;
                  // set the onprogress event handler
                  xhr.upload.onprogress = function(evt){ 
                    baProgressModal.setProgress((evt.loaded/evt.total*100).toFixed(0));
                    console.log('progress', (evt.loaded/evt.total*100).toFixed(1))
                  };
                  // set the onload event handler
                  xhr.upload.onload = function(){
                    baProgressModal.setProgress(100); 
                    $timeout(function (argument) {
                      baProgressModal.close();
                    },750)
                  };
                  // return the customized object
                  return xhr;
                },
                cache: false,
                contentType: false,
                processData: false
            });
           
        },
        uploadFileSection: function (data, success, error) {
            console.log(data);
            var formData = new FormData();
            formData.append("id", data.id);
            formData.append("section_id", data.section_id);
            formData.append("pid", data.pid);
            formData.append("image", data.base64);
            formData.append("imagename", data.name);
            formData.append("content_type_id", 1);
            baProgressModal.setProgress(0);
            var using = ($cookies.get("promo_id"))? $cookies.get("alias").replace(/\"/g, '') + "_promoid_" + $cookies.get("promo_id").replace(/\"/g, ''):$cookies.get("alias").replace(/\"/g, '');
            
             $.ajax({
                url: API[API.ENV]+"api/v1/images/projects",
                // url: "http://carsscope.com/web/loadimage.php",
                type: 'POST',
                data: formData,
                async: true,
                headers: {
                  'Authorization': $http.defaults.headers.common.Authorization,
                  'X-Using': using
                },
                success: function (data) {
                  success(data);
                },
                error: function (data) {
                  baProgressModal.close();
                },
                xhr: function(){
                  // get the native XmlHttpRequest object
                  var xhr = $.ajaxSettings.xhr() ;
                  // set the onprogress event handler
                  xhr.upload.onprogress = function(evt){ 
                    baProgressModal.setProgress((evt.loaded/evt.total*100).toFixed(0));
                    console.log('progress', (evt.loaded/evt.total*100).toFixed(1))
                  };
                  // set the onload event handler
                  xhr.upload.onload = function(){
                    baProgressModal.setProgress(100); 
                    $timeout(function (argument) {
                      baProgressModal.close();
                    },750)
                  };
                  // return the customized object
                  return xhr;
                },
                cache: false,
                contentType: false,
                processData: false
            });
           
        },
        uploadFiles: function (data, success, error) {
            var formData = new FormData();

            // formData.append("ref_id", data.ref_id);
            // formData.append("file", data.filein);
            // formData.append("model", data.model);
            // formData.append("total_size", data.total_size);
            // formData.append("total_files", data.total_files);
            // formData.append("name", data.name);

            for (var property in data) {
                formData.append(property, data[property]);
            }
            
            // formData.append("ext", "");
            baProgressModal.setProgress(0);
            var using = ($cookies.get("promo_id"))? $cookies.get("alias").replace(/\"/g, '') + "_promoid_" + $cookies.get("promo_id").replace(/\"/g, ''):$cookies.get("alias").replace(/\"/g, '');
            
             $.ajax({
                // url: API[API.ENV]+"api/v1/images/projects",
                url: data["url"],
                type: 'POST',
                data: formData,
                transformRequest: angular.identity,
                async: true,
                headers: {
                  'Authorization': $http.defaults.headers.common.Authorization,
                  'X-Using': using,
                  'Content-Type': undefined 
                },
                success: function (data) {
                  $timeout(function (argument) {
                      baProgressModal.close();
                    },750)
                  success(data);
                },
                error: function (data) {
                  baProgressModal.close();
                  error(data)
                },
                xhr: function(){
                  
                  // get the native XmlHttpRequest object
                  var xhr = $.ajaxSettings.xhr() ;
                  // set the onprogress event handler
                  xhr.upload.onprogress = function(evt){ 
                    baProgressModal.setProgress((evt.loaded/evt.total*100).toFixed(0));
                    console.log('progress', (evt.loaded/evt.total*100).toFixed(1))
                  };
                  // set the onload event handler
                  xhr.upload.onload = function(){
                    baProgressModal.setProgress(100); 
                    
                  };
                  // return the customized object
                  return xhr;
                },
                cache: false,
                contentType: false,
                processData: false
            });
           
        }
    };
  }



})();






(function () {
  'use strict';

  angular.module('BlurAdmin.pages.home', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('home', {
          abstract: true,
          controller:"HomeCtrl",
          templateUrl: 'app/pages/home/index.html',  
          data: {
              access: 'logged',
              title: ' '
          }
        });
  }

   angular.module('BlurAdmin.pages.home').
  directive('homeStyle', homeStyle);

function homeStyle(layoutPaths, baConfig) {
    return {
      restrict: 'A',
      scope: {
      },
      link: function (scope, element, attr) {
        $("body").css("background-image", 'none');
        $("body").css("height", 'auto');
        $("html").css("height", 'auto');
      }
    };
  }



   angular.module('BlurAdmin.pages.home').filter('replace', replace);

    function replace(){

        return function (value, string, replacement) {
            if (!value) return '';
            var re = new RegExp(string, "g");
            return value.replace(re, replacement);
        };
    }



})();



(function () {
  'use strict';

  angular.module('BlurAdmin.pages.inventory', [])
      .config(routeConfig).config(chartJsConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('home.inventory', {
          url: '/inventory?dealer&body&dimension',
          templateUrl: 'app/pages/inventory/inventory.html',
          title: 'Inventory Comparison',
          controller: 'InventoryCtrl',
          resolve: {
            isGroup: function($rootScope, $state, $q, $timeout,AuthService) {
              var group=AuthService.user.groups[0];
              if($rootScope.domain==""){
                try{
                  $timeout(function() { $state.go("home.dashboard"); });
                  return $q.reject("rejection message");
                }catch(err){
                  console.log(err);
                }
              }
            }
          },
          onExit: function(inventoryService, $state){

          },
          data: {
              access: 'logged',
              title: ' '
          },
          sidebarMeta: {
            icon: 'ion-model-s',
            order: 0,
          },
          params: { 
            hiddenParam: 'YES'
          }
        });
        // .state('home.metrics', {
        //   url: '/metrics',
        //   templateUrl: 'app/pages/inventory/metrics.html',
        //   controller: 'MetricsCtrl',
        //   data: {
        //       access: 'logged',
        //   }
          
        // });
  }

  function chartJsConfig(ChartJsProvider, baConfigProvider) {

        var layoutColors = baConfigProvider.colors;

        function cut(value, wordwise, max, tail) {
            if (!value) return '';

            max = parseInt(max, 10);
            if (!max) return value;
            if (value.length <= max) return value;

            value = value.substr(0, max);
            if (wordwise) {
                var lastspace = value.lastIndexOf(' ');
                if (lastspace !== -1) {
                  //Also remove . and , so its gives a cleaner result.
                  if (value.charAt(lastspace-1) === '.' || value.charAt(lastspace-1) === ',') {
                    lastspace = lastspace - 1;
                  }
                  value = value.substr(0, lastspace);
                }
            }

            return value + (tail || ' …');
        };

        var isMobile = (/android|webos|iphone|ipad|ipod|blackberry|windows phone/).test(navigator.userAgent.toLowerCase());

    }



})();


(function () {
  'use strict';

  angular.module('BlurAdmin.pages.inventory')
      .controller('InventoryCtrl', InventoryCtrl);

  /** @ngInject */
  function InventoryCtrl($scope, $rootScope, fileFactory, $stateParams, $cookies, Projects, $q, $state, $filter, layoutPaths, $location, $window, $anchorScroll, baConfig, colorHelper, $timeout, inventoryService, dataService, salesService, themeLayoutSettings, AuthService, toastr, toastrConfig, API) {

    try{
      inventoryService.cancel();
    }catch(e){
      console.log(e);
    }

    $scope.group = AuthService.user.groups[0];
    $rootScope.userinfo = AuthService.user;

    $scope.conf = {};

    function groupBy( array , f )
    {
      var groups = {};
      array.forEach( function( o )
      {
        var group = JSON.stringify( f(o) );
        groups[group] = groups[group] || [];
        groups[group].push( o );  
      });
      return Object.keys(groups).map( function( group )
      {
        return groups[group]; 
      })
    }

    $scope.configSelect = {
      plugins:['remove_button'],
      persist:true,
      valueField: 'value',
      labelField: 'text'
    };


    $scope.configSingleOne = {
      maxItems: 1,
      persist:true, 
      valueField: 'value',
      labelField: 'text'
    };

    $scope.completeLoad=false;

    $scope.items = [];
    $scope.dataType = ["New", "Used"];
    $scope.dimensions = [{"value":"body_style", "text": "Body Style"}, {"value":"model", "text": "Model"}];
    $scope.dimension = "body_style";

    $scope.certified = [0, 1];
    $scope.report = "normal";
    $scope.type = "all";
    $scope.public = "[1]";
    $scope.dealer = [];
    $scope.adealer = []; $scope.make=[]; $scope.model=[]; $scope.year=[]; $scope.body=[];
    $scope.dealers = []; $scope.makes=[]; $scope.models=[]; $scope.bodys=[]; $scope.years=[];
    $scope.rtitle = "";
    $scope.opacity = false;
    $scope.flagInit = false;
    $scope.info;
    $scope.title_details;
    $scope.loadDealers = false;
    $scope.showUpdate = false;
    $scope.page = undefined;
    $scope.loading = undefined;

    $scope.fullresults = [];
    $scope.items = [];

    $scope.datasetOverride = [
       {
            fill: true,
            backgroundColor: "#065cbe"
            
        },
        {
            fill: true,
            backgroundColor:  "#55bef2"
            
        }];

    function numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    function getScreenSize() {
      var sm = window.matchMedia("(min-width: 320px) and (max-width: 480px)");
      var md = window.matchMedia("(min-width: 481px) and (max-width: 768px)");
      var lg = window.matchMedia("(min-width: 769px) and (max-width: 1024px)");
      var xl = window.matchMedia("(min-width: 1025px)");
    
      if (sm.matches) {
        return 'sm';
      } else if (md.matches) {
        return 'md';
      } else if (lg.matches) {
        return 'lg';
      } else if (xl.matches) {
        return 'xl';
      } else {
        return 'unknown';
      }
    }

    var screen = getScreenSize();
    var chart_cnf = {"sm" : {yaxes_font_size : 10, legend_font_size: 9, bars_size: 250},  
                    "md" : {yaxes_font_size : 10, legend_font_size: 10, bars_size: 100},
                    "lg" : {yaxes_font_size : 15, legend_font_size: 10, bars_size: 1},
                    "xl" : {yaxes_font_size : 15, legend_font_size: 10, bars_size: 1}};

    function truncateString(str, maxLength) {
      if (str.length > maxLength) {
        return str.slice(0, maxLength) + "...";
      } else {
        return str;
      }
    }
    $scope.barhorizontal = {
         scales: {
          yAxes: [{
                ticks: {
                    fontSize: 11, 
                    fontColor: ['#000'],
                    fontFamily: 'Rubik',
                    // Include a dollar sign in the ticks
                    callback: function(value, index, values) {
                        if ($scope.report == "stock"){
                          var element = $scope.stock_results.find( function(item) { return item.section_id == value; } );
                          var amount = (element.amount) ? $filter("number")(element.amount.toString(), '0') + "$ Still)" : "Unknown)";
                          if (screen == "sm"){
                              amount = ""
                          }
                          value = [truncateString(element.section_name, 20), "(" + element.quantity + " Cars / " + Math.round(element.time_duration).toString() + " Days / " + amount]; 
                        }else{
                          var element = $scope.max_results.find( function(item) { return item.section_id == value; } );
                          value = truncateString(element.section_name, 20); 
                        }

                        return value;
                    },
                    fontStyle: 'bold',
                    fontFunction: function (tickIndex) {
                        return '"Gotham Book"';
                    },
                    lineHeight:0.5
                }
            }]
          },
      animation: {
          duration: 500, 
          onComplete: function () { 
              var ctx = this.chart.ctx;
              ctx.font = Chart.helpers.fontString(15, 'bold', "Rubik");
              ctx.fillStyle = "#000";
              ctx.textAlign = 'center';
              ctx.textBaseline = 'bottom';
              this.data.datasets.forEach(function (dataset) {
                for (var i = 0; i < dataset.data.length; i++) {
                  if(dataset.hidden === true && dataset._meta[Object.keys(dataset._meta)[0]].hidden !== false){ continue; }
                  var model = dataset._meta[Object.keys(dataset._meta)[0]].data[i]._model;
                  if(dataset.data[i] !== null){
                    if(dataset.data[i] > 0){
                        var npos = dataset.data[i].toString().length * 7;
                        var dato = dataset.data[i];
                        ctx.fillText(dato, model.x + npos, model.y + 7);
                    }
                  }
                }
              });
          }
      }
    }

   
    $scope.baroptions = {
      devicePixelRatio: 1,
      responsive:true,
      layout: {
            padding: {
                left: 20,
                right: 40,
                top: 0,
                bottom: 0
            }
        },
      tooltips: {
       callbacks: {
          title: function(tooltipItem, data) {
              var value = tooltipItem[0]["yLabel"][0];
              return value;
          }
        }
      },
      legend: { 
        position: "top",
        fullWidth: true,
        align: "start",
        offsetX: 0,
          offsetY: 0,
        labels:{
          fontSize: chart_cnf[screen].legend_font_size
        },
        display: true,
        onClick: null
      },
      scales: {
         yAxes: [{
                barPercentage: 1,
                ticks: {
                  fontColor: ['#000'],
                  padding: -5,
                  fontFamily: 'Rubik',
                  callback: function(value, index, values) {
                      value = value.toString().split("|");
                      if(value[1] != "0" && value[1] != "NaN" ){
                        if(screen == "sm" || screen == "md"){
                          return  [value[0], "Avg: $" + numberWithCommas(value[1])];
                        }else{
                          return  [value[0], "Avg Price: $" + numberWithCommas(value[1])];

                        }
                      
                        }else{
                        return  [value[0]];
                      }
                  
                  },
                  fontStyle: 'bold',
                  fontFunction: function (tickIndex) {
                    console.log(tickIndex);
                      if (tickIndex % 2 !== 0) {
                          return '14px "Gotham Book"';
                      } else {
                          return '30px "Gotham Book"';
                      }
                  },
                  fontSize: chart_cnf[screen].yaxes_font_size,
                  // lineHeight: 0,
                  // padding: 40
                }
              }
              ],

          xAxes:[{
            barPercentage: 1
          }]
      }
    };
    
    $scope.initialize=function(){ 
      try{
        inventoryService.getDealers($scope.group.name, dataService.getParams("dealers")).then(function(response){
        if ($stateParams.dealer){
          $scope.dealers.push(response.data.resultset.map(function(x) { return { value: x.section_id,  text: x.section_name};}));
        }else{
            $scope.dealers=response.data.resultset.map(function(x) { return { value: x.section_id,  text: x.section_name};});
        }
        $scope.loadDealers = true;
        $scope.flagInit = true;
        inventoryService.getMakes($scope.group.name, dataService.getParams("makes")).then(function(response){
          $scope.makes= response.data.resultset.map(function(x) { return { value: x.make,  text: x.make};});
          inventoryService.getBodys($scope.group.name, dataService.getParams("bodys")).then(function(response){
            $scope.bodys = response.data.resultset.map(function(x) { return { value: x.body_style,  text: x.body_style};});
            inventoryService.getModels($scope.group.name, dataService.getParams("models")).then(function(response){
              $scope.models=response.data.resultset.map(function(x) { return { value: x.model,  text: x.model};});
              $scope.flagInit=true;
              $scope.completeLoad=true;
              inventoryService.getYears($scope.group.name, dataService.getParams("years")).then(function(response){
                $scope.years=response.data.resultset.map(function(x) { return { value: x.year,  text: x.year};}).reverse();
                $scope.flagInit=true;
                $scope.completeLoad=true;
              }, function (response) {
                $scope.completeLoad=true;
                toastr.warning('<span class="toast-description"> Unable to access data mining. Please check your connection, then try again <span>', '<strong class="toast-titles"> Access Server </strong>');
              });
            }, function (response) {
              $scope.completeLoad=true;
              toastr.warning('<span class="toast-description"> Unable to access data mining. Please check your connection, then try again <span>', '<strong class="toast-titles"> Access Server </strong>');
            });
          }, function (response) {
            $scope.completeLoad=true;
            toastr.warning('<span class="toast-description"> Unable to access data mining. Please check your connection, then try again <span>', '<strong class="toast-titles"> Access Server </strong>');
          });
          }, function (response) {
            $scope.completeLoad=true;
            toastr.warning('<span class="toast-description"> Unable to access data mining. Please check your connection, then try again <span>', '<strong class="toast-titles"> Access Server </strong>');            
          });
        }, function (response) {
          $scope.completeLoad=true;
          toastr.warning('<span class="toast-description"> Unable to access data mining. Please check your connection, then try again <span>', '<strong class="toast-titles"> Access Server </strong>');          
      });

      }catch(error){
        console.log(error);
      }
    }

    $scope.printPdf = function (data) {
      var dealer = dataService.getBuildParams($scope.dealers, [$scope.adealer]);
      var payload = {};
      payload["name"] = dealer[0];
      payload["dealers"] = data;
      payload["type"] = "normal";
      fileFactory.downloadFile(API[API.ENV]+"api/v1/metricspdf", "post", {data:payload, "type": "benchmark"}, "export_"+ new Date(), false, function (response) {
        });
    }


    $scope.toggleType = function(value) {
      $scope.completeLoad=false;
      $scope.loadDealers = false;
      $scope.opacity = true;
      $scope.dealer = []; $scope.make = []; $scope.body = []; $scope.model = []; $scope.year = [];

      switch(value){
        case "all":
          dataService.setTypes(["New", "Used"]);
          dataService.setCertified([0, 1]);
          $scope.dataType = dataService.getTypes();
          $scope.certified = dataService.getCertified();
          $rootScope.$emit('refreshCondition', dataService.getParams("types"));
          $scope.initialize();
          break;
        case "new":
          dataService.setTypes(["New"]);
          dataService.setCertified([0]);
          $scope.dataType = dataService.getTypes();
          $scope.certified = dataService.getCertified();
          $rootScope.$emit('refreshCondition', dataService.getParams("types"));    
          $scope.initialize();
          break;
        case "used":
          dataService.setTypes(["Used"]);
          dataService.setCertified([0,1]);
          $scope.dataType = dataService.getTypes();
          $scope.certified = dataService.getCertified();
          $rootScope.$emit('refreshCondition', dataService.getParams("types"));    
          $scope.initialize();
          break;
        case "certified":
          dataService.setTypes(["Used"]);
          dataService.setCertified([1]);
          $scope.dataType = dataService.getTypes();
          $scope.certified = dataService.getCertified();
          $rootScope.$emit('refreshCondition', dataService.getParams("types"));    
          $scope.initialize();
          break;
      }
    }

    var selectionCompose = function(selects){
      var newarray = [];
      for (idx in selects){
        if (typeof(selects[idx])=="string"){
          var sel = selects[idx].match(/\.\[(.*?)\]/i);
          newarray.push(sel);
        }
      }

      return newarray;

    }

    var titleCompose = function(name, topic){
      $scope.title_details = "CARS FOR " + topic + " SELECTED · <b class='title'>" + name + "</b>";
    }

    $scope.toggleReport=function(value){
      $scope.opacity = true;
      $scope.report = value;
      if ($scope.adealer.length && !$scope.dealer.length){
        $scope.dealer = [$scope.adealer];
        dataService.setDealers($scope.dealer);
        $scope.initialize();
      }
    }

    $scope.$watch('dimension', function (value) {
      $scope.opacity = true;
    });

    $scope.$watch('dealer', function (value) {
        dataService.setDealers(value);
        if($scope.flagInit){
          $scope.completeLoad=false;
          $scope.loadend = false;
          $scope.opacity = ($scope.unopacity)? false : true;  
            var paramsMakes=dataService.getParams("makes");
          inventoryService.getMakes($scope.group.name, paramsMakes).then(function(response){
              $scope.makes = response.data.resultset.map(function(x) { return { value: x.make,  text: x.make};});

              $scope.make = dataService.getBuildParams($scope.makes, $scope.make);
              
              dataService.setMakes($scope.make)
              $scope.completeLoad = true;
            }, function (response) {
              $scope.completeLoad = true;
              toastr.warning('<span class="toast-description"> Unable to access data mining. Please check your connection, then try again <span>', '<strong class="toast-titles"> Access Server </strong>');
          });
        }
    });

    $scope.$watch('make', function (value) {
        if($scope.flagInit){
          $scope.completeLoad = false;
          $scope.loadend = false;
          $scope.opacity = ($scope.unopacity)? false : true;  
          // $scope.model=[]; $scope.year=[];
          dataService.setDealers($scope.dealer);
          dataService.setMakes($scope.make);
          var paramsBodys = dataService.getParams("bodys");
            inventoryService.getBodys($scope.group.name, paramsBodys).then(function(response){
              $scope.bodys = response.data.resultset.map(function(x) { return { value: x.body_style,  text: x.body_style};});
              $scope.body = dataService.getBuildParams($scope.bodys, $scope.body);
              $scope.completeLoad = true;
              }, function (response) {
                $scope.completeLoad = true;
                toastr.warning('<span class="toast-description"> Unable to access data mining. Please check your connection, then try again <span>', '<strong class="toast-titles"> Access Server </strong>');
            });
        }
    }); 

    $scope.$watch('body', function (value) {
        if($scope.flagInit){
          $scope.completeLoad=false;
          $scope.loadend = false;
          $scope.opacity = ($scope.unopacity)? false : true;  
          // $scope.model=[]; $scope.year=[];
          dataService.setDealers($scope.dealer);
          dataService.setMakes($scope.make);
          dataService.setBodys($scope.body);
          var paramsModels = dataService.getParams("models");
          inventoryService.getModels($scope.group.name, paramsModels).then(function(response){
                $scope.models = response.data.resultset.map(function(x) { return { value: x.model,  text: x.model};});
                $scope.model = dataService.getBuildParams($scope.models, $scope.model);
                $scope.completeLoad = true;
              }, function (response) {
                $scope.completeLoad = true;
                toastr.warning('<span class="toast-description"> Unable to access data mining. Please check your connection, then try again <span>', '<strong class="toast-titles"> Access Server </strong>');
          });
             
        }
    });

    $scope.$watch('model', function (value, oldvalue) {
        if($scope.flagInit){
          $scope.completeLoad = false;
          $scope.loadend = false;
          $scope.opacity = ($scope.unopacity)? false : true;  
          dataService.setDealers($scope.dealer);
          dataService.setMakes($scope.make);
          dataService.setBodys($scope.body);
          dataService.setModels(value);
          var paramsYears = dataService.getParams("years");
          inventoryService.getYears($scope.group.name, paramsYears).then(function(response){
            $scope.years = response.data.resultset.map(function(x) { return { value: x.year,  text: x.year};}).reverse();
            $scope.year = dataService.getBuildParams($scope.years, $scope.year);
            dataService.setYears($scope.year);
            $scope.completeLoad=true;
          }, function (response) {
            $scope.completeLoad=true;
            toastr.warning('<span class="toast-description"> Unable to access data mining. Please check your connection, then try again <span>', '<strong class="toast-titles"> Access Server </strong>');
          });
        }
    });


    $scope.$watch('year', function (value) {
        if($scope.flagInit){
          $scope.loadend = true;
          $scope.opacity = ($scope.unopacity)? false : true; 
          $scope.unopacity = false;
          dataService.setDealers($scope.dealer);
          dataService.setMakes($scope.make);
          dataService.setBodys($scope.body);
          dataService.setModels($scope.model);
          dataService.setYears(value);
        }
    });

     function parseDataMainChart(data){
      var list=[];
      angular.forEach(data, function (value, key) {
        list.push({dealer:value[0], make:value[1], 
            body:value[2], model:value[3], quantity:value[4]
        });
      });

      var resultData = groupBy(list, function(item)
      {
        return [item.dealer, item.make, item.body];
      });

      var results=[];
      var Colors = [];
      for(var i = 0; i < resultData.length; i++) {
        var Labels=[]; var Values=[]; var Title; var Total=0; var Id;
        for(var j = 0; j < resultData[i].length; j++) {
          Labels.push(resultData[i][j].model);
          Values.push(resultData[i][j].quantity);
          Total+=resultData[i][j].quantity;
          Title=resultData[i][j].dealer+" - "+resultData[i][j].make+" - "+resultData[i][j].body;
          Id=resultData[i][j].dealer;
        }
        if(resultData[i].length>5){
          var Height=(resultData[i].length*25).toString()+"px";
        }else{
          switch(resultData[i].length){
            case 1:
              var Height="50px"; break;
            case 2:
              var Height="75px"; break;
            case 3:
              var Height="100px"; break;
            case 4:
              var Height="125px"; break;
            case 5:
              var Height="150px"; break;
          }
        }
              
        results.push({labels:Labels, data:[Values], title:Title,  dealer:Id, height:Height, total:Total});
        
        }
        return results;
    }

    $scope.copystock = false;

    $scope.getReverse = function () {
      var data = $scope.datafilter;
      data["onlystock"] = true;
      inventoryService.getDetail($scope.group.name, data).then(function(response){
        var dealer = { stocks : [] };
        var stocks = [];
        var stocksstring = "";
        var count = 0;

        angular.forEach(response.data, function (value, index) {
          if (value){
            stocksstring += value + ",";
            count++;
            stocks.push(value);
          }
        });

      var project = {};
      var dealer = { stocks : [] };
      dealer["name"] = $scope.dealername;
      dealer["id"] = $scope.dealerid;
      dealer["stocks"] = stocks;
      project["alias"] = ($cookies.get("promo_id"))? $cookies.get("alias").replace(/\"/g, '') + "_promoid_" + $cookies.get("promo_id").replace(/\"/g, ''):$cookies.get("alias").replace(/\"/g, '');
      var confmax = ($scope.conf.day_min)?$scope.conf.day_min.toString():"unlimit";
      var confmin = ($scope.conf.day_max)?$scope.conf.day_max.toString():"unlimit";
      var range = (!$scope.conf.day_max && !$scope.conf.day_min)?" No time range ": "Time " + confmin + " to " + confmax 

      project['name'] = dealer.name + " - " + range + " " + $filter("date")(new Date(), 'medium');
      project['temp'] = true; 
      Projects.save(project, function (response) {  
        $state.go('home.export.index', {id:response.id, oportunity: {project: response, dealer:dealer}});
      },function (response) {
          toastr.warning('<span class="toast-description"> Trey with another project name. <span>', '<strong class="toast-titles"> Already exist this export project!</strong>');
      });

      },function (response) {
          toastr.warning('<span class="toast-description"> Unable to access data mining. Please check your connection, then try again <span>', '<strong class="toast-titles"> Access Server </strong>');
      });
    }

    $scope.getDemo = function () {
      var data = $scope.datafilter;
        data["onlystock"] = true;
      inventoryService.getDetail($scope.group.name, data).then(function(response){
        var dealer = { stocks : [] };
        var stocks = [];
        var stocksstring = "";
        var count = 0;

        angular.forEach(response.data, function (value, index) {
          if (value){
            stocksstring += value + ",";
            count++;
            stocks.push(value);
          }
        });

        dealer["name"] = $scope.dealername;
        dealer["id"] = $scope.dealerid;
        dealer["stocks"] = stocks;
       $state.go('home.demos', {id:null, oportunity: {project: null, dealer:dealer}});
      },function (response) {
          toastr.warning('<span class="toast-description"> Unable to access data mining. Please check your connection, then try again <span>', '<strong class="toast-titles"> Access Server </strong>');
      });
    
    }

    
    $scope.copyStocks = function($event){
        console.log($scope.datafilter); 
        var data = $scope.datafilter;
        console.log(data);
        data["onlystock"] = true;
        inventoryService.getDetail($scope.group.name, data).then(function(response){
            var stocksstring = "";
            var count = 0;
            angular.forEach(response.data, function (value, index) {
              if (value){
                stocksstring += value + ",";
                count++;
              }
            });
            var textArea = document.createElement("textarea");
            textArea.value = stocksstring.replace(/,\s*$/, "");
            document.body.appendChild(textArea);
            textArea.select();
            textArea.setSelectionRange(0, 99999); 
            document.execCommand("Copy");
            textArea.remove();

            $scope.copystockmsg =  count.toString() + " stocks copied!"
            $scope.copystock = true;
            $timeout(function() {
              $scope.copystock = false;
              $scope.copystockmsg = "";
            }, 750);

          if(!$scope.items.length){
            toastr.info('<span class="toast-description">  Unable to access to these autos now, try later or contact to with support <span>', '<strong class="toast-titles"> Sync Process </strong>');
          }
        },function (response) {
          toastr.warning('<span class="toast-description"> Unable to access data mining. Please check your connection, then try again <span>', '<strong class="toast-titles"> Access Server </strong>');
        });
    }

    $scope.getReport = function() {

      if ($scope.report == "normal" && dataService.invalid()){
        toastr.info('<span class="toast-description"> Please select at least 1 options, then try again <span>', '<strong class="toast-titles"> Invalid form </strong>');
        return;
      }
      
      $scope.opacity = false;     
      $scope.unopacity = false;   
      var deferred = $q.defer();
      var data={};
      $scope.items = [];
      $scope.page = null;
      $scope.info;
      $scope.best_results = []; $scope.stock_results = []; $scope.fullresults = []; 
      $scope.max_results = []; $scope.inv_results = []; $scope.amount_results = [];
      $scope.data = []; $scope.series = []; $scope.labels = [];
      
      $scope.benchfound = "";
      
      if (!$scope.loadend){
        $scope.unopacity = true;
      }

      data["section_id[]"] = dataService.getDealers();
      data["make[]"] = dataService.getMakes();
      data["body_style[]"] = dataService.getBodys();
      data["model[]"]=dataService.getModels();
      data["year[]"] = dataService.getYears();
      data["type_name[]"] = dataService.getTypes();
      data["certified_preowned[]"] = dataService.getCertified();
      data["public[]"] = 1;

      switch($scope.report){
        case "normal":
          $scope.rtitle="- Inventory Comparison";
          data["path"] = "reports/normal";
          inventoryService.getReport($scope.group.name, data).then(function(response){

        try{
          var list = [];
          var inyear = false;
          angular.forEach(response.data.resultset, function (value, key) {
              inyear = (value.hasOwnProperty("year"))?true:false;
              if (inyear){
                list.push({dealer:value.section_name, dealer_id:value.section_id, make:value.make, 
                    body:value.body_style, year:value.year, model:value.model, active:value.active, quantity:value.total, avg_price:Math.round(value.avg_price)
                });
              }else{
                list.push({dealer:value.section_name, dealer_id:value.section_id, make:value.make, 
                    body:value.body_style, model:value.model, active:value.active, quantity:value.total, avg_price: Math.round(value.avg_price)
                });
              }
          });

          var resultData = groupBy(list, function(item)
          {
            var group = (inyear) ? [item.dealer, item.dealer_id,  item.make, item.body, item.year] : [item.dealer, item.dealer_id, item.make, item.body];
            return group;
          });

          var inventory=[];
          // Vehicles 
          $scope.series = ['Current Inventory', 'Sold Last 30 Days'];
          $scope.colors = ['#065cbe', "#55bef2"];          
            for(var i = 0; i < resultData.length; i++) {
              var Labels=[]; var Values=[]; var Title; var Total=0; var Sales=0; var Id; var ValuesSales = []; var Name; var year = undefined;
              var finalData = [];

              for(var j = 0; j < resultData[i].length; j++) {
                var index = finalData.findIndex(function(item) {return item.model == resultData[i][j].model; });
                if (index>=0){
                  if (finalData[index].active){
                    finalData[index]["sales"] = resultData[i][j].quantity;
                  }else{
                    finalData[index]["quantity"] = resultData[i][j].quantity;
                  }
                }else{
                  var obj = {};
                  if (resultData[i][j].active){
                    obj = resultData[i][j];
                    obj["sales"] = 0;
                    finalData.push(obj);
                  }else{
                    obj = resultData[i][j];
                    obj["sales"] = obj.quantity;
                    obj["quantity"] = 0;
                    finalData.push(obj);
                  }
                }
              }

              for(var j = 0; j < finalData.length; j++) {
                Labels.push(finalData[j].model + "|" + finalData[j].avg_price);
                Values.push(finalData[j].quantity);
                ValuesSales.push(finalData[j].sales);
                Total += finalData[j].quantity;
                Sales += finalData[j].sales;
                var titleyear = (finalData[j].year)? "Year " + finalData[j].year.toString() : "All years";
                year = (finalData[j].year) ? finalData[j].year : year;
                Title = finalData[j].dealer + " - "+finalData[j].make+" - "+finalData[j].body + " - " + titleyear;
                Name = finalData[j].dealer;
                Id = finalData[j].dealer_id;
              }

              console.log("screen", chart_cnf[screen].bars_size);


              if(finalData.length > 5){
                var Height = (resultData[i].length * 60).toString() + "px";
                console.log("screen", screen);
              }else{
                switch(finalData.length){
                  case 1:
                    var Height = 150 - chart_cnf[screen].bars_size;
                    break;
                  case 2:
                    var Height = 250 - chart_cnf[screen].bars_size; 
                    break;
                  case 3:
                    var Height = 350 - chart_cnf[screen].bars_size; 
                    break;
                  case 4:
                    var Height = 500 - chart_cnf[screen].bars_size; 
                    break;
                  case 5:
                    var Height = 600 - chart_cnf[screen].bars_size; 
                    break;
                }
                Height = Height.toString() + "px"
                
              }
              inventory.push({labels:Labels, data:[Values, ValuesSales], title:Title, dealer_id:Id, dealer:Name, year: year, height:Height, total:Total, sales:Sales});
            
            }
            $scope.inv_results = inventory;
            $anchorScroll();
            $location.hash('results');
            for (var i = 0; i < $scope.inv_results.length; i++) {
              $scope.fullresults.push($scope.inv_results[i])
            }
              deferred.resolve(response);
            }catch(err){
                console.log(err);
                deferred.resolve();
            }
              }, function (response) {
              deferred.resolve();
              toastr.warning('<span class="toast-description"> Unable to access data mining. Please check your connection, then try again <span>', '<strong class="toast-titles"> Access Server </strong>');
            });

          break;
        case "max":
          $scope.rtitle = "- Max Quantity";
          data["path"] = "reports/maxlot";

          inventoryService.getReport($scope.group.name, data).then(function(response){ 

            try{

            $scope.max_results = response.data.resultset;
            var labels=[]; var values=[];
            if($scope.max_results.length>5){
              var height=($scope.max_results.length*40).toString()+"px";
            }else{
              switch($scope.max_results.length){
                case 1:
                  var height="80px"; break;
                case 2:
                  var height="120px"; break;
                case 3:
                  var height="160px"; break;
                case 4:
                  var height="200px"; break;
                case 5:
                  var height="250px"; break;
              }
            }
            // $scope.colors = [ '#803690', '#00ADF9', '#DCDCDC', '#46BFBD', '#FDB45C', '#949FB1', '#4D5360'];
            $scope.colors = ["#065cbe"];
            for (var i = $scope.max_results.length - 1; i >= 0; i--) {
              labels.push($scope.max_results[i]["section_id"]);
              values.push($scope.max_results[i]["total"]);
            }
            $(".chartjs-canvas-holder-third-row").css("height", height);
            $scope.labels = labels;
            $scope.data = [values];
            $scope.series = ['Cars'];
            $location.hash('results');
            $anchorScroll();
            deferred.resolve(response);
              
              }catch(err){
                console.log(err);
                deferred.resolve();
            }
          }, function (response) {
            toastr.warning('<span class="toast-description"> Unable to access data mining. Please check your connection, then try again <span>', '<strong class="toast-titles"> Access Server </strong>');
            deferred.resolve();
          });
          break;
        case "best":
          $scope.rtitle="- Best Prices";
          data["path"]="reports/bestsprices";
          inventoryService.getReport($scope.group.name, data).then(function(response){ 
            try{
              $scope.best_results = response.data.resultset;
              $location.hash('results');
              $anchorScroll();
              deferred.resolve(response);
            }catch(err){
                deferred.resolve();
                console.log(err);
            }
          }, function (response) {
            toastr.warning('<span class="toast-description"> Unable to access data mining. Please check your connection, then try again <span>', '<strong class="toast-titles"> Access Server </strong>');
            deferred.resolve();
          });
          break;
        case "stock":
          $scope.rtitle = "- Stock Time";
          data["path"] = "reports/stocktimes";

          if ($scope.conf.day_min ){
            data["day_min"] = $scope.conf.day_min;
          }

          if ($scope.conf.day_max){
            data["day_max"] = ($scope.conf.day_max);
          }
          
          inventoryService.getReport($scope.group.name, data).then(function(response){ 
            try{
              $scope.colors = [ '#065cbe'];
              $scope.stock_results = response.data.resultset;
              var labels = []; var values = [];

              if( $scope.stock_results.length > 5 ){
                var height=($scope.stock_results.length*60).toString()+"px";
              }else{
                switch($scope.stock_results.length){
                  case 1:
                    var height="80px"; break;
                  case 2:
                    var height="140px"; break;
                  case 3:
                    var height="210px"; break;
                  case 4:
                    var height="300px"; break;
                  case 5:
                    var height="380px"; break;
                }
              }

              angular.forEach($scope.stock_results, function (value, key) {
                  labels.push(value.section_id);
                  values.push(value.quantity);
              });

              $(".chartjs-canvas-holder-third-row").css("height", height);
              $scope.labels =labels;
              $scope.data = [values];
              $scope.series = ['Cars'];
              $location.hash('results');
              $anchorScroll();
              deferred.resolve(response);
            }catch(err){
                deferred.resolve();
                console.log(err);
            }
          }, function (response) {
            toastr.warning('<span class="toast-description"> Unable to access data mining. Please check your connection, then try again <span>', '<strong class="toast-titles"> Access Server </strong>');
            deferred.resolve();
          });
          break;
      }

      return deferred.promise;
    };

     if ($stateParams.dealer){
      var dealer = $stateParams.dealer;
      $scope.dealers.push({value: "[section_name].[" + dealer + "]", text: dealer});
      $scope.adealer = "[section_name].[" + dealer + "]";

      if( $stateParams.dimension == "model"){
        $scope.dimension = "model";
      }else{
        $scope.dimension = "body_style";
      }
      // dataService.setDealers(dealer.name);
      $scope.loadDealers = true;
      $scope.getReport();
      // return;
    }

    $scope.goBack = function () {
      $scope.items=[];
      $scope.page=null;
      $scope.loading=false;
      $scope.info;
      inventoryService.cancel();
    }

    $scope.selectRow = function (info, id) {
      $scope.info = name;
      if($scope.opacity){
        return;
      }
      var data=[];
      data["page"] = $scope.page;
      $scope.loading = true;
      data["section_id[]"] = id;      
      data["make[]"] = dataService.getBuildParams($scope.makes, $scope.make);
      data["model[]"] = dataService.getBuildParams($scope.models, $scope.model);
      data["year[]"] = dataService.getBuildParams($scope.years, $scope.year);
      data["body_style[]"] = dataService.getBuildParams($scope.bodys, $scope.body);
      data["certified_preowned[]"] = dataService.getCertified().normal;
      data["type_name[]"]=dataService.getTypes().normal;
      $scope.datafilter = data;
      inventoryService.getDetail($scope.group.name, data).then(function(response){
        $scope.loading=false;
        $scope.items_quantity = response.data.count; 
        
        angular.forEach(response.data.results, function(value, key){
          $scope.items.push(value);
        });

        titleCompose(info, "DEALER");

        if (response.data.next){
          $scope.page = ($scope.page)?$scope.page:1;
          $scope.page++; 
        }else{
          $scope.page=null; 
        }
        $scope.loading=false;
        if(!$scope.items.length){
          toastr.info('<span class="toast-description">  Unable to access to these autos now, try later or contact to with support <span>', '<strong class="toast-titles"> Sync Process </strong>');
        }
      },function (response) {
        toastr.warning('<span class="toast-description"> Unable to access data mining. Please check your connection, then try again <span>', '<strong class="toast-titles"> Access Server </strong>');
      });
    }

    $scope.selectBar = function (info, event) {
      
      $scope.info = info;

      if($scope.opacity){
        return;
      }
      var data=[];
      data["page"] = $scope.page;
      $scope.loading=true;
      if(typeof(info) != "undefined"){ 
        if(!info.length){ 
          return;
        }
      }else{
        return;
      }

      var title, year, dealer_id = undefined;
      var active = 1;
      angular.forEach(info[0]._chart.canvas.attributes, function (value, key) {
        if(value.nodeName == "data-dealer"){
          title = value.nodeValue;
        }

        if(value.nodeName == "data-dealer-id"){
          dealer_id = value.nodeValue;
        }

        if(value.nodeName == "data-active"){
          active = value.nodeValue;
        }
        
        if(value.nodeName == "data-year"){
          year = value.nodeValue;
        }
      });
      
      switch($scope.report){
        case "normal":
          $scope.rtitle = "- Inventory - List";
            if(event){
              var pos = Chart.helpers.getRelativePosition(event,this.chart.chart);
               var intersect = info.find(function(element) {
                return element.inRange(pos.x, pos.y);
              });
              
              if (intersect._datasetIndex){
                data["active"] = 0;
                $scope.showUpdate = true;
              }else{
                data["active"] = 1;
                $scope.showUpdate = false;
              }

              $scope.info = [info[intersect._datasetIndex]];
            }
            
            var sections = title;
            
            if (sections == "All section_names"){
              data["section_id[]"] = dataService.getBuildParams($scope.dealers, $scope.dealer);
            }else{
              data["section_id[]"] = dealer_id;
            }

            if (year){
              data["year"] = year;
            }
            console.log(data)
            data["body_style"] = dataService.getBuildParams($scope.bodys, $scope.body);
            data["model"] = info[0]._model.label;
            var mod = info[0]._model.label.split("|")[0];
            data["model"] = mod;
            data["public"] = dataService.getPub();
            data["type_name[]"] = dataService.getTypes().normal;
            data["certified_preowned[]"]=dataService.getCertified().normal;
            console.log(mod);
            titleCompose(mod, "MODEL");
            $scope.datafilter = data;

            inventoryService.getDetail($scope.group.name, data).then(function(response){              
              $scope.items_quantity = response.data.count; 
              angular.forEach(response.data.results, function(value, key){
                $scope.items.push(value);
              });

              if (response.data.next){
                $scope.page = ($scope.page)?$scope.page:1;
                $scope.page++; 
              }else{
                $scope.page=null; 
              }
              $scope.loading=false;

              if(!$scope.items.length){
                // toastr.info('<span class="toast-description">  Unable to access to these autos now, try later or contact to with support <span>', '<strong class="toast-titles"> Sync Process </strong>');
              }
            },function (response) {
              // toastr.warning('<span class="toast-description"> Unable to access data mining. Please check your connection, then try again <span>', '<strong class="toast-titles"> Access Server </strong>');
            });           
          break;
        case "max":
          $scope.rtitle="- Max Quantity - List";
          data["section_id[]"] = info[0]._model.label;
          var element = $scope.max_results.find( function(item) { return item.section_id == info[0]._model.label; } );
          data["make[]"] = dataService.getBuildParams($scope.makes, $scope.make);
          data["body_style[]"] = dataService.getBuildParams($scope.bodys, $scope.body);
          data["model[]"] = dataService.getBuildParams($scope.models, $scope.model);
          data["year[]"] = dataService.getBuildParams($scope.years, $scope.year);
          data["certified_preowned[]"] = dataService.getCertified().normal;
          data["public"] = dataService.getPub();
          data["type_name[]"] = dataService.getTypes().normal;
          titleCompose(element.section_name, "DEALER");
          $scope.datafilter = data;
          inventoryService.getDetail($scope.group.name, data).then(function(response){
              $scope.items_quantity = response.data.count; 
            
            angular.forEach(response.data.results, function(value, key){
              $scope.items.push(value);
            });

            if (response.data.next){
              $scope.page = ($scope.page)?$scope.page:1;
              $scope.page++; 
            }else{
              $scope.page=null; 
            }
            $scope.loading=false;

            if(!$scope.items.length){
              toastr.info('<span class="toast-description">  Unable to access to these autos now, try later or contact to with support <span>', '<strong class="toast-titles"> Sync Process </strong>');
            }
          },function (response) {
            toastr.warning('<span class="toast-description"> Unable to access data mining. Please check your connection, then try again <span>', '<strong class="toast-titles"> Access Server </strong>');
          });
          break;
        case "stock":

          $scope.rtitle="- Stock Time - List";
          var element = $scope.stock_results.find( function(item) { return item.section_id == info[0]._model.label; } );
          data["section_id[]"] = info[0]._model.label;
          data["make[]"] = dataService.getBuildParams($scope.makes, $scope.make);
          data["model[]"] = dataService.getBuildParams($scope.models, $scope.model);
          data["year[]"] = dataService.getBuildParams($scope.years, $scope.year);
          data["body_style[]"] = dataService.getBuildParams($scope.bodys, $scope.body);
          data["public"] = dataService.getPub();
          data["certified_preowned[]"] = dataService.getCertified();
          data["type_name[]"] = dataService.getTypes();

          if ($scope.conf.day_min ){
            data["day_min"] = $scope.conf.day_min;
          }

          if ($scope.conf.day_max){
            data["day_max"] = ($scope.conf.day_max);
          }

          $scope.datafilter = data;
          titleCompose(element.section_name, "DEALER");
          $scope.dealername = element.section_name;
          inventoryService.getDetail($scope.group.name, data).then(function(response){
            
            $scope.items_quantity = response.data.count; 
            angular.forEach(response.data.results, function(value, key){
              $scope.items.push(value);
              $scope.dealerid = value.section_id;
            });

            if (response.data.next){
              $scope.page = ($scope.page)?$scope.page:1;
              $scope.page++; 
            }else{
              $scope.page=null; 
            }
            $scope.loading=false;

            if(!$scope.items.length){
              toastr.info('<span class="toast-description">  Unable to access to these autos now, try later or contact to with support <span>', '<strong class="toast-titles"> Sync Process </strong>');
            }
          },function (response) {
            toastr.warning('<span class="toast-description"> Unable to access data mining. Please check your connection, then try again <span>', '<strong class="toast-titles"> Access Server </strong>');
          });
          break;
      }
    };

    $scope.loadMore = function () {
      if($scope.page && !$scope.loading){
        if($scope.report!="best"){
          $scope.selectBar($scope.info);
        }else{
          $scope.selectRow($scope.info);
        }
      }


      if($(window).scrollTop() + $(window).height() == $(document).height()) {
        if (!$scope.items.length && $scope.fullresults.length){
          $scope.limitChart += 5; 
        }  
      }

    }

    $scope.limitChart = 5;
    dataService.initialize();
     // var dateParam=dataService.getDates();
    $scope.initialize();
  }
})();


(function () {
  'use strict';


  angular.module('BlurAdmin.pages.inventory')
      .service('metricsServices', metricsServices);
  /** @ngInject */
   function metricsServices($resource, API) {
    return $resource(API[API.ENV]+"api/v1/inventories/metrics", {}, {save: {
                method: 'POST'
            }});
   }

  angular.module('BlurAdmin.pages.inventory')
      .service('inventoryService', inventoryService);

  /** @ngInject */
  function inventoryService($http, $q, API) {
  		var data = {};
      var canceler=[];

      function requestGet(group, data){
        var can=$q.defer();
        canceler.push(can);
        return $http.get(API[API.ENV]+"api/v1/"+data['path'],
        {
          params: data,
          timeout: can.promise,
          headers: {
            'Authorization': $http.defaults.headers.common.Authorization,
        }
        }).then(
         function(response) {
          return response;
        }, function (response) {
            return response;
        });
      } 

      function requestPost(group, data){
        var can=$q.defer();
        canceler.push(can);

      var settings = {
          timeout: can.promise,
			    headers: {
            'Authorization': $http.defaults.headers.common.Authorization,
            'Content-Type': 'application/x-www-form-urlencoded'
          },
          transformRequest: function(obj) {
              var str = [];
              for(var p in obj){
                if (p=="page"){
                  continue;
                }

                if (typeof(obj[p])=="undefined"){
                  continue;
                }

                if(typeof(obj[p])=="object"){
                  for(var i=0; i<obj[p].length; i++)
                    str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p][i]));
                }else{
                    str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
                }
              }
              return str.join("&");
          }
	    	};
        
        if (data['path']== "inventories/saleshistory"){
          settings["ignoreLoadingBar"] = true;
        }

        if (data['path']== "inventories/analysis"){
          settings["ignoreLoadingBar"] = true;
        }

  			return $http.post(API[API.ENV]+"api/v1/"+data['path'], data, settings
        ).then(
		     function(response) {
		    	return response;
		    }, function (response) {
		        return response;
		    });
  		} 

        return {
            setTypes: function (value) {
                
            },
            getTypes: function (group, params) {
               params["path"]="filters/info/types";
               params["active"]=1;
               return requestPost(group, params); 
            },
            setDealers: function (value) {
                  
            },
            getDealers: function (group, params) {
               params["path"]="filters/info/sections";
               params["active"]=1;
              return requestPost(group, params); 
            },
            setMakes: function (value) {
                
            },
            getMakes: function (group, params) {
               params["path"]="filters/info/makes";
               params["active"]=1;
              return requestPost(group, params); 
            },
            getBodys: function (group, params) {
               params["path"]="filters/info/bodys";
               params["active"]=1;
              return requestPost(group, params); 
            },
            setModels: function (value) {
                
            },
            getModels: function (group, params) {
               params["path"]="filters/info/models";
               params["active"]=1;
                return requestPost(group, params); 
            },
            setYears: function (value) {
                
            },
            getYears: function (group, params) {
                params["path"]="filters/info/years";
                params["active"]=1;
                return requestPost(group, params); 
            },
            getReport: function (group, params) {
                params["path"]="inventories/"+params["path"];
                return requestPost(group, params); 
            },
            getDetail: function (group, params) {
                
                if (!params.hasOwnProperty("active")){
                  params["active"]=1;
                }

                params["path"]="filters/info/details";
                if (params.hasOwnProperty("page")){
                  if(params['page']){
                    params["path"]="filters/info/details?page="+params['page'];
                  }
                }
                
                return requestPost(group, params); 
            },
            cancel: function () {
              angular.forEach(canceler, function(c) {
                c.resolve();
              });
            }
        };
  }

})();

(function () {
  'use strict';

  angular.module('BlurAdmin.pages.inventory')
      .controller('MetricsCtrl', MetricsCtrl);

  /** @ngInject */
  function MetricsCtrl($scope,  $rootScope, $cookies, metricsServices, Projects, $q, $state, $filter, layoutPaths, $location, $window, $anchorScroll, baConfig, colorHelper, $timeout, inventoryService, dataService, salesService, themeLayoutSettings, AuthService, toastr, toastrConfig) {


    metricsServices.save({}, function (response) {

      // angular.forEach(response, function (value, index) {
        
      //   angular.forEach(response, function (value, index) {
          
      //   });

      // });

      $scope.results = response;
    });

    
   
  }
})();


(function () {
    'use strict';
  
    angular.module('BlurAdmin.pages.maintenance', [])
        .config(routeConfig);
  
    /** @ngInject */
    function routeConfig($stateProvider) {
      $stateProvider
          .state('maintenance', {
            url: '/maintenance',
            templateUrl: 'app/pages/maintenance/index.html',
            // controller: 'AuthCtrl',
            data: {
                access: '*',
                title: ' '
            }
          });
    }
})();
  
/**
 * @author a.demeshko
 * created on 21.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.profile')
    .controller('ProfileModalCtrl', ProfileModalCtrl);

  /** @ngInject */
  function ProfileModalCtrl($scope, $uibModalInstance) {
    $scope.link = '';
    $scope.ok = function () {
      $uibModalInstance.close($scope.link);
    };
  }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.profile')
    .controller('ProfilePageCtrl', ProfilePageCtrl);

  /** @ngInject */
  function ProfilePageCtrl($scope, $rootScope, fileReader, $filter, $uibModal, $cookies) {
    $scope.picture = $filter('profilePicture')('no-photo');
    $rootScope.app_name = ($cookies.get('app_name'))?$cookies.get('app_name').replace(/\"/g, ''):"Smart Reports";
    $scope.removePicture = function () {
      $scope.picture = $filter('appImage')('theme/no-photo.png');
      $scope.noPicture = true;
    };

    $scope.uploadPicture = function () {
      var fileInput = document.getElementById('uploadFile');
      fileInput.click();

    };

    $scope.socialProfiles = [
      {
        name: 'Facebook',
        href: 'https://www.facebook.com/akveo/',
        icon: 'socicon-facebook'
      },
      {
        name: 'Twitter',
        href: 'https://twitter.com/akveo_inc',
        icon: 'socicon-twitter'
      },
      {
        name: 'Google',
        icon: 'socicon-google'
      },
      {
        name: 'LinkedIn',
        href: 'https://www.linkedin.com/company/akveo',
        icon: 'socicon-linkedin'
      },
      {
        name: 'GitHub',
        href: 'https://github.com/akveo',
        icon: 'socicon-github'
      },
      {
        name: 'StackOverflow',
        icon: 'socicon-stackoverflow'
      },
      {
        name: 'Dribbble',
        icon: 'socicon-dribble'
      },
      {
        name: 'Behance',
        icon: 'socicon-behace'
      }
    ];

    $scope.unconnect = function (item) {
      item.href = undefined;
    };

    $scope.showModal = function (item) {
      $uibModal.open({
        animation: false,
        controller: 'ProfileModalCtrl',
        templateUrl: 'app/pages/profile/profileModal.html'
      }).result.then(function (link) {
          item.href = link;
        });
    };

    $scope.getFile = function () {
      fileReader.readAsDataUrl($scope.file, $scope)
          .then(function (result) {
            $scope.picture = result;
          });
    };

    $scope.switches = [true, true, false, true, true, false];
  }

})();


(function () {
  'use strict';

  angular.module('BlurAdmin.pages.sales', ['ui.select', 'ngSanitize'])
      .config(routeConfig).config(chartJsConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('home.sales', {
          url: '/sales',
          templateUrl: 'app/pages/sales/sales.html',
          title: 'Sales',
          controller: 'SalesCtrl',
          data: {
              access: 'logged',
              title: ' '
          },
          resolve:{
            isGroup: function($rootScope, $state, $q, $timeout,AuthService) {
              var group=AuthService.user.groups[0];
              if($rootScope.domain==""){
                try{
                  $timeout(function() { $state.go("home.dashboard"); });
                  return $q.reject("rejection message");
                }catch(err){
                  console.log(err);
                }
              }
            }
          },
          onExit: function(salesService){
            salesService.cancel();
          },
          sidebarMeta: {
            icon: 'ion-cash',
            order: 0,
          },
        });
  }

  function chartJsConfig(ChartJsProvider, baConfigProvider) {

        var layoutColors = baConfigProvider.colors;

        function cut(value, wordwise, max, tail) {
            if (!value) return '';

            max = parseInt(max, 10);
            if (!max) return value;
            if (value.length <= max) return value;

            value = value.substr(0, max);
            if (wordwise) {
                var lastspace = value.lastIndexOf(' ');
                if (lastspace !== -1) {
                  //Also remove . and , so its gives a cleaner result.
                  if (value.charAt(lastspace-1) === '.' || value.charAt(lastspace-1) === ',') {
                    lastspace = lastspace - 1;
                  }
                  value = value.substr(0, lastspace);
                }
            }

            return value + (tail || ' …');
        };

        var isMobile = (/android|webos|iphone|ipad|ipod|blackberry|windows phone/).test(navigator.userAgent.toLowerCase());

        // Configure all charts
        ChartJsProvider.setOptions({
          layout: {
            padding: {
                left: 20,
                right: 40,
                top: 0,
                bottom: 0
            }
          },
           elements: { 
              arc: { 
                borderWidth: 0 
              }
            }, 
            chartColors: [
                layoutColors.primary, layoutColors.danger, layoutColors.warning, layoutColors.success, layoutColors.info, layoutColors.default, layoutColors.primaryDark, layoutColors.successDark, layoutColors.warningLight, layoutColors.successLight, layoutColors.primaryLight],
            responsive: true,
            maintainAspectRatio: false,
            animation: {
                duration: 500
            },
            scale: {
                gridLines: {
                    color: layoutColors.border
                },
                scaleLabel: {
                    fontColor: layoutColors.defaultText
                },
                ticks: {
                    fontColor: layoutColors.defaultText,
                    showLabelBackdrop: false
                }
            }
        });
        // Configure all line charts
        // ChartJsProvider.setOptions('line', );
        // Configure all radar charts
        ChartJsProvider.setOptions('radar', {
            scale: {
                pointLabels: {
                    fontColor: layoutColors.defaultText
                },
                ticks: {
                    maxTicksLimit: 5,
                    display: false
                }
            }
        });

        // Configure all bar charts
        ChartJsProvider.setOptions('horizontalBar', {
           elements: { 
              arc: { 
                borderWidth: 0 
              }
            }, 
            scales: {
              yAxes: [{
                ticks: {
                  fontSize: 15,
                  beginAtZero: true,
                  callback: function(value) {
                    if(isMobile){
                       return cut(value,true, 25,"...");
                    }else{
                      return value;
                    }
                  }
                }
              }],
              xAxes: [{
                ticks: {
                  fontSize: 15,
                  beginAtZero: true
                },
                afterTickToLabelConversion : function(q){
                    q.ticks = q.ticks.map(function(tick){  return parseFloat(tick) % 1 === 0 ? parseInt(tick) : "" });
                }
              }]
            },
            tooltips: {
              mode: 'label',
              labels:{
                fontSize: 15
              },
              enabled: true,
               callbacks: {
                 title: function(tooltipItem){
                      // `tooltipItem` is an object containing properties such as
                      // the dataset and the index of the current item
                      // Here, `this` is the char instance
                      // The following returns the full string
                      return this._data.labels[tooltipItem[0].index];
                  }
                }
            },
            hover: { animationDuration: 0 },
            animation: {
                duration: 500, 
                onComplete: function () { 
                    var ctx = this.chart.ctx;
                    ctx.font = Chart.helpers.fontString(15, 'bold', "Rubik");
                    ctx.fillStyle = "#000";
                    ctx.textAlign = 'center';
                    ctx.textBaseline = 'bottom';
                     // console.log(this.chart.config.options.defaultFontColor);
                    this.data.datasets.forEach(function (dataset) {
                      for (var i = 0; i < dataset.data.length; i++) {
                        if(dataset.hidden === true && dataset._meta[Object.keys(dataset._meta)[0]].hidden !== false){ continue; }
                        var model = dataset._meta[Object.keys(dataset._meta)[0]].data[i]._model;
                        if(dataset.data[i] !== null){
                          if(dataset.data[i]>0){
                              var npos = dataset.data[i].toString().length * 7;
                              ctx.fillText(dataset.data[i], model.x + npos, model.y + 7);
                          }
                        }
                      }
                    });
                }
            }
        });
    }


})();


(function () {
  'use strict';

  angular.module('BlurAdmin.pages.sales')
      .controller('SalesCtrl', SalesCtrl);

  /** @ngInject */
  function SalesCtrl($scope, $rootScope, $q, $filter, layoutPaths, $anchorScroll, baConfig, $location, $window, colorHelper, $timeout, salesService, dataService, themeLayoutSettings, AuthService, cfpLoadingBar, toastr, toastrConfig) {

    $scope.group=AuthService.user.groups[0];
    $rootScope.userinfo=AuthService.user;
    dataService.initialize();

    $scope.datasetOverride = [
      {
        fill: true,
        backgroundColor: "#065cbe"
      },
      {
        fill: true,
        backgroundColor:  "#55bef2"
      }];

      function getScreenSize() {
        var sm = window.matchMedia("(min-width: 320px) and (max-width: 480px)");
        var md = window.matchMedia("(min-width: 481px) and (max-width: 768px)");
        var lg = window.matchMedia("(min-width: 769px) and (max-width: 1024px)");
        var xl = window.matchMedia("(min-width: 1025px)");
      
        if (sm.matches) {
          return 'sm';
        } else if (md.matches) {
          return 'md';
        } else if (lg.matches) {
          return 'lg';
        } else if (xl.matches) {
          return 'xl';
        } else {
          return 'unknown';
        }
      }
  
      var screen = getScreenSize();
      var chart_cnf = {"sm" : {yaxes_font_size : 10, legend_font_size: 9, bars_size: 250, ellipsis: 15},  
                      "md" : {yaxes_font_size : 10, legend_font_size: 10, bars_size: 100, ellipsis: 20},
                      "lg" : {yaxes_font_size : 15, legend_font_size: 10, bars_size: 1, ellipsis: 50},
                      "xl" : {yaxes_font_size : 15, legend_font_size: 10, bars_size: 1}, ellipsis: 50};
  
      function truncateString(str, maxLength) {
        if (str.length > maxLength) {
          return str.slice(0, maxLength) + "...";
        } else {
          return str;
        }
      }

    $scope.optionsLine = {
            devicePixelRatio: 1,
            responsive:true,
            // maintainAspectRatio: true,
            animation: {
                duration: 500
            },
            tooltips: {
              mode: 'label',
              bodySpacing: 10,
              cornerRadius: 0,
              titleMarginBottom: 15,
              callbacks: {
                 label: function(tooltipItem, data) {
                      var value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].toString();
                      value = value.split(/(?=(?:...)*$)/);
                      value = value.join('.');
                      return '$' + value;
                  }
              }
            },
            scales: {
              xAxes: [{
                ticks: {
                  userCallback: function(value, index, values) {
                      return $filter("date")(value, 'mediumDate');
                    }
                }
              }],
              yAxes: [{
                ticks: {
                  userCallback: function(value, index, values) {
                      value = value.toString();
                      value = value.split(/(?=(?:...)*$)/);
                      value = value.join('.');
                      return '$' + value;
                    }
                }
              }]
            }
        };

    $scope.optionsBar={
      responsive:true,
      animation: {
          duration: 2000, 
          onComplete: function () { 
              var ctx = this.chart.ctx;
              ctx.font = Chart.helpers.fontString(Chart.defaults.global.defaultFontSize, 'normal', Chart.defaults.global.defaultFontFamily);
              ctx.fillStyle = this.chart.config.options.defaultFontColor;
              ctx.textAlign = 'center';
              ctx.textBaseline = 'bottom';
              this.data.datasets.forEach(function (dataset) {
                for (var i = 0; i < dataset.data.length; i++) {
                  if(dataset.hidden === true && dataset._meta[Object.keys(dataset._meta)[0]].hidden !== false){ continue; }
                  var model = dataset._meta[Object.keys(dataset._meta)[0]].data[i]._model;
                  if(dataset.data[i] !== null){
                    var value = dataset.data[i].toString();
                    value = value.split(/(?=(?:...)*$)/);
                    value = "$"+value.join('.');
                    ctx.fillText(value, model.x + 38, model.y + 7);
                  }
                }
              });
          }
      },
      tooltips: {
      mode: 'label',
      enabled: true,
       callbacks: {
          label: function(tooltipItem, data) {
              var value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].toString();
              value = value.split(/(?=(?:...)*$)/);
              value = value.join('.');
              return '$' + value;
          }
        }
    }
    };

    $scope.barsalesOptions = {
      scales: {
        xAxes: [{
          ticks: {
            userCallback: function(value, index, values) {
                return value;
              }
          }
        }],
        yAxes: [{
          ticks: {
            userCallback: function(value, index, values) {
                return truncateString(value, chart_cnf[screen].ellipsis);
              }
          }
        }]
      }
    }

    $scope.setDate = function(year, month, day) {
      $scope.dt = new Date(year, month, day);
    };

    function parseDataMainChart(data){
      var list = [];
      var inyear = false;
      angular.forEach(data, function (value, key) {
        inyear = (value.hasOwnProperty("year"))?true:false;
        if (inyear){
          list.push({dealer:value.section_name, dealer_id:value.section_id, make:value.make, 
              body:value.body_style, year:value.year, model:value.model, quantity:value.total
          });
        }else{
          list.push({dealer:value.section_name, dealer_id:value.section_id, make:value.make, 
              body:value.body_style, model:value.model, quantity:value.total
          });
        }
      });

      var resultData = groupBy(list, function(item)
      {
        var group = (inyear) ? [item.dealer, item.dealer_id, item.make, item.body, item.year] : [item.dealer, item.dealer_id, item.make, item.body];
        return group;
      });

      var results=[];
      var Colors = [];
      for(var i = 0; i < resultData.length; i++) {
        var Labels = []; var Values = []; var Title; var Total = 0; var Name; var Id = 0; var year = undefined;
        for(var j = 0; j < resultData[i].length; j++) {
          Labels.push(resultData[i][j].model);
          Values.push(resultData[i][j].quantity);
          Total += resultData[i][j].quantity;
          
          try{
            var titleyear = (resultData[i][j].year)? "Year " + resultData[i][j].year.toString() : "All years";
            year = (resultData[i][j].year) ? resultData[i][j].year : year; 
          }catch(e){
            var titleyear = "All years";
          }

          Title = resultData[i][j].dealer + " - " + resultData[i][j].make + " - " + resultData[i][j].body + " - " + titleyear;
          Name = resultData[i][j].dealer;  
          Id = resultData[i][j].dealer_id;  
        }
        if(resultData[i].length>5){
          var Height = ((resultData[i].length * 60) - chart_cnf[screen].bars_size).toString() + "px";
        }else{
          switch(resultData[i].length){
            case 1:
              var Height = 80 - chart_cnf[screen].bars_size; 
              break;
            case 2:
              var Height = 100 - chart_cnf[screen].bars_size; 
              break;
            case 3:
              var Height = 250 - chart_cnf[screen].bars_size; 
              break;
            case 4:
              var Height = 500 - chart_cnf[screen].bars_size; 
              break;
            case 5:
              var Height = 600 - chart_cnf[screen].bars_size; 
              break;
          }
          Height = Height.toString()+"px";
        }
        results.push({labels:Labels, data:[Values], title:Title, dealer_id:Id, dealer:Name, height:Height, year: year, total:Total});
        
        }
        return results;
    }

    function groupBy( array , f )
    {
      var groups = {};
      array.forEach( function( o )
      {
        var group = JSON.stringify( f(o) );
        groups[group] = groups[group] || [];
        groups[group].push( o );  
      });
      return Object.keys(groups).map( function( group )
      {
        return groups[group]; 
      })
    }

    $scope.configSelect = {
      plugins:['remove_button'],
      persist:true,
      valueField: 'value',
      labelField: 'text',
      onChange: function(value){
        // console.log('onChange', value)
      }
    };

    $scope.completeLoad=false;

    $scope.items=[];
    $scope.dataType=["New", "Used"];
    $scope.certified=[0, 1];
    $scope.report="normal";
    $scope.public="[1]";
    $scope.chartmode="amount";
    $scope.type="all";
    $scope.dealer=[]; $scope.make=[]; $scope.body=[]; $scope.model=[]; // $scope.year=[];
    $scope.dealers=[];  $scope.makes=[]; $scope.models=[]; $scope.bodys=[]; // $scope.years=[];
    $scope.rtitle="";
    $scope.opacity=false;
    $scope.flagInit=false;
    $scope.info;

    $scope.page=undefined;
    $scope.loading=undefined;


    $scope.opened = false;
    $scope.opened2 = false;
    $scope.formats = ['MMMM dd, yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
    $scope.format = $scope.formats[0];

    Date.prototype.formatDate = function() {
      var mm = this.getMonth() + 1; // getMonth() is zero-based
      var dd = this.getDate();

      return [this.getFullYear(),
              "-"+(mm>9 ? '' : '0') + mm,
              "-"+(dd>9 ? '' : '0')  +dd
             ].join('');
    };


    $scope.open = function() {
        $scope.opened = true;
        if($scope.dt2){
          $scope.optionsStart = {
              showWeeks: false,
              maxDate: $scope.dt2
          };
        }else{
          $scope.optionsStart = {
              showWeeks: false,
              maxDate: new Date()
          };
        }
    };
    
    $scope.open2 = function() {
        $scope.opened2 = true;
        if ($scope.dt){
          $scope.optionsEnd = {
              showWeeks: false,
              maxDate: new Date(),
              minDate: $scope.dt
          };
        }else{
          $scope.optionsEnd = {
              showWeeks: false,
              maxDate: new Date(),
              minDate: new Date()
          };
        }
    }
    
    $scope.$watch("dt", function(newValue, oldValue) {
      if($scope.flagInit){
        $scope.completeLoad = false;
        $scope.opacity = true;
        if(newValue){
            if($scope.dt2){
              $scope.completeLoad = false;
              dataService.setDates($scope.dt.formatDate(), $scope.dt2.formatDate());
              $rootScope.$emit('refreshCondition', dataService.getParams("types", true));
              $scope.initialize();
            }
        }
      }

    });

    $scope.$watch("dt2", function(newValue, oldValue) {
      if($scope.flagInit){
        $scope.completeLoad = false;
        $scope.opacity = true;
        if(newValue){
          if($scope.dt){
            $scope.completeLoad = false;
             dataService.setDates($scope.dt.formatDate(), $scope.dt2.formatDate());
            $rootScope.$emit('refreshCondition', dataService.getParams("types", true));
            $scope.initialize();
          }
        }
      }
    });

    $scope.initialize=function(){
      try {
        dataService.setDates($scope.dt.formatDate(), $scope.dt2.formatDate());
        salesService.getDealers($scope.group.name, dataService.getParams("dealers", true)).then(function(response){
            $scope.dealers = response.data.resultset.map(function(x) { return { value: x.section_id,  text: x.section_name};});
            
            salesService.getMakes($scope.group.name, dataService.getParams("makes", true)).then(function(response){
            $scope.makes= response.data.resultset.map(function(x) { return { value: x.make,  text: x.make};});
            
            salesService.getBodys($scope.group.name, dataService.getParams("bodys", true)).then(function(response){
              $scope.bodys = response.data.resultset.map(function(x) { return { value: x.body_style,  text: x.body_style};});
              
              salesService.getModels($scope.group.name, dataService.getParams("models", true)).then(function(response){
                $scope.models = response.data.resultset.map(function(x) { return { value: x.model,  text: x.model};});
                
                salesService.getYears($scope.group.name, dataService.getParams("years", true)).then(function(response){
                  $scope.years = response.data.resultset.map(function(x) { return { value: x.year,  text: x.year};}).reverse();
                  $scope.flagInit = true;
                  $scope.completeLoad = true;
                }, function (response) {
                    $scope.completeLoad = true;
                    toastr.warning('<span class="toast-description"> Unable to access data mining. Please check your connection, then try again <span>', '<strong class="toast-titles"> Access Server </strong>');
                  });
                  
                }, function (response) {
                  $scope.completeLoad=true;
                  toastr.warning('<span class="toast-description"> Unable to access data mining. Please check your connection, then try again <span>', '<strong class="toast-titles"> Access Server </strong>');
                });
                
              }, function (response) {
                $scope.completeLoad=true;
                toastr.warning('<span class="toast-description"> Unable to access data mining. Please check your connection, then try again <span>', '<strong class="toast-titles"> Access Server </strong>');
              });
              
            }, function (response) {
              $scope.completeLoad=true;
              toastr.warning('<span class="toast-description"> Unable to access data mining. Please check your connection, then try again <span>', '<strong class="toast-titles"> Access Server </strong>');
            });
          }, function (response) {
            $scope.completeLoad=true;
            toastr.warning('<span class="toast-description"> Unable to access data mining. Please check your connection, then try again <span>', '<strong class="toast-titles"> Access Server </strong>');
        });
        } catch (error) {
          console.log(error);
        }
      }
      
      $scope.toggleType = function(value) {
        $scope.completeLoad=false;
      $scope.opacity=true;
      $scope.dealer=[]; $scope.make=[]; $scope.body=[]; $scope.model=[];
      switch(value){
        case "all":
          dataService.setTypes(["New", "Used"]);
          dataService.setCertified([0, 1]);
          $scope.dataType = dataService.getTypes();
          $scope.certified = dataService.getCertified();
          $rootScope.$emit('refreshCondition', dataService.getParams("types", true));
          $scope.initialize();
          break;
        case "new":
          dataService.setTypes(["New"]);
          dataService.setCertified([0]);
          $scope.dataType = dataService.getTypes();
          $scope.certified = dataService.getCertified();
          $rootScope.$emit('refreshCondition', dataService.getParams("types", true));    
          $scope.initialize();
          break;
        case "used":
          dataService.setTypes(["Used"]);
          dataService.setCertified([0,1]);
          $scope.dataType = dataService.getTypes();
          $scope.certified = dataService.getCertified();
          $rootScope.$emit('refreshCondition', dataService.getParams("types", true));    
          $scope.initialize();
          break;
        case "certified":
          dataService.setTypes(["Used"]);
          dataService.setCertified([1]);
          $scope.dataType = dataService.getTypes();
          $scope.certified = dataService.getCertified();
          $rootScope.$emit('refreshCondition', dataService.getParams("types", true));    
          $scope.initialize();
          break;
      }
    }

    $scope.togglePublic=function(value){
      $scope.completeLoad=false;
      $scope.opacity=true;
      $scope.dealer=[]; $scope.body=[]; $scope.make=[]; $scope.model=[];

      dataService.setPub(value);
      $scope.dataType=dataService.getTypes();
      $scope.certified=dataService.getCertified();
      var payload = dataService.getParams("types", true);
      payload['public'] = value;
      $rootScope.$emit('refreshCondition', payload);
      $scope.initialize();

    }

    $scope.toggleReport=function(value){
      $scope.opacity = true;
      $scope.report = value;
    }

    var titleCompose = function(name, topic){
      if ($scope.report == "time"){
        $scope.title_details = "CARS FOR " + topic + " SELECTED · <b class='title'>" + $filter("date")(name, 'mediumDate') + "</b>";
      }else{
        $scope.title_details = "CARS FOR " + topic + " SELECTED · <b class='title'>" + name + "</b>";
      }
    
    }

    $scope.toggleMainChart=function(value){
      $scope.chartmode=value;
    }

    $scope.$watch('dealer', function (value) {
        if($scope.flagInit){
            $scope.completeLoad=false;
            $scope.opacity = ($scope.unopacity)? false : true; 
            dataService.setDates($scope.dt.formatDate(), $scope.dt2.formatDate());
            dataService.setDealers(value);
            var paramsMakes=dataService.getParams("makes", true);
            salesService.getMakes($scope.group.name, paramsMakes).then(function(response){
              $scope.makes = response.data.resultset.map(function(x) { return { value: x.make,  text: x.make};});
              $scope.make = dataService.getBuildParams($scope.makes, $scope.make);
              $scope.completeLoad=true;

            }, function (response) {
              $scope.completeLoad=true;
              toastr.warning('<span class="toast-description"> Unable to access data mining. Please check your connection, then try again <span>', '<strong class="toast-titles"> Access Server </strong>');
          });
        }
    });

    $scope.$watch('make', function (value) {
        if($scope.flagInit){
          $scope.completeLoad=false;
          $scope.opacity = ($scope.unopacity)? false : true; 
          dataService.setDates($scope.dt.formatDate(), $scope.dt2.formatDate());
          dataService.setDealers($scope.dealer);
          dataService.setMakes(value);
          var paramsBodys = dataService.getParams("bodys", true);
          salesService.getBodys($scope.group.name, paramsBodys).then(function(response){
            $scope.bodys = response.data.resultset.map(function(x) { return { value: x.body_style,  text: x.body_style};});
            $scope.body = dataService.getBuildParams($scope.bodys, $scope.body);
            $scope.completeLoad=true;
              $scope.completeLoad=true;
            }, function (response) {
              $scope.completeLoad=true;
              toastr.warning('<span class="toast-description"> Unable to access data mining. Please check your connection, then try again <span>', '<strong class="toast-titles"> Access Server </strong>');
          });
        }
    });

    $scope.$watch('body', function (value) {
        if($scope.flagInit){
          $scope.completeLoad=false;
          $scope.opacity = ($scope.unopacity)? false : true; 
          dataService.setDates($scope.dt.formatDate(), $scope.dt2.formatDate());
          dataService.setDealers($scope.dealer);
          dataService.setMakes($scope.make);
          dataService.setBodys(value);
          var paramsModels=dataService.getParams("models", true);
          salesService.getModels($scope.group.name, paramsModels).then(function(response){
              $scope.models = response.data.resultset.map(function(x) { return { value: x.model,  text: x.model};});
              $scope.model = dataService.getBuildParams($scope.models, $scope.model);
              $scope.completeLoad = true;
            }, function (response) {
              $scope.completeLoad=true;
              toastr.warning('<span class="toast-description"> Unable to access data mining. Please check your connection, then try again <span>', '<strong class="toast-titles"> Access Server </strong>');
          });

        }
    });

    $scope.$watch('model', function (value, oldvalue) {
      if($scope.flagInit){
        $scope.completeLoad=false;
        $scope.opacity = ($scope.unopacity)? false : true; 
        dataService.setDealers($scope.dealer);
        dataService.setMakes($scope.make);
        dataService.setBodys($scope.body);
        dataService.setModels(value);
        var paramsYears = dataService.getParams("years", true);
        salesService.getYears($scope.group.name, paramsYears).then(function(response){
          $scope.years = response.data.resultset.map(function(x) { return { value: x.year,  text: x.year};}).reverse();
          $scope.year = dataService.getBuildParams($scope.years, $scope.year);
          dataService.setYears($scope.year);
          $scope.completeLoad = true;
        }, function (response) {
          $scope.completeLoad = true;
          toastr.warning('<span class="toast-description"> Unable to access data mining. Please check your connection, then try again <span>', '<strong class="toast-titles"> Access Server </strong>');
        });

      }
    });

    $scope.$watch('year', function (value) {
      if($scope.flagInit){
        $scope.opacity = ($scope.unopacity)? false : true; 
         $scope.unopacity = false;
        dataService.setDealers($scope.dealer);
        dataService.setMakes($scope.make);
        dataService.setBodys($scope.body);
        dataService.setModels($scope.model);
        dataService.setYears(value);
      }
    });

    $scope.getReport = function() {

      if((!$scope.dt && $scope.dt2) || (!$scope.dt2 && $scope.dt)){
        toastr.warning('<span class="toast-description"> You must select both dates <span>', '<strong class="toast-titles"> Incorrect Dates </strong>');
        return;
      }

      if ($scope.report == "normal" && dataService.invalid()){
        toastr.info('<span class="toast-description"> Please select at least 1 options, then try again <span>', '<strong class="toast-titles"> Invalid form </strong>');
        return;
      }

      $scope.unopacity = false;  
      $scope.opacity = false;
      var deferred = $q.defer();
      var data = {};
      $scope.items = [];
      $scope.page = undefined;
      $scope.loading = undefined;
      $scope.info;
      $scope.time_results = []; $scope.max_results = []; $scope.sales_results = []; $scope.amount_results = [];
      $scope.data=[]; $scope.series = []; $scope.labels = []; $scope.labelsLine = []; $scope.dataLine = []; $scope.seriesLine = [];

       if (!$scope.loadend){
        $scope.unopacity = true;
      }

      // setters for reports
      data["public[]"] = dataService.getPub();
      data["section_id[]"] = dataService.getDealers();
      data["make[]"] = dataService.getMakes();
      data["body_style[]"] = dataService.getBodys();
      data["year[]"] = dataService.getYears();
      data["model[]"] = dataService.getModels();
      // data["model[]"] = dataService.getModels("children");
      data["type_name[]"] = dataService.getTypes();
      data["certified_preowned[]"] = dataService.getCertified();
      var paramDate=dataService.getDates();
      data["from"]=paramDate.from;
      data["to"]=paramDate.to;
      
      switch($scope.report){
        case "normal":
          $scope.rtitle="- Sales";
          data["path"]="reports/normal";
          salesService.getReport($scope.group.name, data).then(function(response){ 
            try{
              $scope.colors_amount = ['#065cbe'];
              $scope.series_amount = ['Cars'];
              $scope.amount_results = parseDataMainChart(response.data.resultset);
              data["path"] = "reports/finances";
              salesService.getReport($scope.group.name, data).then(function(response){ 
                try{
                  $scope.series = ['Sales'];
                  $scope.colors = ['#065cbe'];
                  $scope.sales_results = parseDataMainChart(response.data.resultset);
                  $location.hash('results');
                  $anchorScroll();
                  deferred.resolve(response);
                  }catch(err){
                      deferred.resolve();
                      console.log(err);
                  }
                }, function (response) {
                  toastr.warning('<span class="toast-description"> Unable to access data mining. Please check your connection, then try again <span>', '<strong class="toast-titles"> Access Server </strong>');
                  deferred.resolve();
                });
              }catch(err){
                  deferred.resolve();
                  console.log(err);
              }
            }, function (response) {
              deferred.resolve();
              toastr.warning('<span class="toast-description"> Unable to access data mining. Please check your connection, then try again <span>', '<strong class="toast-titles"> Access Server </strong>');
            });
          break;
        case "max":
            $scope.rtitle = "- Max. Sales";
            data["path"]="reports/maxsales";
            salesService.getReport($scope.group.name, data).then(function(response){ 
            try{
                $scope.max_results=response.data.resultset;
                var labels=[]; var values=[];
                if($scope.max_results.length>5){
                    var height = ($scope.max_results.length * 35).toString() + "px";
                }else{
                switch($scope.max_results.length){
                  case 1:
                    var height = 80 - chart_cnf[screen].bars_size;
                    break;
                  case 2:
                    var height = 120 - chart_cnf[screen].bars_size;
                    break;
                  case 3:
                    var height = 160 - chart_cnf[screen].bars_size;
                    break;
                  case 4:
                    var height = 200 - chart_cnf[screen].bars_size;
                    break;
                  case 5:
                    var height = 300 - chart_cnf[screen].bars_size;
                    break;
                  }

                  Height = Height.toString() + "px"
                }
                // $scope.colors = [ '#803690', '#00ADF9', '#DCDCDC', '#46BFBD', '#FDB45C', '#949FB1', '#4D5360'];
                $scope.colors = ["#065cbe"];
                for (var i = $scope.max_results.length - 1; i >= 0; i--) {
                labels.push($scope.max_results[i].section_name);
                values.push($scope.max_results[i].total);
                }
                $(".chartjs-canvas-holder-third-row").css("height", height);
                $scope.labels =labels;
                $scope.data = [values];
                $scope.series = ['Sales'];
                $location.hash('results');
                  $anchorScroll();
                  deferred.resolve(response);
            }catch(err){
              deferred.resolve();
              console.log(err);
            }
          }, function (response) {
            toastr.warning('<span class="toast-description"> Unable to access data mining. Please check your connection, then try again <span>', '<strong class="toast-titles"> Access Server </strong>');
            deferred.resolve(response);
          });
          break;
        case "time":
          $scope.rtitle="- Sales Evolution";
          data["path"]="reports/stocktimes";
          salesService.getReport($scope.group.name, data).then(function(response){ 
            try{
              $scope.colors = [ '#55bef2'];
              $scope.time_results=response.data.resultset;
              var labelsLine=[]; var valuesLine=[];

              angular.forEach($scope.time_results, function (value, key) {
                // labelsLine.push($filter("date")(value.date_update, 'yyyy-MM-dd'));
                labelsLine.push(value.date_update);
                valuesLine.push(value.total);
              });

              $(".chartjs-canvas-holder-third-row").css("height", "350px");
              $scope.labelsLine =labelsLine;
              $scope.dataLine = [valuesLine];
              $scope.seriesLine = ['Sales'];
              $location.hash('results');
              $anchorScroll();
              deferred.resolve(response);
            }catch(err){
              deferred.resolve();
              console.log(err);
            }
          }, function (response) {
            deferred.resolve(response);
            toastr.warning('<span class="toast-description"> Unable to access data mining. Please check your connection, then try again <span>', '<strong class="toast-titles"> Access Server </strong>');
          });
          break;
      }
      return deferred.promise;
    };

    $scope.goBack = function () {
      $scope.items=[];
      $scope.page=undefined;
      $scope.loading=undefined;

      try{
        salesService.cancel();
      }catch(e){
        console.log(e);
      }
      
      $scope.info;
    }

    $scope.selectRow = function (info) {
      $scope.info=info;
      if($scope.opacity){
        return;
      }
      $scope.items=[];
      var data=[];
      data["page"] = $scope.page;
      data["section_name"]=info;
      data["make[]"]=dataService.getBuildParams($scope.makes, $scope.make);
      data["model[]"]=dataService.getBuildParams($scope.models, $scope.model);
      data["body_style[]"]=dataService.getBuildParams($scope.bodys, $scope.body);
      // data["paramarrayYearsCount"]=dataService.getBuildParams($scope.years, $scope.year);
      data["certified_preowned[]"]=dataService.getCertified();
      data["type_name[]"]=dataService.getTypes();


      titleCompose(info[0]._model.label, "DEALER");

      salesService.getDetails($scope.group.name, data).then(function(response){
        $scope.items_quantity = response.data.count; 
        angular.forEach(response.data.resultset, function(value, key){
          $scope.items.push(value);
        });
        if (response.data.next){
          $scope.page = ($scope.page)?$scope.page:1;
          $scope.page++; 
        }else{
          $scope.page=null; 
        }
        $scope.loading=false;

      },function (response) {
        toastr.warning('<span class="toast-description"> Unable to access data mining. Please check your connection, then try again <span>', '<strong class="toast-titles"> Access Server </strong>');
      });
    }

    $scope.selectBar = function (info) {
      $scope.info = info;
      if($scope.opacity){
        return;
      }

      var data=[];
      data["page"] = $scope.page;
      if(!info.length){ 
        return;
      }

      var title, year, dealer_id = undefined;
      var active = 0;

      angular.forEach(info[0]._chart.canvas.attributes, function (value, key) {
        if(value.nodeName == "data-dealer"){
          title = value.nodeValue;
        }

        if(value.nodeName == "data-dealer-id"){
          dealer_id = value.nodeValue;
        }

        if(value.nodeName == "data-active"){
          active = value.nodeValue;
        }
        
        if(value.nodeName == "data-year"){
          year = value.nodeValue;
        }
      });
      

      switch($scope.report){
        case "normal":
          $scope.rtitle="- Sales - List";
            var sections = title;
            if (sections == "All section_names"){
              data["section_name"] = dataService.getBuildParams($scope.dealers, $scope.dealer);
            }else{
              data["section_id[]"] = dealer_id;
            }
            data["model"] = info[0]._model.label;
            var paramDate = dataService.getDates();
            data["from"] = paramDate.from;
            data["to"] = paramDate.to;
            if (year){
              data["year[]"] = year;
            }
            titleCompose(info[0]._model.label, "MODEL");
            data["public"] = dataService.getPub();
            data["body_style[]"] = dataService.getBuildParams($scope.bodys, $scope.body);
            data["certified_preowned[]"] = dataService.getCertified();
            data["type_name[]"] = dataService.getTypes();
            salesService.getDetail($scope.group.name, data).then(function(response){
              try{
                $scope.items_quantity = response.data.count; 
                angular.forEach(response.data.results, function(value, key){
                  $scope.items.push(value);
                });
                if (response.data.next){
                  $scope.page = ($scope.page)?$scope.page:1;
                  $scope.page++; 
                }else{
                  $scope.page = null; 
                }
                $scope.loading = false;
                
                if(!$scope.items.length){
                  toastr.info('<span class="toast-description">  Unable to access to these autos now, try later or contact to with support <span>', '<strong class="toast-titles"> Sync Process </strong>');
                }
              }catch(err){
                console.log(err);
                toastr.info('<span class="toast-description">  Unable to access to these autos now, try later or contact to with support <span>', '<strong class="toast-titles"> Sync Process </strong>');

              }

            },function (response) {
              toastr.warning('<span class="toast-description"> Unable to access data mining. Please check your connection, then try again <span>', '<strong class="toast-titles"> Access Server </strong>');
            });           
          break;
        case "max":
          $scope.rtitle = "- Max. Sales - List";
          data["section_name"] = info[0]._model.label;
          data["make[]"] = dataService.getBuildParams($scope.makes, $scope.make);
          data["model[]"] = dataService.getBuildParams($scope.models, $scope.model);
          data["year[]"]=dataService.getBuildParams($scope.years, $scope.year);
          data["certified_preowned[]"] = dataService.getCertified();
          data["body_style[]"] = dataService.getBuildParams($scope.bodys, $scope.body);
          data["public"] = dataService.getPub();
          data["type_name[]"] = dataService.getTypes();
          var paramDate = dataService.getDates();
          data["from"] = paramDate.from;
          data["to"] = paramDate.to;
          titleCompose(info[0]._model.label, "DEALER");
          
          salesService.getDetail($scope.group.name, data).then(function(response){
            try{
                $scope.items_quantity = response.data.count; 
              angular.forEach(response.data.results, function(value, key){
                $scope.items.push(value);
              });
              if (response.data.next){
                $scope.page = ($scope.page)?$scope.page:1;
                $scope.page++; 
              }else{
                $scope.page=null; 
              }
              $scope.loading=false;
              
              if(!$scope.items.length){
                toastr.info('<span class="toast-description">  Unable to access to these autos now, try later or contact to with support <span>', '<strong class="toast-titles"> Sync Process </strong>');
              }
            }catch(err){
                console.log(err);
            }

          },function (response) {
            toastr.warning('<span class="toast-description"> Unable to access data mining. Please check your connection, then try again <span>', '<strong class="toast-titles"> Access Server </strong>');
          });
          break;
        case "time":
          $scope.rtitle="- Sales Time - List";
          data["date_update"] = info[0]._chart.config.data.labels[info[0]._index];
          data["section_name[]"] = dataService.getBuildParams($scope.dealers, $scope.dealer);
          data["make[]"] = dataService.getBuildParams($scope.makes, $scope.make);
          data["model[]"] = dataService.getBuildParams($scope.models, $scope.model);
          data["year[]"]=dataService.getBuildParams($scope.years, $scope.year);
          data["public"] = dataService.getPub();
          data["certified_preowned[]"] = dataService.getCertified();
          data["body_style[]"] = dataService.getBuildParams($scope.bodys, $scope.body);
          data["type_name[]"] = dataService.getTypes();
          titleCompose(data["date_update"], "DATE");

          salesService.getDetail($scope.group.name, data).then(function(response){
            try{
                $scope.items_quantity = response.data.count; 
              angular.forEach(response.data.results, function(value, key){
                $scope.items.push(value);
              });
              if (response.data.next){
                $scope.page = ($scope.page)?$scope.page:1;
                $scope.page++; 
              }else{
                $scope.page=null; 
              }
              $scope.loading=false;
              if(!$scope.items.length){
                toastr.info('<span class="toast-description">  Unable to access to these autos now, try later or contact to with support <span>', '<strong class="toast-titles"> Sync Process </strong>');
              }
            }catch(err){
                console.log(err);
            }
          },function (response) {
            toastr.warning('<span class="toast-description"> Unable to access data mining. Please check your support, then try again <span>', '<strong class="toast-titles"> Access Server </strong>');
          });
          break;
      }
    };
    
    $scope.loadMore = function () {
      if($scope.page && !$scope.loading){
        $scope.pageStart+=20;
        $scope.selectBar($scope.info);
      }
    }

    var dates = new Date(), y = dates.getFullYear(), m = dates.getMonth(), d = dates.getDate();
    $scope.dt2 = new Date();
    $scope.dt = new Date(y, m, d - 30);
    dataService.setDates($scope.dt.formatDate(), $scope.dt2.formatDate());
    $scope.initialize();

  }
})();


(function () {
  'use strict';

  angular.module('BlurAdmin.pages.sales')
      .service('salesService', salesService);

  /** @ngInject */
  function salesService($http, $q, HOST, API) {
  		var data = {};
      var canceler=[];
      var dates={};
  		
      function requestGet(group, data){
        var can=$q.defer();
        canceler.push(can);
        return $http.get(API[API.ENV]+"api/v1/"+data['path'], data,
        {
          timeout: can.promise,
          headers: {
            'Authorization': $http.defaults.headers.common.Authorization,
        }
        }).then(
         function(response) {
          return response;
        }, function (response) {
            return response;
        });
      } 

      function requestPost(group, data){
        var can=$q.defer();
        canceler.push(can);
        return $http.post(API[API.ENV]+"api/v1/"+data['path'], data,
        {
          timeout: can.promise,
			    headers: {
            'Authorization': $http.defaults.headers.common.Authorization,
            'Content-Type': 'application/x-www-form-urlencoded'
          },
          transformRequest: function(obj) {
              var str = [];
              for(var p in obj){
                if(typeof(obj[p])=="object"){
                  for(var i=0; i<obj[p].length; i++)
                    str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p][i]));
                }else{
                    str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
                }
              }
              return str.join("&");
          }
	    	}).then(
		     function(response) {
		    	return response;
		    }, function (response) {
		        return response;
		    });
  		} 

        return {
            setTypes: function (value) {
                
            },
            getTypes: function (group, params) {
               params["path"] ="filters/info/types";
               params["active"] = 0;
               return requestPost(group, params); 
            },
            setDealers: function (value) {
                  
            },
            getDealers: function (group, params) {
              params["path"] = "filters/info/sections";
              params["active"] = 0;
              return requestPost(group, params); 
            },
            setMakes: function (value) {
                
            },
            getMakes: function (group, params) {
              params["path"] = "filters/info/makes";
               params["active"] = 0;
              return requestPost(group, params); 
            },
            setModels: function (value) {
                
            },
            getBodys: function (group, params) {
                params["path"] = "filters/info/bodys";
                params["active"] = 0;
                return requestPost(group, params); 
            },
            getModels: function (group, params) {
                params["path"] = "filters/info/models";
                params["active"] = 0;
                return requestPost(group, params); 
            },
            setYears: function (value) {
                
            },
            getYears: function (group, params) {
			          params["path"] = "filters/info/years";
                params["active"] = 0;
                return requestPost(group, params); 
            },
            getReport: function (group, params) {
              params["path"]="sales/"+params["path"];
              return requestPost(group, params); 
            },
            getDetail: function (group, params) {
                
                if (!params.hasOwnProperty("active")){
                  params["active"] = 0;
                }

                params["path"]="filters/info/details";
                if (params.hasOwnProperty("page")){
                  if(params['page']){
                    params["path"] = "filters/info/details?page="+params['page'];
                  }
                }
                
                return requestPost(group, params); 
            },
            cancel: function () {
              angular.forEach(canceler, function(c) {
                c.resolve();
              });
            }
        };
  }

})();

(function () {
  'use strict';

  angular.module('BlurAdmin.pages.settings', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('home.settings', {
          url: '/settings',
          templateUrl: 'app/pages/settings/index.html',
          title: 'Settings',
          controller: 'Settings',
          resolve: {
            isGroup: function($rootScope, $state, $q, $timeout,AuthService) {
              var group=AuthService.user.groups[0];
              if($rootScope.domain==""){
                try{
                  $timeout(function() { $state.go("home.dashboard"); });
                  return $q.reject("rejection message");
                }catch(err){
                  console.log(err);
                }
              }
            }
          },
          onExit: function($state){

          },
          data: {
              access: 'logged',
              title: ' '
          },
          sidebarMeta: {
            icon: 'ion-ios-gear',
            order: 0,
          },
          params: { 
            hiddenParam: 'YES'
          }
        })
        .state('home.newsettings', {
          url: '/settings/:order_id?mode&p',
          templateUrl: 'app/pages/settings/new.html',
          // controller: 'NewSettings',
          onEnter: function($stateParams){
          },
          data: {
              access: 'logged',
          },
          params: { 
            oportunity:null,
            hiddenParam: 'YES'
          }
        });
  }



})();




(function () {
  'use strict';

  angular.module('BlurAdmin.pages.settings')
      .controller('Settings', Settings);

  /** @ngInject */
  function Settings($scope, $rootScope, Settings,  $uibModal, fileReader,  fileFactory, $stateParams, filtersService, $cookies,  $q, $state, $filter, layoutPaths, $location, $window, $anchorScroll, baConfig, colorHelper, $timeout, themeLayoutSettings, AuthService, toastr, toastrConfig, baProgressModal, API, inventoryService, dataService, CleanSections, SyncMetrics) {

    // $scope.sections = JSON.parse(localStorage.getItem("sections"));
    $scope.errorimage = false;
    $scope.group = AuthService.user.groups[0];
    $scope.groups = AuthService.user.groupes;
    $rootScope.group_name = $scope.group.name;

    dataService.initialize();

    if($stateParams.mode){
      $scope.type_export = $stateParams.mode;
    }else{
      $scope.type_export = "settings";
    }

    $scope.uploadFile = function (id) {
      var fileInput = document.getElementById(id);
      fileInput.value="";
      fileInput.click();
    };

    function create_UUID(){
          var dt = new Date().getTime();
          var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
              var r = (dt + Math.random()*16)%16 | 0;
              dt = Math.floor(dt/16);
              return (c=='x' ? r :(r&0x3|0x8)).toString(16);
          });
          return uuid;
      }

    $scope.configSelect = {
      plugins:['remove_button'],
      persist:true,
      valueField: 'value',
      labelField: 'text'
    };


    $scope.getDealers = function(){
        inventoryService.getDealers($scope.group.name, dataService.getParams("dealers")).then(function(response){  
          $scope.loaded=true;
          $scope.dealers = response.data.resultset.map(function(x) { return { value: x.section_id,  text: x.section_name};});
        });
    }

    $scope.getDealers();

    Settings.get(function (response) {
      response["branding_image"] = response.branding_image.replace("http:", "https:").replace("8000", "8500");
      $scope.settings = response;
    });

     $scope.getFile = function (file, entity) {     
        baProgressModal.open();
        fileReader.readAsDataUrl(file, $scope).then(function (result) {
            var url = API[API.ENV]+"api/v1/settings/images";
            var total_size = 0;
            var data = {image: result, url : url};
            fileFactory.uploadFiles(data, function(response){
              console.log("response");
              console.log(response);
              console.log(entity);
              if (entity == "branding"){
                $scope.settings.branding_image = response.image_url;
                $("#branding_image").attr('src', response.image_url + "?cache=" + create_UUID());
              }else{

              }
            }, function(response){
              if (response.status=="406"){
                toastr.warning('<span class="toast-description">' + response.responseJSON.message + '  <span>', '<strong class="toast-titles"> Upload File </strong>');
              }else{
                toastr.warning('<span class="toast-description"> Has ocurred a problem, contact to support and try again. <span>', '<strong class="toast-titles"> Upload File </strong>');
              }
            });

          });
    };

    $scope.dimension = [{"model": false, "loading":false}, {"make": false, "loading":false}, {"body_style" : false, "loading":false}];

     $scope.refreshMetrics = function () {

        var dimensions = ["body_style", "make", "model"];
        $scope.dimension = [{"done": false, "loading":true}, {"done": false, "loading":false}, {"done" : false, "loading":false}];

        SyncMetrics.save({ dimension : "body_style" }, function(response){  
          $scope.dimension[0]["loading"] = false;
          $scope.dimension[1]["loading"] = true;
          $scope.dimension[0]["done"] = true;
          SyncMetrics.save({ dimension : "make" }, function(response){
            $scope.dimension[1]["loading"] = false;
            $scope.dimension[2]["loading"] = true;
            $scope.dimension[1]["done"] = true;
            SyncMetrics.save({ dimension : "model" }, function(response){
               $scope.dimension[2]["loading"] = false;
               $scope.dimension[2]["done"] = true;
            });
          });
        });

     }


     $scope.goClean = function () {
      $uibModal.open({
        animation: true,
        templateUrl: "app/pages/modals/modalTemplates/warningModal.html",
        size: "sm",
        scope:$scope,
        controller:function($uibModalInstance, CleanSections, dataService) {
          $scope.title ="Dealers";
          $scope.close=function() {
            $uibModalInstance.dismiss('no');
          }
          $scope.ok = function() {
            $uibModalInstance.close('yes');
            var dealer = dataService.getBuildParamsValue($scope.dealers, $scope.dealer);
            CleanSections.delete({ sections : dealer.join(",")  }, function (response) {
              $scope.dealer = [];    
              $scope.getDealers();
              toastr.info('<span class="toast-description"> The sections was cleaned rightly...  <span>', '<strong class="toast-titles"> Clean sections </strong>');
            });
           
          }
        }
      }).closed.then(function(){
        $scope.selectedBox=null;
      });
    }

  }

  angular.module('BlurAdmin.pages.settings')
      .controller('SettingsList', SettingsList);

  /** @ngInject */
  function SettingsList($scope, $rootScope,  $uibModal, fileFactory, $stateParams, $cookies, Worksorders, $q, $state, $filter, layoutPaths, $location, $window, $anchorScroll, baConfig, colorHelper, $timeout, inventoryService, dataService, salesService, themeLayoutSettings, AuthService, toastr, toastrConfig, API) {

 
   
  }

  
})();


(function () {
  'use strict';

   angular.module('BlurAdmin.pages.settings')
      .service('Settings', Settings);
  /** @ngInject */
   function Settings($resource, API) {
    return $resource(API[API.ENV]+"api/v1/settings/:id", {id:'@id'}, {save: {
                method: 'POST'
            },
           update: { method:'PUT'}});
   }


   angular.module('BlurAdmin.pages.settings')
      .service('SyncMetrics', SyncMetrics);
  /** @ngInject */
   function SyncMetrics($resource, API) {
    return $resource(API[API.ENV]+"api/v1/inventories/syncmetrics", {}, {save: {
                method: 'POST'
            },
           update: { method:'PUT'}});
   }

   angular.module('BlurAdmin.pages.settings')
      .service('CleanSections', CleanSections);
  /** @ngInject */
   function CleanSections($resource, API) {
    return $resource(API[API.ENV]+"api/v1/settings/sections", {}, {save: {
                method: 'POST'
            },
           update: { method:'PUT'}});
   }


   angular.module('BlurAdmin.pages.settings')
      .service('ImagesSettings', ImagesSettings);
  /** @ngInject */
   function ImagesSettings($resource, API) {
    return $resource(API[API.ENV]+"api/v1/settings/images", {id:'@id'}, {save: {
                method: 'POST'
            },
           update: { method:'PUT'}});
   }

})();



(function () {
  'use strict';

		
})();



(function () {
  'use strict';

  angular.module('BlurAdmin.pages.utils', []);


  angular.module('BlurAdmin.pages.utils').filter('bydefault', bydefault);
  
  /**
 * Sets a default value for a given input.
 *
 * @param mixed input
 * @param string defaultValue
 * @return string
 */
 
  function bydefault(){
      return function( input, defaultValue ) {
          if ( !input || input=="$0") return defaultValue;    
          return input;
    };
  }

  angular.module('BlurAdmin.pages.utils').filter('cut', cut);

    function cut(){
        return function (value, wordwise, max, tail) {
            if (!value) return '';

            max = parseInt(max, 10);
            if (!max) return value;
            if (value.length <= max) return value;

            value = value.substr(0, max);
            if (wordwise) {
                var lastspace = value.lastIndexOf(' ');
                if (lastspace !== -1) {
                  //Also remove . and , so its gives a cleaner result.
                  if (value.charAt(lastspace-1) === '.' || value.charAt(lastspace-1) === ',') {
                    lastspace = lastspace - 1;
                  }
                  value = value.substr(0, lastspace);
                }
            }

            return value + (tail || ' …');
        };
    }

  angular.module('BlurAdmin.pages.utils').filter('replace', replace);

    function replace(){
      console.log("epaleee");
        return function (value, string, replacement) {
            if (!value) return '';
            var re = new RegExp("/"+string+"/", "g");
            return value.replace(re, replacement);
        };
    }


  angular.module('BlurAdmin.pages.utils').filter('secondsToStr', secondsToStr);

    function secondsToStr() {
      return function (milliseconds) {
        function numberEnding (number) {
            return (number > 1) ? 's' : '';
        }
        var temp = Math.floor(milliseconds / 60);
        var days = Math.floor((temp %= 525600) / 1440);
        if (days) {
            return days+" days";
        }
        var hours = Math.floor((temp %= 1440) / 60);
        if (hours) {
            return hours;
        }
        var minutes = temp % 60;
        if (minutes) {
            return minutes;
        }
        return '1 day';
      }
    }

      angular.module('BlurAdmin.pages.utils')
  .filter('titleCase', function() {
    return function(input) {
      try{
        input = input || '';
        return input.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});
      }catch(e){
        return input;
      }
      
    };
  })


})();


(function () {
  'use strict';

  angular.module('BlurAdmin.pages.workorders', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('home.workorders', {
          url: '/workorders?dealer&body&dimension',
          templateUrl: 'app/pages/workorders/index.html',
          title: 'Work Orders',
          controller: 'WorkOrdersList',
          resolve: {
            isGroup: function($rootScope, $state, $q, $timeout,AuthService) {
              var group = AuthService.user.groups[0];
              if($rootScope.domain == ""){
                try{
                  $timeout(function() { $state.go("home.dashboard"); });
                  return $q.reject("rejection message");
                }catch(err){
                  console.log(err);
                }
              }
            }
          },
          onExit: function(inventoryService, $state){

          },
          data: {
              access: 'logged',
              title: ' '
          },
          sidebarMeta: {
            icon: 'ion-card',
            order: 0,
          },
          params: { 
            hiddenParam: 'YES'
          }
        })
        .state('home.neworder', {
          url: '/workorders/:order_id?mode&ref',
          templateUrl: 'app/pages/workorders/new.html',
          controller: 'NewOrders',
          resolve: {
            extern: function($rootScope, $state, $stateParams, $q, $timeout, AuthService, DashService, Ciphers,  $cookieStore) {
              var groups = AuthService.user.groupes;
              var deferred = $q.defer();
              if ($stateParams.ref && groups.includes("root")){
                 Ciphers.get({mode:"decode", text:$stateParams.ref},function (response) {
                    var ide = response.data;
                    $cookieStore.remove("title");
                    var ides = ide.split("_");
                    $cookieStore.put("domain", ides[0]);
                    $rootScope.domain = ides[0];
                    $cookieStore.put("alias", ides[1]);
                    
                    if (ides.length >= 3 ){
                      $cookieStore.put("promo_id", ides[3]);                      
                    }else{
                      $cookieStore.remove("promo_id");  
                    }

                    try{
                      DashService.getSites(AuthService.user.groups[0], AuthService.user.groupes, function (response) {  
                        var sites = response;
                        var idx;
                        angular.forEach(response, function (value, index) {
                          if (ides.length >= 3){
                            if (value.hasOwnProperty("promo_id")){
                              if (value.alias == ides[1] && value.promo_id == ides[3]){
                                idx = index;
                              }
                            }
                          }else{
                            if (!value.hasOwnProperty("promo_id")){
                              if (value.alias == ides[1]){
                                idx = index;
                              }
                            }
                          }
                        });
                        $rootScope.title = sites[idx].title;
                        $cookieStore.put("title", $rootScope.title);
                        DashService.setSite(sites[idx]);
                      }, function (response) {});
                    }catch(e){
                      console.log(e);
                    }
                    deferred.resolve("go!");
                 }, function (response) {
                    deferred.reject();
                    $cookieStore.remove("title");  
                    $cookieStore.remove("promo_id");  
                    $cookieStore.remove("domain");  
                    $cookieStore.remove("alias");
                    $rootScope.domain = "";    
                    $timeout(function () {$state.go("home.dashboard");});
                 });
              }else{
                if ($stateParams.ref){
                  deferred.reject();
                  $cookieStore.remove("promo_id");  
                  $cookieStore.remove("domain");  
                  $cookieStore.remove("alias"); 
                  $rootScope.domain = "";
                  $timeout(function () {$state.go("home.dashboard");});
                }else{
                  deferred.resolve("go!")
                }
              }
              return deferred.promise;
            }
          },
          onExit: function($state){
            // console.log($state);
          },
          data: {
              access: 'logged',
          },
          params: { 
            oportunity:null,
            hiddenParam: 'YES'
          }
        });
  }


  angular.module('BlurAdmin.pages.workorders').filter('Filesize', function () {
    return function (size) {
      if (isNaN(size))
        size = 0;

      if (size < 1024)
        return size + ' Bytes';

      size /= 1024;

      if (size < 1024)
        return size.toFixed(2) + ' Kb';

      size /= 1024;

      if (size < 1024)
        return size.toFixed(2) + ' Mb';

      size /= 1024;

      if (size < 1024)
        return size.toFixed(2) + ' Gb';

      size /= 1024;

      return size.toFixed(2) + ' Tb';
    };
  });


})();




(function () {
  'use strict';

  angular.module('BlurAdmin.pages.workorders')
      .controller('NewOrders', NewOrders);

  /** @ngInject */
  function NewOrders($scope, $rootScope, sectionsService, $uibModal, fileReader, baProgressModal, Requests, WorksRequests, Worksorders, fileFactory, $stateParams, filtersService, promakesService, bodysService, promodelsService, $cookies,  $q, $state, $filter, layoutPaths, $location, $window, $anchorScroll, baConfig, colorHelper, $timeout, inventoryService, dataService, salesService, themeLayoutSettings, AuthService, toastr, toastrConfig, API) {

    // $scope.sections = JSON.parse(localStorage.getItem("sections"));
    $scope.type="all";
    if($stateParams.mode){
      $scope.type_export = $stateParams.mode;
    }else{
      $scope.type_export = "workorders";
    }

    $scope.uploadFile = function (id) {
      var fileInput = document.getElementById(id);
      fileInput.value="";
      fileInput.click();
    };


     $scope.getFile = function (file, entity) {
             
      
      fileReader.readAsDataUrl(file, $scope)
          .then(function (result) {
            var url = API[API.ENV]+"api/v1/files";
            var total_size = 0;
            if (entity=="workorders"){
              var ref_id = ($scope.order_id)?$scope.order_id:null;
              var total_files = ($scope.order_id)?0:$scope.order.files.length;
              angular.forEach($scope.order.files, function (value, index) {
                  total_size+=value.size;
              });
            }else{
              var ref_id = ($scope.request.id)?$scope.request.id:null;
              var total_files = ($scope.request.id)?0:$scope.request.files.length;
              angular.forEach($scope.request.files, function (value, index) {
                total_size+=value.size;
              });
            }

            var data={id : $scope.file.id, file: file, total_files: total_files, total_size:total_size, ref_id:ref_id, name:file.name, model:entity, url:url};
            $scope.fileload = true;
            fileFactory.uploadFiles(data, function(response){
              $scope.fileload = false;
              if (response.model == "workorders"){
                $scope.order.files.push(response);
              }else{
                $scope.request.files.push(response);
              }
            }, function(response){
              if (response.status=="406"){
                toastr.warning('<span class="toast-description">' + response.responseJSON.message + '  <span>', '<strong class="toast-titles"> Upload File </strong>');
              }else{
                toastr.warning('<span class="toast-description"> Has ocurred a problem, contact to support and try again. <span>', '<strong class="toast-titles"> Upload File </strong>');
              }

            });

          });
    };

    $scope.statuses = "all";

    $scope.toggleStatus = function (status) {
      $scope.statuses = status;
      var tmp = $scope.requests;
      $scope.requests = [];
      $scope.requests = tmp;
    }

    $scope.getDealers = function (dealer) {
      var adealer = dealer;
      var payload = {};


      if ($scope.type!="all"){
        payload["type"] = $scope.type;
      }
      
      sectionsService.query(payload, function(response){
        $scope.dealers = response.map(function(x) { return { value: x.id, text: x.section_name};});
        if($stateParams.oportunity){
          var adealer = $stateParams.oportunity.dealer;
          $scope.order.dealer = adealer.id.toString();
          $scope.order.vehicles = adealer[adealer["entity"]];
        }else{
          // $scope.order.dealer = adealer.toString();
        }
        
        $scope.completeLoad = true;
      }, function (response) {
        $scope.completeLoad=true;
        toastr.info('<span class="toast-description"> Has occurred a problem. Please check with system support, then try again <span>', '<strong class="toast-titles"> Data Access  </strong>');          
      });
    }

    $scope.toggleType = function(value) {
      $scope.completeLoad=false;
      $scope.loadDealers = false;
      $scope.dealer=[];
      $scope.make=[];
      $scope.body=[];
      $scope.model=[];
      $scope.year=[];
      $scope.type = value;

      $scope.getDealers();
    }
    
    $scope.customFilter = function (item) {
      if ($scope.statuses=="all"){
        return true;
      }
      return item.status == $scope.statuses;
    }

    $scope.solu = {banner300x50:true,  banner300x250:true, banner300x600:true, banner728x90:true, banner970x90:true, banner970x240:true, banner970x250:true, banner1280x250:true,  banner1280x220:true,  banner1280x600:true};
    $scope.typetemplates = [{"value":"grid", "text": "Grid"},  {"value":"list", "text": "List"}];
    $scope.status = [{"value":"progress", "text": "In Progress"},  {"value":"closed", "text": "Closed"}];
    $scope.order ={"status": "progress", "solutions": [], "files": [], "freedesign":true, "onreverse":false, "onsocial":false, "onemail":false, "reverse":{ "paper_orientation": "portrait"}};
    $scope.request ={"status": "progress", "files": [],};

    $scope.order_id = $stateParams.order_id;  
    $scope.wostocks=[];

    $scope.opened = false;
    $scope.opened2 = false;
    $scope.formats = ['MMMM dd, yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
    $scope.format = $scope.formats[0];

    $scope.configSingleOne = {
      maxItems: 1,
      persist:true, 
      valueField: 'value',
      labelField: 'text',
       sortField: [
          {
              field: 'text',
              direction: 'asc'
          }
      ]
    };

     Date.prototype.formatDate = function() {
      var mm = this.getMonth() + 1; // getMonth() is zero-based
      var dd = this.getDate();

      return [this.getFullYear(),
              "-"+(mm>9 ? '' : '0') + mm,
              "-"+(dd>9 ? '' : '0')  +dd
             ].join('');
    };

    $scope.setDateStart = function(dt) {
      $scope.dt=dt;
    }

    $scope.setDateEnd = function(dt2) {
      $scope.dt2=dt2;
    }

    $scope.open = function() {
        $scope.opened = true;
        if($scope.dt2){
          $scope.optionsStart = {
              showWeeks: false,
          };
        }else{
          $scope.optionsStart = {
              showWeeks: false,
          };
        }
    };
    
    $scope.open2 = function() {
        $scope.opened2 = true;
        if ($scope.dt){
          $scope.optionsEnd = {
              showWeeks: false,
              minDate: $scope.dt
          };
        }else{
          $scope.optionsEnd = {
              showWeeks: false,
          };
        }
    }

     $rootScope.getSites = function(){
        try{
          if ($rootScope.group_name=="root"){
            var url = API[API.ENV]+"api/v1/alias?export=true";
          }else{
            var queryparams = $scope.groups.join(",");
            var url = API[API.ENV]+"api/v1/alias"+"?group="+queryparams;
          }
        }catch(e){
          var queryparams = $scope.group;
          var url = API[API.ENV]+"api/v1/alias"+"?group="+queryparams;
        }
      $http.get(url,
        {
          headers: {'Authorization': AuthService.user.atok},
        }).then(
       function(response) {
          $rootScope.sites=[];
          angular.forEach(response.data, function (value, key) {
              if ($rootScope.group_name=="root"){
                  value['multisite'] = false;
                  value['title'] = value.host;
                  $rootScope.sites.push(value);
                  if (value.promotions.length){
                    angular.forEach(value.promotions, function (v, k) {
                      var extras = {};
                      try{
                        extras = v.extras;
                      }catch(e){} 
                    

                      $rootScope.sites.push({"id":value.id, "host":value.host, 'export': value.export, 'extras': extras, 'multisite': true,  'title': v.name, 'alias': value.alias, 'promo_id':v.id, 'report':v.group});
                    
                    });
                  }
              }else{
                  
                if($rootScope.groups.includes(value.report)){
                  value['multisite'] = false;
                  value['title'] = value.host;
                  $rootScope.sites.push(value);
                }

                if (value.promotions.length){
                    angular.forEach(value.promotions, function (v, k) {
                        if($rootScope.groups.includes(v.group)) {
                          var extras = {};
                          try{
                            extras = v.extras;
                          }catch(e){} 

                          $scope.sites.push({"id":value.id, "host":value.host, 'export': value.export, 'extras': extras, 'multisite': true,  'title': v.name, 'alias': value.alias, 'promo_id':v.id, 'report':v.group});
                        }
                    });
                }
              
              }
          })
      }, function (response) {
        // return response;
      });

    }

    $scope.newOrder = function () {
      $scope.solu = {banner300x50:true,  banner300x250:true, banner300x600:true, banner728x90:true, banner970x90:true, banner970x240:true, banner970x250:true, banner1280x250:true,  banner1280x220:true,  banner1280x600:true};
      $scope.status = [{"value":"progress", "text": "In Progress"},  {"value":"closed", "text": "Closed"}];
      $scope.order ={"status": "progress", "solutions": [], "files": [], "freedesign":true, "onreverse":false, "onsocial":false, "onemail":false};
      $scope.wostocks=[];
      $state.go("home.neworder", {order_id:undefined}, {location: "replace", notify: false});
      $stateParams.order_id=undefined;
      $scope.order_id=undefined;
      $scope.type_export = 'workorders';
      $scope.label_export = 'Work Orders';
    }

    $scope.saveOrder = function (form) {
      
      if($scope.order.dealer){
        form.dealer.$setValidity('required', true);
      }
      
      if (form.$invalid){
        return;
      }      

      $scope.order["alias"] =($cookies.get("promo_id"))? $cookies.get("alias").replace(/\"/g, '') + "_promoid_" + $cookies.get("promo_id").replace(/\"/g, ''):$cookies.get("alias").replace(/\"/g, '');
      $scope.order.solutions = [];
      angular.forEach($scope.solu, function(index, value){
        if (index){
            $scope.order.solutions.push(value);
        }
      });

      if ($scope.dt){
        $scope.order.start_date = moment($scope.dt).format('YYYY-MM-DDT00:00');
      }
      
      if ($scope.dt2){
        $scope.order.end_date = moment($scope.dt2).format('YYYY-MM-DDT23:59');
      }

      if (!$stateParams.order_id){
        Worksorders.save($scope.order, function (response) {
          // $scope.solu = {banner300x50:true,  banner300x250:true, banner300x600:true, banner728x90:true, banner970x90:true, banner970x240:true, banner970x250:true, banner1280x250:true,  banner1280x220:true,  banner1280x600:true};
          // $scope.order = {"status": "progress", "solutions": [], "files": [], "freedesign":true, "onreverse":false, "onsocial":false, "onemail":false};
          // $scope.wostocks = [];
          form.$setPristine();
          form.$setUntouched();
          
          $scope.order_id = response.id;
          $stateParams.order_id = $scope.order_id;

          Worksorders.get({id:$stateParams.order_id}, function (resp) {
            // $scope.wostocks = resp.stocks.map(function(x) { return { value: x,  text: x};});
            $scope.order = resp;

            angular.forEach($scope.solu, function (index, value) {
                if (resp.solutions.includes(value)){
                  $scope.solu[value] = true;  
                }else{
                  $scope.solu[value] = false;
                }
            });
    
            WorksRequests.query({order_id:$stateParams.order_id}, function (response) {
              $scope.requests = response;
            });
            
            $scope.order.dealer = resp.dealer;
            console.log($scope.form);
            $scope.form.$setValidity('required', true);
    
            if (resp.start_date){
              $scope.dt = new Date(moment(resp.start_date));
            }
            if (resp.end_date){
              $scope.dt2 = new Date(moment(resp.end_date));
            }
            $scope.getDealers(resp.dealer);
            // $scope.$emit('someEvent', resp.sections);
            $scope.title_pro = resp.name;
        
            $state.go("home.neworder", {order_id:response.id}, {location: "replace", notify: false});

            toastr.info('<span class="toast-description"> The work order was created! <span>', '<strong class="toast-titles"> Work Order </strong>');
        },function (response) {
            toastr.warning('<span class="toast-description"> Please try a different order name or contact support for assistance. <span>', '<strong class="toast-titles"> Something went wrong! </strong>');
        });

        }, function (response) {
          $state.go("home.workorders");
        });
      }else{
        console.log($scope.order);
        Worksorders.update($scope.order, function (response) {
          form.$setPristine();
          form.$setUntouched();
          toastr.info('<span class="toast-description"> The work order was update! <span>', '<strong class="toast-titles"> Work Order </strong>');
        },function (response) {
          toastr.warning('<span class="toast-description"> Please try a different order name or contact support for assistance. <span>', '<strong class="toast-titles"> Something went wrong! </strong>');
        });
      }
    }

    $scope.cancelRequest = function (form) {
      $scope.request = {files:[]};
      $scope.req_update = false;
      $scope.toggleExport('requests', 'Requests');
    }

    $scope.saveRequest = function (form) {
      if (!$scope.req_update){
        $scope.request["order_id"] = $stateParams.order_id;
        WorksRequests.save($scope.request, function (response) {
          $scope.request = {files:[]};
          toastr.info('<span class="toast-description"> The request was send! <span>', '<strong class="toast-titles"> Request </strong>');
        },function (response) {
            toastr.warning('<span class="toast-description"> Try with another order name or ask him to support. <span>', '<strong class="toast-titles"> Has ocurred a problem! </strong>');
        });
      }else{
        Requests.update($scope.request, function (response) {
          toastr.info('<span class="toast-description"> The request was update! <span>', '<strong class="toast-titles"> Request </strong>');
        },function (response) {
            toastr.warning('<span class="toast-description"> Try contact with  support. <span>', '<strong class="toast-titles"> Has ocurred a problem! </strong>');
        });
      }
    }

    $scope.toggleExport = function(value, label) {
      $scope.type_export = value;
      $scope.label_export = label;
      switch(value){
        case "requests":
          WorksRequests.query({order_id:$stateParams.order_id}, function (response) {
          $scope.requests = response;
          });
          $scope.req_update = false;
          break;
        
        case "newrequest":
          $scope.request= {files:[]};
          break;
        default:
      }
      $state.go("home.neworder", {mode:value}, {location: "replace", notify: false});
    }

    $scope.getRequest = function(request) {
      $scope.req_update =true;
      $scope.toggleExport('newrequest', 'Request');
      Requests.get({id:request.id}, function (response) {
          $scope.request = response;
      });
    }

    if ($stateParams.order_id) {
      $scope.update = true;
      Worksorders.get({id:$stateParams.order_id}, function (resp) {
        // $scope.wostocks = resp.stocks.map(function(x) { return { value: x,  text: x};});
        $scope.order = resp;    
        angular.forEach($scope.solu, function (index, value) {
            if (resp.solutions.includes(value)){
              $scope.solu[value] = true;  
            }else{
              $scope.solu[value] = false;
            }
        });

        WorksRequests.query({order_id:$stateParams.order_id}, function (response) {
          $scope.requests = response;
        });
        
        $scope.order.dealer = resp.dealer;
        console.log($scope.form);
        $scope.form.$setValidity('required', true);

        if (resp.start_date){
          $scope.dt = new Date(moment(resp.start_date));
        }
        if (resp.end_date){
          $scope.dt2 = new Date(moment(resp.end_date));
        }
        $scope.getDealers(resp.dealer);
        // $scope.$emit('someEvent', resp.sections);
        $scope.title_pro = resp.name;
      }, function (response) {
        $state.go("home.workorders");
      });
    }else{
      $scope.getDealers(undefined);
    }

     $scope.openConfirm = function (request) {
      $scope.selectReq = request;
      $uibModal.open({
        animation: true,
        templateUrl: "app/pages/modals/modalTemplates/warningModal.html",
        size: "sm",
        scope:$scope,
        controller:function($uibModalInstance, Requests) {
          $scope.title ="Request";
          $scope.close=function() {
            $uibModalInstance.dismiss('no');
          }
          $scope.ok=function() {
            $uibModalInstance.close('yes');
            Requests.delete({id:$scope.selectReq.id}, function (response) {
              var index = $scope.requests.indexOf($scope.selectReq);
              $scope.requests.splice(index, 1);
            }, function (response) {
            });
          }
        }
      }).closed.then(function(){
        $scope.selectedBox=null;
      });
    }


     var  updateOrder = $rootScope.$on('updateOrder', function(event, args) {
          event.preventDefault(); event.stopPropagation();
        if ($stateParams.order_id){
          $scope.order["alias"] =($cookies.get("promo_id"))? $cookies.get("alias").replace(/\"/g, '') + "_promoid_" + $cookies.get("promo_id").replace(/\"/g, ''):$cookies.get("alias").replace(/\"/g, '');
          Worksorders.update($scope.order, function (response) {
            toastr.info('<span class="toast-description"> The work order was update! <span>', '<strong class="toast-titles"> Work Order </strong>');
          },function (response) {
              toastr.warning('<span class="toast-description"> Try contact with  support. <span>', '<strong class="toast-titles"> Has ocurred a problem! </strong>');
          });
        }
     
     });


   
  }

  angular.module('BlurAdmin.pages.workorders')
      .controller('WorkOrdersList', WorkOrdersList);

  /** @ngInject */
  function WorkOrdersList($scope, $rootScope,  $uibModal, fileFactory, $stateParams, $cookies, Worksorders, $q, $state, $filter, layoutPaths, $location, $window, $anchorScroll, baConfig, colorHelper, $timeout, inventoryService, dataService, salesService, themeLayoutSettings, AuthService, toastr, toastrConfig, API) {

    Worksorders.query(function (response) {
      $scope.workorders = response;
    },function (response) {
    });

    $scope.status = "all";
    $scope.toggleStatus = function (status) {
      $scope.status = status;
      var tmp = $scope.workorders;
      $scope.workorders = [];
      $scope.workorders = tmp;
    }
    

    $scope.customFilter = function (item) {
      if ($scope.status=="all"){
        return true;
      }
      return item.status == $scope.status;
    }

    $scope.onLongPress = function(item) {
      console.log('Long press');
      $scope.selectedBox=item.id;
      $scope.selectedItem=item;
      $scope.openConfirm();
    }

    $scope.openConfirm = function () {
      $uibModal.open({
        animation: true,
        templateUrl: "app/pages/modals/modalTemplates/warningModal.html",
        size: "sm",
        scope:$scope,
        controller:function($uibModalInstance, Worksorders) {
          $scope.title ="Work Order";

          $scope.close=function() {
            $uibModalInstance.dismiss('no');
          }
          $scope.ok=function() {
            $uibModalInstance.close('yes');
            Worksorders.delete({id:$scope.selectedBox}, function (response) {
              var index = $scope.workorders.indexOf($scope.selectedItem);
              $scope.workorders.splice(index, 1);
            }, function (response) {
            });
          }
        }
      }).closed.then(function(){
        $scope.selectedBox=null;
      });
    }

   
  }

  
})();


(function () {
  'use strict';

   angular.module('BlurAdmin.pages.workorders')
      .service('Ciphers', Ciphers);
  /** @ngInject */
   function Ciphers($resource, API) {
    return $resource(API[API.ENV]+"api/v1/ciphers");
   }

   angular.module('BlurAdmin.pages.workorders')
      .service('Worksorders', Worksorders);
  /** @ngInject */
   function Worksorders($resource, API) {
    return $resource(API[API.ENV]+"api/v1/worksorders/:id", {id:'@id'}, {save: {
                method: 'POST'
            },
           update: { method:'PUT'}});
   }

    angular.module('BlurAdmin.pages.workorders')
      .service('WorksRequests', WorksRequests);
  /** @ngInject */
   function WorksRequests($resource, API) {
    return $resource(API[API.ENV]+"api/v1/worksorders/:order_id/requests", {order_id:'@order_id'}, {save: {
                method: 'POST'
            },
           update: { method:'PUT'}});
   }

    angular.module('BlurAdmin.pages.workorders')
      .service('Requests', Requests);
  /** @ngInject */
   function Requests($resource, API) {
    return $resource(API[API.ENV]+"api/v1/requests/:id", {id:'@id'}, {save: {
                method: 'POST'
            },
           update: { method:'PUT'}});
   }

})();
/**
 * @author v.lugovksy
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .config(toastrLibConfig);

  /** @ngInject */
  function toastrLibConfig(toastrConfig) {
    angular.extend(toastrConfig, {
      closeButton: true,
      closeHtml: '<button>&times;</button>',
      timeOut: 6000,
      autoDismiss: false,
      containerId: 'toast-container',
      maxOpened: 0,
      newestOnTop: true,
      allowHtml: true,
      positionClass: 'toast-top-center',
      preventDuplicates: false,
      preventOpenDuplicates: false,
      target: 'body'
    });
  }
})();
/**
 * Change top "Daily Downloads", "Active Users" values with animation effect
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('animatedChange', animatedChange);

  /** @ngInject */
  function animatedChange($timeout) {
    return {
      link: function (scope, element) {
        $timeout(function () {
          var newValue = element.attr('new-value');
          var oldvalue = parseInt(element.html());

          function changeValue(val) {
            $timeout(function () {
              element.html(val);
            }, 30);
          }

          if (newValue > oldvalue) {
            for (var i = oldvalue; i <= newValue; i++) {
              changeValue(i);
            }
          } else {
            for (var j = oldvalue; j >= newValue; j--) {
              changeValue(j);
            }
          }
          $timeout(function () {
            element.next().find('i').addClass('show-arr');
          }, 500);
        }, 3500);
      }
    };
  }

})();
/**
 * Auto expand textarea field
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('autoExpand', autoExpand);

  /** @ngInject */
  function autoExpand() {
    return {
      restrict: 'A',
      link: function ($scope, elem) {
        elem.bind('keydown', function ($event) {
          var element = $event.target;
          $(element).height(0);
          var height = $(element)[0].scrollHeight;
          height = (height < 16) ? 16 : height;
          $(element).height(height);
        });

        // Expand the textarea as soon as it is added to the DOM
        setTimeout(function () {
          var element = elem;
          $(element).height(0);
          var height = $(element)[0].scrollHeight;
          height = (height < 16) ? 16 : height;
          $(element).height(height);
        }, 0)
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('autoFocus', autoFocus);

  /** @ngInject */
  function autoFocus($timeout, $parse) {
    return {
      link: function (scope, element, attrs) {
        var model = $parse(attrs.autoFocus);
        scope.$watch(model, function (value) {
          if (value === true) {
            $timeout(function () {
              element[0].focus();
              element[0].select();
            });
          }
        });
        element.bind('blur', function () {
          scope.$apply(model.assign(scope, false));
        });
      }
    };
  }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('includeWithScope', includeWithScope);

  /** @ngInject */
  function includeWithScope() {
    return {
      restrict: 'AE',
      templateUrl: function(ele, attrs) {
        return attrs.includeWithScope;
      }
    };
  }

})();

/**
 * @author a.demeshko
 * created on 22.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .directive('ionSlider', ionSlider);

  /** @ngInject */
  function ionSlider($timeout) {
    return {
      restrict: 'EA',
      template: '<div></div>',
      replace: true,
      scope: {
        min: '=',
        max: '=',
        type: '@',
        prefix: '@',
        maxPostfix: '@',
        prettify: '=',
        prettifySeparator: '@',
        grid: '=',
        gridMargin: '@',
        postfix: '@',
        step: '@',
        hideMinMax: '@',
        hideFromTo: '@',
        from: '=',
        to: '=',
        disable: '=',
        onChange: '=',
        onFinish: '=',
        values: '=',
        timeout: '@'
      },
      link: function ($scope, $element) {
            $element.ionRangeSlider({
              min: $scope.min,
              max: $scope.max,
              type: $scope.type,
              prefix: $scope.prefix,
              maxPostfix: $scope.maxPostfix,
              prettify_enabled: $scope.prettify,
              prettify_separator: $scope.prettifySeparator,
              grid: $scope.grid,
              gridMargin: $scope.gridMargin,
              postfix: $scope.postfix,
              step: $scope.step,
              hideMinMax: $scope.hideMinMax,
              hideFromTo: $scope.hideFromTo,
              from: $scope.from,
              to: $scope.to,
              disable: $scope.disable,
              onChange: $scope.onChange,
              onFinish: $scope.onFinish,
              values: $scope.values
            });

            $scope.$watch('min', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({min: value});
              });
            }, true);
            $scope.$watch('max', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({max: value});
              });
            });
            $scope.$watch('from', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({from: value});
              });
            });
            $scope.$watch('to', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({to: value});
              });
            });
            $scope.$watch('disable', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({disable: value});
              });
            });
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('ngFileSelect', ngFileSelect);

  /** @ngInject */
  function ngFileSelect() {
    return {
      link: function ($scope, el, attr) {
        el.bind('change', function (e, id) {
          $scope.file = (e.srcElement || e.target).files[0];
          $scope.getFile($scope.file, attr.item);

        })
      }
    }
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('scrollPosition', scrollPosition);

  /** @ngInject */
  function scrollPosition() {
    return {
      scope: {
        scrollPosition: '=',
        maxHeight: '='
      },
      link: function (scope) {
        $(window).on('scroll', function() {
          var scrollTop = $(window).scrollTop() > scope.maxHeight;
          if (scrollTop !== scope.prevScrollTop) {
            scope.$apply(function() {
              scope.scrollPosition = scrollTop;
            });
          }
          scope.prevScrollTop = scrollTop;
        });
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('trackWidth', trackWidth);

  /** @ngInject */
  function trackWidth() {
    return {
      scope: {
        trackWidth: '=',
        minWidth: '=',
      },
      link: function (scope, element) {
        scope.trackWidth = $(element).width() < scope.minWidth;
        scope.prevTrackWidth = scope.trackWidth;

        $(window).resize(function() {
          var trackWidth = $(element).width() < scope.minWidth;
          if (trackWidth !== scope.prevTrackWidth) {
            scope.$apply(function() {
              scope.trackWidth = trackWidth;
            });
          }
          scope.prevTrackWidth = trackWidth;
        });
      }
    };
  }

})();
/**
 * Animated load block
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('zoomIn', zoomIn);

  /** @ngInject */
  function zoomIn($timeout, $rootScope) {
    return {
      restrict: 'A',
      link: function ($scope, elem) {
        var delay = 750;

        if ($rootScope.$pageFinishedLoading) {
          delay = 100;
        }

        $timeout(function () {
          elem.removeClass('full-invisible');
          elem.addClass('animated zoomIn');
        }, delay);
      }
    };
  }

})();
/**
 * @author n.poltoratsky
 * created on 27.06.2016
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.theme')
        .factory('baProgressModal', baProgressModal);

    /** @ngInject */
    function baProgressModal($uibModal) {
        var methods = {};
        var progress = 0;
        var max = 100;
        var opened = false;

        return {
            setProgress: function (value) {
                if (value > max) {
                    throw Error('Progress can\'t be greater than max');
                }
                progress = value;
            },
            getProgress: function () {
                return progress;
            },
            open: function() {
                if (!opened) {
                    methods = $uibModal.open({
                        animation: true,
                        templateUrl: 'app/pages/modals/progressModal/progressModal.html',
                        size: 'sm',
                        keyboard: false,
                        backdrop: 'static'
                    });
                    opened = true;
                } else {
                    throw Error('Progress modal opened now');
                }

            },
            close: function() {
                if (opened) {
                    methods.close();
                    opened = false;
                } else {
                    throw Error('Progress modal is not active');
                }

            }
        };
    }

})();
/**
 * @author v.lugovsky
 * created on 03.05.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .service('baUtil', baUtil);

  /** @ngInject */
  function baUtil() {

    this.isDescendant = function(parent, child) {
      var node = child.parentNode;
      while (node != null) {
        if (node == parent) {
          return true;
        }
        node = node.parentNode;
      }
      return false;
    };

    this.hexToRGB = function(hex, alpha) {
      var r = parseInt( hex.slice(1,3), 16 );
      var g = parseInt( hex.slice(3,5), 16 );
      var b = parseInt( hex.slice(5,7), 16 );
      return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + alpha + ')';
    };

    this.hasAttr = function (elem, attrName) {
      var attr = $(elem).attr(attrName);
      return (typeof attr !== typeof undefined && attr !== false);
    }
  }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .service('fileReader', fileReader);

  /** @ngInject */
  function fileReader($q) {
    var onLoad = function(reader, deferred, scope) {
      return function () {
        scope.$apply(function () {
          deferred.resolve(reader.result);
        });
      };
    };

    var onError = function (reader, deferred, scope) {
      return function () {
        scope.$apply(function () {
          deferred.reject(reader.result);
        });
      };
    };

    var onProgress = function(reader, scope) {
      return function (event) {
        scope.$broadcast('fileProgress',
            {
              total: event.total,
              loaded: event.loaded
            });
      };
    };

    var getReader = function(deferred, scope) {
      var reader = new FileReader();
      reader.onload = onLoad(reader, deferred, scope);
      reader.onerror = onError(reader, deferred, scope);
      reader.onprogress = onProgress(reader, scope);
      return reader;
    };

    var readAsDataURL = function (file, scope) {
      var deferred = $q.defer();

      var reader = getReader(deferred, scope);
      reader.readAsDataURL(file);

      return deferred.promise;
    };

    return {
      readAsDataUrl: readAsDataURL
    };
  }
})();
/**
 * @author a.demeshko
 * created on 3/1/16
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .service('preloader', preloader);

  /** @ngInject */
  function preloader($q) {
    return {
      loadImg: function (src) {
        var d = $q.defer();
        var img = new Image();
        img.src = src;
        img.onload = function(){
          d.resolve();
        };
        return d.promise;
      },
      loadAmCharts : function(){
        var d = $q.defer();
        AmCharts.ready(function(){
          d.resolve();
        });
        return d.promise;
      }
    }
  }

})();
/**
 * @author a.demeshko
 * created on 12/21/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .service('stopableInterval', stopableInterval);

  /** @ngInject */
  function stopableInterval($window) {
    return {
      start: function (interval, calback, time) {
        function startInterval() {
          return interval(calback, time);
        }

        var i = startInterval();

        angular.element($window).bind('focus', function () {
          if (i) interval.cancel(i);
          i = startInterval();
        });

        angular.element($window).bind('blur', function () {
          if (i) interval.cancel(i);
        });
      }
    }
  }

})();

(function () {
  'use strict';

function delete_cookie( name, path, domain ) {
  if( get_cookie( name ) ) {
    document.cookie = name + "=" +
      ((path) ? ";path="+path:"")+
      ((domain)?";domain="+domain:"") +
      ";expires=Thu, 01 Jan 1970 00:00:01 GMT";
  }
}

  angular.module('BlurAdmin.pages.auth')
    .factory('AuthService', AuthService);
  


  /** @ngInject */
  function AuthService($http, $window, $rootScope, $stateParams, $cookieStore, $cookies, API) {
    var loggedUser; var usr;
    try {
        setters();        
    } catch (err) {
      // console.log(err);
      loggedUser = null;
    }

    // var accessLevels = routingConfig.accessLevels
    //     , userRoles = routingConfig.userRoles
    //     , currentUser = usr || { username: '', role: userRoles.public };

    var  currentUser = usr || { username: '', role: "anon" };

    function changeUser(user) {
        angular.extend(currentUser, user);
        $cookies.put('app.oUwmsjuA', JSON.stringify(user));
    }

    function setters() {
        usr = JSON.parse($cookies.get('app.oUwmsjuA'));
        $rootScope.usr=usr;
        $http.defaults.headers.common.Authorization=usr.atok;
        loggedUser = JSON.parse($cookies.get('app.oUwmsjuA'));
        $rootScope.export= $cookies.get('export')=='true';
        $rootScope.metrics = $cookies.get('metrics')=='true';
        $rootScope.app_name = ($cookies.get('app_name'))?$cookies.get('app_name').replace(/\"/g, ''):"AI Reports";
        try{
          $rootScope.extras = JSON.parse($cookies.get('extras'));
        }catch(e){}
        $rootScope.promotion= $cookies.get('promotion')!='0';
        $rootScope.domain= $cookies.get('domain').replace(/\"/g, '');
        // $rootScope.promotions= JSON.parse($cookies.get('promotions'));
        $rootScope.title = $cookies.get('title').replace(/\"/g, '');
    }

    return {
        setters: setters,
        authorize: function(accessLevel){
            if(accessLevel === '*' && !$cookies.get('app.oUwmsjuA')) {
                return true;
            }
            return (accessLevel === 'logged' && !!$cookies.get('app.oUwmsjuA'));
        },
        login: function(user, success, error){
             var payload={
                client_id:'kq60fNxgKmXlRec5eAIjS0DM2heexI53gcKWe2Em',
                grant_type:'password',
                username: user.username,
                password: user.password
            }
            $http.post(API[API.ENV]+'api/v1/access/', $.param(payload), {
                headers:{
                  'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
                }
              })
              .success(function (response) {
                  response["success"]=true;
                  $http.defaults.headers.common.Authorization="Bearer "+response.access_token;
                  response.user["main_group"]=response.user.groups[0].name;
                  response.user["groupes"] = [];
                  angular.forEach(response.user.groups, function(value,index){
                    response.user["groupes"].push(value.name);
                  });
                  response.user["atok"]="Bearer "+response.access_token;
                  $rootScope.domain="";
                  $cookieStore.put("domain", "");

                  if (response.user.first_name!=""){
                    $cookieStore.put("app_name", response.user.first_name);
                  }
                  
                  var atok=response.user["atok"];
                  changeUser(response.user);
                  success(response);
              }).error(error);
        },
        logout: function(success, error){

            
            var cookies = $cookies.getAll();
            angular.forEach(cookies, function (v, k) {
                $cookies.remove(k, {path: '/'});
                $cookies.remove(k, {path: '/develop'});
            });

            $http.defaults.headers.common.Authorization = 'Basic ';
            success();
        },
        clear: function(){
             var cookies = $cookies.getAll();
            angular.forEach(cookies, function (v, k) {
                $cookies.remove(k, {path: '/'});
                $cookies.remove(k, {path: '/develop'});
            });
            $http.defaults.headers.common.Authorization = 'Basic ';
        },
        isLoggedIn: function(){
            return !!$cookies.get('app.oUwmsjuA');
        },
        updateUser: function(user){
          changeUser(user);
        },
        getLoggedUser: function(){
            return loggedUser;
        },
        user: currentUser
    };
    }



  angular.module('BlurAdmin.pages.auth')
      .service('databasService', databasService);
  /** @ngInject */
   function databasService($resource, API) {
    return $resource(API[API.ENV]+"api/v1/exports");
   }


})();

(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .controller('setSiteCtrl', function($scope, $uibModalInstance, Alias, data, CronService) {
    $scope.title = "Add Site";
    $scope.cronDescription = '';
    
    $scope.microsettings = {};
    $scope.microextras = {};

    $scope.status={open:0, open2:0};
    
    var additionals = {
      "analyses" : true,
      "permissions" : {
      "metrics" : true, "sales" : true, "workorders" : true, "inventory" : true,
      "benchmark" : true, "demos" : true, "reverse" : true}, "access" : "basic", "active" : 1
    };
    $scope.item = {sversion : "3.x", type_id: 1,  export:true, report:"", promotions:[], settings : {}, extras: additionals};
    
    var settings = {  "name": "production",
                      "api":{
                          "gov":{
                                "url": "https://vpic.nhtsa.dot.gov/"
                          },
                          "job" :{
                            "name": "", "token": ""
                          }
                      },
                      "permissions" : {
                            "metrics" : true, "sales" : true, "workorders" : true, "inventory" : true, 
                            "benchmark" : true, "demos" : true, "reverse" : true
                        },
                        "access" : "basic", "backward":0, "newscheme": true
                   };

    $scope.$watch('item.cron', function(newValue) {
        $scope.cronDescription = CronService.toString(newValue);
    });

    $scope.versions = [{value: "1.x", label: "Version 1.x"}, {value: "2.x", label: "Version 2.x"}, {value: "3.x", label: "Version 3.x"}]; 

    if (jQuery.isEmptyObject(data)){
      $scope.title = "Add new site";
      $scope.item["settings"] = settings;
    }else{
        $scope.title = "Edit site";
        $scope.disabling = true;

        if (data.settings && !$.isEmptyObject(data.settings) && data.settings.hasOwnProperty("cron")) {
          console.log("data settings");
          data["cron"] = data["settings"]["cron"];
          delete data["settings"]["cron"];
        }
        $scope.item = data;
        if ($.isEmptyObject(data.extras)){
            $scope.item["extras"] = additionals;
        }
        if ($.isEmptyObject(data.settings)){
            $scope.item["settings"] = settings;
        }
        $scope.item["sversion"] = data.sversion;
    }

    $scope.close = function() {
        $uibModalInstance.dismiss('no');
    };
  
    $scope.isObjectEmpty = function(obj){
      return Object.keys(obj).length === 0;
    } 

    $scope.addSite = function (form) {
      if (form.$valid){
          $scope.item["settings"]["cron"] = $scope.item["cron"];
          delete $scope.item["cron"]
          if (!$scope.disabling){
              Alias.save($scope.item, function(response){
                  $uibModalInstance.close(response);
              }, function (response) {
                  $scope.item["cron"] = $scope.item["settings"]["cron"]  
                  delete $scope.item["settings"]["cron"]
                  dialogs.error('Failed - Add Site','An unexpected problem has occurred.');
              });
          }else{
              Alias.update($scope.item, function(response){
                  $uibModalInstance.close($scope.item);
              }, function (response) {
                  $scope.item["cron"] = $scope.item["settings"]["cron"]  
                  delete $scope.item["settings"]["cron"]
                  dialogs.error('Failed - Add Site','An unexpected problem has occurred.');
              });                
          }
      }
    }

    $scope.addPromo = function (form) {
      $scope.microextras = additionals;
      $scope.item.promotions.unshift({ extras : additionals });
    }    

    $scope.selPromo = function(select){
        if ($.isEmptyObject(select.extras)){
            $scope.microextras = additionals;
        }else{
            $scope.microextras = select.extras;
        }
    }

    $scope.delPromo = function (promo) {
        var index = $scope.item.promotions.indexOf(promo);
        $scope.item.promotions.splice(index, 1);
    }   
  });

  angular.module('BlurAdmin.pages.dashboard')
      .controller('DashboardCtrl', DashboardCtrl);

  /** @ngInject */
  function DashboardCtrl(DashService, $scope, $q, $filter, Projects, fileFactory, $stateParams, metricsServices, $cookies, inventoryService, $timeout, dataService, $rootScope, $cookieStore, $state, $http, API, AuthService, Alias, toastr, $uibModal) {  

    $scope.edit_site = 0;
    $scope.loaded = false; 
    $scope.loading = true; 
    $scope.group = AuthService.user.groups[0];
    $scope.groups = AuthService.user.groupes;
    $rootScope.group_name = $scope.group.name;
    $scope.init = true;
    $scope.humbral = { "b" : 10 };
    $rootScope.sites = [];
    $rootScope.fullsites = [];
    $scope.analyses_filter = false;
    $scope.params = [];

    $scope.segm = 1;

    inventoryService.cancel();

    
    var index = 0;
    var textToType = 'Loading analysis...';
    var typingSpeed = 180;
  
    function typex(item) {
     
    if (!item.hasOwnProperty("typedText")){
      item["typedText"] = "";
      item["index"] = 0;
    }
      if (item.index < textToType.length) {
        item.typedText += textToType[item.index];
        item.index++;
        $timeout(function() {
          typex(item);
        }, typingSpeed);
      }
    }    

    $scope.siteFilter = function(item) {
      
      if ($scope.edit_site){
        return true;
      }
      // if ($scope.searchsite && item.title.toLowerCase().indexOf($scope.searchsite.toLowerCase()) === -1) {
      //   return false;
      // }
      
      return item.extras.analyses == true;
    };

    $scope.customFilter = function (item) {
      if ($scope.statuses=="all"){
        return true;
      }
      return item.status == $scope.statuses;
    }

    $scope.addNewSite = function () {
      $uibModal.open({
        animation: true,
        templateUrl: "app/pages/modals/modalTemplates/addSite.html",
        size: "lg",
        scope:$scope,
        controller: 'setSiteCtrl',
        backdrop: 'static', 
        keyboard: false,
        resolve: {
          data: function() {
            return {};
          }
        } 
      }).closed.then(function(data){

        if (data){
          $rootScope.sites.push(data);
          $rootScope.fullsites.push(data);
        }
      
      });

    }

    $scope.editSite = function($event, elem){
      $event.stopPropagation();
      console.log(elem);
      Alias.get({id:elem.id}, function(response){
        $uibModal.open({
          animation: true,
          templateUrl: "app/pages/modals/modalTemplates/addSite.html",
          size: "lg",
          scope:$scope,
          controller: 'setSiteCtrl',
          backdrop: 'static', 
          keyboard: false,
          resolve: {
            data: function() {
              return response;
            }
          } 
        }).closed.then(function(){

        });
      });
    }

    $scope.addSite = function (form) {
      if (form.$valid){
          if (!$scope.disabling){
              Alias.save($scope.item, function(response){
                  $uibModalInstance.close($scope.item);
              }, function (response) {
                  dialogs.error('Failed - Add Site','An unexpected problem has occurred.');
              });
          }else{
              Alias.update($scope.item, function(response){
                  $uibModalInstance.close($scope.item);
              }, function (response) {
                  dialogs.error('Failed - Add Site','An unexpected problem has occurred.');
              });                
          }
      }
  }

  $scope.removeSite = function($event, item) {
      $event.stopPropagation();
      $uibModal.open({
        animation: true,
        templateUrl: "app/pages/modals/modalTemplates/customModal.html",
        size: "sm",
        scope:$scope,
        controller:function($uibModalInstance, Projects) {
          $scope.selectedItem = item;
          $scope.title ="Remove Site ";
          $scope.description ="The site doens't will appear more in the system!";

          $scope.close = function() {
            $uibModalInstance.dismiss('no');
          }
          $scope.ok = function() {
            $uibModalInstance.close('yes');
            angular.forEach($rootScope.fullsites, function(site, key){
              if(item["alias"] == site["alias"]){
                  if (item.hasOwnProperty("promo_id")){          
                    var idxpromo = site["promotions"].findIndex(function(promo){ return promo["id"] == item["promo_id"]});
                    item["export"] = false;
                    site["promotions"][idxpromo]["export"] = false;
                  }else{
                    item["export"] = false;
                    site["export"] = false;
                  }
                  Alias.update(site, function(response){
                    var index = $rootScope.sites.indexOf(item);
                    $rootScope.sites.splice(index, 1);
                  }, function (response) {
                      console.error('Failed - Update Site','An unexpected problem has occurred.');
                  }); 
                  $scope.opacity = false;
              }
            });   
          }
        }
      }).closed.then(function(){
        $scope.selectedBox=null;
      });
    }

    $scope.updateSite = function($event, item) {
      $event.stopPropagation();

      angular.forEach($rootScope.fullsites, function(site, key){
        if(item["alias"] == site["alias"]){
          if (item.hasOwnProperty("promo_id")){          
              var idxpromo = site["promotions"].findIndex(function(promo){ return promo["id"] == item["promo_id"]});
              if (!item["extras"].hasOwnProperty("analyses")) {
                  item["extras"]["analyses"] = false;
              }
              item["extras"].analyses = (item["extras"].analyses)?false:true;
              if (!site["promotions"][idxpromo].hasOwnProperty("extras")) {
                site["promotions"][idxpromo]["extras"] = { "analyses" : item["extras"]["analyses"] };
              }else{
                site["promotions"][idxpromo]["extras"]["analyses"] = item["extras"].analyses;
              }
            }else{
              
              item["extras"].analyses = (item["extras"].analyses) ? false : true;
              
              if (!site.hasOwnProperty("extras")) {
                site["extras"] = { "analyses" : item["extras"]["analyses"] };
              }else{
                site["extras"]["analyses"] = item["extras"]["analyses"];
              }
            }
            Alias.update(site, function(response){
            }, function (response) {
                console.error('Failed - Update Site','An unexpected problem has occurred.');
            }); 
            // $scope.opacity = false;

        }

      });   

    }

    $scope.setEdit = function() {
      $scope.edit_site = ($scope.edit_site)?false:true;
      // $scope.opacity = true;
    }

    $scope.Copy = function($event, item, index) {
         if($event){
          $event.stopPropagation();
          $event.preventDefault();
        }
        var copyText = document.getElementById("dealername"+index);
        var textArea = document.createElement("textarea");

        textArea.value = copyText.textContent;
        document.body.appendChild(textArea);
        textArea.select();
        textArea.setSelectionRange(0, 99999); 
        document.execCommand("Copy");
        textArea.remove();

        item.copy = true;
        item.copy_msg ="Copied!";
        $timeout(function() {
          item.copy = false;
          item.copy_msg ="Copy dealer name!";
        }, 600);

        return;
    };

    $scope.optionsLine = {
            responsive: true,
            elements: {
              line: {
                fill: false,
                 // tension: 0
              }
            },
            legend: {
              display: true,
              position: "top"
            },
        };

    $scope.caches = [];
    $scope.results = [];
    // $scope.adealer = [];

    if ($stateParams.type){
      $scope.type=$stateParams.type;
    }else{
      $scope.type="new";
    }

    $scope.dimensions=[{"value":"body_style", "text": "Body Style"},  {"value":"make", "text": "Make"},  {"value":"model", "text": "Model"}];
  
    $scope.rawProperty = function(key) {
        return function(item) {
            return item[key];
        };
    };

    if ($stateParams.dimension){
      $scope.dimension = $stateParams.dimension;
    }else{
      $scope.dimension = "model";
    }
    $scope.configSingleOne = {
      maxItems: 1,
      persist:true, 
      valueField: 'value',
      labelField: 'text'
    };

    $scope.cancelAllRequests = function() {
      angular.forEach($http.pendingRequests, function(request) {
        if (request.cancel) {
          request.cancel.resolve(); // resolve the cancel promise to cancel the request
        }
      });
    };
    

    $scope.configSelect = {
      plugins:['remove_button'],
      persist:true,
      valueField: 'value',
      labelField: 'text'
    };
    
    $scope.openOportunity = function (dealer, prop, dimname) {
      dealer['entity'] = prop;
      dealer[prop] = dimname;
      $state.go('home.demos', {id:null, oportunity: {project: null, dealer:dealer}});
    }


    $scope.openOrder = function (dealer, prop, dimname) {
      dealer['entity'] = prop;
      dealer[prop] = dimname;
      $state.go('home.neworder', {id:null, oportunity: {project: null, dealer:dealer}});
    }

    $scope.barspecs = {
      responsive:true,
    maintainAspectRatio: true,
    devicePixelRatio: 1,
      scaleShowValues: false,
          scales: {
             xAxes: [{
                 ticks: {
                     min: 0,
                     stepSize:20,
                     max: 100,
                     callback: function(value) {
                         return value + "%"
                     },
                     fontColor: '#000',
                     fontFamily:'Rubik'
                 }
             }],
            yAxes: [{
              ticks: {
                fontSize: 15,
                beginAtZero: true
              }
            }],
                
          },
          tooltips: {
              enabled: false
            },
          legend: {
              display: true,
              position: "top",
              onClick: null,
              align: "left",
              labels:{
                fontSize:14,
                fontFamily:'Rubik',
                fontColor: '#000'
              }
          },
          hover: { animationDuration: 0 },

          animation: {
            onComplete: function () { 
                var ctx = this.chart.ctx;
                ctx.font = Chart.helpers.fontString(13, 'bold', 'Rubik');
                ctx.fillStyle = '#000';
                ctx.textAlign = 'center';
                ctx.textBaseline = 'bottom';
                this.data.datasets.forEach(function (dataset) {
                  for (var i = 0; i < dataset.data.length; i++) {
                    if(dataset.hidden === true && dataset._meta[Object.keys(dataset._meta)[0]].hidden !== false){ continue; }
                    var model = dataset._meta[Object.keys(dataset._meta)[0]].data[i]._model;
                    if(dataset.data[i] !== null){
                      var value = dataset.data[i].toString();
                      value = value + "%";
                      ctx.fillText(value, model.x + 25, model.y + 7);
                    }
                  }
                });
            }
          }
        };


    $scope.datasetOverride = [
       {
            fill: true,
            backgroundColor: "#065cbe"
            
        },
        {
            fill: true,
            backgroundColor:  "#55bef2"
            
        }
    ];

    $scope.barseries = ["Inventory", "Sales"];
    $scope.barlabels = [" "];
    $scope.barcolors = ["#065cbe", "#55bef2"];

    $scope.getStockByName= function(name, item) {
      var quantity = 0;
      angular.forEach(item.metrics.stocksales, function(value, index){
        if(name == value.name){
          quantity = value.quantity;
        }
      });
      return quantity;
    }

    $scope.openOnClose = function(id, item, scroll) {
        typex(item);
        $(".chartjs-canvas-holder-bar").css("height", "150px");
        console.log("scroll",scroll);
        if (scroll){
          $timeout(function () {
            $('html,body').animate({
            scrollTop: $("#acor"+id).offset().top-80},
            'medium');
            $scope.top=$("#acor"+id).offset().top-80;
          },400);
        }

        $scope.colors = [ "#DB4453",  "#F6BB43", "#8DC152", "#4989DD", "#957ADB", "#D870AD", "#4BC0C0", "#FFCD56"];

        var info = $scope.caches.find(function(x){ return x.id == item.id;});
        item["metrics"] = info.metrics;

        var data = {};
        data["path"] = "saleshistory";
        data["section_id"] = [ item.id ];

        if ($scope.type=="certified"){
          data["certified_preowned[]"] = [ 1 ];
        }
        
        var labelsLine = []; var valuesLine = []; var seriesLine = [];
        var index = 0;

        if(!item.hasOwnProperty("labelsLine")){
        item["opportunities"] = info.opportunities;
        angular.forEach(item.opportunities, function(value, index){
          if (value.type=="A1" || value.type=="A2"){
            value.data = [[value.pctstock], [value.pctsales]];

          }
          value.quantity = $scope.getStockByName(value.dimension, item);
        });

        var payload = {};

        var stocksales = item["metrics"]["stocksales"];
        
        stocksales.forEach(function(stock) {
          delete stock.b2;
          delete stock.b1;
          delete stock.$$hashKey;
        });

        payload["metrics"] = JSON.stringify(stocksales);
        payload["name"] = item["name"]
        payload["path"] = "analysis"
        payload["section_id"] = [ item.id ];
        payload["dimension"] = $scope.dimension;
        
        inventoryService.getReport(null, payload).then(function(response){
          console.log(response);
           item["analysis"] = response.data.analysis;
        }, function (response) {
        });

        item["humbral"] = info.humbral; 
         $(".chartjs-canvas-holder-third-row").css("height", "450px");
          data["dimension"] =  $scope.dimension;
          data["metrics"] = JSON.stringify(item["metrics"]["stocksales"]);
          data["name"] = item["name"];
          inventoryService.getReport(null, data).then(function(response){
            try{
                var data = response.data;
                angular.forEach(data.data, function (value, key) {
                  if (value.name!="UNKNOWN"){
                    seriesLine.push(value.name);
                    valuesLine.push([value.period1, value.period2, value.period3, value.period4, value.period5, value.period6, value.period7, value.period8, value.period9])
                  }
                });

                $(".chartjs-canvas-holder-third-row").css("height", "450px");
                item["seriesLine"] = seriesLine;
                item["labelsLine"] = data.periods;
                item["dataLine"] = valuesLine;

              }catch(err){
                console.log("err");
                console.log(err);
              }
          }, function (response) {
          });
        }

        $state.go("home.dashboard", {id:item.id, dealer:item.name, dimension:$scope.dimension}, {location: "replace", notify: false});
    
      }

    $scope.getMetrics = function (data) {
        var deferred = $q.defer();
        metricsServices.save(data, function(response){  
             deferred.resolve(response);
        }, function (response) {
             deferred.reject({"dealers":[]});
        });
        return deferred.promise;
    }

    $scope.switchType = function (value, onlyset) {
      switch(value){
        case "all":
          dataService.setTypes(["New", "Used"]);
          dataService.setCertified([0, 1]);
          $scope.dataType = dataService.getTypes();
          $scope.certified = dataService.getCertified();
          
          if (!onlyset){
            $scope.getDealers();
          }
          
          break;
        case "new":
          dataService.setTypes(["New"]);
          dataService.setCertified([0]);
          $scope.dataType = dataService.getTypes();
          $scope.certified = dataService.getCertified();
          
          if (!onlyset){
            $scope.getDealers();
          }
          break;
        case "used":
          dataService.setTypes(["Used"]);
          dataService.setCertified([0,1]);
          $scope.dataType = dataService.getTypes();
          $scope.certified = dataService.getCertified();
          
          // if (!onlyset){
            $scope.getDealers();
          // }
          break;
        case "certified":
          dataService.setTypes(["Used"]);
          dataService.setCertified([1]);
          $scope.dataType = dataService.getTypes();
          $scope.certified = dataService.getCertified();
          if (!onlyset){
            $scope.getDealers();
          }
          break;
        
      }
    }

    $scope.toggleType = function(value, onlyset) {
      if (!$scope.mainloading){
        $scope.completeLoad=false;
        $scope.loadDealers = false;
        $scope.opacity=true;
        $scope.dealer=[];
        $scope.results=[];
        $scope.loading = true;
        
        var data = {};
        data["dimension"] =  $scope.dimension;
        if (value =="new" || value =="used"){
          data["type_name"]= value;
        }
        
        data["certified"] =  (value=="certified")?1:undefined;
        $scope.certype = (data["certified"])?true:false; 
        
        $scope.getMetrics(data).then(function(response) { 
          $scope.caches = response.dealers;
          // angular.forEach($scope.caches, function(val, idx){
          //     $scope.results.push({id:val.id, name:val.name, qtyoppors:val.qtyoppors});                
          // });
          $scope.humbral = response.humbral;
          $scope.switchType(value, false);
        });

        console.log("$scope.certype", $scope.certype);
      
        // $scope.switchType(value, onlyset);

        $scope.lasttype = value;

        if (!onlyset){
          $state.go("home.dashboard", {id:undefined, dealer:undefined, type:value}, {location: "replace", notify: false});
        }
      }
    }

    $scope.limit = 15;
    $scope.mainloading = true; 

    $scope.loadMore = function () {
      // if ($scope.limit <= $scope.results.length){
      //   $scope.limit = $scope.limit + 15; 
      // }
      if (!$scope.mainloading && !$scope.adealer.length){
            console.log("FLAG 2");
            var data = {"dimension" : $scope.dimension}; 
  
            if ($scope.type =="new" || $scope.type =="used"){
              data["type_name"]= $scope.type;
            }
            data["certified"] =  ($scope.type=="certified")?1:undefined;

            $scope.segm++;
            data["segm"] = $scope.segm; 
            $scope.mainloading = true;
            metricsServices.save(data, function (response) {
              console.log("FLAG");
              angular.forEach(response.dealers, function(v, k){
                $scope.caches.push(v);
              });

              $scope.init=false;

              angular.forEach($scope.caches, function(val, idx){
                var objparam = $scope.params.find(function(item){ return item ==  val.id});
                var exist_param = $scope.results.find(function(item){ return item.id ==  val.id});
                if (objparam && !exist_param){
                  $scope.results.push({id:val.id, datetime: val.datetime, name:val.name, qtyoppors:val.qtyoppors});                
                }
              });
              $scope.mainloading = false;

            });
          }
    }

    $scope.printPdf = function (item) {
        item["humbral"] = $scope.humbral;
      // console.log(JSON.stringify(item));
        $("#chartline" + item.id ).css("width", "980px");
        var url_base64 = document.getElementById("line" + item.id ).toDataURL("image/jpg");
        var payload = {data:item};
        payload["url_base64"] = url_base64;
        $timeout(function() {
          var url_base64 = document.getElementById("line" + item.id ).toDataURL("image/jpg");
          var payload = {data:item};
          payload["url_base64"] = url_base64;
          $("#chartline" + item.id ).css("width", "100%");        
          fileFactory.downloadFile(API[API.ENV]+"api/v1/metricspdf", "post", payload, "export_"+ new Date(), false, function (response) {
          });
        }, 100);
    }


    $scope.myFilter = function (item) { 
      return item.name != '0' && item.name != null && item.name!="UNKNOWN"; 
    };

    $scope.nonZero = function (item) { 
        return item.quantity!=0; 
    };

    $scope.myFilter2 = function (item) { 
        return item.quantity!=0; 
    };

    $scope.getDealers = function(){
        
        inventoryService.getDealers($scope.group.name, dataService.getParams("dealers")).then(function(response){
          
          $scope.loaded=true;
          $scope.dealers = response.data.resultset.map(function(x) { return { value: x["section_id"],  text: x["section_name"]};});
          $scope.results = [];
          var params = []; 
          
          if ($scope.adealer){
            
            if ($scope.adealer.length){
              var dealers = dataService.getBuildParams($scope.dealers, $scope.adealer);
              angular.forEach(dealers, function(value,index){
                 var info = $scope.dealers.find(function(x){ return x.text == value;});
                 if(info){
                    params.push(info.text);
                 }
              
              });  
            }
          }

          if (!params.length){
            angular.forEach($scope.dealers, function(value,index){
              params.push(value.text);
            });
          }

          angular.forEach($scope.caches, function(val, idx){
            var objparam = params.find(function(item){ return item ==  val.name});
            if (objparam){
              $scope.results.push({id:val.id, datetime: val.datetime, name:val.name, qtyoppors:val.qtyoppors});                
            }
          });
                  
          if ($scope.results.length){
            $scope.loading = false;
          }

          if ($scope.certype){
            var data = {};
            data["dimension"] =  $scope.dimension;
            data["certified"] =  ($scope.type=="certified")?1:undefined;          
            data["segm"] = 2;

            $scope.getMetrics(data).then(function(response2) { 
              $scope.loading = false;
              angular.forEach(response2.dealers, function(v, k){
                $scope.caches.push(v);
              });

              if (response2.dealers.length){
                angular.forEach(params, function(v, k){
                    angular.forEach(response2.dealers, function(val, idx){
                        if (val.name == v){
                          $scope.results.push({id:val.id, datetime: val.datetime, name:val.name, qtyoppors:val.qtyoppors});                
                        }
                    });
                });
              }
            });
          }

        });
    }

    if(!$rootScope.metrics){
      $rootScope.domain = "";
    }

    $scope.initialize = function() {
        if ($rootScope.domain!=""){
          var data = {};
          data["dimension"] = $scope.dimension
          if ($scope.type =="new" || $scope.type =="used"){
              data["type_name"]= $scope.type;
          }
          data["certified"] =  ($scope.type=="certified")?1:undefined;

          inventoryService.getDealers($scope.group.name, dataService.getParams("dealers")).then(function(response){
            $scope.loaded = true;
            $scope.dealers = response.data.resultset.map(function(x) { return { value: x.section_id,  text: x.section_name};});
           
            if ($stateParams.id){
              $scope.adealer = [$stateParams.id];
              $scope.params = [$stateParams.id];
            }else{
              $scope.adealer = [];
              angular.forEach($scope.dealers, function(value,index){
                $scope.params.push(value.value);
              });
            }
            
            metricsServices.save(data, function (response) {
                $scope.humbral = response.humbral;

                angular.forEach(response.dealers, function(dval, dkey){
                  $scope.caches.push(dval);
                });

                $scope.results = [];

                angular.forEach($scope.caches, function(val, idx){
                  var objparam = $scope.params.find(function(item){ return item ==  val.id});
                  if (objparam){
                    $scope.results.push({id:val.id, datetime: val.datetime, name:val.name, qtyoppors:val.qtyoppors});                
                  }
                });

                $scope.init = true;
                $scope.loading = false;
                $scope.mainloading = false;

            });
          });
        }
    } 

     dataService.initialize();

    if ($stateParams.type){
      $scope.toggleType($stateParams.type, true);
    }else{
      $scope.type = "new";
      $scope.toggleType("new", true);
    }

    $scope.initialize();

    $scope.reload = function(response){
      var params = [];
      angular.forEach($scope.dealers, function(value,index){
        params.push(value.text);
      });
      angular.forEach(params, function(value,index){
         var info = response.find(function(x){ return x.name == value;});
         if(info){
            $scope.results.push({ id: info["id"], name: info["name"],  qtyoppors: info["qtyoppors"]});
         }
      }); 

      $state.go("home.dashboard", {id:undefined, dealer:undefined, dimension:undefined, type:undefined}, {location: "replace", notify: false});
 
    }
      

    $scope.getBenchmark = function(item){
        $state.go("home.dashboard", {id:item.id, dealer:item.name, dimension:$scope.dimension}, {location: "replace", notify: false});
        $timeout(function() {
          $state.go('home.benchmark', {id:item.id, dealer:item.name, dimension:$scope.dimension});
        }, 100);
    }
    
    $scope.$watch('adealer', function (value, oldvalue) {
          // if (!$scope.init){
            $scope.loading = true;
            if (value && oldvalue){
              if (value.length < oldvalue.length){
                var missing = oldvalue.filter(function(item) {
                  return value.indexOf(item) === -1;
                });
                console.log($scope.caches)
                var index = $scope.caches.findIndex(function(item) {
                  return item.id === parseInt(missing[0]);
                });
                console.log("remove fromcache")
                $scope.caches.splice(index, 1)
              }
            }


            if (value){
              console.log($scope.init);
              console.log(value);
                $scope.results = [];
                if (value.length){
                  var params = dataService.getBuildParamsValue($scope.dealers, $scope.adealer);
                  // console.log(params);
                  angular.forEach(params, function(v, k){
                      var founded = false;
                      angular.forEach($scope.caches, function(val, idx){
                          if (val.id == parseInt(v)){
                            val["selected"]= false;
                            console.log("selected");
                            $scope.results.unshift(val);
                            founded = true;                
                          }
                      });
                      if(!founded){
                        var payload = {"dimension" : $scope.dimension, "id" : parseInt(v) };
                        metricsServices.save(payload, function (response) {
                          $scope.caches.push(response.dealers[0]);
                          $scope.results.unshift(response.dealers[0]);
                        })
                      }
                  });
                  console.log("FLAG 1")

                  if ($scope.results.length) {
                    // $scope.init = false;
                    console.log($scope.results[0]);
                    // $scope.openOnClose(0, $scope.results[0], false);
                  } 
                
                }else{
                  console.log("FLAG 2")
                  $scope.reload($scope.caches);
                  $scope.limit = 15;
                }
                  
            }else{
              console.log("FLAG 3")
              $scope.reload($scope.caches);
              $scope.limit = 15;
            }
          // }
    });

    $scope.$watch('dimension', function (value, oldvalue) {
        if(!$scope.init){
          if (value && oldvalue){
              var data = {};
              data["dimension"] = value;
              data["certified"] =  ($scope.type=="certified")?1:undefined;
              $scope.loading = true;
              $scope.results = [];
                metricsServices.save(data, function (response) {
                    $scope.results = [];
                    $scope.loading = false;
                    $scope.caches = response.dealers;
                    $scope.humbral = response.humbral;
                    var params = dataService.getBuildParams($scope.dealers, $scope.adealer);
                    
                    angular.forEach(params, function(v, k){
                        angular.forEach($scope.caches, function(val, idx){
                            if (val.name == v){
                              $scope.results.push(val);                
                            }
                        });
                    });

                    data["segm"] = 2;
                    metricsServices.save(data, function (response2) {
                      angular.forEach(response2.dealers, function(v, k){
                        $scope.caches.push(v);
                      });

                      if (!$scope.adealer.length){
                          $scope.reload($scope.caches);
                      }else{
                        angular.forEach(params, function(v, k){
                            angular.forEach($scope.caches, function(val, idx){
                                if (val.name == v){
                                  $scope.results.push(val);                
                                }
                            });
                        });
                      }
                    });
                });
          }
        }
    });


    DashService.getSites($scope.group, $scope.groups, function (response) {
    }, function (response) {
    });

    $scope.setGroup=function(item) {
      if($scope.edit_site){
        $scope.isAnimating = true;
        $timeout(function() {
          $scope.isAnimating = false;
        }, 1000); 
        toastr.info('<span class="toast-description">Ready to explore? Please save your favorite sites to select and explore them at your convenience! <span>', '<strong class="toast-titles"> Save Sites List <ion-icon class="ion-archive"></ion-icon> </strong>');          
        return;
      }
      
      $scope.caches = [];
      $scope.results = [];

      DashService.setSite(item);
        if( $rootScope.group_name == 'root' ){
          
          if ($rootScope.metrics ){
            $scope.loading = true;
            $scope.initialize();
          }else{
            try{
              if ( $rootScope.extras.access != "basic" || $rootScope.group_name == 'root' ){
                $state.go("home.inventory");
              }else{
                $state.go("home.export");
              }
            }catch(e){
              $state.go("home.inventory");
            }
          }
        }else{
          try{
            if ( $rootScope.extras.access != "basic" || $rootScope.group_name == 'root' ){
              $state.go("home.inventory");
            }else{
              $state.go("home.export");
            }
          }catch(e){
            $state.go("home.inventory");
          }
        }
    }

  }
})();

(function () {
  'use strict';

  angular.module('BlurAdmin.pages.home')
      .controller('HomeCtrl', HomeCtrl);

  /** @ngInject */
  function HomeCtrl($scope, $rootScope, $state, AuthService, DashService, $stateParams) {
      
      $scope.user={};
      $rootScope.logout=function(form) {
        AuthService.logout(function() {
           $state.go("auth");
        }, function() {
            $rootScope.error = "Failed to logout";
        });
      }


      $rootScope.showSites = function(){

        $rootScope.metrics = false;
        $rootScope.domain = "";
        DashService.unsetSite();
        $stateParams = {};
        $state.go("home.dashboard", {id:null, dealer:null, dimension:null}, {location: "replace", notify: false});
        $state.go("home.dashboard");
        $scope.adealer = [];
        $scope.results = [];
        $scope.caches = [];
      }

      // $rootScope.showSites = function() {
      //   $rootScope.$broadcast('showSites');
      // };

      // $rootScope.$on('showSites', function() {
      //   $rootScope.showSites();
      // });
      
  }
})();

(function () {
  'use strict';

  angular.module('BlurAdmin.pages.export')
      .controller('EditorCtrl', EditorCtrl);

  /** @ngInject */
  function EditorCtrl($scope, $state, $stateParams, $rootScope, debounce, $q, $filter, layoutPaths, $location, tempbaseService, $window, $anchorScroll, baConfig, colorHelper, $timeout, $uibModal, inventoryService, dataService, themeLayoutSettings, AuthService, toastr, toastrConfig, filtersService, exportsService, editableOptions, editableThemes, fileFactory, fileReader, API, baProgressModal, templatesService, Projects, $cookies) {
      $scope.color={header:"#fff", footer:"#fff", title:"#fff"};
      $scope.conf={};
      if ($stateParams.template_id!=""){
        $scope.create=false;
      }else{
        tempbaseService.query(function (response) {
          $scope.bases = response;
        }, function (response) {
        });
        $scope.create=true;
      }


    $scope.sections=[];

    $scope.init_project=0;
      
    try{
      if (!$stateParams.templates){
          $scope.templates=JSON.parse(localStorage.templates);  
      }else{
        $scope.templates=$stateParams.templates;
      }

      if (!$stateParams.conf){
        $scope.conf={};
      }else{
        $scope.conf=$stateParams.conf;
        $cookies.put('conf', JSON.stringify($scope.conf));
      }

      for (var i = 0; i < $scope.templates.length; i++) {
        if($stateParams.template_id==$scope.templates[i].id){
          localStorage.setItem("templates", JSON.stringify($scope.templates));
          $scope.template=$scope.templates[i];
          // console.log($scope.template);
          $scope.conf["template"]=$scope.template.name;

        }
      }
    }catch(e){
          
    }


    $scope.goBackTemp = function (type) {
        $state.go("home.export.index", {mode:$stateParams.mode, id:$stateParams.pid, conf:$scope.conf, template_id:$scope.template.id});
    };


    $scope.goBack = function () {
      // $state.go("home.export.index", {});
      $state.go("home.export.index", {mode:$stateParams.mode, id:$stateParams.pid, conf:$scope.conf, template_id:$scope.template.id});
    };

    $scope.goBack2 = function () {
      // $state.go("home.export.index", {});
      $state.go("home.export.index", {mode:$stateParams.mode,id:$stateParams.pid});
    };

    $scope.selectTemplate = function (id) {
      $scope.selectedTemplate=id;
    };

    $scope.templateNew={};
    $scope.createTemplate = function () {
      
      if (!$scope.templateNew.name){
          toastr.warning('<span class="toast-description">   Enter right data   <span>', '<strong class="toast-titles"> Enter a valid template name.</strong>');   
        return;
      }

      if (!$scope.selectedTemplate){
          toastr.warning('<span class="toast-description">  Enter right data  <span>', '<strong class="toast-titles"> You must select a base template.  </strong>');   
        return;
      }

      var data = {name:$scope.templateNew.name, clone:$scope.selectedTemplate};

      templatesService.save(data,function (response) {
        $scope.template=response;

        $scope.conf["template"]=response.name;
        $scope.create=false;
        $("#iframe-container iframe")[0].setAttribute("height", 1460);


    Projects.get({id:$stateParams.pid}, function(response){
      $scope.sections=response.sections;
      $scope.conf["sections"]=response.sections;
      console.log($scope.sections);
       templatesService.update($scope.template, function (response) {
            $scope.conf.limit = $scope.limit;
            console.log($scope.conf);
            $scope.template = response;
            fileFactory.downloadFile(API[API.ENV]+"api/v1/exports", "post", $scope.conf, "export_"+ new Date(), true, function (response) {
              $scope.init_project = 1;
              $scope.pdfUrl = response;
            });
          });

    });      
          
      }, function (response) {
          toastr.warning('<span class="toast-description">  Check it with support  <span>', '<strong class="toast-titles"> Something went wrong. </strong>');   
        
      });
    };

    $scope.uploadPictureSolution = function (id) {
      var fileInput = document.getElementById(id);
      fileInput.value="";
      fileInput.click();
    };

    $scope.uploadPictureFooter = function () {
      var fileInput = document.getElementById("fileFooter");
      fileInput.value="";
      fileInput.click();
    };

    $scope.uploadPictureHeader = function () {
      var fileInput = document.getElementById("fileHeader");
      fileInput.value="";
      fileInput.click();
    };

    $scope.section_id=null;
    
    $scope.uploadPictureSection = function () {
      var fileInput = document.getElementById("fileSection");
      fileInput.value="";
      fileInput.click();
    };

    $scope.uploadPictureDealer = function (section_id) {
      $scope.section_id=section_id;
      var fileInput = document.getElementById("sectionImage");
      fileInput.value="";
      fileInput.click();
    };

      function create_UUID(){
          var dt = new Date().getTime();
          var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
              var r = (dt + Math.random()*16)%16 | 0;
              dt = Math.floor(dt/16);
              return (c=='x' ? r :(r&0x3|0x8)).toString(16);
          });
          return uuid;
      }

    $scope.getFile = function (file, id) {
      
      fileReader.readAsDataUrl(file, $scope)
          .then(function (result) {
            $scope.picture = result;
            baProgressModal.open();
             var url = API[API.ENV]+"api/v1/exports";
            if ($scope.template.ttype=="dynamic"){
              url = API[API.ENV]+"api/v1/solutions";
            }

            if (id=="sectionImage"){
              var data={base64: result, id:$scope.template.name, name:id, section_id:$scope.section_id, pid:$stateParams.pid};
              fileFactory.uploadFileSection(data, function(response){
                $scope.conf["sections"]=response.sections;
                for (var i = $scope.sections.length - 1; i >= 0; i--) {
                  if ($scope.sections[i].id==$scope.section_id){
                    $scope.sections[i].section_image=response.image_url;
                     $("#dealer_image"+$scope.section_id.toString()).attr('src', response.image_url+"?cache="+create_UUID());
                  }
                }
                if (response.success){ 
                  fileFactory.downloadFile(url, "post", $scope.conf, "export_"+ new Date(), true, function (response) {
                      $scope.pdfUrl=response;
                    });
                  $scope.$apply();
                }
              }, function(response){
              });
            }else{
              var data={base64: result, id:$scope.template.name, name:id};
              fileFactory.uploadFile2(data, function(response){
                if (response.success){
                  if(id=="footer"){
                    $scope.template["footer_img"]=response.image_url;
                  }else{
                    console.log(id);
                    if(id=="section"){
                      $scope.template["section_img"]=response.image_url;
                    }else{
                      if(id=="header"){
                        $scope.template["header_img"] = response.image_url;
                      }else{
                        $scope.template.images[id] = response.image_url;
                      }
                    }
                  }

                  fileFactory.downloadFile(url, "post", $scope.conf, "export_"+ new Date(), true, function (response) {
                      $scope.pdfUrl=response;
                    });
                  $scope.$apply();
                }
              }, function(response){
              });
            }

          });
    };


    $scope.options = {
      required: true,
      placeholder: 'Hex',
      inputClass: 'picker-color',
      // validation
      restrictToFormat:true,
      allowEmpty:true,
      // color
      format: 'hex',
      case: 'lower',
      // sliders
      hue: true,
      alpha: false,
      dynamicSaturation: true,
      dynamicLightness: true,
      dynamicAlpha: false,
      pos: 'bottom left'
    };

    $scope.templates=[];
    $scope.limit=5;

    $scope.reload = function(){
        if(!$scope.create){
        if ($scope.init_project){ 
          templatesService.update($scope.template, function (response) {
            $scope.conf.limit=$scope.limit;
            // console.log($scope.conf);
            var url = API[API.ENV]+"api/v1/exports";
            if ($scope.template.ttype=="dynamic"){
              url = API[API.ENV]+"api/v1/solutions";
            }

            fileFactory.downloadFile(url, "post", $scope.conf, "export_"+ new Date(), true, function (response) {
                $scope.pdfUrl=response;
            });

          });
        }
      }      
    }

    $scope.reload();

    Projects.get({id:$stateParams.pid}, function(response){
      $scope.sections=response.sections;
      $scope.conf["sections"]=response.sections;
       templatesService.update($scope.template, function (response) {
          $scope.conf.limit=$scope.limit;
          var url = API[API.ENV]+"api/v1/exports";
          if ($scope.template.ttype=="dynamic"){
            url = API[API.ENV]+"api/v1/solutions";
          }
          $scope.template = response;
          fileFactory.downloadFile(url, "post", $scope.conf, "export_"+ new Date(), true, function (response) {
            $scope.init_project=1;
            $scope.pdfUrl=response;
            templatesService.get({id:$stateParams.template_id}, function (response) {
              $scope.template = response;
            });
          });
        
        });

    });

    $scope.rangeFinishTitle=function (value) {
      $scope.template.item_title_size=value.from.toString();
      $scope.$apply(); 
    }

    $scope.rangeFinishSubtitle=function (value) {
      $scope.template.item_subtitle_size=value.from.toString();
      $scope.$apply(); 
    }

    $scope.rangeFinishExtitle=function (value) {
      $scope.template.item_extxt_size=value.from.toString();
       $scope.$apply(); 
    }

    $scope.rangeFinishTitle2=function (value) {
      $scope.template.item_title_size2=value.from.toString();
      $scope.$apply(); 
    }

    $scope.rangeFinishSubtitle2=function (value) {
      $scope.template.item_subtitle_size2=value.from.toString();
      $scope.$apply(); 
    }

    $scope.rangeFinishExtitle2=function (value) {
      $scope.template.item_extxt_size2=value.from.toString();
       $scope.$apply(); 
    }

    $scope.rangeFinishSectionTitle2=function (value) {
      $scope.template.section_title_size2=value.from.toString();
       $scope.$apply(); 
    }

    $scope.rangeFinishSeparator=function (value) {
      $scope.template.sep_h=value.from.toString();
       $scope.$apply(); 
    }

  }


  angular.module('BlurAdmin.pages.export')
    .controller('modalCtrl', modalCtrl);

  /** @ngInject */
  function modalCtrl($scope, $uibModalInstance) {
    // $scope.link = '';
    $scope.ok = function () {
      // $uibModalInstance.close($scope.link);
      $uibModalInstance.close();
    };

  }


})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.inventory')
      .directive('condChart', trafficChart);

  /** @ngInject */
  function trafficChart() {
    return {
      restrict: 'E',
      controller: 'CondChartCtrl',
      templateUrl: 'app/pages/inventory/condChart/CondChart.html'
    };
  }
  
})();


(function () {
  'use strict';

  angular.module('BlurAdmin.pages.inventory')
      .controller('CondChartCtrl', CondChartCtrl);

  /** @ngInject */
  function CondChartCtrl($scope, $filter, $state, $rootScope, baConfig, colorHelper, salesService, inventoryService, dataService, AuthService, toastr, toastrConfig) {

      $scope.transparent = baConfig.theme.blur;
      var dashboardColors = baConfig.colors.dashboard;
      var ctx;
      var params;

      $scope.group=AuthService.user.groups[0];

      $rootScope.group_name=$scope.group.name;

      if($state.current.title=="Sales"){
        var service_type = salesService;
        params = dataService.getParams("types", true);
      }else{
        var service_type = inventoryService;
        params = dataService.getParams("types");
      }
      

      service_type.getTypes($scope.group.name, params).then(function(response){
        $scope.totals=response.data.resultset; 
        $scope.doughnutData=$scope.readData($scope.totals);
        ctx = document.getElementById('chart-area').getContext('2d');
        window.myDoughnut = new Chart(ctx, {
            type: 'doughnut',
            data: $scope.doughnutData,
            options: {
                cutoutPercentage: 64,
                responsive: true,
                elements: {
                    arc: {
                        borderWidth: 0
                    }
                }
            }
        }); 
      }, function(response){
         toastr.error('<span class="toast-description"> Access Server <span>', '<strong class="toast-titles"> Unable to access data mining. Please check your connection, then try again </strong>');

      });

    $scope.readData = function(data){
      
      var BackgroundColor=[];
      var color = new Object();
        
      color["New"] = dashboardColors.blueStone;
      color["Used"] = dashboardColors.surfieGreen;

      angular.forEach(data, function(value, key) {
        BackgroundColor.push(color[value.type_name]);
      });

      if(BackgroundColor.length==1){
        $scope.backcolor = BackgroundColor[0];
      }

      var total=0;
      for (var i = 0; i < data.length; i++) {
        total+=data[i].total;
      }


      $(".cond-text").html($filter("number")(total)+"<span>Total Vehicles</span>");
        
      var Labels=[];
      for (var i = 0; i < data.length; i++) {
        Labels.push(data[i].type_name);
      }
      var Values=[];
      for (var i = 0; i < data.length; i++) {
        Values.push(data[i].total);
      }

      var Percentage=[];
      for (var i = 0; i < data.length; i++) {
        Percentage.push(((data[i].total/total)*100).toFixed(2));
      }

      return {
            labels: Labels,
            datasets: [
                {
                    data: Values,
                    backgroundColor: BackgroundColor,
                    // hoverBackgroundColor: [
                    //     colorHelper.shade(dashboardColors.blueStone, 15),
                    //     colorHelper.shade(dashboardColors.surfieGreen, 15),
                    // ],
                    percentage: Percentage
                }]
        };
    }
    
    $scope.refreshCondition=function(params) {
      if($state.current.title=="Sales"){
        var service_type = salesService;
        params = dataService.getParams("types", true);
      }else{
        var service_type = inventoryService;
        params = dataService.getParams("types");
      }
      service_type.getTypes($scope.group.name, params).then(function(response){
        $scope.totals = response.data.resultset;
        window.myDoughnut.data.labels = $scope.readData($scope.totals).labels; 
        window.myDoughnut.data.datasets = $scope.readData($scope.totals).datasets; 
        window.myDoughnut.update(); 
      }, function(response){
        toastr.error('<span class="toast-description"> Access Server <span>', '<strong class="toast-titles"> Unable to access data mining. Please check your connection, then try again </strong>');

      })
    }

    var refreshCondition = $rootScope.$on('refreshCondition', function(event, args) {
      event.preventDefault(); event.stopPropagation();
      $scope.refreshCondition(args);
    });

    $scope.$on('$destroy', refreshCondition);
  
  }
})();

(function () {
  'use strict';

  angular.module('BlurAdmin.pages.utils')
      .service('dataService', dataService);

  /** @ngInject */
  function dataService($http, $q, HOST) {
  	  var data = {};
      var date, pub, condition, certified_preowned, dealers, makes, models, years, bodys;

        return {
            initialize: function (from, to) {
              pub = [1]; date={from:undefined, to:undefined};
              condition = ["New", "Used"]; certified_preowned = [0,1];
              dealers=[]; makes=[]; models=[]; years=[]; bodys=[];
            },
            reset: function () {
              dealers=[]; makes=[]; bodys=[]; models=[]; years=[];
            },
            setPub: function (value){
                pub = value; 
            },
            getPub: function (){
                return pub; 
            },
            getDates: function () {
               return date;
            },
            setDates: function (start,end) {
               date["from"] = start;
               date["to"] = end;
            },
            setTypes: function (type) {
                condition = type;
            },
            getTypes: function () {
               return condition;
            },
            setCertified: function (certified) {
                certified_preowned = certified;
            },
            getCertified: function () {
               return certified_preowned;
            },
            setDealers: function (value) {
              dealers=[];
              if(typeof(value)=="undefined"){
                  dealers=[];
              }else{
                if(value.length){
                  angular.forEach(value, function(val, key) {
                    dealers.push(val);
                  });
                }else{
                  dealers=[];
                }
              }
            },
            getDealers: function () {
              return dealers;
            },
            setMakes: function (value) {
                makes=[];
                if(typeof(value)=="undefined"){
                  makes=[];
                }else{
                  if(value.length){
                    angular.forEach(value, function(val, key) {
                      makes.push(val);
                    });
                  }else{
                    makes=[];
                  }  
                }
            },
            getMakes: function (group, params) {
              return makes; 
            },
            setModels: function (value) {
                models=[];
                if(typeof(value)=="undefined"){
                  models=[];
                }else{
                  if(value.length){
                    angular.forEach(value, function(val, key) {
                      models.push(val);
                    });
                  }else{
                    models=[];
                  }
                }
            },
            getModels: function (style) {
                
                return models; 
            },
            setBodys: function (value) {
                bodys=[];
                if(typeof(value)=="undefined"){
                  bodys=[];
                }else{
                  if(value.length){
                    angular.forEach(value, function(val, key) {
                      bodys.push(val);
                    });
                  }else{
                    bodys=[];
                  }
                }
            },
            getBodys: function (style) {
                return bodys; 
            },
            setYears: function (value) {
                years=[];
                if(typeof(value)==undefined){
                  years=[];
                }else{
                  if(value.length){
                    angular.forEach(value, function(val, key) {
                      years.push(val);
                    });
                  }else{
                    years=[];
                  }  
                }  
            },
            getYears: function (){
                return years; 
            },
            getBuildParams: function (values, selecteds) {
                data=[];
                if (selecteds){
                  if(selecteds.length){
                    for (var i = 0; i < selecteds.length; i++) {
                      var val = selecteds[i];
                      var match = values.find(function(element) { return element.text == val;});
                      if (match){
                        data.push(val);    
                      } 
                    }
                  }else{
                    data =[];
                  }
                }

                return data; 
            },
            getBuildParamsValue: function (values, selecteds) {
              data=[];
              if (selecteds){
                if(selecteds.length){
                  for (var i = 0; i < selecteds.length; i++) {
                    var val = selecteds[i];
                    var match = values.find(function(element) { return element.value == val;});
                    if (match){
                      data.push(val);    
                    } 
                  }
                }else{
                  data =[];
                }
              }

              return data; 
          },
            getParams: function (mode, sales){
              
              var params = {}; 
              var dates = {};

              if (sales){
                  var dates = { 
                    from:date.from,
                    to:date.to
                  }
              }
              switch(mode){
                case "sections":
                case "dealers":
                case "types":
                    params = {
                        "type_name[]": condition,
                        "certified_preowned[]": certified_preowned,
                        "public[]": pub
                    };
                    $.extend(params, dates, params);
                    return params;
                  break;
                case "makes":
                  params = {
                      "type_name[]": condition,
                      "certified_preowned[]": certified_preowned,
                      "section_id[]": dealers,
                      "public[]": pub
                  };
                  $.extend(params, dates, params);
                  return params;
                  break;
                case "bodys":
                    params = {
                        "type_name[]": condition,
                        "certified_preowned[]": certified_preowned,
                        "section_id[]": dealers,
                        "make": makes,
                        "public[]": pub
                    };
                    $.extend(params, dates, params);
                    return params;
                  break;
                case "models":
                    params = {
                        "type_name[]": condition,
                        "certified_preowned[]": certified_preowned,
                        "section_id[]": dealers,
                        "make[]": makes,
                        "body_style[]": bodys,
                        "public[]": pub
                    };
                    $.extend(params, dates, params);
                    return params;
                  break;
                
                case "years":
                    params = {
                        "type_name[]": condition,
                        "certified_preowned[]": certified_preowned,
                        "section_id[]" : dealers,
                        "make[]": makes,
                        "body_style[]" : bodys,
                        "model[]": models,
                        "public[]": pub
                    };
                    $.extend(params, dates, params);
                    return params;
                  break;
              }
            },
            invalid: function (){
              if (!dealers.length && !makes.length && !bodys.length && !models.length && !years.length){
                return true;
              }else{
                return false;
              }
            }
        };
  }

})();
/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  /**
   * Includes basic panel layout inside of current element.
   */
  angular.module('BlurAdmin.theme')
      .directive('baPanel', baPanel);

  /** @ngInject */
  function baPanel(baPanel, baConfig) {
    return angular.extend({}, baPanel, {
      template: function(el, attrs) {
        var res = '<div  class="panel ' + (baConfig.theme.blur ? 'panel-blur' : '') + ' full-invisible ' + (attrs.baPanelClass || '');
        res += '" zoom-in ' + (baConfig.theme.blur ? 'ba-panel-blur' : '') + '>';
        res += baPanel.template(el, attrs);
        res += '</div>';
        return res;
      }
    });
  }
})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .factory('baPanel', baPanel);

  /** @ngInject */
  function baPanel() {

    /** Base baPanel directive */
    return {
      restrict: 'A',
      transclude: true,
      template: function(elem, attrs) {
        var res = '<div class="panel-body" ng-transclude></div>';
        if (attrs.baPanelTitle) {
          var titleTpl = '<div class="panel-heading clearfix"><h3 class="panel-title">' + attrs.baPanelTitle + '</h3></div>';
          res = titleTpl + res; // title should be before
        }

        return res;
      }
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('baPanelBlur', baPanelBlur);

  /** @ngInject */
  function baPanelBlur(baPanelBlurHelper, $window, $rootScope) {
    var bodyBgSize;

    baPanelBlurHelper.bodyBgLoad().then(function() {
      bodyBgSize = baPanelBlurHelper.getBodyBgImageSizes();
    });

    $window.addEventListener('resize', function() {
      bodyBgSize = baPanelBlurHelper.getBodyBgImageSizes();
    });

    return {
      restrict: 'A',
      link: function($scope, elem) {
        if(!$rootScope.$isMobile) {
          baPanelBlurHelper.bodyBgLoad().then(function () {
            setTimeout(recalculatePanelStyle);
          });
          $window.addEventListener('resize', recalculatePanelStyle);

          $scope.$on('$destroy', function () {
            $window.removeEventListener('resize', recalculatePanelStyle);
          });
        }

        function recalculatePanelStyle() {
          if (!bodyBgSize) {
            return;
          }
          elem.css({
            backgroundSize: Math.round(bodyBgSize.width) + 'px ' + Math.round(bodyBgSize.height) + 'px',
            backgroundPosition: Math.floor(bodyBgSize.positionX) + 'px ' + Math.floor(bodyBgSize.positionY) + 'px'
          });
        }

      }
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .service('baPanelBlurHelper', baPanelBlurHelper);

  /** @ngInject */
  function baPanelBlurHelper($q) {
    var res = $q.defer();
    var computedStyle = getComputedStyle(document.body, ':before');
    var image = new Image();
    image.src = computedStyle.backgroundImage.replace(/url\((['"])?(.*?)\1\)/gi, '$2');
    image.onerror = function() {
      res.reject();
    };
    image.onload = function() {
      res.resolve();
    };

    this.bodyBgLoad = function() {
      return res.promise;
    };

    this.getBodyBgImageSizes = function() {
      var elemW = document.documentElement.clientWidth;
      var elemH = document.documentElement.clientHeight;
      if(elemW <= 640) return;
      var imgRatio = (image.height / image.width);       // original img ratio
      var containerRatio = (elemH / elemW);     // container ratio

      var finalHeight, finalWidth;
      if (containerRatio > imgRatio) {
        finalHeight = elemH;
        finalWidth = (elemH / imgRatio);
      } else {
        finalWidth = elemW;
        finalHeight = (elemW * imgRatio);
      }
      return { width: finalWidth, height: finalHeight, positionX: (elemW - finalWidth)/2, positionY: (elemH - finalHeight)/2};
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  /**
   * Represents current element as panel, adding all necessary classes.
   */
  angular.module('BlurAdmin.theme')
      .directive('baPanelSelf', baPanelSelf);

  /** @ngInject */
  function baPanelSelf(baPanel) {
    return angular.extend({}, baPanel, {
      link: function(scope, el, attrs) {
        el.addClass('panel panel-white');
        if (attrs.baPanelClass) {
          el.addClass(attrs.baPanelClass);
        }
      }
    });
  }

})();


(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .controller('BaSidebarCtrl', BaSidebarCtrl);

  /** @ngInject */
  function BaSidebarCtrl($scope, $rootScope, $state, baSidebarService, AuthService, toastr) {

    if(AuthService.user.main_group!="root"){
      // $scope.menuItems = baSidebarService.getMenuItems().slice(1, baSidebarService.getMenuItems().length);
      $scope.menuItems = baSidebarService.getMenuItems();
    }else{
      $scope.menuItems = baSidebarService.getMenuItems();
    }

    $scope.defaultSidebarState = $scope.menuItems[0].stateRef;

    $scope.selecSite = function ($event) {
      if ($rootScope.domain == ""){
        toastr.info('<span class="toast-description"> Please select a site to explore its data. <span>', '<strong class="toast-titles">  Select a Site! </strong>');
      }
    }

    $scope.hoverItem = function ($event) {
      $scope.showHoverElem = true;
      $scope.hoverElemHeight =  $event.currentTarget.clientHeight;
      var menuTopValue = 66;
      $scope.hoverElemTop = $event.currentTarget.getBoundingClientRect().top - menuTopValue;
    };

    $scope.$on('$stateChangeSuccess', function () {
      if (baSidebarService.canSidebarBeHidden()) {
        baSidebarService.setMenuCollapsed(true);
      }
    });
  }
})();

(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('baSidebar', baSidebar);

  /** @ngInject */
  function baSidebar($timeout, baSidebarService, baUtil, layoutSizes) {
    var jqWindow = $(window);
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/baSidebar/ba-sidebar.html',
      controller: 'BaSidebarCtrl',
      link: function(scope, el) {

        scope.menuHeight = el[0].childNodes[0].clientHeight - 84;
        jqWindow.on('click', _onWindowClick);
        jqWindow.on('resize', _onWindowResize);

        scope.$on('$destroy', function() {
          jqWindow.off('click', _onWindowClick);
          jqWindow.off('resize', _onWindowResize);
        });

        function _onWindowClick($evt) {
          if (!baUtil.isDescendant(el[0], $evt.target) &&
              !$evt.originalEvent.$sidebarEventProcessed &&
              !baSidebarService.isMenuCollapsed() &&
              baSidebarService.canSidebarBeHidden()) {
            $evt.originalEvent.$sidebarEventProcessed = true;
            $timeout(function () {
              baSidebarService.setMenuCollapsed(true);
            }, 10);
          }
        }

        // watch window resize to change menu collapsed state if needed
        function _onWindowResize() {
          var newMenuCollapsed = baSidebarService.shouldMenuBeCollapsed();
          var newMenuHeight = _calculateMenuHeight();
          if (newMenuCollapsed != baSidebarService.isMenuCollapsed() || scope.menuHeight != newMenuHeight) {
            scope.$apply(function () {
              scope.menuHeight = newMenuHeight;
              baSidebarService.setMenuCollapsed(newMenuCollapsed)
            });
          }
        }

        function _calculateMenuHeight() {
          return el[0].childNodes[0].clientHeight - 84;
        }
      }
    };
  }


  angular.module('BlurAdmin.theme.components')
      .directive('eatClickIf', eatClickIf);

  /** @ngInject */
   function eatClickIf($parse, $rootScope, toastr, toastrConfig) {
      return {
        // this ensure eatClickIf be compiled before ngClick
        priority: 100,
        restrict: 'A',
        compile: function($element, attr) {
          var fn = $parse(attr.eatClickIf);
          return {
            pre: function link(scope, element) {
              var eventName = 'click';
              element.on(eventName, function(event) {
                var callback = function() {
                  // if (fn(scope, {$event: event})) {
                    // prevents ng-click to be executed
                    event.stopImmediatePropagation();
                    // prevents href 
                    event.preventDefault();
                    return false;
                  // }
                };

                if ($rootScope.domain=='') {
                  scope.$evalAsync(callback);
                  scope.$apply(callback);
                  toastr.warning('<span class="toast-description"> Please select a website for explore <span>', '<strong class="toast-titles"> Select a web site </strong>');
                }
              });
            },
            post: function() {}
          }
        }
      }
    }

})();

(function() {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .provider('baSidebarService', baSidebarServiceProvider);

  /** @ngInject */
  function baSidebarServiceProvider() {
    var staticMenuItems = [];

    this.addStaticItem = function() {
      staticMenuItems.push.apply(staticMenuItems, arguments);
    };

    /** @ngInject */
    this.$get = function($state, layoutSizes) {
      return new _factory();

      function _factory() {
        var isMenuCollapsed = shouldMenuBeCollapsed();

        this.getMenuItems = function() {
          var states = defineMenuItemStates();
          var menuItems = states.filter(function(item) {
            return item.level == 1;
          });

          menuItems.forEach(function(item) {
            var children = states.filter(function(child) {
              return child.level == 2 && child.name.indexOf(item.name) !== -1;
            });


            item.subMenu = children.length ? children : null;
          });

          return menuItems.concat(staticMenuItems);
        };

        this.shouldMenuBeCollapsed = shouldMenuBeCollapsed;
        this.canSidebarBeHidden = canSidebarBeHidden;

        this.setMenuCollapsed = function(isCollapsed) {
          isMenuCollapsed = isCollapsed;
        };

        this.isMenuCollapsed = function() {
          return isMenuCollapsed;
        };

        this.toggleMenuCollapsed = function() {
          isMenuCollapsed = !isMenuCollapsed;
        };

        this.getAllStateRefsRecursive = function(item) {
          var result = [];
          _iterateSubItems(item);
          return result;

          function _iterateSubItems(currentItem) {
            currentItem.subMenu && currentItem.subMenu.forEach(function(subItem) {
              subItem.stateRef && result.push(subItem.stateRef);
              _iterateSubItems(subItem);
            });
          }
        };

        function defineMenuItemStates() {
          return $state.get()
              .filter(function(s) {
                return s.sidebarMeta;
              })
              .map(function(s) {
                var meta = s.sidebarMeta;
                return {
                  name: s.name,
                  title: s.title,
                  level: (s.name.match(/\./g) || []).length,
                  order: meta.order,
                  icon: meta.icon,
                  stateRef: s.name
                };
              })
              .sort(function(a, b) {
                return (a.level - b.level) * 100 + a.order - b.order;
              });
        }

        function shouldMenuBeCollapsed() {
          return window.innerWidth <= layoutSizes.resWidthCollapseSidebar;
        }

        function canSidebarBeHidden() {
          return window.innerWidth <= layoutSizes.resWidthHideSidebar;
        }
      }

    };

  }
})();



(function () {
  'use strict';

angular.module('BlurAdmin.theme.components')
      .directive('baSidebarToggleMenu', baSidebarToggleMenu)
      .directive('baSidebarCollapseMenu', baSidebarCollapseMenu)
      .directive('baSidebarTogglingItem', baSidebarTogglingItem)
      .controller('BaSidebarTogglingItemCtrl', BaSidebarTogglingItemCtrl)
      .directive('baUiSrefTogglingSubmenu', baUiSrefTogglingSubmenu)
      .directive('baUiSrefToggler', baUiSrefToggler);

  /** @ngInject */
  function baSidebarToggleMenu(baSidebarService) {
    return {
      restrict: 'A',
      link: function(scope, elem) {
        elem.on('click', function($evt) {
          $evt.originalEvent.$sidebarEventProcessed = true;
          scope.$apply(function() {
            baSidebarService.toggleMenuCollapsed();
          });
        });
      }
    };
  }

  /** @ngInject */
  function baSidebarCollapseMenu(baSidebarService) {
    return {
      restrict: 'A',
      link: function(scope, elem) {
        elem.on('click', function($evt) {
          $evt.originalEvent.$sidebarEventProcessed = true;
          if (!baSidebarService.isMenuCollapsed()) {
            scope.$apply(function() {
              baSidebarService.setMenuCollapsed(true);
            });
          }
        });
      }
    };
  }

  /** @ngInject */
  function baSidebarTogglingItem() {
    return {
      restrict: 'A',
      controller: 'BaSidebarTogglingItemCtrl'
    };
  }

  /** @ngInject */
  function BaSidebarTogglingItemCtrl($scope, $element, $attrs, $state, baSidebarService) {
    var vm = this;
    var menuItem = vm.$$menuItem = $scope.$eval($attrs.baSidebarTogglingItem);
    if (menuItem && menuItem.subMenu && menuItem.subMenu.length) {
      vm.$$expandSubmenu = function() { console.warn('$$expandMenu should be overwritten by baUiSrefTogglingSubmenu') };
      vm.$$collapseSubmenu = function() { console.warn('$$collapseSubmenu should be overwritten by baUiSrefTogglingSubmenu') };

      var subItemsStateRefs = baSidebarService.getAllStateRefsRecursive(menuItem);

      vm.$expand = function() {
        vm.$$expandSubmenu();
        $element.addClass('ba-sidebar-item-expanded');
      };

      vm.$collapse = function() {
        vm.$$collapseSubmenu();
        $element.removeClass('ba-sidebar-item-expanded');
      };

      vm.$toggle = function() {
        $element.hasClass('ba-sidebar-item-expanded') ?
            vm.$collapse() :
            vm.$expand();
      };

      if (_isState($state.current)) {
        $element.addClass('ba-sidebar-item-expanded');
      }

      $scope.$on('$stateChangeStart', function (event, toState) {
        if (!_isState(toState) && $element.hasClass('ba-sidebar-item-expanded')) {
          vm.$collapse();
          $element.removeClass('ba-sidebar-item-expanded');
        }
      });

      $scope.$on('$stateChangeSuccess', function (event, toState) {
        if (_isState(toState) && !$element.hasClass('ba-sidebar-item-expanded')) {
          vm.$expand();
          $element.addClass('ba-sidebar-item-expanded');
        }
      });
    }

    function _isState(state) {
      return state && subItemsStateRefs.some(function(subItemState) {
            return state.name.indexOf(subItemState) == 0;
          });
    }
  }

  /** @ngInject */
  function baUiSrefTogglingSubmenu($state) {
    return {
      restrict: 'A',
      require: '^baSidebarTogglingItem',
      link: function(scope, el, attrs, baSidebarTogglingItem) {
        baSidebarTogglingItem.$$expandSubmenu = function() { el.slideDown(); };
        baSidebarTogglingItem.$$collapseSubmenu = function() { el.slideUp(); };
      }
    };
  }

  /** @ngInject */
  function baUiSrefToggler(baSidebarService) {
    return {
      restrict: 'A',
      require: '^baSidebarTogglingItem',
      link: function(scope, el, attrs, baSidebarTogglingItem) {
        el.on('click', function() {
          if (baSidebarService.isMenuCollapsed()) {
            // If the whole sidebar is collapsed and this item has submenu. We need to open sidebar.
            // This should not affect mobiles, because on mobiles sidebar should be hidden at all
            scope.$apply(function() {
              baSidebarService.setMenuCollapsed(false);
            });
            baSidebarTogglingItem.$expand();
          } else {
            baSidebarTogglingItem.$toggle();
          }
        });
      }
    };
  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('backTop', backTop);

  /** @ngInject */
  function backTop() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/backTop/backTop.html',
      controller: function () {
        $('#backTop').backTop({
          'position': 200,
          'speed': 100
        });
      }
    };
  }

})();
(function() {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .directive('baWizard', baWizard);

  /** @ngInject */
  function baWizard() {
    return {
      restrict: 'E',
      transclude: true,
      templateUrl: 'app/theme/components/baWizard/baWizard.html',
      controllerAs: '$baWizardController',
      controller: 'baWizardCtrl'
    }
  }
})();

(function() {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .controller('baWizardCtrl', baWizardCtrl);

  /** @ngInject */
  function baWizardCtrl($scope) {
    var vm = this;
    vm.tabs = [];

    vm.tabNum = 0;
    vm.progress = 0;

    vm.addTab = function(tab) {
      tab.setPrev(vm.tabs[vm.tabs.length - 1]);
      vm.tabs.push(tab);
      vm.selectTab(0);
    };

    $scope.$watch(angular.bind(vm, function () {return vm.tabNum;}), calcProgress);

    vm.selectTab = function (tabNum) {
      vm.tabs[vm.tabNum].submit();
      if (vm.tabs[tabNum].isAvailiable()) {
        vm.tabNum = tabNum;
        vm.tabs.forEach(function (t, tIndex) {
          tIndex == vm.tabNum ? t.select(true) : t.select(false);
        });
      }
    };

    vm.isFirstTab = function () {
      return vm.tabNum == 0;
    };

    vm.isLastTab = function () {
      return vm.tabNum == vm.tabs.length - 1 ;
    };

    vm.nextTab = function () {
      vm.selectTab(vm.tabNum + 1)
    };

    vm.previousTab = function () {
      vm.selectTab(vm.tabNum - 1)
    };

    function calcProgress() {
      vm.progress = ((vm.tabNum + 1) / vm.tabs.length) * 100;
    }
  }
})();


(function() {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .directive('baWizardStep', baWizardStep);

  /** @ngInject */
  function baWizardStep() {
    return {
      restrict: 'E',
      transclude: true,
      require: '^baWizard',
      scope: {
        form: '='
      },
      templateUrl:  'app/theme/components/baWizard/baWizardStep.html',
      link: function($scope, $element, $attrs, wizard) {
        $scope.selected = true;

        var tab = {
          title: $attrs.title,
          select: select,
          submit: submit,
          isComplete: isComplete,
          isAvailiable: isAvailiable,
          prevTab: undefined,
          setPrev: setPrev
        };

        wizard.addTab(tab);

        function select(isSelected) {
          if (isSelected) {
            $scope.selected = true;
          } else {
            $scope.selected = false;
          }
        }

        function submit() {
          $scope.form && $scope.form.$setSubmitted(true);
        }

        function isComplete() {
          return $scope.form ? $scope.form.$valid : true;
        }

        function isAvailiable() {
          return tab.prevTab ? tab.prevTab.isComplete() : true;
        }

        function setPrev(pTab) {
          tab.prevTab = pTab;
        }
      }
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('contentTop', contentTop);

  /** @ngInject */
  function contentTop($location, $state) {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/contentTop/contentTop.html',
      link: function($scope) {
        $scope.$watch(function () {
          $scope.activePageTitle = $state.current.title;
        });
      }
    };
  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .controller('MsgCenterCtrl', MsgCenterCtrl);

  /** @ngInject */
  function MsgCenterCtrl($scope, $sce) {
    $scope.users = {
      0: {
        name: 'Vlad',
      },
      1: {
        name: 'Kostya',
      },
      2: {
        name: 'Andrey',
      },
      3: {
        name: 'Nasta',
      }
    };

    $scope.notifications = [
      {
        userId: 0,
        template: '&name posted a new article.',
        time: '1 min ago'
      },
      {
        userId: 1,
        template: '&name changed his contact information.',
        time: '2 hrs ago'
      },
      {
        image: 'assets/img/shopping-cart.svg',
        template: 'New orders received.',
        time: '5 hrs ago'
      },
      {
        userId: 2,
        template: '&name replied to your comment.',
        time: '1 day ago'
      },
      {
        userId: 3,
        template: 'Today is &name\'s birthday.',
        time: '2 days ago'
      },
      {
        image: 'assets/img/comments.svg',
        template: 'New comments on your post.',
        time: '3 days ago'
      },
      {
        userId: 1,
        template: '&name invited you to join the event.',
        time: '1 week ago'
      }
    ];

    $scope.messages = [
      {
        userId: 3,
        text: 'After you get up and running, you can place Font Awesome icons just about...',
        time: '1 min ago'
      },
      {
        userId: 0,
        text: 'You asked, Font Awesome delivers with 40 shiny new icons in version 4.2.',
        time: '2 hrs ago'
      },
      {
        userId: 1,
        text: 'Want to request new icons? Here\'s how. Need vectors or want to use on the...',
        time: '10 hrs ago'
      },
      {
        userId: 2,
        text: 'Explore your passions and discover new ones by getting involved. Stretch your...',
        time: '1 day ago'
      },
      {
        userId: 3,
        text: 'Get to know who we are - from the inside out. From our history and culture, to the...',
        time: '1 day ago'
      },
      {
        userId: 1,
        text: 'Need some support to reach your goals? Apply for scholarships across a variety of...',
        time: '2 days ago'
      },
      {
        userId: 0,
        text: 'Wrap the dropdown\'s trigger and the dropdown menu within .dropdown, or...',
        time: '1 week ago'
      }
    ];

    $scope.getMessage = function(msg) {
      var text = msg.template;
      if (msg.userId || msg.userId === 0) {
        text = text.replace('&name', '<strong>' + $scope.users[msg.userId].name + '</strong>');
      }
      return $sce.trustAsHtml(text);
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('msgCenter', msgCenter);

  /** @ngInject */
  function msgCenter() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/msgCenter/msgCenter.html',
      controller: 'MsgCenterCtrl'
    };
  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('pageTop', pageTop);

  /** @ngInject */
  function pageTop() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/pageTop/pageTop.html'
    };
  }

})();
/**
 * Created by n.poltoratsky
 * on 28.06.2016.
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.theme.components')
        .directive('progressBarRound', progressBarRound);

    /** @ngInject */
    function progressBarRound(baProgressModal) {
        return {
            restrict: 'E',
            templateUrl: 'app/theme/components/progressBarRound/progressBarRound.html',
            link:function($scope, element, attrs) {
                $scope.baProgressDialog = baProgressModal;
                $scope.$watch(function () {
                    return baProgressModal.getProgress();
                }, animateBar);

                function animateBar() {
                    var circle = element.find('#loader')[0];
                    circle.setAttribute("stroke-dasharray", baProgressModal.getProgress() * 180 * Math.PI / 100 + ", 20000");
                    $scope.progress = baProgressModal.getProgress();
                }
            }
        }
    }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('widgets', widgets);

  /** @ngInject */
  function widgets() {
    return {
      restrict: 'EA',
      scope: {
        ngModel: '='
      },
      templateUrl: 'app/theme/components/widgets/widgets.html',
      replace: true
    };
  }

})();
/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .filter('appImage', appImage);

  /** @ngInject */
  function appImage(layoutPaths) {
    return function(input) {
      return layoutPaths.images.root + input;
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .filter('kameleonImg', kameleonImg);

  /** @ngInject */
  function kameleonImg(layoutPaths) {
    return function(input) {
      return layoutPaths.images.root + 'theme/icon/kameleon/' + input + '.svg';
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .filter('profilePicture', profilePicture);

  /** @ngInject */
  function profilePicture(layoutPaths) {
    return function(input, ext) {
      ext = ext || 'png';
      return layoutPaths.images.profile + input + '.' + ext;
    };
  }

})();

/**
 * @author a.demeshko
 * created on 23.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .filter('plainText', plainText);

  /** @ngInject */
  function plainText() {
    return function(text) {
      return  text ? String(text).replace(/<[^>]+>/gm, '') : '';
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 10.12.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.inputs')
      .directive('baSwitcher', baSwitcher);

  /** @ngInject */
  function baSwitcher() {
    return {
      templateUrl: 'app/theme/inputs/baSwitcher/baSwitcher.html',
      scope: {
        switcherStyle: '@',
        switcherValue: '='
      }
    };
  }

})();

/* Minified js for jQuery BackTop */
!function(o){o.fn.backTop=function(e){var n=this,i=o.extend({position:400,speed:500,color:"white"},e),t=i.position,c=i.speed,d=i.color;n.addClass("white"==d?"white":"red"==d?"red":"green"==d?"green":"black"),n.css({right:40,bottom:40,position:"fixed"}),o(document).scroll(function(){var e=o(window).scrollTop();e>=t?n.fadeIn(c):n.fadeOut(c)}),n.click(function(){o("html, body").animate({scrollTop:0},{duration:1200})})}}(jQuery);
angular.module('BlurAdmin').run(['$templateCache', function($templateCache) {$templateCache.put('app/pages/auth/index.html','<main class="auth-main" initial-style=""><div class="auth-block"><h1>AI-Powered Reports: Please Sign In</h1><form class="form-horizontal" name="form" ng-submit="login(form)" novalidate=""><div class="form-group"><label for="inputEmail3" class="col-sm-2 control-label">Username</label><div class="col-sm-10"><input type="text" ng-model="user.username" class="form-control" id="inputEmail3" placeholder="Username" required=""></div></div><div class="form-group"><label for="inputPassword3" class="col-sm-2 control-label">Password</label><div class="col-sm-10"><input type="password" ng-model="user.password" class="form-control" id="inputPassword3" placeholder="Password" required=""></div></div><div class="form-group"><div class="col-sm-offset-2 col-sm-10"><button type="submit" class="btn btn-default btn-auth">Sign in</button></div></div></form><div class="auth-sep"><span><span>Wehaa LLC</span></span></div><div class="al-share-auth"><div class="alert bg-danger p-10 no-m text-center blur-alert-danger" ng-show="msgError!=\'\'"><strong>{{msgError}}</strong></div></div></div></main>');
$templateCache.put('app/pages/benchmark/benchmark.html','<div class="row"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" style="z-index: 100;" ba-panel="" ba-panel-class=""><div class="row mb-10"><div class="col-lg-7 col-md-7 col-sm-7"><h1 style="font-weight: 400;">Comparison Metrics</h1></div><div class="col-lg-5 col-md-5 row-type col-sm-5 col-xs-12"><div class="btn-group btn-agroup pull-right type-btn"><label class="btn btn-sm btn-primary" ng-model="type" ng-change="toggleType(\'all\')" uib-btn-radio="\'all\'">All</label> <label class="btn btn-sm btn-primary" ng-model="type" ng-change="toggleType(\'new\')" uib-btn-radio="\'new\'">New</label> <label class="btn btn-sm btn-primary" ng-model="type" ng-change="toggleType(\'used\')" uib-btn-radio="\'used\'">Used</label> <label class="btn btn-sm btn-primary" ng-model="type" ng-change="toggleType(\'certified\')" uib-btn-radio="\'certified\'">Certified</label></div></div></div><form name="form"><div class="form-group mb-5" ng-hide="report==\'benchmark\'"><label>Dealers</label><selectize config="configSelect" placeholder="Select Dealers" options="$parent.dealers" ng-model="$parent.dealer" ng-disabled="!loadDealers"></selectize><span class="help-block sub-little-text">Select one or more dealer from this list</span></div><div class="form-group mb-5" ng-show="report==\'benchmark\'"><label>Choose Dealer</label><selectize config="configSingleOne" ng-disabled="!loadDealers" placeholder="Select Dealer" options="dealers" ng-model="$parent.adealer"></selectize></div><div class="form-group mb-5" ng-hide="report!=\'benchmark\'"><label>Dimension</label><selectize config="configSingleOne" placeholder="Select Dimension" options="$parent.dimensions" ng-model="$parent.dimension"></selectize></div><div class="form-group mb-5" ng-hide="report!=\'benchmark\'"><label>Year</label><selectize config="configSingleOneYear" placeholder="Select Year" options="$parent.years" ng-model="$parent.year"></selectize></div><button type="submit" ng-click="getReport()" style="float: right; margin-top: 10px!important;" ng-disabled="!completeLoad && !loadDealers" class="btn btn-primary btn-raised no-m"><b>Get Report</b></button></form></div></div><div class="row" id="results"><div class="col-lg-12 col-md-12 col-sm-12" ba-panel="" ba-panel-class="with-scroll panel-default min-height-panel"><div ng-class="{\'opacity-res\': opacity}"><div class="row results-comparison" ng-show="benchmark_results.length"><div class="form-group col-lg-7 col-md-7 col-sm-12 col-xs-12"><h1 ng-show="dealersel">Benchmark Analysis for {{dealersel}}</h1></div><div class="form-group col-lg-5 col-md-5 col-sm-12 col-xs-12"><div class="pull-right" style="margin-left: 10px;"><button type="button" ng-click="printPdf(benchmark_results)" class="btn btn-primary btn-raised btn-block no-m"><b>Print Report</b></button></div><div class="pull-right hidden-sm hidden-xs"><a ui-sref="home.dashboard({dealer:benchmark_results[0].name, dimension:dimension})" class="btn btn-primary btn-raised btn-block no-m"><b>Performance</b></a></div><div class="pull-left hidden-md hidden-lg"><a ui-sref="home.dashboard({dealer:benchmark_results[0].name, dimension:dimension})" class="btn btn-primary btn-raised btn-block no-m"><b>Performance</b></a></div></div></div><div class="center-ripple" ng-show="!benchmark_results.length && loading"><div class="lds-ripple"><div></div><div></div></div></div><form class="row form-inline" ng-show="items.length"><div class="form-group col-md-9 col-sm-9"><label>Search string</label> <input type="text" class="form-control" ng-model="search" id="searchItems" placeholder="Search cars"></div><div class="form-group col-md-offset-1 col-md-2 col-sm-offset-1 col-sm-2"><button type="button" ng-click="goBack()" class="btn btn-primary btn-raised btn-block no-m">Go Back</button></div></form><br><h3 ng-show="benchfound">{{benchfound}}</h3><div class="benchmark-results" ng-show="benchmark_results.length"><div class="table-wrapper" style="margin-bottom: 25px; padding-top: 20px;" ng-repeat="dealer in benchmark_results | orderBy:\'-quantity\' | filter:searchdiff"><div class="header"><table class="table dcf-table dcf-table-responsive dcf-table-bordered dcf-table-striped dcf-w-100%"><thead><tr><th scope="col">DEALER</th><th scope="col">OBSERVATIONS</th><th scope="col">INVENTORY</th><th scope="col">SALES</th><th scope="col">INVENTORY TIME</th><th scope="col">PRICES</th></tr></thead><tbody><tr class="main-dealer"><td scope="row" class="table-th"><span><span class="dealer-name">{{dealer.name}}</span></span></td><td data-label="OBSERVATIONS"><span><span ng-repeat="legend in dealer.legend | filter:\'!Lower Inventory\'"><span ng-if="$index==0">{{legend}}</span> <span ng-if="$index!=0">/ {{legend}}</span></span> <span ng-if="!dealer.legend.length"><span class="hidden-lg">Opportunities</span> <span class="hidden-md hidden-sm hidden-xs">Opportunities for Improvement</span></span> <span ng-if="dealer.legend.length==1 &amp;&amp; dealer.legend[0]==\'Lower Inventory\'">Opportunities for Improvement / Lower Inventory</span></span></td><td data-label="INVENTORY"><span><ng-pluralize count="dealer.quantity" when="{\'0\': \'None\', \'1\': \'{{dealer.quantity}} CAR\', \'other\': \'{{dealer.quantity}} CARS\'}"></ng-pluralize></span></td><td data-label="SALES"><span><span ng-if="dealer.qty_sale > 0">{{dealer.qty_sale | number:0}}</span> <span ng-if="!dealer.qty_sale > 0">-</span></span></td><td data-label="INV. TIME"><span><span ng-if="dealer.avg_time>=6">{{dealer.avg_time}} DAYS</span> <span ng-if="dealer.avg_time<6">-</span></span></td><td data-label="PRICES"><span><span ng-if="dealer.avg_price > 0">{{dealer.avg_price | currency:"$":0}}</span> <span ng-if="!dealer.avg_price > 0">-</span></span></td></tr><tr><td scope="row" class="table-th"><span class="dealer-alt">{{dealer.dealers[0].section_name}}</span></td><td data-label="OBSERVATIONS"><span><span ng-repeat="legend in dealer.dealers[0].legend"><span ng-if="$index==0">{{legend}}</span> <span ng-if="$index!=0">/ {{legend}}</span></span> <span ng-if="!dealer.dealers[0].legend.length &amp;&amp; dealer.dealers[0].section_name">Relatively Similar</span></span></td><td data-label="INVENTORY"><span><ng-pluralize count="dealer.dealers[0].quantity" when="{\'0\': \'None\', \'1\': \'{{dealer.dealers[0].quantity}} CAR\', \'other\': \'{{dealer.dealers[0].quantity}} CARS\'}"></ng-pluralize></span></td><td data-label="SALES"><span><span ng-if="dealer.dealers[0].qty_sale > 0">{{dealer.dealers[0].qty_sale | number:0}}</span> <span ng-if="!dealer.dealers[0].qty_sale > 0">-</span></span></td><td data-label="INV. TIME"><span><span ng-if="dealer.dealers[0].avg_time>=6">{{dealer.dealers[0].avg_time}} DAYS</span> <span ng-if="dealer.dealers[0].avg_time<6">-</span></span></td><td data-label="PRICES"><span><span ng-if="dealer.dealers[0].avg_price > 0">{{dealer.dealers[0].avg_price | currency:"$":0}}</span> <span ng-if="!dealer.dealers[0].avg_price > 0">-</span></span></td></tr><tr><td scope="row" class="table-th"><span class="dealer-alt">{{dealer.dealers[1].section_name}}</span></td><td data-label="OBSERVATIONS"><span><span ng-repeat="legend in dealer.dealers[1].legend"><span ng-if="$index==0">{{legend}}</span> <span ng-if="$index!=0">/ {{legend}}</span></span> <span ng-if="!dealer.dealers[1].legend.length &amp;&amp; dealer.dealers[1].section_name">Relatively Similar</span></span></td><td data-label="INVENTORY"><span><ng-pluralize count="dealer.dealers[1].quantity" when="{\'0\': \'None\', \'1\': \'{{dealer.dealers[1].quantity}} CAR\', \'other\': \'{{dealer.dealers[1].quantity}} CARS\'}"></ng-pluralize></span></td><td data-label="SALES"><span><span ng-if="dealer.dealers[1].qty_sale > 0">{{dealer.dealers[1].qty_sale | number:0}}</span> <span ng-if="!dealer.dealers[1].qty_sale > 0">-</span></span></td><td data-label="INV. TIME"><span><span ng-if="dealer.dealers[1].avg_time>=6">{{dealer.dealers[1].avg_time}} DAYS</span> <span ng-if="dealer.dealers[1].avg_time<6">-</span></span></td><td data-label="PRICES"><span><span ng-if="dealer.dealers[1].avg_price > 0">{{dealer.dealers[1].avg_price | currency:"$":0}}</span> <span ng-if="!dealer.dealers[1].avg_price > 0">-</span></span></td></tr><tr><td scope="row" class="table-th"><span class="dealer-alt">{{dealer.dealers[2].section_name}}</span></td><td data-label="OBSERVATIONS"><span><span ng-repeat="legend in dealer.dealers[2].legend"><span ng-if="$index==0">{{legend}}</span> <span ng-if="$index!=0">/ {{legend}}</span></span> <span ng-if="!dealer.dealers[2].legend.length &amp;&amp; dealer.dealers[2].section_name">Relatively Similar</span></span></td><td data-label="INVENTORY"><span><ng-pluralize count="dealer.dealers[2].quantity" when="{\'0\': \'None\', \'1\': \'{{dealer.dealers[2].quantity}} CAR\', \'other\': \'{{dealer.dealers[2].quantity}} CARS\'}"></ng-pluralize></span></td><td data-label="SALES"><span><span ng-if="dealer.dealers[2].qty_sale > 0">{{dealer.dealers[2].qty_sale | number:0}}</span> <span ng-if="!dealer.dealers[2].qty_sale > 0">-</span></span></td><td data-label="INV. TIME"><span><span ng-if="dealer.dealers[2].avg_time>=6">{{dealer.dealers[2].avg_time}} DAYS</span> <span ng-if="dealer.dealers[2].avg_time<6">-</span></span></td><td data-label="PRICES"><span><span ng-if="dealer.dealers[2].avg_price > 0">{{dealer.dealers[2].avg_price | currency:"$":0}}</span> <span ng-if="!dealer.dealers[2].avg_price > 0">-</span></span></td></tr></tbody></table><br><div class="row table-buttons hidden-md hidden-lg"><div class="col-lg-6 col-md-6 col-sm-6 col-xs-12"><button type="button" ng-click="openOportunity(dealer, dimension)" class="btn btn-primary btn-raised btn-block no-m"><b>Reverse Pub.</b></button></div><div class="col-lg-6 col-md-6 col-sm-6 col-xs-12"><button type="button" ng-click="openOrder(dealer, dimension)" class="btn btn-primary btn-raised btn-block no-m"><b>Work Order</b></button></div></div><div class="row table-buttons hidden-xs hidden-sm"><div class="col-lg-3 col-md-3"></div><div class="col-lg-3 col-md-3"></div><div class="col-lg-3 col-md-3"><button type="button" ng-click="openOportunity(dealer, dimension)" class="btn btn-primary btn-raised btn-block no-m"><b>Reverse Pub.</b></button></div><div class="col-lg-3 col-md-3"><button type="button" ng-click="openOrder(dealer, dimension)" class="btn btn-primary btn-raised btn-block no-m"><b>Work Order</b></button></div></div></div></div></div><div infinite-scroll="loadMore()"><h3 class="title-details" ng-show="items.length">{{items_quantity}} <span ng-bind-html="title_details"></span></h3><div class="list-articles" ng-show="items.length"><div class="article-item clearfix" ng-repeat="item in items | filter:search"><table><tr class="title-row"><td><h3 class="no-m"><span class="title">{{item.title}}</span></h3></td><td></td></tr></table><div class="more-box"><div class="row"><div class="col-sm-5 col-xs-6 col-md-5 short-name" style="padding-right: 0;"><div class="info clearfix"><div class="lbl-text pull-left">Dealer:</div><div class="value pull-left truncate-col"><span>{{item.section_name}}</span></div></div><div class="info clearfix"><div class="lbl-text pull-left">Type:</div><div class="value pull-left">{{item.type_name}}</div></div><div class="info clearfix"><div class="lbl-text pull-left">Stock:</div><div class="value no-data pull-left"><span>{{item.stock}}</span></div></div><div class="info clearfix"><div class="lbl-text pull-left">Mileage:</div><div class="value no-data pull-left"><span>{{item.miles | number:0 }}</span></div></div></div><div class="col-sm-4 col-xs-6 col-md-5 long-name"><div class="info clearfix visible-xs-block"><div class="lbl-text pull-left">Price:</div><div class="value pull-left"><span>{{item.price}}</span></div></div><div class="info clearfix"><div class="lbl-text pull-left">Year:</div><div class="value pull-left"><span>{{item.year}}</span></div></div><div class="info clearfix"><div class="lbl-text pull-left">Make:</div><div class="value pull-left"><span>{{item.make}}</span></div></div><div class="info clearfix"><div class="lbl-text pull-left">Model:</div><div class="value pull-left">{{item.model}}</div></div><div class="info clearfix"><div class="lbl-text pull-left">Time:</div><div class="value no-data pull-left"><span>{{item.time_duration}} Days</span></div></div></div><div class="col-sm-2 col-xs-0 col-md-2 hidden-xs"><div class="price-details" ng-class="{\'good-deal\':item[10]==\'Good Deal\'}"><div class="rank" ng-show="item.price">Total Price</div><span class="price" ng-show="item.price">{{item.price | currency:"$":0}}</span><div class="rank" ng-show="!item.price">Call for Price</div></div></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/pages/dashboard/dashboard.html','<div class="row select-site" ng-show="domain==\'\'"><div class="col-lg-12 col-md-12" ba-panel="" ba-panel-class="medium-panel traffic-panel auto-height"><h1 style="font-weight: 400;">Please select a site to explore&nbsp;<ion-icon ng-show="!edit_site && group_name==\'root\'" ng-click="addNewSite()" uib-tooltip="Create New Site" class="sites-new ion-android-add-circle"></ion-icon><ion-icon ng-show="!edit_site && group_name==\'root\'" ng-click="setEdit()" uib-tooltip="Edit list" class="ion-edit sites-edit"></ion-icon><ion-icon ng-show="edit_site && group_name==\'root\'" ng-click="setEdit()" uib-tooltip="Save list" class="ion-archive bounce sites-edit" ng-class="{\'bouncing\': isAnimating}"></ion-icon></h1><form class="row form-inline searchdiff"><div class="form-group col-md-12 col-sm-12"><input style="border-radius: 2px;" type="text" class="form-control input-sm" ng-model="searchsite" id="searchsite" placeholder="Search site"></div></form><ul class="list-group sites-list"><li ng-click="setGroup(item)" class="list-group-item pointer disable-sites-list" ng-repeat="item in sites | filter:searchsite | filter:siteFilter | orderBy:\'title\'"><div><h3 class="sites-title"><i class="ion-cube hidden-sm hidden-xs"></i> {{item.title}}&nbsp;<ion-icon ng-show="edit_site && group_name==\'root\'" style="cursor: pointer;" ng-click="editSite($event, item)" class="ion-compose"></ion-icon></h3><h5 class="sites-sub-url">{{item.url}}</h5></div><ion-icon ng-show="edit_site && !item.extras.analyses" ng-click="updateSite($event, item)" class="ion-ios-circle-outline sites-hide"></ion-icon><ion-icon ng-click="updateSite($event, item)" ng-show="edit_site && item.extras.analyses" class="ion-ios-checkmark-outline sites-hide"></ion-icon><ion-icon ng-click="removeSite($event, item, $index)" style="margin-right: 40px;" ng-show="edit_site && !item.extras.analyses" class="ion-ios-close-outline sites-hide"></ion-icon></li></ul></div></div><div class="row dash-metrics" ng-show="domain!=\'\' && metrics"><div class="col-lg-12 col-md-12 col-sm-12" style="z-index: 100;"><div class="panel animated zoomIn"><div class="panel-body"><form name="form"><div class="row"><div class="col-lg-7 col-md-8 col-sm-6 col-xs-12"><h1 class="hidden-xs hidden-sm font-weight-400">Performance & Sales Trends & Opportunities</h1><h1 class="hidden-md hidden-lg font-weight-400">Performance</h1></div><div class="col-lg-5 col-md-4 col-sm-6 col-xs-12"><div class="btn-group btn-sm btn-agroup pull-right type-btn"><label class="btn btn-sm btn-primary" ng-model="type" ng-change="toggleType(\'all\', false)" uib-btn-radio="\'all\'">All</label> <label class="btn btn-sm btn-primary" ng-model="type" ng-change="toggleType(\'new\', false)" uib-btn-radio="\'new\'">New</label> <label class="btn btn-sm btn-primary" ng-model="type" ng-change="toggleType(\'used\', false)" uib-btn-radio="\'used\'">Used</label> <label class="btn btn-sm btn-primary" ng-model="type" ng-change="toggleType(\'certified\', false)" uib-btn-radio="\'certified\'">Certified</label></div></div></div><div class="row"><div class="col-lg-12 col-md-12 col-sm-12"><label style="font-size: 15px;">Choose Dealers</label><selectize config="configSelect" ng-disabled="!loaded" placeholder="Select Dealer" options="dealers" ng-model="adealer"></selectize></div></div><div class="row" style="margin-top: 10px"><div class="col-lg-12 col-md-12 col-sm-12"><label style="font-size: 15px;">Choose Dimension</label><selectize config="configSingleOne" placeholder="Select Dimension" options="dimensions" ng-model="dimension"></selectize></div></div></form></div></div></div></div><div class="center-ripple" ng-show="domain!=\'\' && !results.length && loading"><div class="lds-ripple"><div></div><div></div></div></div><div class="panel with-scroll animated zoomIn" ng-show="domain!=\'\' && !loading && !results.length" zoom-in=""><div class="panel-heading clearfix"><h3 class="panel-title hidden-xs hidden-sm">Insufficient Data for Reports</h3><h3 class="panel-title hidden-md hidden-lg">Insufficient Data for Reports</h3></div><div class="panel-body"><div class="ng-scope"><div class="alert bg-info" style="font-size: 1em;">There\u2019s not enough history to generate Performance, Sales Trends & Opportunities reports. If this is a new site, please wait two weeks for data collection. If the issue persists, contact <a style="color: cyan" href="mailto:info@wehaa.com">info@wehaa.com</a> for assistance.</div></div></div></div><div class="wrapper-results" infinite-scroll="loadMore()" style="margin-top: -20px;"><div id="results" ng-repeat="item in results | filter:search" ng-show="domain!=\'\'"><uib-accordion><uib-accordion-group panel-class="bootstrap-panel accordion-panel" is-open="item.selected"><div data-uib-accordion-heading=""><span id="acor{{$index}}" class="super-title" ng-click="openOnClose($index, item, true)"><span style="all:unset;" class="dealername" id="dealername{{$index}}">&nbsp; {{item.name}}</span> <i class="ion-ios-copy-outline hidden-sm hidden-xs" ng-show="!item.copy" ng-click="Copy($event, item, $index)" uib-tooltip="Copy dealer name!"></i> <i class="ion-ios-copy" uib-tooltip="Copied!" tooltip-is-open="item.copy" ng-show="item.copy"></i><br class="hidden-el-d"><span class="hidden-lg-d hidden-sm-d hidden-md-d dat-oppors" ng-show="item.qtyoppors">.</span><h5 ng-show="item.qtyoppors" class="opportunities-qty">{{item.qtyoppors}} Opportunities Found on {{item.datetime | date:\'mediumDate\'}}</h5><h5 ng-show="!item.qtyoppors" class="opportunities-qty">Analyzed on {{item.datetime | date:\'mediumDate\'}}</h5><i class="ion-chevron-down" ng-show="!item.selected" style="float: right;"></i> <i class="ion-chevron-up" ng-show="item.selected" style="float: right;"></i></span></div><div class="metrics-item clearfix"><div class="row"><div class="col-lg-12 col-md-12 col-sm-12"><div class="section-block ng-scope"><span style="float: left; margin-top: -8px;"><div class="pull-left"><button type="button" ng-click="getBenchmark({id: item.id, name: item.name, dimension:dimension})" class="btn btn-primary btn-raised btn-block no-m"><b>Benchmark</b></button></div></span> <span style="float: right; margin-top: -8px;"><div class="pull-right" style="margin-right: 15px;"><button type="button" ng-click="printPdf(item)" class="btn btn-primary btn-raised btn-block no-m"><b>Print Report</b></button></div></span></div></div></div><figure class="txt-analysis"><figcaption>Summary:</figcaption><div class="terminal" ng-hide="item.analysis"><span class="typed-text">{{item.typedText}}</span> <span class="terminal-cursor"></span></div><p>{{item.analysis}}</p></figure><div class="wrapper-cars"><div class="card-metrics" ng-class="{\'highlight-card-strong\' : elem.type==\'A1\', \'highlight-card\' : elem.type==\'A2\'}" ng-repeat="elem in item.opportunities | orderBy:\'type\'" ng-if="elem.dimension != \'UNKNOWN\'" style="margin-top: 20px;"><span class="pull-right symbol" style="margin-top: 0;" ng-class="{\'highlight-typeo\' : elem.type==\'A1\'}">{{elem.type | uppercase}}</span><div class="wrapper-padding"><h3>{{elem.name}}</h3><div ng-if="elem.type!=\'A1\' && elem.type!=\'A2\'"><br><br><br></div><h1 ng-if="elem.type!=\'A1\' && elem.type!=\'A2\'">{{elem.value}} <i ng-if="elem.asc" class="ion-ios-arrow-thin-up"></i> <i ng-if="!elem.asc" class="ion-ios-arrow-thin-down"></i></h1><div ng-if="elem.type==\'A1\' || elem.type==\'A2\'" class="chartjs-canvas-holder-bar chartjs-metrics"><canvas id="{{item.id}}bar{{$index}}" class="chart chart-horizontal-bar" chart-data="elem.data" chart-labels="barlabels" chart-series="barseries" chart-colors="barcolors" chart-dataset-override="datasetOverride" chart-options="barspecs"></canvas></div><h4>{{elem.dimension}} ({{elem.quantity}} Units.)</h4><p ng-bind-html="elem.auxdescription"></p><div class="pull-left"><button type="button" ng-click="openOportunity(item, dimension, elem.dimension)" class="btn btn-primary btn-raised no-m"><b>Demo</b></button> <button type="button" ng-click="openOrder(item, dimension, elem.dimension)" class="btn btn-primary btn-raised no-m"><b>Work Order</b></button></div></div></div></div><div class="row metrics-panels"><div class="col-lg-6 col-md-6 col-sm-6 intern-panel" ng-show="item.metrics.facts.length"><div class="panel light-text"><div class="panel-heading clearfix"><h3 class="panel-title">Facts (based in the last 90 days)</h3></div><div class="panel-body"><div class="horizontal-scroll"><table class="table"><thead><tr><th><b>{{dimension | titleCase | replace:"_":" "}}</b></th><th class="align-center"><b>AVG SALES</b></th><th class="align-center"><b>AVG ARRIVALS</b></th><th class="align-center"><b>AVG SALES TIME</b></th><th class="align-right"><b>AVG INVENTORY</b></th></tr></thead><tbody><tr ng-repeat="elem in item.metrics.facts | orderBy:\'-qty\' | filter:myFilter"><td>{{elem.name | titleCase}}</td><td class="align-center">{{elem.avg_sales | number:0}}</td><td class="align-center">{{elem.avg_arrivals | number:0}}</td><td class="align-center">{{elem.avg_times | number:0}}</td><td class="align-right">{{elem.avg_qty | number:0}}</td></tr></tbody></table></div></div></div></div><div class="col-lg-6 col-md-6 col-sm-6 intern-panel"><div class="panel inside-panel light-text"><div class="panel-heading clearfix"><h3 class="panel-title">CURRENT INVENTORY VS SALES LAST 90 DAYS</h3></div><div class="panel-body"><div class="horizontal-scroll"><table class="table"><thead><tr><th><b>{{dimension | titleCase | replace:"_":" "}}</b></th><th class="align-right"><b>Inventory</b></th><th class="align-right"><b>Sold</b></th></tr></thead><tbody><tr ng-repeat="elem in item.metrics.stocksales | orderBy:\'-quantity\' | filter:myFilter" ng-class="{\'bg-blue\': (elem.pct> elem.pctsales+item.humbral.b) && (elem.quantity>item.humbral.qty_global), \'bg-light\': (elem.pctsales > elem.pct + item.humbral.b) && (elem.quantity>item.humbral.qty_global)}" ng-init="elem[\'b1\']=(elem.pct> elem.pctsales+item.humbral.b) && (elem.quantity>item.humbral.qty_global); elem[\'b2\']=(elem.pctsales > elem.pct + item.humbral.b) && (elem.quantity>item.humbral.qty_global);"><td>{{elem.name | titleCase}}</td><td class="align-right">{{elem.pct}}% ({{elem.quantity}}<span style="all: revert;" class="hidden-sm hidden-xs">Units</span>)</td><td class="align-right">{{elem.pctsales}}% ({{elem.qtysales}}<span style="all: revert;" class="hidden-sm hidden-xs">Units</span>)</td></tr></tbody></table></div></div></div></div></div><div class="row metrics-panels" ng-show="item.metrics.periods.data.length && item.dataLine.length"><div class="col-lg-12 col-md-12 col-sm-12 intern-panel"><div class="panel inside-panel light-text"><div class="panel-heading clearfix"><h3 class="panel-title">SALES EVOLUTION IN THE LAST 90 DAYS</h3></div><div class="panel-body"><div class="horizontal-scroll"><table class="table table-evol"><thead><tr><th></th><th colspan="3" class="align-center"><b>{{item.metrics.periods.period3}}</b></th><th colspan="3" class="align-center"><b>{{item.metrics.periods.period2}}</b></th><th colspan="3" class="align-center"><b>{{item.metrics.periods.period1}}</b></th></tr></thead><thead><tr><th><b>{{dimension | titleCase | replace:"_":" "}}</b></th><th class="align-center"><b>INVENTORY</b></th><th class="align-center"><b>ARRIVED</b></th><th class="align-center"><b>SALES</b></th><th class="align-center"><b>ARRIVED</b></th><th class="align-center"><b>SALES</b></th><th class="align-center"><b>EVOLUTION</b></th><th class="align-center"><b>ARRIVED</b></th><th class="align-center"><b>SALES</b></th><th class="align-center"><b>EVOLUTION</b></th></tr></thead><tbody><tr ng-repeat="elem in item.metrics.periods.data |orderBy:\'-qty\' | filter:myFilter"><td>{{elem.name | titleCase}}</td><td class="align-center">{{elem.invperiod3.avg_qty || 0}}</td><td class="align-center">{{elem.period3.qty_arrivals || 0}}</td><td class="align-center">{{elem.period3.qty_sales || 0}}</td><td class="align-center">{{elem.period2.qty_arrivals || 0}}</td><td class="align-center">{{elem.period2.qty_sales || 0}}</td><td class="align-center" style="background: #8DC152; color: #fff" ng-if="!elem.period2.evolsales || elem.period2.evolsales>=0">{{ elem.period2.evolsales || 0 | number:2 }}% <i ng-if="elem.period2.evolsales > 0" class="ion-arrow-up-c"></i></td><td class="align-center" style="background: #DB4453; color: #fff" ng-if="elem.period2.evolsales<0">{{ elem.period2.evolsales || 0 | number:2 }}% <i ng-if="elem.period2.evolsales < 0" class="ion-arrow-down-c"></i></td><td class="align-center">{{elem.period1.qty_arrivals || 0}}</td><td class="align-center">{{elem.period1.qty_sales || 0}}</td><td class="align-center" style="background: #8DC152; color: #fff" ng-if="!elem.period1.evolsales || elem.period1.evolsales >= 0">{{elem.period1.evolsales || 0 | number:2 }}% <i ng-if="elem.period1.evolsales > 0" class="ion-arrow-up-c"></i></td><td class="align-center" style="background: #DB4453; color: #fff" ng-if="elem.period1.evolsales < 0">{{elem.period1.evolsales || 0 | number:2 }}% <i ng-if="elem.period1.evolsales < 0" class="ion-arrow-down-c"></i></td></tr></tbody></table></div></div></div></div></div><div class="row metrics-panels" ng-show="item.metrics.periods.data.length && item.dataLine.length"><div class="col-lg-12 col-md-12 col-sm-12 intern-panel"><div class="panel inside-panel light-text"><div class="panel-heading clearfix"><h3 class="panel-title">TOP 20 SALES EVOLUTION IN THE LAST 90 DAYS</h3></div><div class="panel-body"><div class="chart-container" id="chartline{{item.id}}" style="height: 450px"><canvas id="line{{item.id}}" class="chart chart-line" chart-options="optionsLine" chart-colors="colors" chart-data="item.dataLine" chart-labels="item.labelsLine" chart-series="item.seriesLine" chart-click="selectBar"></canvas></div></div></div></div></div></div></uib-accordion-group></uib-accordion></div></div>');
$templateCache.put('app/pages/demos/index.html','<div class="row"><div class="col-lg-12 col-md-12 col-sm-12" style="z-index: 100;" ba-panel="" ba-panel-class="medium-panel auto-height"><h1 style="font-weight: 400;">Demos List</h1><br><form class="row form-inline searchdiff"><div class="form-group col-md-12 col-sm-12"><label>Search string</label> <input style="border-radius: 5px;" type="text" class="form-control" ng-model="searchdiff" id="searchdiff" placeholder="Search orders"></div></form><br><div class="row mb-10"><div class="col-lg-6 col-md-5 col-sm-4"><div class="btn-group btn-agroup pull-left type-btn"><label class="btn btn-primary" ng-model="status" ng-change="toggleStatus(\'all\')" uib-btn-radio="\'all\'">All</label> <label class="btn btn-primary" ng-model="status" ng-change="toggleStatus(\'progress\')" uib-btn-radio="\'progress\'">In Progress</label> <label class="btn btn-primary" ng-model="status" ng-change="toggleStatus(\'closed\')" uib-btn-radio="\'closed\'">Finished</label></div></div><div class="col-lg-6 col-md-7 col-sm-8"><button type="button" ui-sref="home.neworder" style="float: right; margin-top: 10px!important;" class="btn btn-primary btn-raised no-m"><b>New Order</b></button></div></div><br><div class="horizontal-scroll"><table class="table"><thead><tr><th><b>#</b></th><th>ORDER TITLE</th><th class="align-center">STATUS</th><th class="align-center">CREATION DATE</th><th class="align-center">LAST MODIFIED</th><th class="align-center">REMOVE</th></tr></thead><tbody><tr ui-sref="home.neworder({order_id:worder.id})" ng-repeat="worder in demos | filter:customFilter" style="cursor: pointer;"><td>{{$index + 1}}</td><td>{{worder.name}}</td><td class="align-center"><span ng-if="worder.status==\'progress\'">In Progress</span> <span ng-if="worder.status==\'closed\'">Closed</span></td><td class="align-center">{{worder.created_at | date:"medium"}}</td><td class="align-center">{{worder.updated_at | date:"medium"}}</td><td class="align-center"><i class="chart-icon ion-close" style="color: #EE6D60;" ng-click="$event.stopPropagation();onLongPress(worder)"></i></td></tr></tbody></table></div></div></div>');
$templateCache.put('app/pages/demos/new.html','<div ng-controller="DemosCtrl"><div class="row"><div class="col-lg-12 col-md-12 col-sm-12"><div class="panel" style="margin-bottom: 15px;"><div class="panel-body"><div class="box-select"><div class="btn-group btn-agroup report-btn pull-left"><label class="btn btn-primary" ng-model="type_export" ng-change="toggleDemos(\'select\', \'Select\')" ng-disabled="!completeLoad" uib-btn-radio="\'select\'"><b class="hidden-sm hidden-xs">Select Vehicles</b> <b class="hidden-lg hidden-md">Vehicles</b></label> <label class="btn btn-primary" ng-model="type_export" ng-change="toggleDemos(\'demos\', \'Demos\')" ng-disabled="!completeLoad" uib-btn-radio="\'demos\'"><b>Demos</b></label></div></div></div></div></div></div><div class="row"><div class="col-lg-7 col-md-7 col-sm-12" style="z-index: 100;" ng-show="type_export==\'demos\'"><div class="panel"><div class="panel-body" style="padding-bottom: 25px;"><h1 style="font-weight: 400;">Demos</h1><div class="row" ng-show="!create"><div class="col-md-7"><div class="form-group mb-5" style="float: left; width: 100%"><label>Choose Solution Template</label><selectize config="configSingle" ng-disabled="!completeLoad" placeholder="Select Solution Template" options="templates" ng-model="soltemplate"></selectize></div></div><div class="no-pl col-md-4 no-pr no-pl"><button type="button" style="margin-top: 22px" data-toggle="tooltip" uib-tooltip="Delete Template" ng-show="soltemplate && group_name==\'root\'" ng-click="deleteTemplate(soltemplate, templates)" class="btn btn-primary btn-icon"><i class="ion-trash-a"></i></button> <button type="button" ng-show="group_name==\'root\'" data-toggle="tooltip" style="margin-top: 22px; margin-left: 22px" uib-tooltip="Create Template" ng-click="editorTemplate(soltemplate)" class="pull-right hidden-sm hidden-xs btn btn-primary btn-raised"><b>New Template</b></button> <button type="button" ng-show="group_name==\'root\'" data-toggle="tooltip" style="margin-top: 22px; margin-right: 10px;" uib-tooltip="Create Template" ng-click="editorTemplate(soltemplate)" class="pull-right hidden-lg hidden-md btn btn-primary btn-raised"><b>New</b></button></div><div class="col-lg-3 col-md-3 pull-left"><div class="pull-right"><label class="label-options" style="text-align: left;">&nbsp;</label></div></div></div><div ng-show="!create"><h3>{{title_pro}}</h3><div class="list-solutions"><div class="row"><div class="col-lg-3 col-md-6 col-sm-6 col-xs-12 mb-10"><h5>INVENTORY BANNERS</h5><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" value="" ng-model="solution.bannerxl" ng-true-value="true" ng-false-value="false"> <span class="font-weight-bold">970x250 px.</span></label><br><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" value="" ng-model="solution.bannersm" ng-true-value="true" ng-false-value="false"> <span class="font-weight-bold">300x250 px.</span></label><br><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" value="" ng-model="solution.bannermd" ng-true-value="true" ng-false-value="false"> <span class="font-weight-bold">300x600 px.</span></label><br><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" value="" ng-model="solution.bannerl" ng-true-value="true" ng-false-value="false"> <span class="font-weight-bold">728x90 px.</span></label></div><div class="col-lg-3 col-md-6 col-sm-6 col-xs-12 mb-10"><h5>SOCIAL ADS</h5><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" value="" ng-model="solution.facebook" ng-true-value="true" ng-false-value="false"> <span class="font-weight-bold">Facebook</span></label><br><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" value="" ng-model="solution.instagram" ng-true-value="true" ng-false-value="false"> <span class="font-weight-bold">Instagram</span></label></div><div class="col-lg-3 col-md-6 col-sm-6 col-xs-12 mb-10"><h5>EMAIL</h5><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" value="" ng-model="solution.email" ng-true-value="true" ng-false-value="false"> <span class="font-weight-bold">Email</span></label></div><div class="col-lg-3 col-md-6 col-sm-6 col-xs-12 mb-10"><h5>PRINT</h5><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" value="" ng-model="solution.reverse" ng-true-value="true" ng-false-value="false"> <span class="font-weight-bold">Reverse Pub</span></label></div></div></div></div><div ng-show="create"><div class="row"><div class="col-lg-12 col-md-12 col-sm-12"><form name="form"><div class="row"><div class="col-lg-6 col-md-6 col-sm-6"><h3 class="pull-left">Create new solution template</h3></div><div class="col-lg-6 col-md-6 col-sm-6"><button type="button" class="btn btn-primary btn-raised btn-with-icon pull-right" ng-show="templates" ng-click="create=false;"><i class="ion-ios-compose"></i> <b>Go Back</b></button></div></div><div class="form-group"><label for="inputLastName">Enter name</label> <input type="text" string-to-number="" class="form-control" ng-model="templateNew.name" id="inputLastName" placeholder="Solution template name"></div><div class="input-demo radio-demo row"><div class="col-lg-12"><label class="nowrap" style="padding-top: 2px;"><span><b>Shared Template</b></span></label></div><div class="col-lg-12"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" ng-model="templateNew.shared" id="inlineRadio2" ng-value="true"> <span>Yes</span></label></div><div class="col-lg-12"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" id="inlineRadio3" ng-value="false" checked=""> <span>No</span></label></div></div><br><div class="form-group"><button type="button" class="pull-right btn btn-primary btn-raised btn-with-icon" ng-click="createTemplate()"><b><i class="ion-ios-compose"></i> Create Template</b></button></div></form></div></div></div></div></div></div><div class="col-lg-7 col-md-7 col-sm-12" style="z-index: 100;" ng-show="type_export==\'select\'"><div class="panel"><div class="panel-body"><h1 style="font-weight: 400;">Select Dealers & Vehicles</h1><h3>{{title_pro}}</h3><form name="form" ng-show="type_export==\'select\' || type_export==\'demos\'"><div class="row"><div class="col-xs-6 col-sm-3 col-md-3 col-lg-3"><div class="form-group"><label for="inputFirstName">Price Min</label><div class="input-group"><span class="input-group-addon custom-group">$</span> <input type="number" class="form-control input-group-currency" ng-disabled="!completeLoad" id="inputFirstName" ng-model="conf.price_min" placeholder="Min"></div></div></div><div class="col-xs-6 col-sm-3 col-md-3 col-lg-3"><div class="form-group"><label for="inputLastName">Price Max</label><div class="input-group"><span class="input-group-addon custom-group">$</span> <input type="number" class="form-control input-group-currency" ng-model="conf.price_max" ng-disabled="!completeLoad" id="inputLastName" placeholder="Max"></div></div></div><div class="col-xs-6 col-sm-3 col-md-2 offset-lg-2 col-lg-2"><div class="form-group"><label for="limitNumber">Limit</label> <input type="number" ng-max="100" max="100" ng-min="3" min="3" ng-model="$parent.conf.numLimit" class="form-control" id="limitNumber" ng-disabled="!completeLoad" placeholder="N\xBA"></div></div><div class="col-xs-6 col-sm-3 col-md-2 col-lg-2"><div class="form-group"><label for="limitNumber">Available</label> <input type="number" readonly="" ng-min="3" min="3" ng-model="available" class="resalt form-control" id="limitNumber" ng-disabled="!completeLoad" placeholder="N\xBA"></div></div><div class="col-lg-12 col-md-12 col-xs-12 col-sm-12 col-md-offset-1 pull-right"><label class="label-options">Get Items By {{label_type}}</label><div class="btn-group btn-agroup type-btn pull-right"><label class="btn btn-sm btn-primary" ng-model="type" ng-change="toggleType(\'random\', \'Random\')" ng-disabled="!completeLoad" uib-btn-radio="\'random\'">Random</label> <label class="btn btn-sm btn-primary" ng-model="type" ng-change="toggleType(\'min\', \'Min Price\')" ng-disabled="!completeLoad" uib-btn-radio="\'min\'">Min Price</label> <label class="btn btn-sm btn-primary" ng-model="type" ng-change="toggleType(\'max\', \'Max Price\')" ng-disabled="!completeLoad" uib-btn-radio="\'max\'">Max Price</label> <label class="btn btn-sm btn-primary" ng-model="type" ng-change="toggleType(\'all\' , \'Stock\')" ng-disabled="!completeLoad" uib-btn-radio="\'all\'">Stock</label></div></div></div><div class="form-group mb-5"><label>Choose Dealer</label><selectize config="configSelect" ng-disabled="!completeLoad" placeholder="Select Dealers" options="$parent.dealers" ng-model="$parent.dealer"></selectize><span ng-show="!dealer.length" class="help-block sub-little-text">Select one dealer from this list</span></div><div class="form-group mb-5" ng-show="dealer.length"><label>Choose Make</label><selectize config="configSelect" placeholder="Select Makes" options="$parent.makes" ng-model="$parent.make" ng-disabled="!completeLoadExtra"></selectize></div><div class="form-group mb-5" ng-show="dealer.length"><label>Choose Body Styles</label><selectize config="configSelect" placeholder="Select Body Styles" options="$parent.bodys" ng-model="$parent.$parent.body" ng-disabled="!completeLoadExtra"></selectize></div><div class="form-group mb-5" ng-show="dealer.length"><label>Choose Model</label><selectize config="configSelect" placeholder="Select Models" options="$parent.models" ng-model="$parent.$parent.model" ng-disabled="!completeLoadExtra"></selectize></div><div class="form-group mb-5" ng-show="type==\'all\'"><label>Write Stock</label><selectize config="configSelect" options="$parent.stocksOptions" placeholder="Add Stock" ng-model="$parent.stocks"></selectize><span class="help-block sub-little-text">Add stock number list</span></div><br><button type="button" ng-click="loadCars(true)" style="padding-left:12px; padding-right:12px; margin-top: -15px;" ng-disabled="!completeLoad" pb-style="top-line" class="btn btn-primary btn-raised pull-right btn-md"><i class="ion-ios-refresh"></i> &nbsp; <b>Load Vehicles</b></button> <button type="button" ng-click="loadCars(false)" style="border-radius: 0; margin-top: -15px; padding-left:12px; padding-right:12px; margin-right: 8px;" ng-disabled="!completeLoad" pb-style="top-line" class="btn btn-primary btn-raised pull-right btn-md"><i class="ion-arrow-swap"></i> &nbsp; <b>Sync Vehicles</b></button></form></div></div></div><div class="col-lg-5 col-md-5 col-sm-12" ng-show="type_export==\'select\' || type_export==\'demos\'"><div class="panel"><div class="panel-body min-height-panel-320" style="padding-bottom: 25px"><h1 style="font-weight: 400;">Vehicles</h1><div class="horizontal-scroll"><table class="table"><thead><tr><th class="align-left">#</th><th class="align-left">DEALER</th><th class="align-center">CARS</th><th class="align-center">REMOVE</th></tr></thead><tbody ui-sortable="sortableOptions" ng-model="sections"><tr ng-repeat="item in sections" class="item-table-xs" style="cursor: pointer;"><td ng-click="refreshResults(item.id)">{{$index+1}}</td><td ng-click="refreshResults(item.id)" ng-class="nowrap">{{item.name}}</td><td ng-click="refreshResults(item.id)" class="align-center">{{item.items.length}}</td><td class="align-center"><span class="text-danger" ng-click="discard(item.eid)"><i class="ion-close"></i></span></td></tr></tbody></table></div></div></div><div></div></div></div><div class="row" id="results" ng-show="type_export==\'select\'"><div class="col-lg-12 col-md-12 col-sm-12"><div class="panel" style="margin-top: -10px;"><div class="panel-body with-scroll panel-default min-height-panel"><h1 style="font-weight: 400;">Vehicles Loaded</h1><h3>{{rtitle}}</h3><form class="row form-inline"><div class="form-group col-md-12 col-sm-12"><input type="text" class="form-control" ng-model="search" id="searchItems" placeholder="Search cars"></div></form><div class="center-ripple" ng-show="!benchmark_results.length && loading"><div class="lds-ripple"><div></div><div></div></div></div><br><div class="row" ng-show="results.length && mode!=\'solutions\'"><div class="col-lg-4 col-md-4"><label class="label-options" style="text-align: left;">Sort</label><div class="btn-group btn-agroup sort-btn"><label class="btn btn-sm btn-primary" ng-model="sort" ng-change="toggleOrder(\'random\', \'Random\')" ng-disabled="!completeLoad" uib-btn-radio="\'random\'"><span class="large">Random</span> <span class="small">Random</span> <span></span></label> <label class="btn btn-sm btn-primary" ng-model="sort" ng-change="toggleOrder(\'sf_price\', \'Price\')" ng-disabled="!completeLoad" uib-btn-radio="\'sf_price\'"><span class="large">Price</span> <span class="small">Price</span></label> <label class="btn btn-sm btn-primary" ng-model="sort" ng-change="toggleOrder(\'sf_make\', \'Make\')" ng-disabled="!completeLoad" uib-btn-radio="\'sf_make\'"><span class="large">Make</span> <span class="small">Make</span></label> <label class="btn btn-sm btn-primary" ng-model="sort" ng-change="toggleOrder(\'sf_model\', \'Model\')" ng-disabled="!completeLoad" uib-btn-radio="\'sf_model\'"><span class="large">Model</span> <span class="small">Model</span></label> <label class="btn btn-sm btn-primary" ng-model="sort" ng-change="toggleOrder(\'sf_year\' , \'Year\')" ng-disabled="!completeLoad" uib-btn-radio="\'sf_year\'"><span class="large">Year</span> <span class="small">Year</span></label></div></div><div class="col-lg-1 col-md-1 col-xs-5 col-sm-3 pull-left"><label class="label-options" style="text-align: left;">Order</label><div class="btn-group btn-agroup pull-left"><label class="btn btn-sm action-button btn-primary" ng-model="reverse" ng-change="toggleReverse(reverse)" ng-disabled="!completeLoad" uib-btn-checkbox="" btn-checkbox-true="1" btn-checkbox-false="0">Reverse</label></div></div><div class="col-lg-3 offset-lg-4 offset-md-4 col-md-3 offset-sm-5 col-sm-4 col-xs-7 pull-left"><div class="row"><div class="form-group col-md-6 col-sm-6 col-xs-6"><label class="label-options" style="text-align: left;">Clean</label> <button type="button" ng-show="results.length" ng-click="resetDealer(dealer)" class="btn btn-primary btn-raised action-button"><i class="ion-android-remove-circle" style="margin-left: -13px;"></i> &nbsp; <span class="hidden-md hidden-lg">Reset</span> <span class="hidden-sm hidden-xs">Reset list</span></button></div><div class="form-group col-md-6 col-sm-6 col-xs-6"><label class="label-options" style="text-align: left;">Save</label> <button type="button" ng-show="results.length" ng-click="addDealer();" id="addDealer" class="btn btn-primary btn-raised action-button"><i class="ion-plus-circled" style="margin-left: -13px;"></i> &nbsp; <span class="hidden-md hidden-lg">Save</span> <span class="hidden-sm hidden-xs">Save list</span></button></div></div></div><div class="col-lg-5 col-md-5"></div></div><div ng-class="{\'opacity-res\': opacity}"><div class="list-articles" ng-show="results.length"><div class="article-item clearfix table" bindonce="" ng-repeat="result in results" ng-init="result[\'section_name\']=getDealerName(result.id)" style="margin-bottom: 10px;"><div class="section_name"><h2 editable-text="result.section_name" buttons="no" blur="cancel">{{result.section_name}}</h2><h2 ng-init="result[\'qty\']=getDealerQty(result.id)" style="color: #005FBD; margin-left: 10px;">{{result.items.length}} / {{result.qty}} Vehicles Loaded</h2></div><br><br><div class="row editable-tr-wrap" ng-repeat="item in result.items | filter:search | orderBy:sort:reverse track by $index"><div class="card"><div class="no-m" ng-mouseover="showFlex(item)" style="width: 300px; max-width: 300px;"><img ng-if="!item.slider" style="border: 4px solid #fff;" data-index="{{$index}}" class="img-responsive" ng-src="{{item.images[0].urlChange|replace:\'widea\':\'280x0\'}}"><flex-slider ng-if="item.slider" id="{{item.id}}" flex-slide="elem in item.images track by elem.id" after="setPhoto(item.id, item.section_id)" slideshow="false" start-at="item.sel_img" control-nav="false" animation="fade" animation-speed="0" animation-loop="false" prev-text="" next-text=""><li class="fade-in" style="display: block;"><img data-index="{{$index}}" ng-src="{{elem.urlChange|replace:\'widea\':\'280x0\'}}"></li></flex-slider></div><div class="card-content"><span class="pull-right text-danger" ng-click="deleteItem(item.id, item.section_id)" style="cursor: pointer;"><i class="ion-close"></i></span><h2 class="card-title"><span class="title" editable-text="item.title" buttons="no" blur="cancel"><h3 style="display: table-cell;">{{item.title}}</h3></span></h2><p class="stock-number"><span>Stock Number:<h4 editable-text="item.sf_stock" buttons="no" blur="cancel">{{item.sf_stock | bydefault: "Unknown"}}</h4></span></p><p class="price"><span>Price:<h4 editable-text="item.sf_price" buttons="no" blur="cancel">{{item.sf_price | currency:"$":0 | bydefault: "Call Us"}}</h4></span></p><div class="card-buttons"><button class="btn btn-primary btn-raised btn-sm" ng-click="uploadPicture(item.id)">Upload Image</button> <a ng-click="deleteItem(item.id, item.section_id, $index); loadCars(false);" class="btn btn-raised btn-primary btn-sm">Replace Car</a> <a href="{{item.hyperlink}}" class="btn btn-raised btn-primary btn-sm" target="_blank">View Detail</a> <input type="file" ng-show="false" id="file{{item.id}}" ng-file-select="onFileSelect($files)" item="item-{{item.id}}"></div></div></div></div></div></div></div></div></div></div></div><div class="row" id="resultpdf" ng-show="type_export==\'demos\' && sections.length"><div class="col-lg-12 col-md-12 col-sm-12" style="z-index: 100;"><div class="panel"><div class="panel-body with-scroll panel-default min-height-panel-large"><div class="row"><div class="col-lg-8 col-md-8 col-sm-7 col-xs-7"><h1 style="font-weight: 400;" ng-show="template.name">Template: {{template.name}}</h1><h1 style="font-weight: 400;" ng-show="!template.name && !create && projectload">Please, Select a Template</h1></div><div class="col-lg-4 col-md-4 col-sm-5 col-xs-5" ng-show="pdfUrl && !create"><button type="button" class="btn btn-sm btn-primary btn-raised hidden-sm hidden-xs btn-with-icon pull-right" ng-show="soltemplate" ng-click="reload()"><i style="margin-right: 0px;" class="ion-refresh"></i>Update</button> <button type="button" class="btn btn-sm btn-primary btn-raised hidden-md hidden-lg btn-with-icon pull-right" ng-show="soltemplate" ng-click="printDemo(soltemplate)"><i style="margin-right: 0px;" class="ion-refresh"></i>Download</button><div class="btn-group btn-agroup pull-right hidden-sm hidden-xs" style="margin-right: 10px;" ng-show="soltemplate"><label class="btn btn-sm btn-raised btn-primary" id="toggleEditor" ng-model="editor" ng-change="toggleEditor(editor)" ng-disabled="!completeLoad" uib-btn-checkbox="" btn-checkbox-true="1" btn-checkbox-false="0"><i class="ion-edit"></i> Editor</label></div></div></div><div id="iframe-container"><div class="center-ripple" ng-show="!pdfUrl"><div class="lds-ripple"><div></div><div></div></div></div><div class="row mt-10"><div id="menu-frame" class="hidden-sm hidden-xs col-lg-3 col-md-3 col-sm-12"><uib-tabset style="margin-top: 10px" active="$tabSetStatus.activeTab2" ng-show="editor && pdfUrl"><uib-tab classes="tools-iframe" heading="Editor"><div class="custom-tab-1" id="custom-tab-1" style="margin-left: -15px; margin-right: -15px;"><form name="form" style="padding: 10px; padding-top: 0;"><div class="input-demo radio-demo row"><div class="col-lg-8 col-md-8 col-sm-8 col-xs-8"><label class="nowrap" style="padding-top: 2px;font-size: 18px;font-weight: 450;"><span>Shared Template</span></label></div><div class="col-lg-2 col-md-2 col-sm-2 col-xs-2"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" ng-model="template.shared" ng-click="updateShared(true)" id="inlineRadio2" ng-value="true"> <span>Yes</span></label></div><div class="col-md-2 col-md-2 col-sm-2 col-xs-2"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" id="inlineRadio3" ng-model="template.shared" ng-click="updateShared(false)" ng-value="false" checked=""> <span>No</span></label></div></div><h4>Banners</h4><div class="row"><div class="col-sm-6 col-md-6 no-pr"><div class="form-group"><label for="inputFirstName">Background</label><color-picker options="options" ng-model="template.sec_color"></color-picker></div></div><div class="col-sm-6 col-md-6 no-pr"><div class="form-group"><label for="inputFirstName">Main Title</label><color-picker options="options" ng-model="template.extras.title_color"></color-picker></div></div></div><div class="row"><div class="col-sm-6 col-md-6"><label>Border Color</label><color-picker options="options" ng-model="template.extras.pages[0].item_border_color"></color-picker></div></div><h4>Banner 970x250</h4><div class="slider-box"><h5>Title</h5><div class="row"><div class="col-sm-6 col-md-6"><label>Text Color</label><color-picker options="options" ng-model="template.extras.pages[0].banner_970x250.title_color"></color-picker></div><div class="col-sm-6 col-md-6"></div></div></div><div class="slider-box"><h5>Sub Title</h5><div class="row"><div class="col-sm-6 col-md-6"><label>Text Color</label><color-picker options="options" ng-model="template.extras.pages[0].banner_970x250.subtitle_color"></color-picker></div><div class="col-sm-6 col-md-6"><div class="form-group"><label>Background</label><color-picker options="options" ng-model="template.extras.pages[0].banner_970x250.subtitle_bg"></color-picker></div></div></div></div><div class="slider-box"><h5>Third Title</h5><div class="row"><div class="col-sm-6 col-md-6"><label>Text Color</label><color-picker options="options" ng-model="template.extras.pages[0].banner_970x250.thirdtitle_color"></color-picker></div><div class="col-sm-6 col-md-6"><div class="form-group"><label>Background</label><color-picker options="options" ng-model="template.extras.pages[0].banner_970x250.thirdtitle_bg"></color-picker></div></div></div></div><h4>Banner 728x90</h4><div class="slider-box"><div class="row"><div class="col-sm-6 col-md-6"><label>Title Color</label><color-picker options="options" ng-model="template.extras.pages[0].banner_728x90.title_color"></color-picker></div><div class="col-sm-6 col-md-6"><label>Sub Title Color</label><color-picker options="options" ng-model="template.extras.pages[0].banner_728x90.subtitle_color"></color-picker></div></div></div><div class="slider-box"><div class="row"><div class="col-sm-6 col-md-6"><label>Third Title Color</label><color-picker options="options" ng-model="template.extras.pages[0].banner_728x90.thirdtitle_color"></color-picker></div></div></div><h4>Banner 300x600</h4><div class="slider-box"><h5>Title</h5><div class="row"><div class="col-sm-6 col-md-6"><label>Text Color</label><color-picker options="options" ng-model="template.extras.pages[0].banner_300x600.title_color"></color-picker></div><div class="col-sm-6 col-md-6"></div></div></div><div class="slider-box"><h5>Sub Title</h5><div class="row"><div class="col-sm-6 col-md-6"><label>Text Color</label><color-picker options="options" ng-model="template.extras.pages[0].banner_300x600.subtitle_color"></color-picker></div><div class="col-sm-6 col-md-6"><div class="form-group"><label>Background</label><color-picker options="options" ng-model="template.extras.pages[0].banner_300x600.subtitle_bg"></color-picker></div></div></div></div><div class="slider-box"><h5>Third Title</h5><div class="row"><div class="col-sm-6 col-md-6"><label>Text Color</label><color-picker options="options" ng-model="template.extras.pages[0].banner_300x600.thirdtitle_color"></color-picker></div><div class="col-sm-6 col-md-6"><div class="form-group"><label>Background</label><color-picker options="options" ng-model="template.extras.pages[0].banner_300x600.thirdtitle_bg"></color-picker></div></div></div></div><h4>Banner 300x250</h4><div class="slider-box"><div class="row"><div class="col-sm-6 col-md-6"><label>Title Color</label><color-picker options="options" ng-model="template.extras.pages[0].banner_300x250.title_color"></color-picker></div><div class="col-sm-6 col-md-6"><label>Sub Title Color</label><color-picker options="options" ng-model="template.extras.pages[0].banner_300x250.subtitle_color"></color-picker></div></div></div><div class="slider-box"><div class="row"><div class="col-sm-6 col-md-6"><label>Third Title Color</label><color-picker options="options" ng-model="template.extras.pages[0].banner_300x250.thirdtitle_color"></color-picker></div><div class="col-sm-6 col-md-6"></div></div></div><h4>Reverse / Email Template</h4><div class="slider-box"><h5>Title</h5><div class="row"><div class="col-sm-6 col-md-6"><label>Text Color</label><color-picker options="options" ng-model="template.extras.pages[1].title_color"></color-picker></div><div class="col-sm-6 col-md-6"><div class="form-group"><label>Background</label><color-picker options="options" ng-model="template.extras.pages[1].title_bg"></color-picker></div></div></div></div><div class="slider-box"><h5>Sub Title</h5><div class="row"><div class="col-sm-6 col-md-6"><label>Text Color</label><color-picker options="options" ng-model="template.extras.pages[1].subtitle_color"></color-picker></div><div class="col-sm-6 col-md-6"><div class="form-group"><label>Background</label><color-picker options="options" ng-model="template.extras.pages[1].subtitle_bg"></color-picker></div></div></div></div><div class="slider-box"><h5>Third Title</h5><div class="row"><div class="col-sm-6 col-md-6"><label>Text Color</label><color-picker options="options" ng-model="template.extras.pages[1].thirdtitle_color"></color-picker></div><div class="col-sm-6 col-md-6"><div class="form-group"><label>Background</label><color-picker options="options" ng-model="template.extras.pages[1].thirdtitle_bg"></color-picker></div></div></div></div></form></div></uib-tab><uib-tab classes="tools-iframe" heading="Images"><div class="row"><div class="col-sm-12 col-md-12"><button class="btn btn-primary btn-sm btn-block" ng-click="uploadPictureSolution(\'banner_970x250\')">Banner 970x250</button> <img style="margin-top: 10px; margin-bottom: 10px" ng-src="{{template.images.banner_970x250}}" id="img_banner_970x250" class="img-responsive"></div><input type="file" ng-show="false" id="banner_970x250" ng-file-select="onFileSelect($files)" item="banner_970x250"></div><br><div class="row"><div class="col-sm-12 col-md-12"><button class="btn btn-primary btn-sm btn-block" ng-click="uploadPictureSolution(\'banner_728x90\')">Banner 728x90</button> <img style="margin-top: 10px; margin-bottom: 10px" ng-src="{{template.images.banner_728x90}}" id="img_banner_728x90" class="img-responsive"></div><input type="file" ng-show="false" id="banner_728x90" ng-file-select="onFileSelect($files)" item="banner_728x90"></div><br><div class="row"><div class="col-sm-12 col-md-12"><button class="btn btn-primary btn-sm btn-block" ng-click="uploadPictureSolution(\'banner_300x600\')">Banner 300x600</button> <img style="margin-top: 10px; margin-bottom: 10px" ng-src="{{template.images.banner_300x600}}" id="img_banner_300x600" class="img-responsive"></div><input type="file" ng-show="false" id="banner_300x600" ng-file-select="onFileSelect($files)" item="banner_300x600"></div><br><div class="row"><div class="col-sm-12 col-md-12"><button class="btn btn-primary btn-sm btn-block" ng-click="uploadPictureSolution(\'banner_300x250\')">Banner 300x250</button> <img style="margin-top: 10px; margin-bottom: 10px" ng-src="{{template.images.banner_300x250}}" id="img_banner_300x250" class="img-responsive"></div><input type="file" ng-show="false" id="banner_300x250" ng-file-select="onFileSelect($files)" item="banner_300x250"></div><br><div class="row"><div class="col-sm-12 col-md-12"><button class="btn btn-primary btn-sm btn-block" ng-click="uploadPictureSolution(\'email_header\')">Email Header</button> <img style="margin-top: 10px; margin-bottom: 10px" ng-src="{{template.images.email_header}}" id="img_email_header" class="img-responsive"></div><input type="file" ng-show="false" id="email_header" ng-file-select="onFileSelect($files)" item="email_header"></div><br><div class="row"><div class="col-sm-12 col-md-12"><button class="btn btn-primary btn-sm btn-block" ng-click="uploadPictureSolution(\'email_footer\')">Email Footer</button> <img style="margin-top: 10px; margin-bottom: 10px" ng-src="{{template.images.email_footer}}" id="img_email_footer" class="img-responsive"></div><input type="file" ng-show="false" id="email_footer" ng-file-select="onFileSelect($files)" item="email_footer"></div><br><div class="row"><div class="col-sm-12 col-md-12"><button class="btn btn-primary btn-sm btn-block" ng-click="uploadPictureSolution(\'reverse_header\')">Reverse Header</button> <img style="margin-top: 10px; margin-bottom: 10px" ng-src="{{template.images.reverse_header}}" id="img_reverse_header" class="img-responsive"></div><input type="file" ng-show="false" id="reverse_header" ng-file-select="onFileSelect($files)" item="reverse_header"></div><br><div class="row"><div class="col-sm-12 col-md-12"><button class="btn btn-primary btn-sm btn-block" ng-click="uploadPictureSolution(\'reverse_footer\')">Reverse Footer</button> <img style="margin-top: 10px; margin-bottom: 10px" ng-src="{{template.images.reverse_footer}}" id="img_reverse_footer" class="img-responsive"></div><input type="file" ng-show="false" id="reverse_footer" ng-file-select="onFileSelect($files)" item="reverse_footer"></div></uib-tab></uib-tabset></div><div class="col-lg-12 col-md-12 col-sm-12" id="frameview"><div class="h_iframe"><iframe ng-show="pdfUrl" name="Tester" height="1060" ng-src="{{pdfUrl | trustAsResourceUrl}}"></iframe></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/pages/export/index.html','<div class="row"><div class="col-lg-12 col-md-12 col-sm-12"><div class="panel" style="margin-bottom: 15px;"><div class="panel-body"><div class="box-select"><div class="btn-group btn-agroup report-btn pull-left"><label class="btn btn-primary" ng-model="type_export" ng-change="toggleExport(\'select\', \'Export XML\')" ng-disabled="!completeLoad" uib-btn-radio="\'select\'"><b class="hidden-sm hidden-xs">Select Vehicles</b> <b class="hidden-lg hidden-md">Vehicles</b></label> <label class="btn btn-primary" ng-model="type_export" ng-change="toggleExport(\'pdf\', \'Export PDF\')" ng-disabled="!completeLoad" uib-btn-radio="\'pdf\'"><b class="hidden-sm hidden-xs">Export To PDF</b> <b class="hidden-lg hidden-md">PDF</b></label> <label class="btn btn-primary" ng-model="type_export" ng-change="toggleExport(\'xml\', \'Export Indesign\')" ng-disabled="!completeLoad" uib-btn-radio="\'xml\'"><b class="hidden-sm hidden-xs">Export To Indesign</b> <b class="hidden-lg hidden-md">Indesign</b></label></div></div></div></div></div></div><div class="row"><div class="col-lg-12 col-md-12 col-sm-12" style="z-index: 100;" ng-show="(extras.access==\'basic\' && type_export==\'select\' ) && group_name != \'root\'"><div class="panel" style="margin-bottom: 15px;"><div class="panel-body" style="padding-bottom: 15px;"><div class="row"><div class="col-lg-12 col-md-12 col-sm-12"><form name="form"><div class="row"><div class="col-lg-6 col-md-6 col-sm-6"><h2 class="pull-left">Choose a Content Layout</h2></div></div><div class="center-ripple" ng-show="!specialtemplates.length"><div class="lds-ripple"><div></div><div></div></div></div><div class="row"><div class="base-template wrapper-template" ng-repeat="base in specialtemplates|orderBy:\'name\'" ng-if="base.name!=\'Template Solutions\'" style="cursor: pointer;" ng-click="selTemplate(base.id)" ng-class="{\'base-template-active\': base.id === seltemplate}"><div class="row"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"><label class="template-name" ng-class="{selectedTemp: base.id === seltemplate}">{{base.name|replace:".base":""}}</label></div></div><div class="row"><div class="col-lg-6 col-md-6 col-sm-6 col-xs-12"><div class="logo-templates" style="background: url(assets/img/templates/{{base.icon|replace:\' \':\'\'}}.png) no-repeat center;" ng-class="{selectedTemp: base.id === seltemplate}"></div></div><div class="col-lg-6 col-md-6 col-sm-6 col-xs-12"><label ng-class="{selectedTemp: base.id === seltemplate}">&nbsp;</label><p>{{base.description}}</p></div></div></div></div></form></div></div></div></div></div><div class="col-lg-12 col-md-12 col-sm-12" style="z-index: 100;" ng-show="type_export == \'pdf\' && !create && !preInit"><div class="panel" ng-hide="extras.access == \'basic\' && group_name!=\'root\'"><div class="panel-body"><h1 style="font-weight: 400;" class="hidden-md hidden-lg">Export PDF \xB7 {{title_pro}} Project</h1><h1 style="font-weight: 400;" class="hidden-sm hidden-xs">{{title_pro}} Project</h1><button ng-click="newTemplate()" data-toggle="tooltip" uib-tooltip="Template Editor" ng-show="!copy" type="button" style="border-radius: 0; padding-left:20px; padding-right:20px; margin-top: -35px;" ng-disabled="!completeLoad" pb-style="top-line" class="hidden-lg hidden-md btn btn-primary btn-raised pull-right btn-md"><b>New</b></button> <button ng-click="newTemplate()" data-toggle="tooltip" uib-tooltip="Template Editor" ng-show="!copy" type="button" style="border-radius: 0; padding-left:20px; padding-right:20px; margin-top: -40px;" ng-disabled="!completeLoad" pb-style="top-line" class="hidden-xs hidden-sm btn btn-primary btn-raised pull-right btn-md"><b>New template</b></button><form style="margin-top: 15px;" name="form"><div class="row"><div class="col-md-10 no-pr"><div class="form-group mb-5"><label>Choose Template</label><selectize config="configSingleOne" ng-disabled="!completeLoad" placeholder="Select Template" options="templates" ng-model="seltemplate"></selectize></div></div><div class="no-pl col-md-2"><button type="button" style="margin-top: 22px;" data-toggle="tooltip" ng-show="seltemplate && group_name==\'root\'" uib-tooltip="Delete Template" ng-click="deleteTemplate(seltemplate, templates)" class="btn btn-primary btn-icon pull-right"><i class="ion-trash-a"></i></button> <button type="button" style="margin-right: 15px; margin-top: 22px" data-toggle="tooltip" ng-show="seltemplate && group_name==\'root\'" uib-tooltip="Copy Template" ng-click="setTemplate(seltemplate, templates)" class="btn btn-primary btn-icon pull-right"><i class="ion-paper-airplane"></i></button></div></div><div class="row mb-10" ng-show="copy"><div class="col-md-7"><div class="form-group mb-5"><label>Copy to site</label><selectize config="configSingleOne" ng-disabled="!completeLoad" placeholder="Select Site" options="sites" ng-model="siteid"></selectize><input type="text" style="margin-top: 5px;" allow-pattern="[a-z .0-9]" class="form-control" ng-model="templateNew.name" id="inputLastName" placeholder="Template name"></div></div></div><button ng-show="copy" ng-click="copyTemplate()" data-toggle="tooltip" type="button" style="border-radius: 0; padding-left:20px; padding-right:20px; margin-right: 20px;" ng-disabled="!completeLoad" pb-style="top-line" class="btn btn-primary btn-raised pull-left btn-md"><b>Copy</b></button> <button ng-show="copy" ng-click="cancelCopy()" data-toggle="tooltip" uib-tooltip="Template Editor" type="button" style="border-radius: 0; padding-left:20px; padding-right:20px; margin-right: 20px;" ng-disabled="!completeLoad" pb-style="top-line" class="btn btn-primary btn-raised pull-left btn-md"><b>Cancel</b></button></form></div></div></div><div class="col-lg-12 col-md-12 col-sm-12" style="z-index: 100;" ng-show="type_export==\'xml\'"><div class="panel"><div class="panel-body" style="padding-bottom: 25px"><h1 style="font-weight: 400;">Export To Indesign \xB7 {{title_pro}} Project</h1><form name="form2" id="form2" novalidate=""><div class="row"><div class="col-md-12"><div class="form-group"><label for="xmlpreset">Select Preset</label><div class="input-group"><selectize config="configSingleOne" placeholder="Select Preset to export" options="presets_options" ng-model="preset_selected" ng-disabled="!completeLoadExtra"></selectize><span class="input-group-btn" ng-show="preset_selected"><button class="btn btn-primary btn-icon" ng-click="deleteTemplateXMLModal()" type="button"><i class="ion-close"></i></button></span></div></div></div><div class="col-md-12" ng-show="preset_selected"><div class="form-group clearfix"><label for="xmlname">Export Name</label> <input type="text" class="form-control" id="xmlname" oninput="this.value = this.value.toLowerCase()" name="xmlname" ng-disabled="!completeLoad" ng-model="xml_name" required="" placeholder="Name to zip export"></div></div><div class="col-md-12" ng-show="!preset_selected"><div class="form-group"><label for="xmlname">Preset Name</label> <input type="text" ng-model="preset_name" class="form-control" id="preset_name" name="preset_name" ng-disabled="!completeLoad" ng-required="" placeholder="Name to create new preset"></div></div><div class="container-fluid"><div class="row" ng-repeat="item in combinations"><div class="col-md-2" style="padding-top: 10px"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" value="" ng-model="item.select" ng-true-value="true" ng-false-value="false"> <span class="font-weight-bold"><b>{{item.tag}}</b></span></label></div><div class="col-md-5"><div class="form-group"><selectize config="configSingleOne" placeholder="Select property" options="getProperties(item.tag)" ng-model="item.property" ng-disabled="!completeLoadExtra" ng-required=""></selectize></div></div><div class="col-md-5"><div class="form-group"><selectize config="configSingleOne" placeholder="Select styles" options="styles" ng-model="item.style" ng-disabled="!completeLoadExtra"></selectize></div></div></div></div></div><div class="alert bg-danger no-m text-center blur-alert-danger" ng-show="seltag===false" style="padding: 5px"><strong>Please, select almost a tag!</strong></div><br><button type="button" ng-show="!preset_selected" ng-click="saveTemplateXML()" style="padding-left:20px; padding-right:20px;" ng-disabled="!preset_name" pb-style="top-line" class="btn btn-primary btn-raised pull-left btn-md"><b>Create new preset</b></button> <button type="button" ng-show="preset_selected" ng-click="newTemplateXML()" style="padding-left:20px; padding-right:20px;" ng-disabled="!completeLoad" pb-style="top-line" class="btn btn-primary btn-raised pull-left btn-md"><b>New preset</b></button> <button ng-click="getExportXML()" type="submit" ng-disabled="!xml_name || !preset_selected" pb-style="top-line" class="btn btn-primary btn-raised pull-right btn-md"><b>Export</b></button></form></div></div></div><div class="col-lg-7 col-md-7 col-sm-12" style="z-index: 100;" ng-show="type_export==\'select\'"><div class="panel"><div class="panel-body"><div class="row"><div class="col-md-10 col-lg-10"><span><h1 style="font-weight: 400;" class="hidden-sm hidden-xs">Select Dealers & Vehicles</h1></span><h2 style="font-weight: 400;" class="hidden-lg hidden-md">Project: {{title_pro}}</h2></div><div class="col-md-2 col-lg-2" ng-show="project.temp"><div class="pull-right copystock" style="font-size: 2em;"><button type="button" ng-click="postProject()" style="float: left;" class="btn btn-primary btn-raised btn-block no-m"><b style="color: #fff; text-transform: none;">Create Project</b></button></div></div></div><form name="form" ng-show="type_export==\'select\'"><div class="row"><div class="col-xs-6 col-sm-3 col-md-3 col-lg-3"><div class="form-group"><label for="inputFirstName">Price Min</label><div class="input-group"><span class="input-group-addon custom-group">$</span> <input type="number" class="form-control input-group-currency" ng-disabled="!completeLoad" id="inputFirstName" ng-model="conf.price_min" placeholder="Min"></div></div></div><div class="col-xs-6 col-sm-3 col-md-3 col-lg-3"><div class="form-group"><label for="inputLastName">Price Max</label><div class="input-group"><span class="input-group-addon custom-group">$</span> <input type="number" class="form-control input-group-currency" ng-model="conf.price_max" ng-disabled="!completeLoad" id="inputLastName" placeholder="Max"></div></div></div><div class="col-xs-6 col-sm-3 col-md-2 offset-lg-2 col-lg-2"><div class="form-group"><label for="limitNumber">Limit</label> <input type="number" ng-max="100" max="100" ng-min="3" min="3" ng-model="conf.numLimit" class="form-control" id="limitNumber" ng-disabled="!completeLoad" placeholder="N\xBA"></div></div><div class="col-xs-6 col-sm-3 col-md-2 col-lg-2"><div class="form-group"><label for="activeNumber">Available</label> <input type="number" readonly="" ng-min="3" min="3" ng-model="available" class="resalt form-control" id="activeNumber" ng-disabled="!completeLoad" placeholder="N\xBA"></div></div></div><div class="row"><div class="col-xs-12 col-sm-12 col-lg-12 col-md-12 col-md-offset-1 pull-right"><label class="label-options">Get Items By {{label_type}}</label><div class="btn-group btn-agroup type-btn pull-right"><label class="btn btn-sm btn-primary" ng-model="type" ng-change="toggleType(\'random\', \'Random\')" ng-disabled="!completeLoad" uib-btn-radio="\'random\'"><span class="large">Random</span> <span class="small">Random</span></label> <label class="btn btn-sm btn-primary" ng-model="type" ng-change="toggleType(\'min\', \'Min Price\')" ng-disabled="!completeLoad" uib-btn-radio="\'min\'"><span class="large">Min Price</span> <span class="small">Min</span></label> <label class="btn btn-sm btn-primary" ng-model="type" ng-change="toggleType(\'max\', \'Max Price\')" ng-disabled="!completeLoad" uib-btn-radio="\'max\'"><span class="large">Max Price</span> <span class="small">Max</span></label> <label class="btn btn-sm btn-primary" ng-model="type" ng-change="toggleType(\'all\' , \'Stock\')" ng-disabled="!completeLoad" uib-btn-radio="\'all\'"><span class="large">Stock</span> <span class="small">Stock</span></label></div></div></div><br><div class="form-group mb-5"><label>Choose Dealer</label><selectize config="configSingle" ng-disabled="!completeLoad" placeholder="Select Dealers" options="dealers" ng-model="dealer"></selectize><span ng-show="!dealer.length" class="help-block sub-little-text">Select one dealer from this list</span></div><div class="form-group mb-5" ng-show="dealer.length"><label>Choose Make</label><selectize config="configSelect" placeholder="Select Makes" options="makes" ng-model="make" ng-disabled="!completeLoadExtra"></selectize></div><div class="form-group mb-5" ng-show="dealer.length"><label>Choose Body Styles</label><selectize config="configSelect" placeholder="Select Body Styles" options="bodys" ng-model="body" ng-disabled="!completeLoadExtra"></selectize></div><div class="form-group mb-5" ng-show="dealer.length"><label>Choose Model</label><selectize config="configSelect" placeholder="Select Models" options="models" ng-model="model" ng-disabled="!completeLoadExtra"></selectize></div><div class="form-group mb-5" ng-show="dealer.length"><label>Choose Year</label><selectize config="configSelect" placeholder="Select Years" options="years" ng-model="year" ng-disabled="!completeLoadExtra"></selectize></div><div class="form-group mb-5" ng-show="type==\'all\'"><label>Write Stock</label><selectize config="configSelect" options="stocksOptions" placeholder="Add Stock" ng-model="stocks"></selectize><span class="help-block sub-little-text">Add stock number list</span></div><div class="row"><div class="col-lg-4 col-md-4 col-sm-8 col-xs-4"><div class="pull-left" style="padding-top: 10px"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" value="" ng-model="excphimages" ng-true-value="1" ng-false-value="0" class="ng-valid ng-dirty ng-valid-parse ng-touched ng-empty"> <span class="font-weight-bold"><b class="ng-binding hidden-sm hidden-xs">No image placeholder</b> <b class="ng-binding hidden-lg hidden-md">No placeholder</b></span></label></div></div><div class="col-lg-4 col-md-4 col-sm-2 col-xs-4 no-pr"><button type="button" ng-click="loadCars(true)" style="padding-left:20px; margin-left:15px;" ng-disabled="!completeLoadExtra" pb-style="top-line" class="btn btn-primary btn-raised pull-right btn-md"><i class="ion-ios-refresh"></i> &nbsp; <b class="hidden-xs hidden-sm">Load Vehicles</b> <b class="hidden-lg hidden-md">Load</b></button></div><div class="col-lg-4 col-md-4 col-sm-2 col-xs-4"><button type="button" ng-click="loadCars(false)" ng-disabled="!completeLoadExtra" style="border-radius: 0; padding-left:20px; padding-right:20px;" pb-style="top-line" class="btn btn-primary btn-raised pull-right btn-md"><i class="ion-arrow-swap"></i> &nbsp; <b class="hidden-xs hidden-sm">Sync Vehicles</b> <b class="hidden-lg hidden-md">Sync</b></button></div></div></form></div></div></div><div class="col-lg-5 col-md-5 col-sm-12" ng-show="(!create && !preInit) || type_export!=\'pdf\'"><div class="panel" ng-hide="((extras.access == \'basic\' && type_export!=\'select\') && group_name!=\'root\') || type_export==\'xml\' || type_export==\'pdf\'"><div class="panel-body min-height-panel-375" style="padding-bottom: 25px"><h1 style="font-weight: 400;">Vehicles<div class="pull-right copystock"><br><i class="ion-ios-grid-view" style="cursor: pointer;" ng-click="expXls($event)" uib-tooltip="XLS Export"></i> <i class="ion-ios-copy-outline" style="cursor: pointer;" ng-show="!copystock" ng-click="copyStock($event)" uib-tooltip="Copy all stocks!"></i> <i class="ion-ios-copy" uib-tooltip="{{copystockmsg}}" tooltip-is-open="copystock" ng-show="copystock"></i></div></h1><div class="horizontal-scroll main-table"><table class="table"><thead><tr><th class="align-left">#</th><th class="align-left">DEALER</th><th class="align-center">CARS</th><th ng-show="selectedTemplate.hybrid">Linear</th><th class="align-center">REMOVE</th></tr></thead><tbody ui-sortable="sortableOptions" ng-model="sections"><tr ng-repeat="item in sections" class="item-table-xs" style="cursor: pointer;"><td ng-click="refreshResults(item.id)">{{$index+1}}</td><td ng-click="refreshResults(item.id)" ng-class="nowrap">{{item.name}}</td><td ng-click="refreshResults(item.id)" class="align-center">{{item.items.length}}</td><td ng-class="align-center" ng-show="selectedTemplate.hybrid" style="text-align: center;"><span class="text-success" ng-if="!item.linear" style="font-size: 1.3em;" ng-click="linear(item.eid, true)"><i class="ion-android-apps"></i></span> <span class="text-success" style="font-size: 1.3em;" ng-if="item.linear" ng-click="linear(item.eid, false)"><i class="ion-android-menu"></i></span></td><td class="align-center"><span class="text-danger" ng-click="discard(item.eid)"><i class="ion-close"></i></span></td></tr></tbody></table></div></div></div><div></div></div></div><div class="row" id="logs" ng-show="type_export==\'xml\'"><div class="col-lg-12 col-md-12 col-sm-12"><div class="panel" style="margin-top: -8px;"><div class="panel-body with-scroll panel-default min-height-panel"><div class="container-fluid"><h1 style="font-weight: 400;">Export Logs</h1><div class="row"><div class="col-md-12"><div class="form-group clearfix"><label for="xmlname">File Name</label> <input type="text" class="form-control" id="filename" name="filename" ng-disabled="!completeLoad" ng-model="filename" required="" placeholder="Search on filename list"></div><div class="horizontal-scroll"><table class="table"><thead><tr><th>#</th><th>TEMPLATE NAME</th><th class="align-center">CREATION DATE</th><th class="align-center">REMOVE</th></tr></thead><tbody><tr ng-repeat="file in files | filter:filename"><td>{{$index+1}}</td><td>{{file.name}}</td><td class="align-center">{{file.date | date:"medium"}}</td><td class="align-center"><i ng-click="deleteFileXML(file)" class="ion-close" style="color: #fa8072"></i></td></tr></tbody></table></div></div></div></div></div></div></div></div><div class="row" id="results" ng-show="type_export==\'select\'"><div class="col-lg-12 col-md-12 col-sm-12"><div class="panel"><div class="panel-body with-scroll panel-default min-height-panel"><h1 style="font-weight: 400;">Vehicles Loaded</h1><h3>{{rtitle}}</h3><form class="row form-inline"><div class="form-group col-md-12 col-sm-12"><input type="text" class="form-control" ng-model="search" id="searchItems" placeholder="Search cars"></div></form><div class="center-ripple" style="margin-top: 35px;" ng-show="!results.length && loading"><div class="lds-ripple"><div></div><div></div></div></div><br><div class="row" ng-show="results.length && mode!=\'solutions\'"><div class="col-lg-4 col-md-4"><label class="label-options" style="text-align: left;">Sort</label><div class="btn-group btn-agroup sort-btn"><label class="btn btn-sm btn-primary" ng-model="sort" ng-change="toggleOrder(\'random\', \'Random\')" ng-disabled="!completeLoad" uib-btn-radio="\'random\'"><span class="large">Random</span> <span class="small">Random</span> <span></span></label> <label class="btn btn-sm btn-primary" ng-model="sort" ng-change="toggleOrder(\'sf_price\', \'Price\')" ng-disabled="!completeLoad" uib-btn-radio="\'sf_price\'"><span class="large">Price</span> <span class="small">Price</span></label> <label class="btn btn-sm btn-primary" ng-model="sort" ng-change="toggleOrder(\'sf_make\', \'Make\')" ng-disabled="!completeLoad" uib-btn-radio="\'sf_make\'"><span class="large">Make</span> <span class="small">Make</span></label> <label class="btn btn-sm btn-primary" ng-model="sort" ng-change="toggleOrder(\'sf_model\', \'Model\')" ng-disabled="!completeLoad" uib-btn-radio="\'sf_model\'"><span class="large">Model</span> <span class="small">Model</span></label> <label class="btn btn-sm btn-primary" ng-model="sort" ng-change="toggleOrder(\'sf_year\' , \'Year\')" ng-disabled="!completeLoad" uib-btn-radio="\'sf_year\'"><span class="large">Year</span> <span class="small">Year</span></label></div></div><div class="col-lg-1 col-md-1 col-xs-5 col-sm-3 pull-left"><label class="label-options" style="text-align: left;">Order</label><div class="btn-group btn-agroup pull-left"><label class="btn btn-sm action-button btn-primary" ng-model="reverse" ng-change="toggleReverse(reverse)" ng-disabled="!completeLoad" uib-btn-checkbox="" btn-checkbox-true="1" btn-checkbox-false="0">Reverse</label></div></div><div class="col-lg-3 offset-lg-4 offset-md-4 col-md-3 offset-sm-5 col-sm-4 col-xs-7 pull-left"><div class="row"><div class="form-group col-md-6 col-sm-6 col-xs-6"><label class="label-options" style="text-align: left;">Clean</label> <button type="button" ng-show="results.length" ng-click="resetDealer(dealer)" class="btn btn-primary btn-raised action-button"><i class="ion-android-remove-circle" style="margin-left: -13px;"></i> &nbsp; <span class="hidden-md hidden-lg">Reset</span> <span class="hidden-sm hidden-xs">Reset list</span></button></div><div class="form-group col-md-6 col-sm-6 col-xs-6"><label class="label-options" style="text-align: left;">Save</label> <button type="button" ng-show="results.length" ng-click="addDealer()" class="btn btn-primary btn-raised action-button"><i class="ion-plus-circled" style="margin-left: -13px;"></i> &nbsp; <span class="hidden-md hidden-lg">Save</span> <span class="hidden-sm hidden-xs">Save list</span></button></div></div></div></div><div ng-show="mode!=\'solutions\'" ng-class="{\'opacity-res\': opacity}"><div class="list-articles" ng-show="results.length"><div class="article-item clearfix table" bindonce="" ng-repeat="result in results" ng-init="result[\'section_name\']=getDealerName(result.id)" style="margin-bottom: 10px;"><div class="section_name"><h2 editable-text="result.section_name" buttons="no" blur="cancel">{{result.section_name}}</h2><h2 ng-init="result[\'qty\']=getDealerQty(result.id)" style="color: #005FBD; margin-left: 10px;">{{result.items.length}} / {{result.qty}} Vehicles Loaded</h2><span class="alert-tracking" ng-show="result.tracking === false"><i class="ion-alert-circled"></i> The cars do not have tracking url</span></div><br><br><div class="row editable-tr-wrap" ng-repeat="item in result.items | filter:search | orderBy:sort:reverse track by $index"><div class="card"><div class="no-m frame-flex-slider" ng-mouseover="showFlex(item)"><img ng-if="!item.slider" style="border: 4px solid #fff;" data-index="{{$index}}" class="img-responsive" ng-src="{{item.images[0].urlChange|replace:\'widea\':\'280x0\'}}"><flex-slider ng-if="item.slider" id="{{item.id}}" flex-slide="elem in item.images track by elem.id" after="setPhoto(item.id, item.section_id)" slideshow="false" start-at="item.sel_img" control-nav="false" animation="fade" animation-speed="0" animation-loop="false" prev-text="" next-text=""><li class="fade-in" style="display: block;"><img data-index="{{$index}}" ng-src="{{elem.urlChange|replace:\'widea\':\'280x0\'}}"></li></flex-slider></div><div class="card-content"><span class="pull-right text-danger" ng-click="deleteItem(item.id, item.section_id)" style="cursor: pointer;"><i class="ion-close"></i></span><h2 class="card-title"><span class="title" editable-text="item.title" buttons="no" blur="cancel"><h3 style="display: table-cell;">{{item.title}}</h3></span></h2><p class="stock-number"><span>Stock Number:<h4 editable-text="item.sf_stock" buttons="no" blur="cancel">{{item.sf_stock | bydefault: "Unknown"}}</h4></span></p><p class="price"><span>Price:<h4 editable-text="item.sf_price" buttons="no" blur="cancel">{{item.sf_price | currency:"$":0 | bydefault: "Call Us"}}</h4></span></p><div class="card-buttons"><button class="btn btn-primary btn-raised btn-sm" ng-click="uploadPicture(item.id)">Upload Image</button> <a ng-click="deleteItem(item.id, item.section_id, $index); loadCars(false);" class="btn btn-raised btn-primary btn-sm">Replace Car</a> <a href="{{item.hyperlink}}" class="btn btn-raised btn-primary btn-sm" target="_blank">View Detail</a> <input type="file" ng-show="false" id="file{{item.id}}" ng-file-select="onFileSelect($files)" item="item-{{item.id}}"></div></div></div></div></div></div></div></div></div></div></div><div class="row" ng-show="type_export==\'pdf\'"><div class="col-lg-12 col-md-12 col-sm-12" style="z-index: 10; margin-top: -10px;"><div class="panel"><div class="panel-body min-height-panel-large" ng-class="{\'min-height-panel\': create==true}"><div class="row"><div class="col-lg-8 col-md-8 col-sm-7 col-xs-7"><h1 class="template-name" ng-show="template.name && !create">{{template.name}}</h1><h1 style="font-weight: 400;" ng-show="!template.name && !create && projectload">Please, Select a Template</h1></div><div class="col-lg-4 col-md-4 col-sm-5 col-xs-5" ng-show="pdfUrl && !create"><button type="button" class="btn btn-sm btn-primary btn-raised hidden-sm hidden-xs btn-with-icon pull-right" ng-show="seltemplate" ng-click="reload()"><i style="margin-right: 0px;" class="ion-refresh"></i>Update</button> <button type="button" class="btn btn-sm btn-primary btn-raised hidden-md hidden-lg btn-with-icon pull-right" ng-show="seltemplate" ng-click="getExport()"><i style="margin-right: 0px;" class="ion-refresh"></i>Download</button><div class="btn-group btn-agroup pull-right hidden-sm hidden-xs" style="margin-right: 10px;" ng-show="seltemplate"><label class="btn btn-sm btn-raised btn-primary" id="toggleEditor" ng-model="editor" ng-change="toggleEditor(editor)" ng-disabled="!completeLoad" uib-btn-checkbox="" btn-checkbox-true="1" btn-checkbox-false="0"><i class="ion-edit"></i> Editor</label></div></div></div><div ng-show="!create" id="iframe-container"><div class="center-ripple" ng-show="!pdfUrl && seltemplate"><div class="lds-ripple"><div></div><div></div></div></div><div class="row mt-10" ng-show="pdfUrl"><div id="menu-frame" class="col-lg-3 col-md-3 col-sm-12"><uib-tabset class="hidden-sm hidden-xs" style="margin-top: 10px" active="$tabSetStatus.activeTab2" ng-if="template.ttype != \'dynamic\'" ng-show="editor && seltemplate && group_name==\'root\'"><uib-tab classes="tools-iframe" style="width: 50%;" heading="Editor"><div class="custom-tab-1" id="custom-tab-1" style="margin-left: -15px; margin-right: -15px;"><form name="form"><h4>Page</h4><div class="row"><div class="col-sm-6 col-md-6 no-pr"><div class="form-group"><label for="inputFirstName">Select Color</label><color-picker options="options" ng-model="template.page_bg"></color-picker></div></div><div class="col-md-6"><div class="form-group"><label for="inputLastName">Limit</label> <input type="number" string-to-number="" class="form-control input-sm" ng-model="template.limit" ng-model-options="{ debounce: 1000 }" id="inputLastName" placeholder=""></div></div></div><div class="row"><div class="col-sm-6 col-md-6"><div class="form-group"><label for="inputFirstName">Width "</label> <input type="number" string-to-number="" class="form-control input-sm" id="inputFirstName" ng-model="template.size_w" placeholder="Inch"></div></div><div class="col-md-6"><div class="form-group"><label for="inputLastName">Height "</label> <input type="number" string-to-number="" class="form-control input-sm" ng-model="template.size_h" ng-model-options="{ debounce: 1000 }" id="inputLastName" placeholder="Inch"></div></div></div><div class="row"><div class="col-md-6"><div class="form-group"><label for="inputLastName">Item on rows</label> <input type="number" string-to-number="" class="form-control input-sm" ng-model="template.item_by_page" ng-model-options="{ debounce: 1000 }" id="inputLastName" placeholder=""></div></div><div class="col-sm-6 col-md-6 no-pr"><div class="form-group"><label for="inputLastName">Show Dealers</label><br><ba-switcher switcher-style="primary" switcher-value="template.sec_col"></ba-switcher></div></div></div><h4>Header</h4><div class="row"><div class="col-sm-3 col-md-3 no-pr"><div class="form-group"><label for="inputFirstName">Width %</label> <input type="number" string-to-number="" class="form-control input-sm input-sm" id="inputFirstName" ng-model="template.header_w" placeholder="px"></div></div><div class="col-md-3 no-pr"><div class="form-group"><label for="inputLastName">Height px</label> <input type="number" string-to-number="" class="form-control input-sm input-sm" ng-model="template.header_h" id="inputLastName" placeholder="px"></div></div><div class="col-sm-6 col-md-6"><div class="form-group"><label for="colorSet">Select Color</label><color-picker options="options" ng-model="template.header_color"></color-picker></div></div></div><div class="row"><div class="col-sm-12 col-md-12"><button class="btn btn-primary btn-sm btn-block" ng-click="uploadPictureHeader()"><i class="ion-upload"></i> Upload new header image</button> <input type="file" ng-show="false" id="fileHeader" ng-file-select="onFileSelect($files)" item="header"></div></div><br><h4>Footer</h4><div class="row"><div class="col-sm-3 col-md-3 no-pr"><div class="form-group"><label for="inputFirstName">Width %</label> <input type="number" string-to-number="" class="form-control input-sm input-sm" id="inputFirstName" ng-model="template.footer_w" placeholder="px"></div></div><div class="col-sm-3 col-md-3 no-pr"><div class="form-group"><label for="inputLastName">Height px</label> <input type="number" string-to-number="" class="form-control input-sm input-sm" ng-model="template.footer_h" id="inputLastName" placeholder="px"></div></div><div class="col-sm-6 col-md-6 no-pr"><div class="form-group"><label for="inputFirstName">Select Color</label><color-picker options="options" ng-model="template.footer_color"></color-picker></div></div></div><div class="row"><div class="col-sm-12 col-md-12"><button class="btn btn-primary btn-sm btn-block" ng-click="uploadPictureFooter()">Upload new footer image</button> <input type="file" ng-show="false" id="fileFooter" ng-file-select="onFileSelect($files)" item="footer"></div></div><uib-tabset style="margin-top: 10px" active="$tabSetStatus.activeTab"><uib-tab classes="tools-iframe" heading="{{!template.hybrid && \'Template Options\' || \'Mosaic Dealers\'}}"><div class="custom-tab-1" id="custom-tab-1" style="margin-left: -15px; margin-right: -15px;"><h4>Dealers Container {{(!template.hybrid && \'Options\') || \'(Mosaic)\'}}</h4><div class="row"><div class="col-sm-3 col-md-3 no-pr"><div class="form-group"><label for="inputFirstName">Width px</label> <input type="number" string-to-number="" class="form-control input-sm input-sm" id="inputFirstName" ng-model="template.sec_w" placeholder="px"></div></div><div class="col-sm-3 col-md-3 no-pr"><div class="form-group"><label for="inputLastName">Height px</label> <input type="number" string-to-number="" class="form-control input-sm input-sm" ng-model="template.sec_h" id="inputLastName" placeholder="px"></div></div><div class="col-sm-6 col-md-6"><div class="form-group"><label for="inputFirstName">Select Color</label><color-picker options="options" ng-model="template.sec_color"></color-picker></div></div></div><h4>Cars Container Options</h4><div class="row"><div class="col-sm-6 col-md-6"><div class="form-group"><label for="inputFirstName">Width px</label> <input type="number" string-to-number="" class="form-control input-sm input-sm" id="inputFirstName" ng-model="template.item_w" placeholder="px"></div></div><div class="col-md-6"><div class="form-group"><label for="inputLastName">Height px</label> <input type="number" string-to-number="" class="form-control input-sm input-sm" ng-model="template.item_h" id="inputLastName" placeholder="auto"></div></div></div><div class="row"><div class="col-sm-6 col-md-6 no-pr"><div class="form-group"><label for="inputFirstName">Border Size px</label> <input type="number" string-to-number="" class="form-control input-sm input-sm" id="inputFirstName" ng-model="template.item_border_size" placeholder="px"></div></div><div class="col-sm-6 col-md-6"><div class="form-group"><label for="inputFirstName">Border Color</label><color-picker options="options" ng-model="template.item_border_color"></color-picker></div></div></div><div class="row"><div class="col-sm-6 col-md-6 no-pr"><div class="form-group"><label for="inputFirstName">Padding T-B px</label> <input type="number" string-to-number="" class="form-control input-sm input-sm" id="inputFirstName" ng-model="template.item_pt" placeholder="px"></div></div><div class="col-sm-6 col-md-6"><div class="form-group"><label for="inputFirstName">Select Color</label><color-picker options="options" ng-model="template.item_color"></color-picker></div></div></div><div class="slider-box"><h5>Title</h5><div class="row"><div class="col-sm-6 col-md-6"><label style="font-weight:normal;">Text Color</label><color-picker options="options" ng-model="template.item_title_color"></color-picker></div><div class="col-sm-6 col-md-6"><div class="form-group"><label>Background Color</label><color-picker options="options" ng-model="template.item_title_bg"></color-picker></div></div></div><div class="row"><div class="col-sm-6 col-md-6"><label>Bold and Size px</label><div class="row"><div class="col-md-2"><div class="btn-group btn-agroup report-btn pull-left" style="float: left;"><label class="btn btn-sm btn-primary" id="toggleBold" ng-model="template.extras.title.bold" uib-btn-checkbox="" btn-checkbox-true="true" btn-checkbox-false="false"><i class=""></i> B</label></div></div><div class="col-md-10"><input type="number" string-to-number="" style="float: right;" class="form-control input-sm input-sm" id="inputFirstName" ng-model="template.item_title_size" placeholder="px"></div></div></div><div class="col-sm-6 col-md-6"><div class="form-group"><label for="inputFirstName">Position px</label> <input type="number" string-to-number="" class="form-control input-sm input-sm" id="inputFirstName" ng-model="template.item_title_top" placeholder="px"></div></div></div></div><div class="slider-box"><h5 class="mt-10">Sub Title</h5><div class="row"><div class="col-sm-6 col-md-6"><div class="form-group"><label>Text Color</label><color-picker options="options" ng-model="template.item_subtitle_color"></color-picker></div></div><div class="col-sm-6 col-md-6"><div class="form-group"><label>Background Color</label><color-picker options="options" ng-model="template.item_subtitle_bg"></color-picker></div></div></div><div class="row"><div class="col-sm-6 col-md-6"><label>Bold and Size px</label><div class="row"><div class="col-md-2"><div class="btn-group btn-agroup report-btn pull-left" style="float: left;"><label class="btn btn-sm btn-primary" id="toggleBold" ng-model="template.extras.subtitle.bold" uib-btn-checkbox="" btn-checkbox-true="true" btn-checkbox-false="false"><i class=""></i> B</label></div></div><div class="col-md-10"><input type="number" string-to-number="" class="form-control input-sm input-sm" id="inputFirstName" ng-model="template.item_subtitle_size" placeholder="px"></div></div></div><div class="col-sm-6 col-md-6"><div class="form-group"><label for="inputFirstName">Position px</label> <input type="number" string-to-number="" class="form-control input-sm input-sm" id="inputFirstName" ng-model="template.item_subtitle_top" placeholder="px"></div></div></div></div><div class="slider-box"><h5 class="mt-10">Third Title</h5><div class="row"><div class="col-sm-6 col-md-6 no-pr"><div class="form-group"><label for="inputFirstName">Text Color</label><color-picker options="options" ng-model="template.item_extxt_color"></color-picker></div></div><div class="col-sm-6 col-md-6"><div class="form-group"><label for="inputFirstName">Background Color</label><color-picker options="options" ng-model="template.item_extxt_bg"></color-picker></div></div></div><div class="row"><div class="col-sm-6 col-md-6"><label>Bold and Size px</label><div class="row"><div class="col-md-2"><div class="btn-group btn-agroup report-btn pull-left" style="float: left;"><label class="btn btn-sm btn-primary" id="toggleBold" ng-model="template.extras.thirdtitle.bold" uib-btn-checkbox="" btn-checkbox-true="true" btn-checkbox-false="false"><i class=""></i> B</label></div></div><div class="col-md-10"><input type="number" string-to-number="" class="form-control input-sm input-sm" id="inputFirstName" ng-model="template.item_extxt_size" placeholder="px"></div></div></div><div class="col-sm-6 col-md-6"><div class="form-group"><label for="inputFirstName">Position px</label> <input type="number" string-to-number="" class="form-control input-sm input-sm" id="inputFirstName" ng-model="template.item_extxt_top" placeholder="px"></div></div></div></div></div></uib-tab><uib-tab heading="Linear Dealers" ng-show="template.hybrid"><div class="custom-tab-1" id="custom-tab-1" style="margin-left: -15px; margin-right: -15px;"><h4>Dealers Container (Linear)</h4><div class="row"><div class="col-md-6 no-pr"><div class="form-group"><label for="inputLastName">Height</label> <input type="number" string-to-number="" class="form-control input-sm input-sm" ng-model="template.sec_v" id="inputLastName" placeholder="auto"></div></div><div class="col-sm-6 col-md-6"><div class="form-group"><label for="inputFirstName">Select Color</label><color-picker options="options" ng-model="template.section_color2"></color-picker></div></div></div><div class="row"><div class="col-sm-5 col-md-5"><label style="font-weight:normal;">Text Color</label><color-picker options="options" ng-model="template.section_title_color2"></color-picker></div><div class="col-sm-5 col-md-5"><div class="form-group"><label>Background Color</label><color-picker options="options" ng-model="template.section_title_bg2"></color-picker></div></div></div><div class="row"><div class="col-sm-12 col-md-12">1 <label>Size px</label> <input type="number" string-to-number="" class="form-control input-sm input-sm" id="inputFirstName" ng-model="template.section_title_size2" placeholder="px"></div></div><br><div class="row"><div class="col-sm-12 col-md-12"><button class="btn btn-primary btn-sm btn-block" ng-click="uploadPictureSection()"><i class="ion-upload"></i> Upload new dealer image</button> <input type="file" ng-show="false" id="fileSection" ng-file-select="onFileSelect($files)" item="section"></div></div><br><h4>Cars Container Options</h4><div class="row"><div class="col-md-6 no-pr"><div class="form-group"><label for="inputLastName">Height</label> <input type="number" string-to-number="" class="form-control input-sm input-sm" ng-model="template.item_v" id="inputLastName" placeholder="auto"></div></div><div class="col-sm-6 col-md-6"><div class="form-group"><label for="inputFirstName">Select Color</label><color-picker options="options" ng-model="template.item_color2"></color-picker></div></div></div><div class="slider-box"><h5>Title</h5><div class="row"><div class="col-sm-6 col-md-6"><label style="font-weight:normal;">Text Color</label><color-picker options="options" ng-model="template.item_title_color2"></color-picker></div><div class="col-sm-6 col-md-6"><div class="form-group"><label>Background Color</label><color-picker options="options" ng-model="template.item_title_bg2"></color-picker></div></div></div><div class="row"><div class="col-sm-12 col-md-12"><label>Size px</label> <input type="number" string-to-number="" class="form-control input-sm input-sm" id="inputFirstName" ng-model="template.item_title_size2" placeholder="px"></div></div></div><div class="slider-box"><h5 class="mt-10">Sub Title</h5><div class="row"><div class="col-sm-6 col-md-6"><div class="form-group"><label>Text Color</label><color-picker options="options" ng-model="template.item_subtitle_color2"></color-picker></div></div><div class="col-sm-6 col-md-6"><div class="form-group"><label>Background Color</label><color-picker options="options" ng-model="template.item_subtitle_bg2"></color-picker></div></div></div><div class="row"><div class="col-sm-12 col-md-12"><label>Size px</label> <input type="number" string-to-number="" class="form-control input-sm input-sm" id="inputFirstName" ng-model="template.item_subtitle_size2" placeholder="px"></div></div></div><div class="slider-box"><h5 class="mt-10">Third Title</h5><div class="row"><div class="col-sm-6 col-md-6 no-pr"><div class="form-group"><label for="inputFirstName">Text Color</label><color-picker options="options" ng-model="template.item_extxt_color2"></color-picker></div></div><div class="col-sm-6 col-md-6"><div class="form-group"><label for="inputFirstName">Background Color</label><color-picker options="options" ng-model="template.item_extxt_bg2"></color-picker></div></div></div><div class="row"><div class="col-sm-12 col-md-12"><label>Size px</label> <input type="number" string-to-number="" class="form-control input-sm input-sm" id="inputFirstName" ng-model="template.item_extxt_size2" placeholder="px"></div></div></div></div><br></uib-tab></uib-tabset><div class="slider-box"><h5 class="mt-10">Separator</h5><div class="row"><div class="col-sm-6 col-md-6"><label>Size px</label> <input type="number" string-to-number="" class="form-control input-sm input-sm" id="inputFirstName" ng-model="template.sep_h" placeholder="px"></div><div class="col-sm-6 col-md-6"><div class="form-group"><label>Color</label><color-picker options="options" ng-model="template.sep_color"></color-picker></div></div></div></div></form></div></uib-tab><uib-tab classes="tools-iframe" heading="Images"><div class="row"><div class="col-sm-12 col-md-12" ng-repeat="section in sections"><button class="btn btn-primary btn-sm btn-block" ng-click="uploadPictureDealer(section.id)">Image for {{section.name}}</button> <img style="margin-top: 10px; margin-bottom: 10px" ng-src="{{section.section_image}}" id="dealer_image{{section.id}}" class="img-responsive"></div><input type="file" ng-show="false" id="sectionImage" ng-file-select="onFileSelect($files)" item="sectionImage"></div></uib-tab></uib-tabset><uib-tabset style="margin-top: 10px" active="$tabSetStatus.activeTab2" ng-if="template.ttype != \'dynamic\'" ng-show="editor && seltemplate && group_name!=\'root\'"><uib-tab classes="tools-iframe" heading="Editor"><div class="custom-tab-1" id="custom-tab-1" style="margin-left: -15px; margin-right: -15px;"><form name="form"><h4>Header <span>{{template.size_w * 150 | number:0}} x {{template.header_h}}</span></h4><div class="row"><div class="col-sm-12 col-md-12"><button class="btn btn-primary btn-sm btn-block" ng-click="uploadPictureHeader()"><i class="ion-upload"></i> Upload new header image</button> <input type="file" ng-show="false" id="fileHeader" ng-file-select="onFileSelect($files)" item="header"></div></div><br><h4>Footer <span>{{template.size_w * 150 | number:0}} x {{template.footer_h}}</span></h4><div class="row"><div class="col-sm-12 col-md-12"><button class="btn btn-primary btn-sm btn-block" ng-click="uploadPictureFooter()">Upload new footer image</button> <input type="file" ng-show="false" id="fileFooter" ng-file-select="onFileSelect($files)" item="footer"></div></div><uib-tabset style="margin-top: 10px" active="$tabSetStatus.activeTab"><uib-tab classes="tools-iframe" heading="{{!template.hybrid && \'Template Options\' || \'Mosaic Dealers\'}}"><div class="custom-tab-1" id="custom-tab-1" style="margin-left: -15px; margin-right: -15px;"><h4>Cars Container Options</h4><div class="slider-box"><h5 class="mt-10">Sub Title</h5><div class="row"><div class="col-sm-6 col-md-6"><div class="form-group"><label>Text Color</label><color-picker options="options" ng-model="template.item_subtitle_color"></color-picker></div></div><div class="col-sm-6 col-md-6"><div class="form-group"><label>Background Color</label><color-picker options="options" ng-model="template.item_subtitle_bg"></color-picker></div></div></div></div><div class="slider-box"><h5 class="mt-10">Third Title</h5><div class="row"><div class="col-sm-6 col-md-6 no-pr"><div class="form-group"><label for="inputFirstName">Text Color</label><color-picker options="options" ng-model="template.item_extxt_color"></color-picker></div></div><div class="col-sm-6 col-md-6"><div class="form-group"><label for="inputFirstName">Background Color</label><color-picker options="options" ng-model="template.item_extxt_bg"></color-picker></div></div></div></div></div></uib-tab><uib-tab heading="Linear Dealers" ng-show="template.hybrid"><div class="custom-tab-1" id="custom-tab-1" style="margin-left: -15px; margin-right: -15px;"><h4>Dealers Container (Linear)</h4><div class="row"><div class="col-md-6 no-pr"><div class="form-group"><label for="inputLastName">Height</label> <input type="number" string-to-number="" class="form-control input-sm input-sm" ng-model="template.sec_v" id="inputLastName" placeholder="auto"></div></div><div class="col-sm-6 col-md-6"><div class="form-group"><label for="inputFirstName">Select Color</label><color-picker options="options" ng-model="template.section_color2"></color-picker></div></div></div><div class="row"><div class="col-sm-6 col-md-6"><label style="font-weight:normal;">Text Color</label><color-picker options="options" ng-model="template.section_title_color2"></color-picker></div><div class="col-sm-6 col-md-6"><div class="form-group"><label>Background Color</label><color-picker options="options" ng-model="template.section_title_bg2"></color-picker></div></div></div><br><div class="row"><div class="col-sm-12 col-md-12"><button class="btn btn-primary btn-sm btn-block" ng-click="uploadPictureSection()"><i class="ion-upload"></i> Upload new dealer image</button> <input type="file" ng-show="false" id="fileSection" ng-file-select="onFileSelect($files)" item="section"></div></div><br><h4>Cars Container Options</h4><div class="row"><div class="col-md-6 no-pr"><div class="form-group"><label for="inputLastName">Height</label> <input type="number" string-to-number="" class="form-control input-sm input-sm" ng-model="template.item_v" id="inputLastName" placeholder="auto"></div></div><div class="col-sm-6 col-md-6"><div class="form-group"><label for="inputFirstName">Select Color</label><color-picker options="options" ng-model="template.item_color2"></color-picker></div></div></div><div class="slider-box"><h5>Title</h5><div class="row"><div class="col-sm-6 col-md-6"><label style="font-weight:normal;">Text Color</label><color-picker options="options" ng-model="template.item_title_color2"></color-picker></div><div class="col-sm-6 col-md-6"><div class="form-group"><label>Background Color</label><color-picker options="options" ng-model="template.item_title_bg2"></color-picker></div></div></div><div class="row"><div class="col-sm-12 col-md-12"><label>Size px</label> <input type="number" string-to-number="" class="form-control input-sm input-sm" id="inputFirstName" ng-model="template.item_title_size2" placeholder="px"></div></div></div><div class="slider-box"><h5 class="mt-10">Sub Title</h5><div class="row"><div class="col-sm-6 col-md-6"><div class="form-group"><label>Text Color</label><color-picker options="options" ng-model="template.item_subtitle_color2"></color-picker></div></div><div class="col-sm-6 col-md-6"><div class="form-group"><label>Background Color</label><color-picker options="options" ng-model="template.item_subtitle_bg2"></color-picker></div></div></div><div class="row"><div class="col-sm-12 col-md-12"><label>Size px</label> <input type="number" string-to-number="" class="form-control input-sm input-sm" id="inputFirstName" ng-model="template.item_subtitle_size2" placeholder="px"></div></div></div><div class="slider-box"><h5 class="mt-10">Third Title</h5><div class="row"><div class="col-sm-6 col-md-6 no-pr"><div class="form-group"><label for="inputFirstName">Text Color</label><color-picker options="options" ng-model="template.item_extxt_color2"></color-picker></div></div><div class="col-sm-6 col-md-6"><div class="form-group"><label for="inputFirstName">Background Color</label><color-picker options="options" ng-model="template.item_extxt_bg2"></color-picker></div></div></div><div class="row"><div class="col-sm-12 col-md-12"><label>Size px</label> <input type="number" string-to-number="" class="form-control input-sm input-sm" id="inputFirstName" ng-model="template.item_extxt_size2" placeholder="px"></div></div></div></div><br></uib-tab></uib-tabset></form></div></uib-tab><uib-tab classes="tools-iframe" heading="Images"><div class="row"><div class="col-sm-12 col-md-12" ng-repeat="section in sections"><button class="btn btn-primary btn-sm btn-block" ng-click="uploadPictureDealer(section.id)">Image for {{section.name}}</button> <img style="margin-top: 10px; margin-bottom: 10px" ng-src="{{section.section_image}}" id="dealer_image{{section.id}}" class="img-responsive"></div><input type="file" ng-show="false" id="sectionImage" ng-file-select="onFileSelect($files)" item="sectionImage"></div></uib-tab></uib-tabset></div><div class="col-lg-12 col-md-12 col-sm-12" id="frameview"><div class="h_iframe"><iframe ng-show="pdfUrl && seltemplate" name="Tester" height="1650" ng-src="{{pdfUrl | trustAsResourceUrl}}"></iframe></div></div></div></div><div ng-show="create"><div class="row"><div class="col-lg-12 col-md-12 col-sm-12"><form name="form"><div class="row"><div class="col-lg-6 col-md-6 col-sm-6"><h3 class="pull-left">New Template</h3></div><div class="col-lg-6 col-md-6 col-sm-6"><button type="button" ng-hide="!templates.length" class="btn btn-primary btn-raised btn-with-icon pull-right" ng-click="goBack2()"><i class="ion-ios-compose"></i> <b>Go Back</b></button></div></div><div class="form-group"><label for="inputLastName">Template name</label> <input type="text" class="form-control" ng-model="templateNew.name" ng-pattern="/^.+\\.base$/" id="inputLastName" title="Template name must end with \'.base\'" placeholder="Template name must end with \'.base\'"></div><br><label for="inputLastName" ng-show="create" style="font-size: 1.45em;font-weight: 400;">Choose a content layout</label><br><br><div class="row pie-charts"><div class="col-lg-3 col-md-3 col-sm-4 col-xs-11 base-template" ng-show="create" ng-repeat="base in bases|orderBy:\'name\'" ng-if="base.name!=\'Template Solutions\'" style="cursor: pointer;" ng-click="selectTemplate(base.id)" ng-class="{\'base-template-active\': base.id === selectedTemplate}"><div class="row"><div class="col-md-6"><label ng-class="{selectedTemp: base.id === selectedTemplate}">{{base.name}}</label><div class="logo-templates" style="background: url(assets/img/templates/{{base.name|replace:\' \':\'\'}}.png) no-repeat center;" ng-class="{selectedTemp: base.id === selectedTemplate}"></div></div><div class="col-md-6"><label ng-class="{selectedTemp: base.id === selectedTemplate}">&nbsp;</label><p>{{base.description}}</p></div></div></div></div><div class="form-group mt-10"><button type="button" style="float: right;" class="btn btn-primary btn-raised btn-with-icon" ng-click="createTemplate()"><i class="ion-ios-compose"></i> <b>Save and Edit</b>></button></div></form></div></div></div></div></div></div></div>');
$templateCache.put('app/pages/export/new.html','<div class="row"><div class="col-lg-12 col-md-12 col-sm-12" style="z-index: 100;" ba-panel="" ba-panel-class="medium-panel auto-height"><div class="row"><div class="col-md-6"><h1 style="font-weight: 400;">Projects</h1></div><div class="col-md-6"><div class="btn-group dropdown pull-right" uib-dropdown="" auto-close="outsideClick" is-open="status.isopen"><button type="button" class="btn btn-primary dropdown-toggle" uib-dropdown-toggle="" aria-haspopup="true" aria-expanded="false">Add new <span class="caret"></span></button><ul uib-dropdown-menu="" class="dropdown-menu"><li class="p-10" style="width: 250px;"><form name="form" ng-submit="saveProject(form)" novalidate=""><div class="form-group"><label for="project">New export project</label> <input type="text" name="name" class="form-control" id="project" ng-model="project.name" placeholder="Project name" autofocus="" required=""></div><button type="submit" ng-disabled="form.name.$invalid" class="btn btn-primary">Save</button></form></li></ul></div></div></div><br><div class="horizontal-scroll main-table"><table class="table"><thead><tr><th class="align-left">NAME</th><th class="align-center hidden-sm hidden-xs">DEALERS</th><th class="align-center hidden-sm hidden-xs">LAST MODIFIED</th><th class="align-center">REMOVE</th></tr></thead><tbody><tr ng-repeat="item in projects | orderBy:\'-date_modified\'" ui-sref="home.export.index({id:item.id})" style="cursor: pointer;"><td class="align-left">{{item.name}}</td><td class="align-center hidden-sm hidden-xs"><ng-pluralize count="item.sections" when="{\'0\': \'Empty\', \'1\': \'{{item.sections}} Dealer\', \'other\': \'{{item.sections}} Dealers\'}"></ng-pluralize></td><td class="align-center hidden-sm hidden-xs">{{item.date_modified | date:"medium"}}</td><td class="align-center"><i class="chart-icon ion-close" style="color: #EE6D60;" ng-click="$event.stopPropagation();onLongPress(item)"></i></td></tr></tbody></table></div></div></div>');
$templateCache.put('app/pages/home/index.html','<main home-style="" ng-if="$pageFinishedLoading" ng-class="{ \'menu-collapsed\': $baSidebarService.isMenuCollapsed() }"><ba-sidebar></ba-sidebar><page-top></page-top><div class="al-main"><div class="al-content"><content-top></content-top><div ui-view="" autoscroll="true" autoscroll-body-top=""></div></div></div><footer class="al-footer clearfix"><div class="al-footer-main clearfix"></div></footer><back-top></back-top></main>');
$templateCache.put('app/pages/inventory/inventory.html','<div class="row"><div class="col-lg-8 col-md-8 col-sm-12 col-sm-12" style="z-index: 100;" ba-panel="" ba-panel-class=""><h1 style="font-weight: 400;" class="hidden-md-d hidden-sm-d">Inventory Comparison - Select Options</h1><h1 style="font-weight: 400;" class="hidden-el-d hidden-lg-d">Inventory Comparison</h1><br><form name="form" style="margin-top: -12px;"><div class="row mb-10"><div class="col-lg-7 col-md-7 col-sm-7 col-xs-12"><div class="btn-group btn-agroup type-btn"><label class="btn btn-sm btn-primary type-btn" ng-model="report" ng-change="toggleReport(\'normal\')" uib-btn-radio="\'normal\'"><span class="large">Normal</span> <span class="small">Normal</span></label> <label class="btn btn-sm btn-primary" ng-model="report" ng-change="toggleReport(\'stock\')" uib-btn-radio="\'stock\'"><span class="large">Stock Time</span> <span class="small">Stk Time</span></label> <label class="btn btn-sm btn-primary" ng-model="report" ng-change="toggleReport(\'max\')" uib-btn-radio="\'max\'"><span class="large">Max. Lot</span> <span class="small">Max. Qty</span></label> <label class="btn btn-sm btn-primary" ng-model="report" ng-change="toggleReport(\'best\')" uib-btn-radio="\'best\'"><span class="large">Best Prices</span> <span class="small">Best Price</span></label></div></div><div class="col-lg-5 col-md-5 col-sm-5 col-xs-12"><div class="btn-group btn-agroup pull-right type-btn"><label class="btn btn-sm btn-primary" ng-model="type" ng-change="toggleType(\'all\')" uib-btn-radio="\'all\'"><span class="large">All</span> <span class="small">All</span></label> <label class="btn btn-sm btn-primary" ng-model="type" ng-change="toggleType(\'new\')" uib-btn-radio="\'new\'"><span class="large">New</span> <span class="small">New</span></label> <label class="btn btn-sm btn-primary" ng-model="type" ng-change="toggleType(\'used\')" uib-btn-radio="\'used\'"><span class="large">Used</span> <span class="small">Used</span></label> <label class="btn btn-sm btn-primary" ng-model="type" ng-change="toggleType(\'certified\')" uib-btn-radio="\'certified\'"><span class="large">Certified</span> <span class="small">Certified</span></label></div></div></div><div class="row" ng-show="report==\'stock\'"><div class="col-sm-5 col-md-5"><div class="form-group range-input"><label for="inputLastName">Days Range</label> <input type="number" class="form-control" ng-disabled="!completeLoad" id="inputFirstName" ng-model="conf.day_min" placeholder="Min"></div><div class="form-group range-input" style="margin-left: 15px;"><label for="inputLastName">&nbsp;</label> <input type="number" class="form-control" ng-model="conf.day_max" ng-disabled="!completeLoad" id="inputLastName" placeholder="Max"></div><span style="display: inline-block;" class="help-block sub-little-text">Set a range of days in stock</span></div></div><div class="form-group mb-5" ng-hide="report==\'benchmark\'"><label>Dealers</label><selectize config="configSelect" placeholder="Select Dealers" options="$parent.dealers" ng-model="$parent.dealer" ng-disabled="!loadDealers"></selectize></div><div class="form-group mb-5" ng-show="report==\'benchmark\'"><label>Choose Dealer</label><selectize config="configSingleOne" ng-disabled="!loadDealers" placeholder="Select Dealer" options="dealers" ng-model="$parent.adealer"></selectize></div><div class="form-group mb-5" ng-hide="report==\'benchmark\'"><label>Makes</label><selectize config="configSelect" placeholder="Select Makes" options="$parent.makes" ng-model="$parent.make" ng-disabled="!completeLoad"></selectize></div><div class="form-group mb-5" ng-hide="report==\'benchmark\'"><label>Body Style</label><selectize config="configSelect" placeholder="Select Body Style" options="$parent.bodys" ng-model="$parent.body" ng-disabled="!completeLoad"></selectize></div><div class="form-group mb-5" ng-hide="report==\'benchmark\'"><label>Models</label><selectize config="configSelect" placeholder="Select Models" options="$parent.models" ng-model="$parent.model" ng-disabled="!completeLoad"></selectize></div><div class="form-group mb-5" ng-hide="report!=\'benchmark\'"><label>Dimension</label><selectize config="configSingleOne" placeholder="Select Dimension" options="$parent.dimensions" ng-model="$parent.dimension"></selectize></div><div class="form-group mb-5"><label>Years</label><selectize config="configSelect" placeholder="Select Years" options="$parent.years" ng-model="$parent.year" ng-disabled="!completeLoad"></selectize></div><button type="button" ng-click="getReport()" style="padding-left:20px; padding-right:20px;" ng-disabled="!completeLoad && !loadDealers" pb-style="top-line" class="btn btn-primary btn-raised pull-right btn-md"><i class="ion-ios-refresh"></i> &nbsp; <b>Get Report</b></button></form></div><div class="col-lg-4 col-md-4 col-sm-12 no-pl hidden-xs hidden-sm"><div class="panel innner-center animated zoomIn" style="height: 458px;"><div class="panel-heading clearfix" style="border-bottom:0"><h1 style="font-weight: 400;">Vehicles Selected</h1></div><div class="panel-body"><cond-chart style="margin-top: -50px;" class="center-block"></cond-chart></div></div></div></div><div class="row" id="results"><div class="col-lg-12 col-md-12 col-sm-12"><div class="panel panel-default min-height-panel"><div class="panel-body"><h2 style="font-weight: 400">Results {{rtitle}}</h2><div ng-class="{\'opacity-res\': opacity}"><form class="row form-inline" ng-show="items.length"><div class="form-group col-md-10 col-sm-10"><input type="text" class="form-control" ng-model="search" id="searchItems" placeholder="Search cars"></div><div class="form-group col-md-offset-1 col-md-1 col-sm-offset-1 col-sm-2"><button type="button" ng-click="goBack()" class="btn btn-primary btn-raised btn-block no-m"><b>Go Back</b></button></div></form><form class="row form-inline searchdiff" ng-show="benchmark_results.length"><div class="form-group col-md-11 col-sm-11"><input style="float: left;" type="text" class="form-control" ng-model="searchdiff" id="searchdiff" placeholder="Search benchmark"></div><div class="form-group col-md-1 col-sm-1"><div class="pull-right"><button type="button" ng-click="printPdf(benchmark_results)" class="btn btn-primary btn-raised btn-block no-m"><i class="ion-android-download"></i> &nbsp; PDF EXPORT</button></div></div></form><div infinite-scroll="loadMore()"><h3 class="title-details" ng-show="items.length">{{items_quantity}} <span ng-bind-html="title_details"></span><div class="pull-right copystock" style="font-size: 2em;"><br><i class="ion-ios-copy-outline" style="cursor: pointer;" ng-show="!copystock" ng-click="copyStocks($event)" uib-tooltip="Copy all stocks!"></i> <i class="ion-ios-copy" uib-tooltip="{{copystockmsg}}" tooltip-is-open="copystock" ng-show="copystock"></i></div><div class="pull-right copystock" style="font-size: 2em; margin-right: 10px" ng-show="report==\'stock\'"><button type="button" ng-click="getDemo()" style="float: left;" class="btn btn-primary btn-raised btn-block no-m"><b style="color: #fff; text-transform: none;">Demo</b></button></div><div class="pull-right copystock" style="font-size: 2em; margin-right: 10px" ng-show="report==\'stock\'"><button type="button" ng-click="getReverse()" style="float: left;" class="btn btn-primary btn-raised btn-block no-m"><b style="color: #fff; text-transform: none;">Reverse Pub</b></button></div></h3><div class="list-articles" ng-show="items.length"><div class="article-item clearfix" ng-repeat="item in items | filter:search"><table><tr class="title-row"><td><h3 class="no-m"><span class="title"><a href="{{item.hyperlink}}" target="_blank">{{item.title}}</a></span></h3></td><td></td></tr></table><div class="more-box"><div class="row"><div class="col-sm-5 col-xs-6 col-md-4 short-name" style="padding-right: 0;"><div class="info clearfix"><div class="lbl-text pull-left">Dealer:</div><div class="value pull-left truncate-col"><span>{{item.section_name}}</span></div></div><div class="info clearfix"><div class="lbl-text pull-left">Type:</div><div class="value pull-left">{{item.type_name}}</div></div><div class="info clearfix"><div class="lbl-text pull-left">Stock:</div><div class="value no-data pull-left"><span>{{item.stock}}</span></div></div><div class="info clearfix"><div class="lbl-text pull-left">Mileage:</div><div class="value no-data pull-left"><span>{{item.miles | number:0 }}</span></div></div></div><div class="col-sm-4 col-xs-6 col-md-4 long-name"><div class="info clearfix visible-xs-block"><div class="lbl-text pull-left">Price:</div><div class="value pull-left"><span>{{item.price}}</span></div></div><div class="info clearfix"><div class="lbl-text pull-left">Year:</div><div class="value pull-left"><span>{{item.year}}</span></div></div><div class="info clearfix"><div class="lbl-text pull-left">Make:</div><div class="value pull-left"><span>{{item.make}}</span></div></div><div class="info clearfix"><div class="lbl-text pull-left">Model:</div><div class="value pull-left">{{item.model}}</div></div><div class="info clearfix"><div class="lbl-text pull-left">Time:</div><div class="value no-data pull-left"><span>{{item.time_duration}} Days</span></div></div></div><div class="col-sm-4 col-xs-6 col-md-4 long-name"><div style="float: left;"><div class="info clearfix"><div class="lbl-text pull-left">Body:</div><div class="value pull-left"><span>{{item.body_style}}</span></div></div><div class="info clearfix" ng-if="item.color"><div class="lbl-text pull-left">Color:</div><div class="value pull-left"><span>{{item.color}}</span></div></div><div class="info clearfix"><div class="lbl-text pull-left">Created:</div><div class="value pull-left"><span>{{item.created_at | date:\'mediumDate\'}}</span></div></div><div class="info clearfix" ng-show="showUpdate"><div class="lbl-text pull-left">:</div><div class="value pull-left"><span>{{item.updated_at | date:\'mediumDate\'}}</span></div></div></div><div class="price-details hidden-xs hidden-sm" style="float: right;" ng-class="{\'good-deal\':item[10]==\'Good Deal\'}"><div class="rank" ng-show="item.price">Total Price</div><span class="price" ng-show="item.price">{{item.price | currency:"$":0}}</span><div class="rank" ng-show="!item.price"><strong>Call for Price</strong></div></div></div></div></div></div></div><div ng-repeat="item in fullresults" class="separate-chart" ng-show="fullresults.length && !items.length"><div ng-show="item.data.length" class="chartjs-canvas-holder-third-row" style="height: {{fullresults[$index].height}}"><label class="label-chart">INVENTORY - {{fullresults[$index].total}} CARS FOR <span class="title-dealer">{{fullresults[$index].title | replace:"All section_names":"All Dealers" | replace:"All body_styles":"All Body Styles" | uppercase }}</span></label><br><label class="uppercase label-chart">SALES - {{fullresults[$index].sales}} CARS SOLD LAST 30 DAYS FOR <span class="title-dealer">{{fullresults[$index].title | replace:"All section_names":"All Dealers" | replace:"All body_styles":"All Body Styles" }}</span></label><canvas id="barinv{{fullresults[$index][0].title}}" data-title="{{fullresults[$index].title}}" data-dealer="{{fullresults[$index].dealer}}" data-dealer-id="{{fullresults[$index].dealer_id}}" data-year="{{fullresults[$index].year}}" data-active="1" class="chart chart-horizontal-bar" chart-data="fullresults[$index].data" chart-options="baroptions" chart-labels="fullresults[$index].labels" chart-colors="colors" chart-series="series" chart-click="selectBar" chart-dataset-override="datasetOverride"></canvas></div></div><div class="table-responsive" ng-show="best_results.length && !items.length"><h4 style="padding: 4px; margin-bottom: 0;">Dealers with the best price:</h4><table class="table table-hover table-normal"><tr class="black-muted-bg"><th class="font-bold text-center">#</th><th class="font-bold" style="width: 68%;">Dealer</th><th class="font-bold">Price AVG</th></tr><tr ng-repeat="item in best_results | orderBy:\'-item[1]\'" ng-click="selectRow(item.section_name, item.section_id)" ng-class="{\'font-bold\':$index==0}"><td>{{$index+1}}</td><td><span class="title-table">{{item.section_name}}</span></td><td>{{item.total | currency:"$ ":0}}</td></tr></table></div><div class="chartjs-canvas-holder-third-row" ng-show="(stock_results.length || max_results.length) && !items.length"><canvas id="bar" class="chart chart-horizontal-bar" chart-data="data" chart-labels="labels" chart-colors="colors" chart-options="barhorizontal" chart-series="series" chart-dataset-override="datasetOverride" chart-click="selectBar" chart-update="updateC"></canvas></div></div></div></div><br><br><br><br></div></div></div>');
$templateCache.put('app/pages/maintenance/index.html','<main class="auth-main" initial-style=""><div class="auth-block"><h1>System Under Maintenance</h1><p>Our system is currently undergoing maintenance. We apologize for the inconvenience.</p><p>For more information, you can contact us via:</p><ul><li>Email: <a href="mailto:info@wehaa.com">info@wehaa.com</a></li><li>Email: <a href="mailto:servers@wehaa.com">servers@wehaa.com</a></li></ul><div class="auth-sep"><span><span>Wehaa LLC</span></span></div><div class="al-share-auth"><div class="alert bg-info p-10 no-m text-center blur-alert-info"><strong>We\'ll be back soon! Thank you for your patience.</strong></div></div></div></main>');
$templateCache.put('app/pages/profile/profile.html','<div ba-panel="" ba-panel-class="profile-page"><div class="panel-content"><div class="progress-info">Your profile is 70% Complete</div><div class="progress"><div class="progress-bar progress-bar-primary progress-bar-striped active" role="progressbar" aria-valuenow="70" aria-valuemin="0" aria-valuemax="100" style="width: 70%"></div></div><h3 class="with-line">General Information</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Picture</label><div class="col-sm-9"><div class="userpic"><div class="userpic-wrapper"><img ng-src="{{ picture }}" ng-click="uploadPicture()"></div><i class="ion-ios-close-outline" ng-click="removePicture()" ng-if="!noPicture"></i> <a href="" class="change-userpic" ng-click="uploadPicture()">Change Profile Picture</a> <input type="file" ng-show="false" id="uploadFile" ng-file-select="onFileSelect($files)"></div></div></div></div><div class="col-md-6"></div></div><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">First Name</label><div class="col-sm-9"><input type="text" class="form-control" id="inputFirstName" placeholder="" value="Anastasiya"></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Last Name</label><div class="col-sm-9"><input type="text" class="form-control" id="inputLastName" placeholder="" value=""></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Department</label><div class="col-sm-9"><select class="form-control" selectpicker=""><option>Web Development</option><option>System Development</option><option>Sales</option><option>Human Resources</option></select></div></div><div class="form-group row clearfix"><label for="inputOccupation" class="col-sm-3 control-label">Occupation</label><div class="col-sm-9"><input type="text" class="form-control" id="inputOccupation" placeholder="" value="Front End Web Developer"></div></div></div></div><h3 class="with-line">Change Password</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputPassword" class="col-sm-3 control-label">Password</label><div class="col-sm-9"><input type="password" class="form-control" id="inputPassword" placeholder="" value="12345678"></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label for="inputConfirmPassword" class="col-sm-3 control-label">Confirm Password</label><div class="col-sm-9"><input type="password" class="form-control" id="inputConfirmPassword" placeholder=""></div></div></div></div><h3 class="with-line">Contact Information</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputEmail3" class="col-sm-3 control-label">Email</label><div class="col-sm-9"><input type="email" class="form-control" id="inputEmail3" placeholder="" value="contact@akveo.com"></div></div><div class="form-group row clearfix"><label for="inputPhone" class="col-sm-3 control-label">Phone</label><div class="col-sm-9"><input type="text" class="form-control" id="inputPhone" placeholder="" value="+1 (23) 456 7890"></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Office Location</label><div class="col-sm-9"><select class="form-control" title="Standard Select" selectpicker=""><option>San Francisco</option><option>London</option><option>Minsk</option><option>Tokio</option></select></div></div><div class="form-group row clearfix"><label for="inputRoom" class="col-sm-3 control-label">Room</label><div class="col-sm-9"><input type="text" class="form-control" id="inputRoom" placeholder="" value="303"></div></div></div></div><h3 class="with-line">Social Profiles</h3><div class="social-profiles row clearfix"><div class="col-md-3 col-sm-4" ng-repeat="item in socialProfiles"><a class="sn-link" href="" ng-click="showModal(item)" ng-if="!item.href"><i class="socicon {{ item.icon }}"></i> <span>{{ item.name }}</span></a> <a class="sn-link connected" href="{{ item.href }}" target="_blank" ng-if="item.href"><i class="socicon {{ item.icon }}"></i> <span>{{ item.name }}</span> <em class="ion-ios-close-empty sn-link-close" ng-mousedown="unconnect(item)"></em></a></div></div><h3 class="with-line">Send Email Notifications</h3><div class="notification row clearfix"><div class="col-sm-6"><div class="form-group row clearfix"><label class="col-xs-8">When I receive a message</label><div class="col-xs-4"><switch color="primary" ng-model="switches[0]"></switch></div></div><div class="form-group row clearfix"><label class="col-xs-8">When Someone sends me an invitation</label><div class="col-xs-4"><switch color="primary" ng-model="switches[1]"></switch></div></div><div class="form-group row clearfix"><label class="col-xs-8">When profile information changes</label><div class="col-xs-4"><switch color="primary" ng-model="switches[2]"></switch></div></div></div><div class="col-sm-6"><div class="form-group row clearfix"><label class="col-xs-8">When anyone logs into your account from a new device or browser</label><div class="col-xs-4"><switch color="primary" ng-model="switches[3]"></switch></div></div><div class="form-group row clearfix"><label class="col-xs-8">Weekly Reports</label><div class="col-xs-4"><switch color="primary" ng-model="switches[4]"></switch></div></div><div class="form-group row clearfix"><label class="col-xs-8">Daily Reports</label><div class="col-xs-4"><switch color="primary" ng-model="switches[5]"></switch></div></div></div></div><button type="button" class="btn btn-primary btn-with-icon save-profile"><i class="ion-android-checkmark-circle"></i>Update Profile</button></div></div>');
$templateCache.put('app/pages/profile/profileModal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" id="myModalLabel">Add Account</h4></div><form name="linkForm"><div class="modal-body"><p>Paste a link to your profile into the box below</p><div class="form-group"><input type="text" class="form-control" placeholder="Link to Profile" ng-model="link"></div></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="ok(link)">Save changes</button></div></form></div>');
$templateCache.put('app/pages/sales/sales.html','<div class="datepicker row"><div class="col-xlg-6 col-md-6 col-sm-6"><label ng-show="dt">Selected date is: <em>{{dt | date:\'fullDate\' }}</em></label> <label ng-show="!dt">Select start date</label><p class="input-group"><input type="text" max-date="maxDateStart" min-date="minDateStart" class="select-date form-control" uib-datepicker-popup="{{format}}" datepicker-options="optionsStart" ng-model="dt" is-open="opened" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false" readonly=""> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-xlg-6 col-md-6 col-sm-6"><label ng-show="dt2">Selected date is: <em>{{dt2 | date:\'fullDate\' }}</em></label> <label ng-show="!dt2">Select end date</label><p class="input-group"><input type="text" class="select-date form-control" uib-datepicker-popup="{{format}}" datepicker-options="optionsEnd" ng-model="dt2" is-open="opened2" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false" readonly=""> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open2()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div><div class="row"><div class="col-lg-8 col-md-7 col-sm-12" style="z-index: 100;" ba-panel="" ba-panel-class=""><h1 style="font-weight: 400;">Sales - Select Options</h1><br><form name="form" style="margin-top: -12px;"><div class="row mb-10"><div class="col-lg-5 col-md-12 col-sm-12"><div class="btn-group btn-agroup report-btn-sales"><label class="btn btn-sm btn-primary" ng-model="report" ng-change="toggleReport(\'normal\')" uib-btn-radio="\'normal\'"><span class="large">Normal</span> <span class="small">Normal</span></label> <label class="btn btn-sm btn-primary" ng-model="report" ng-change="toggleReport(\'max\')" uib-btn-radio="\'max\'"><span class="large">Max. Sales</span> <span class="small">Max. Sales</span></label> <label class="btn btn-sm btn-primary" ng-model="report" ng-change="toggleReport(\'time\')" uib-btn-radio="\'time\'"><span class="large">Sales Time</span> <span class="small">Sales Time</span></label></div></div><div class="col-lg-5 row-type col-md-5 col-sm-12 col-xs-12"><div class="btn-group btn-agroup pull-right report-btn-sales"><label class="btn btn-sm btn-primary" ng-model="type" ng-change="toggleType(\'all\')" uib-btn-radio="\'all\'"><span class="large">All</span> <span class="small">All</span></label> <label class="btn btn-sm btn-primary" ng-model="type" ng-change="toggleType(\'new\')" uib-btn-radio="\'new\'"><span class="large">New</span> <span class="small">New</span></label> <label class="btn btn-sm btn-primary" ng-model="type" ng-change="toggleType(\'used\')" uib-btn-radio="\'used\'"><span class="large">Used</span> <span class="small">Used</span></label></div></div></div><div class="form-group mb-5"><label>Dealers</label><selectize config="configSelect" placeholder="Select Dealers" options="$parent.dealers" ng-model="$parent.dealer" ng-disabled="!completeLoad"></selectize></div><div class="form-group mb-5"><label>Makes</label><selectize config="configSelect" placeholder="Select Makes" options="$parent.makes" ng-model="$parent.make" ng-disabled="!completeLoad"></selectize></div><div class="form-group mb-5"><label>Body Style</label><selectize config="configSelect" placeholder="Select Body Style" options="$parent.bodys" ng-model="$parent.body" ng-disabled="!completeLoad"></selectize></div><div class="form-group no-mb"><label>Models</label><selectize config="configSelect" placeholder="Select Models" options="$parent.models" ng-model="$parent.model" ng-disabled="!completeLoad"></selectize></div><div class="form-group mb-5"><label>Years</label><selectize config="configSelect" placeholder="Select Years" options="$parent.years" ng-model="$parent.year" ng-disabled="!completeLoad"></selectize></div><button type="button" ng-click="getReport()" style="padding-left:20px; padding-right:20px;" ng-disabled="!completeLoad" pb-style="top-line" class="btn btn-primary btn-raised pull-right btn-md"><i class="ion-ios-refresh"></i> &nbsp; <b>Get Report</b></button></form></div><div class="col-lg-4 col-md-5 col-sm-12 hidden-xs hidden-sm"><div class="panel innner-center animated zoomIn" style="height: 476px;"><div class="panel-heading clearfix" style="border-bottom:0"><h1 style="font-weight: 400;">Vehicles Selected</h1></div><div class="panel-body"><cond-chart style="margin-top: -55px;" class="center-block"></cond-chart></div></div></div></div><div class="row" id="results"><div class="col-lg-12 col-md-12 col-sm-12" ba-panel="" ba-panel-class="with-scroll panel-default min-height-panel"><h2 style="font-weight: 400">Results {{rtitle}}</h2><div ng-class="{\'opacity-res\': opacity}"><form class="row form-inline" ng-show="items.length"><div class="form-group col-md-9 col-sm-9"><input type="text" class="form-control" ng-model="search" id="searchItems" placeholder="Search cars"></div><div class="form-group col-md-offset-1 col-md-2 col-sm-offset-1 col-sm-2"><button type="button" ng-click="goBack()" class="btn btn-primary btn-raised btn-block no-m"><b>Go Back</b></button></div></form><div infinite-scroll="loadMore()"><h3 class="title-details" ng-show="items.length">{{items_quantity}} <span ng-bind-html="title_details"></span></h3><div class="list-articles" ng-show="items.length"><div class="article-item clearfix" ng-repeat="item in items | filter:search"><table><tr class="title-row"><td><h3 class="no-m"><span class="title"><a href="{{item.hyperlink}}" target="_blank">{{item.title}}</a></span></h3></td><td></td></tr></table><div class="more-box"><div class="row"><div class="col-sm-4 col-xs-4 col-md-4 short-name" style="padding-right: 0;"><div class="info clearfix"><div class="lbl-text pull-left">Dealer:</div><div class="value pull-left truncate-col"><span>{{item.section_name}}</span></div></div><div class="info clearfix"><div class="lbl-text pull-left">Type:</div><div class="value pull-left">{{item.type_name}}</div></div><div class="info clearfix"><div class="lbl-text pull-left">Stock:</div><div class="value no-data pull-left"><span>{{item.stock}}</span></div></div><div class="info clearfix"><div class="lbl-text pull-left">Mileage:</div><div class="value no-data pull-left"><span>{{item.miles | number:0 }}</span></div></div></div><div class="col-sm-4 col-xs-4 col-md-4 long-name"><div class="info clearfix"><div class="lbl-text pull-left">Sale Price:</div><div class="value pull-left"><span>{{item.price | currency:"$ ":0}}</span></div></div><div class="info clearfix"><div class="lbl-text pull-left">Year:</div><div class="value pull-left"><span>{{item.year}}</span></div></div><div class="info clearfix"><div class="lbl-text pull-left">Make:</div><div class="value pull-left"><span>{{item.make}}</span></div></div><div class="info clearfix"><div class="lbl-text pull-left">Model:</div><div class="value pull-left">{{item.model}}</div></div><div class="info clearfix"><div class="lbl-text pull-left">Time:</div><div class="value no-data pull-left"><span>{{item.time_duration}}</span></div></div></div><div class="col-sm-4 col-xs-4 col-md-4 long-name"><div style="float: left;"><div class="info clearfix"><div class="lbl-text pull-left">Created:</div><div class="value pull-left"><span>{{item.created_at | date:\'mediumDate\'}}</span></div></div><div class="info clearfix"><div class="lbl-text pull-left">Output:</div><div class="value pull-left"><span>{{item.updated_at | date:\'mediumDate\'}}</span></div></div></div><div class="price-details hidden-xs hidden-sm" style="float: right;"><div class="rank" ng-show="item.price"><strong>Sale Price</strong><br></div><span class="price" ng-show="item.price">{{item.price | currency:"$":0}}</span><div class="rank" ng-show="!item.price"><strong>Call for Price</strong></div></div></div></div></div></div></div></div><div ng-show="sales_results.length || amount_results.length"><div class="row mb-10" ng-show="!items.length"><div class="col-lg-7 col-md-12 col-sm-12"></div><div class="col-lg-5 row-type no-pl col-md-12 col-sm-12"><div class="btn-group btn-agroup chat-mode-btn pull-right"><label class="btn btn-primary" ng-model="chartmode" ng-change="toggleMainChart(\'sales\')" uib-btn-radio="\'amount\'"><span>Quantity Sales</span></label> <label class="btn btn-primary" ng-model="chartmode" ng-change="toggleMainChart(\'sales\')" uib-btn-radio="\'sales\'"><span>Total Sales</span></label></div></div></div><div class="chartjs-canvas-holder-third-row" style="height: {{item.height}}" ng-repeat="item in sales_results" ng-show="sales_results.length && !items.length && chartmode==\'sales\'"><label class="label-chart">SALES - {{item.total | number:0}}$ FOR <span class="title-dealer">{{item.title | replace:"All section_names":"All Dealers" | replace:"All body_styles":"All Body Styles" | uppercase }}</span></label><canvas id="barinv{{item.title}}" data-title="{{item.title}}" data-dealer="{{item.dealer}}" data-dealer-id="{{item.dealer_id}}" data-year="{{item.year}}" class="chart chart-horizontal-bar" chart-data="item.data" chart-labels="item.labels" chart-colors="colors" chart-series="series" chart-options="optionsBar" chart-dataset-override="datasetOverride" chart-click="selectBar"></canvas></div><div class="chartjs-canvas-holder-third-row" style="height: {{item.height}}" ng-repeat="item in amount_results" ng-show="amount_results.length && !items.length && chartmode==\'amount\'"><label class="label-chart">SALES - {{item.total | number:0}} CARS FOR <span class="title-dealer">{{item.title | replace:"All section_names":"All Dealers" | replace:"All body_styles":"All Body Styles" | uppercase }}</span></label><canvas id="barinv{{item.title}}" data-title="{{item.title}}" data-dealer="{{item.dealer}}" data-dealer-id="{{item.dealer_id}}" data-year="{{item.year}}" class="chart chart-horizontal-bar" chart-data="item.data" chart-labels="item.labels" chart-options="barsalesOptions" chart-dataset-override="datasetOverride" chart-colors="colors_amount" chart-series="series_amount" chart-click="selectBar"></canvas></div></div><div class="chartjs-canvas-holder-third-row" ng-show="max_results.length && !items.length"><canvas id="bar" class="chart chart-horizontal-bar" chart-data="data" chart-labels="labels" chart-colors="colors" chart-series="series" chart-options="optionsBar" chart-click="selectBar" chart-dataset-override="datasetOverride" chart-update="updateC"></canvas></div><div class="chartjs-canvas-holder-third-row" ng-show="time_results.length && !items.length"><canvas id="line" class="chart chart-line" chart-data="dataLine" chart-options="optionsLine" chart-colors="colors" chart-labels="labelsLine" chart-series="seriesLine" chart-dataset-override="datasetOverride" chart-click="selectBar"></canvas></div></div></div></div>');
$templateCache.put('app/pages/settings/index.html','<div class="row"><div class="col-lg-12 col-md-12 col-sm-12" style="z-index: 100;" ba-panel="" ba-panel-class="medium-panel auto-height"><br><div class="row mb-10"><div class="col-lg-12"><h4>Upload branding image</h4><div class="upload-box"><input type="file" ng-show="false" id="branding" ng-file-select="onFileSelect($files)" accept="image/*" item="branding"> <img style="margin-top: 10px; margin-bottom: 10px; margin: auto;" ng-src="{{settings.branding_image}}" id="branding_image" onerror="angular.element(this).scope().errorimage = true" ng-show="!errorimage" class="img-responsive"><h5 ng-show="errorimage">Please upload a new header to show on demo pdf!</h5><button type="button" class="pull-left btn btn-primary btn-raised" ng-click="uploadFile(\'branding\')"><b>Upload</b></button></div></div></div><br><div class="row mb-10"><div class="col-lg-11"><div class="form-group mb-5"><h4>Select Dealers to clean</h4><selectize config="configSelect" placeholder="Select Dealers" options="$parent.dealers" ng-model="$parent.dealer"></selectize><span class="help-block sub-little-text">Select one or more dealer from this list</span></div></div><div class="col-lg-1" style="margin-top: 28px;"><button ng-disabled="!$parent.dealer.length" type="button" ng-click="goClean()" class="btn btn-primary btn-raised btn-block no-m"><b>Clean</b></button></div></div><br><div class="row mb-10"><div class="col-lg-12"><div class="form-group mb-5"><h4>Sync Metrics</h4><button type="button" ng-click="refreshMetrics()" class="btn btn-primary btn-raised no-m"><b>Start Sync</b></button><div class="container"><ul class="progressbar"><li ng-class="{\'active\' : (dimension[0][\'done\'] && !dimension[0][\'loading\']) || (!dimension[0][\'done\'] && dimension[0][\'loading\'])}"><i class="fa fa-circle-o-notch fa-spin" ng-show="!dimension[0][\'done\'] && dimension[0][\'loading\']"></i> <i class="fa fa-check" ng-show="dimension[0][\'done\'] && !dimension[0][\'loading\']"></i> Body Style</li><li ng-class="{\'active\' : dimension[1][\'done\']}"><i class="fa fa-circle-o-notch fa-spin" ng-show="!dimension[1][\'done\'] && dimension[1][\'loading\']"></i> <i class="fa fa-check" ng-show="dimension[1][\'done\']"></i> Make</li><li ng-class="{\'active\' : dimension[2][\'done\']}"><i class="fa fa-circle-o-notch fa-spin" ng-show="!dimension[2][\'done\'] && dimension[2][\'loading\']"></i> <i class="fa fa-check" ng-show="dimension[2][\'done\']"></i> Model</li><li ng-class="{\'active\' : dimension[0][\'done\'] && dimension[1][\'done\'] && dimension[2][\'done\']}"><i class="fa fa-check" ng-show="dimension[0][\'done\'] && dimension[1][\'done\'] && dimension[2][\'done\']"></i> Synced</li></ul></div></div></div></div></div></div>');
$templateCache.put('app/pages/settings/new.html','<div><div class="row"><div class="col-lg-12 col-md-12 col-sm-12"><div class="panel"><div class="panel-body"><div class="box-select"><div class="btn-group btn-agroup report-btn pull-left"><label class="btn btn-primary" ng-model="type_export" ng-change="toggleExport(\'settings\', \'Work Order\')" uib-btn-radio="\'settings\'"><b>Work Order</b></label> <label class="btn btn-primary" ng-model="type_export" ng-disabled="!order_id" ng-change="toggleExport(\'deliverables\', \'Deliverables\')" uib-btn-radio="\'deliverables\'"><b>Deliverables</b></label> <label class="btn btn-primary" ng-model="type_export" ng-disabled="!order_id" ng-change="toggleExport(\'requests\', \'Requests\')" uib-btn-radio="\'requests\'"><b>Requests</b></label> <label class="btn btn-primary" ng-model="type_export" ng-disabled="!order_id" ng-show="type_export==\'requests\' || type_export==\'newrequest\'" ng-change="toggleExport(\'newrequest\', \'Request\')" uib-btn-radio="\'newrequest\'"><b>New Request</b></label></div><button type="button" ng-click="newOrder()" ng-show="order_id" style="float: right; margin-top: 10px!important; height: 43px;" class="btn btn-primary btn-raised no-m pull-right"><b>New Order</b></button></div></div></div></div></div><div class="row"><div class="col-lg-12 col-md-12 col-sm-12" style="z-index: 100;" ng-show="type_export==\'settings\'"><div class="panel"><div class="panel-body"><h2 class="title-form">Work Order</h2><form name="form2" ng-submit="saveOrder(form2)" novalidate=""><div class="row"><div class="col-lg-6 col-md-6 col-sm-12"><div class="form-group mb-5"><label for="Order name">Title</label> <input type="text" class="form-control" id="ordername" name="ordername" ng-model="order.name" ng-required="true" placeholder=""> <span class="help-block sub-little-text">e.g. Summer Sales Event (required)</span></div></div><div class="col-lg-6 col-md-6 col-sm-5"><div class="form-group mb-5"><label>Status</label><selectize config="configSingleOne" placeholder="Select status" ng-required="true" options="status" ng-model="order.status"></selectize></div></div></div><div class="row mb-10"><div class="col-lg-6 col-md-6"><div class="form-group mb-5" ng-hide="report==\'benchmark\'"><label>Choose Dealer</label><selectize config="configSingleOne" placeholder="" options="dealers" name="dealer" ng-required="true" ng-model="order.dealer"></selectize><span class="help-block sub-little-text">Select a Dealer (required)</span></div></div><div class="col-lg-6 col-md-6"><div class="form-group mb-5"><label for="Order name">Vehicles</label> <input type="text" class="form-control" id="ordervehicles" name="ordervehicles" ng-model="order.vehicles" placeholder=""> <span class="help-block sub-little-text">e.g. F-150 (Only 2019) and SUVS (from 2017 to 2019)</span></div></div></div><div class="row mb-15"><div class="col-lg-2 col-md-2"><label ng-show="!dt2" style="font-weight: normal;">Start Date</label><p class="input-group date-select"><input type="text" max-date="maxDateStart" min-date="minDateStart" class="select-date form-control" uib-datepicker-popup="{{format}}" datepicker-options="optionsStart" ng-model="dt" ng-change="setDateStart(dt)" is-open="opened" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false" readonly=""> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-lg-2 col-md-2"><label ng-show="!dt2" style="font-weight: normal;">End Date</label><p class="input-group date-select"><input type="text" class="select-date form-control" uib-datepicker-popup="{{format}}" datepicker-options="optionsEnd" ng-model="dt2" is-open="opened2" close-text="Close" ng-change="setDateEnd(dt2)" alt-input-formats="altInputFormats" show-button-bar="false" readonly=""> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open2()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div><h2 class="title-form">Inventory Banners</h2><div class="row mb-15 select-banner"><div class="col-lg-3 col-md-3"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" value="" ng-model="solu.banner300x50" ng-true-value="true" ng-false-value="false"> <span class="font-weight-bold">300x50 (Mobile)</span></label><br><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" value="" ng-model="solu.banner300x250" ng-true-value="true" ng-false-value="false"> <span class="font-weight-bold">300x250 (Medium Rectangle)</span></label><br><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" value="" ng-model="solu.banner300x600" ng-true-value="true" ng-false-value="false"> <span class="font-weight-bold">300x600 (Half Page)</span></label><br><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" value="" ng-model="solu.banner728x90" ng-true-value="true" ng-false-value="false"> <span class="font-weight-bold">728x90 (Leaderboard)</span></label></div><div class="col-lg-3 col-md-3"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" value="" ng-model="solu.banner970x90" ng-true-value="true" ng-false-value="false"> <span class="font-weight-bold">970x90 (Expandible to 250)</span></label><br><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" value="" ng-model="solu.banner970x240" ng-true-value="true" ng-false-value="false"> <span class="font-weight-bold">970x240 (Responsive)</span></label><br><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" value="" ng-model="solu.banner970x250" ng-true-value="true" ng-false-value="false"> <span class="font-weight-bold">970x250 (Responsive)</span></label><br><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" value="" ng-model="solu.banner1280x220" ng-true-value="true" ng-false-value="false"> <span class="font-weight-bold">1280x220 (Responsive)</span></label></div><div class="col-lg-3 col-md-3"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" value="" ng-model="solu.banner1280x250" ng-true-value="true" ng-false-value="false"> <span class="font-weight-bold">1280x250 (Responsive)</span></label><br><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" value="" ng-model="solu.banner1280x600" ng-true-value="true" ng-false-value="false"> <span class="font-weight-bold">1280x600 (Lighthouse)</span></label></div><div class="col-lg-3 col-md-3"></div></div><h2>Facebook Campaign</h2><div class="row mb-15"><div class="col-lg-3 col-md-3"><div class="row"><div class="col-lg-3 col-md-3"><label class="contain">Yes <input type="radio" name="optsocial" ng-model="order.onsocial" ng-value="true"> <span class="checkmark"></span></label></div><div class="col-lg-3 col-md-3"><label class="contain">No <input type="radio" name="optsocial" ng-model="order.onsocial" ng-value="false" checked=""> <span class="checkmark"></span></label></div></div></div></div><div class="row mb-15" ng-show="order.onsocial"><div class="col-lg-2 col-md-2"><div class="form-group mb-5"><label for="Budget">Budget</label> <input type="text" class="form-control" id="socialbudget" name="socialbudget" ng-model="order.social.budget" placeholder=""></div></div><div class="col-lg-2 col-md-2"><div class="form-group mb-5"><label for="Audience City">Audience City</label> <input type="text" class="form-control" id="audiencecity" name="audiencecity" ng-model="order.social.audiencecity" placeholder=""></div></div><div class="col-lg-2 col-md-2"><div class="form-group mb-5"><label for="Audience State">Audience State</label> <input type="text" class="form-control" id="audiencestate" name="audiencestate" ng-model="order.social.audiencestate" placeholder=""></div></div><div class="col-lg-6 col-md-6"><div class="form-group mb-5"><label for="Additional Info">Additional Info</label> <input type="text" class="form-control" id="socialinfo" name="socialinfo" ng-model="order.social.info" placeholder=""></div></div></div><h2>Email</h2><div class="row mb-15"><div class="col-lg-3 col-md-3"><div class="row"><div class="col-lg-3 col-md-3"><label class="contain">Yes <input type="radio" name="optemail" ng-model="order.onemail" ng-value="true"> <span class="checkmark"></span></label></div><div class="col-lg-3 col-md-3"><label class="contain">No <input type="radio" name="optemail" ng-model="order.onemail" ng-value="false" checked=""> <span class="checkmark"></span></label></div></div></div></div><div class="row mb-15" ng-show="order.onemail"><div class="col-lg-6 col-md-6"><div class="form-group mb-5"><label for="Order name">Special Vehicles Info</label> <input type="text" class="form-control" id="emailvehicles" name="emailvehicles" ng-model="order.email.vehicles" placeholder=""></div></div><div class="col-lg-6 col-md-6"><div class="form-group mb-5"><label for="Order name">Additional Info</label> <input type="text" class="form-control" id="emailinfo" name="emailinfo" ng-model="order.email.info" placeholder=""></div></div></div><h2>Reverse Publishing</h2><div class="row mb-15"><div class="col-lg-3 col-md-3"><div class="row"><div class="col-lg-3 col-md-3"><label class="contain">Yes <input type="radio" name="optreverse" ng-model="order.onreverse" ng-value="true"> <span class="checkmark"></span></label></div><div class="col-lg-3 col-md-3"><label class="contain">No <input type="radio" name="optreverse" ng-model="order.onreverse" ng-value="false" checked=""> <span class="checkmark"></span></label></div></div></div></div><div class="row mb-15" ng-show="order.onreverse"><div class="col-lg-3 col-md-3"><span class="mb-5 d-block">Paper Orientation</span> <label class="contain">Portrait <input type="radio" name="optpaper" ng-model="order.reverse.paper_orientation" ng-value="\'portrait\'" checked=""> <span class="checkmark"></span></label> <label class="contain">Landscape <input type="radio" name="optpaper" ng-model="order.reverse.paper_orientation" ng-value="\'landscape\'"> <span class="checkmark"></span></label></div><div class="col-lg-3 col-md-3"><div class="form-group mb-5"><label for="Order name">Paper Size</label> <input type="text" class="form-control" id="paper_size" name="paper_size" ng-model="order.reverse.paper_size" placeholder="(in Inches e.g. 8x11)"></div></div><div class="col-lg-3 col-md-3"><div class="form-group mb-5"><label>Content Layout</label><selectize config="configSingleOne" placeholder="Templates" options="typetemplates" ng-model="typetemplate"></selectize></div></div><div class="col-lg-3 col-md-3"></div></div><div class="row mb-15" ng-show="order.onreverse"><div class="col-lg-6 col-md-6"><div class="form-group mb-5"><label for="Order name">Special Vehicles</label> <input type="text" class="form-control" id="reversevehicles" name="reversevehicles" ng-model="order.reverse.vehicles" placeholder=""></div></div><div class="col-lg-6 col-md-6"><div class="form-group mb-5"><label for="Order name">Additional Info</label> <input type="text" class="form-control" id="reverseinfo" name="reverseinfo" ng-model="order.reverse.info" placeholder=""></div></div></div><h2 class="title-form">Help us make a better design for you!</h2><div class="row mb-15"><div class="col-lg-6 col-md-6"><h4>How will the graphics be designed?</h4><label class="contain">Wehaa free design based on dealer brand <input type="radio" name="optradio" ng-model="order.freedesign" ng-value="true" checked=""> <span class="checkmark"></span></label> <label class="contain">Wehaa design based on client graphics files <input type="radio" name="optradio" ng-model="order.freedesign" ng-value="false"> <span class="checkmark"></span></label><br><div class="form-group"><label for="textarea01">Additional info</label> <textarea placeholder="" class="form-control" id="infodesign" name="infodesign" ng-model="order.design.info"></textarea></div></div><div class="col-lg-6 col-md-6"><h4>Graphic files to helps help us in the design process</h4><div class="form-group mb-5"><label for="Order name">Online drive link</label> <input type="text" class="form-control" id="url_drive" name="url_drive" ng-model="order.design.drive_url" placeholder=""></div><br><span>Upload Files (Max 100mb)</span><div class="upload-box"><button type="button" style="float: left;" class="btn btn-primary btn-raised" ng-click="uploadFile(\'settings\')"><b>Upload</b></button> <input type="file" ng-show="false" id="settings" ng-file-select="onFileSelect($files)" item="settings"> <span ng-repeat="file in order.files" class="file-attach"><a href="{{file.url}}">{{file.name}} {{file.size | Filesize}}</a></span></div></div></div><br><button type="submit" style="padding-left:20px; padding-right:20px;" ng-disabled="form2.$invalid" pb-style="top-line" class="btn btn-primary btn-raised pull-right btn-md"><b>Save Order</b></button></form></div></div></div><div class="col-lg-12 col-md-12 col-sm-12" style="z-index: 100;" ng-show="type_export==\'deliverables\'"><div class="panel"><div class="panel-body"><h2 class="title-form">Inventory Banners</h2><form name="form3" ng-submit="saveOrder(form3)" novalidate=""><div class="row"><div class="col-lg-12 col-md-12 col-sm-12"><div class="form-group mb-5"><input type="text" class="form-control" id="deliveryurl" name="deliveryurl" ng-model="order.deliverables.url" placeholder=""></div></div></div><br><div class="row mb-10"><div class="col-lg-6 col-md-6"><div class="form-group"><label for="textarea01">For DFP implementation, distribute these tags</label> <textarea placeholder="" class="form-control" id="dfpsource" name="dfpsource" ng-model="order.deliverables.dfpsource"></textarea></div></div><div class="col-lg-6 col-md-6"><div class="form-group"><label for="textarea01">For Native implementation, distribute these tags</label> <textarea placeholder="" class="form-control" id="nativesource" name="nativesource" ng-model="order.deliverables.nativesource"></textarea></div></div></div><h2 class="title-form">Facebook Campaign</h2><div class="row"><div class="col-lg-12 col-md-12 col-sm-12"><div class="form-group mb-5"><input type="text" class="form-control" id="devfacebook" name="devfacebook" ng-model="order.deliverables.facebook" placeholder=""></div></div></div><br><h2>Email</h2><div class="row mb-10"><div class="col-lg-12 col-md-12"><div class="form-group"><textarea placeholder="" class="form-control" id="devemail" name="devemail" ng-model="order.deliverables.email"></textarea></div></div></div><h2>Reverse Publishing</h2><div class="row mb-10"><div class="col-lg-12 col-md-12"></div></div><h2>Report</h2><div class="row mb-10"><div class="col-lg-12 col-md-12"><div class="form-group"><textarea placeholder="" class="form-control" id="devreport" name="devreport" ng-model="order.deliverables.report"></textarea></div></div></div><br><button type="submit" style="padding-left:20px; padding-right:20px;" ng-disabled="form2.$invalid" pb-style="top-line" class="btn btn-primary btn-raised pull-right btn-md"><b>Save Deliverys</b></button></form></div></div></div><div class="col-lg-12 col-md-12 col-sm-12" style="z-index: 100;" ng-show="type_export==\'requests\'"><div class="panel"><div class="panel-body" style="min-height: 350px;"><h1 style="font-weight: 400;">Request List</h1><br><form class="row form-inline searchdiff"><div class="form-group col-md-12 col-sm-12"><label>Search string</label> <input style="border-radius: 5px;" type="text" class="form-control" ng-model="searchdiff" id="searchdiff" placeholder="Search requets"></div></form><br><div class="row mb-10"><div class="col-lg-6 col-md-5 col-sm-4"><div class="btn-group btn-agroup pull-left type-btn"><label class="btn btn-primary" ng-model="statuses" ng-change="toggleStatus(\'all\')" uib-btn-radio="\'all\'">All</label> <label class="btn btn-primary" ng-model="statuses" ng-change="toggleStatus(\'progress\')" uib-btn-radio="\'progress\'">In Progress</label> <label class="btn btn-primary" ng-model="statuses" ng-change="toggleStatus(\'closed\')" uib-btn-radio="\'closed\'">Finished</label></div></div><div class="col-lg-6 col-md-7 col-sm-8"><button type="button" ng-click="toggleExport(\'newrequest\', \'New Request\')" style="float: right; margin-top: 10px!important;" class="btn btn-primary btn-raised no-m"><b>New Request</b></button></div></div><br><div class="horizontal-scroll"><table class="table"><thead><tr><th><b>#</b></th><th>REQUEST TITLE</th><th class="align-center">STATUS</th><th class="align-center">CREATION DATE</th><th class="align-center">LAST MODIFIED</th><th class="align-center">REMOVE</th></tr></thead><tbody><tr ng-click="getRequest(request)" ng-repeat="request in requests | filter:customFilter" style="cursor: pointer;"><td>{{$index + 1}}</td><td>{{request.title}}</td><td class="align-center"><span ng-if="request.status==\'progress\'">In Progress</span> <span ng-if="request.status==\'closed\'">Closed</span></td><td class="align-center">{{request.created_at | date:"medium"}}</td><td class="align-center">{{request.updated_at | date:"medium"}}</td><td class="align-center"><i class="chart-icon ion-close" style="color: #EE6D60;" ng-click="$event.stopPropagation();openConfirm(request)"></i></td></tr></tbody></table></div></div></div></div><div class="col-lg-12 col-md-12 col-sm-12" style="z-index: 100;" ng-show="type_export==\'newrequest\'"><div class="panel"><div class="panel-body"><h2 class="title-form">Request</h2><form name="form5" ng-submit="saveRequest(form5)" novalidate=""><div class="row"><div class="col-lg-6 col-md-6 col-sm-6"><div class="form-group mb-5"><label for="textarea01">Title</label> <input type="text" class="form-control" id="titlerequest" name="titlerequest" ng-model="request.title" ng-required="true" placeholder=""></div></div><div class="col-lg-6 col-md-6 col-sm-5"><div class="form-group mb-5"><label>Status</label><selectize config="configSingleOne" placeholder="Select status" options="status" ng-model="request.status"></selectize></div></div></div><br><div class="row mb-10"><div class="col-lg-6 col-md-6"><div class="form-group"><label for="textarea01">Comments</label> <textarea placeholder="" class="form-control" id="comments" name="comments" ng-model="request.comments" ng-required="true"></textarea></div></div><div class="col-lg-6 col-md-6"><span>Upload Files (Max 100mb)</span><div class="upload-box"><button type="button" style="float: left;" class="btn btn-primary btn-raised" ng-click="uploadFile(\'requests\')"><b>Upload</b></button> <input type="file" ng-show="false" id="requests" ng-file-select="onFileSelect($files)" item="requests"> <span ng-repeat="file in request.files" class="file-attach"><a href="{{file.url}}">{{file.name}} {{file.size | Filesize}}</a></span></div></div></div><br><button type="submit" style="padding-left:20px; padding-right:20px;" ng-disabled="form5.$invalid" pb-style="top-line" class="btn btn-primary btn-raised pull-right btn-md"><b ng-if="!req_update">Send Request</b> <b ng-if="req_update">Update Request</b></button> <button type="button" style="padding-left:20px; padding-right:20px;" ng-if="req_update" ng-click="cancelRequest()" pb-style="top-line" class="btn btn-primary btn-raised pull-right btn-md"><b>Cancel</b></button></form></div></div></div></div></div>');
$templateCache.put('app/pages/workorders/index.html','<div class="row"><div class="col-lg-12 col-md-12 col-sm-12" style="z-index: 100;" ba-panel="" ba-panel-class="medium-panel auto-height"><div class="row"><div class="col-lg-12 col-md-12 col-xs-12 col-sm-12"><h1 style="font-weight: 400; float: left; width: auto;">Orders List</h1></div></div><form class="row form-inline searchdiff"><div class="form-group col-md-12 col-sm-12"><label>Search string</label> <input style="border-radius: 5px;" type="text" class="form-control" ng-model="searchdiff" id="searchdiff" placeholder="Search orders"></div></form><br><div class="row mb-10"><div class="col-lg-6 col-md-5 col-sm-9 col-xs-9"><div class="btn-group btn-agroup pull-left type-btn"><label class="btn btn-sm btn-primary" ng-model="status" ng-change="toggleStatus(\'all\')" uib-btn-radio="\'all\'"><span class="large">All</span> <span class="small">All</span></label> <label class="btn btn-sm btn-primary" ng-model="status" ng-change="toggleStatus(\'progress\')" uib-btn-radio="\'progress\'"><span class="large">In Progress</span> <span class="small">Progress</span></label> <label class="btn btn-sm btn-primary" ng-model="status" ng-change="toggleStatus(\'closed\')" uib-btn-radio="\'closed\'"><span class="large">Finished</span> <span class="small">Close</span></label></div></div><div class="col-lg-6 col-md-7 col-sm-3 col-xs-3"><button type="button" ui-sref="home.neworder" style="float: right;" class="btn btn-primary btn-raised no-m"><b class="visible-xs">New</b> <b class="hidden-xs">New Order</b></button></div></div><div class="horizontal-scroll"><table class="table"><thead><tr><th><b>#</b></th><th>ORDER TITLE</th><th class="align-center">STATUS</th><th class="align-center hidden-sm hidden-xs">CREATION DATE</th><th class="align-center hidden-sm hidden-xs">LAST MODIFIED</th><th class="align-center">REMOVE</th></tr></thead><tbody><tr ui-sref="home.neworder({order_id:worder.id})" ng-repeat="worder in workorders | filter:customFilter | orderBy:\'-date_modified\'" style="cursor: pointer;"><td>{{$index + 1}}</td><td>{{worder.name}}</td><td class="align-center"><span ng-if="worder.status==\'progress\'">In Progress</span> <span ng-if="worder.status==\'closed\'">Closed</span></td><td class="align-center hidden-sm hidden-xs">{{worder.created_at | date:"medium"}}</td><td class="align-center hidden-sm hidden-xs">{{worder.updated_at | date:"medium"}}</td><td class="align-center"><i class="chart-icon ion-close" style="color: #EE6D60;" ng-click="$event.stopPropagation();onLongPress(worder)"></i></td></tr></tbody></table></div></div></div>');
$templateCache.put('app/pages/workorders/new.html','<div><div class="row"><div class="col-lg-12 col-md-12 col-sm-12"><div class="panel" style="margin-bottom: 15px;"><div class="panel-body"><div class="box-select"><div class="btn-group btn-agroup report-btn pull-left"><label class="btn btn-primary" ng-model="type_export" ng-change="toggleExport(\'workorders\', \'Work Order\')" uib-btn-radio="\'workorders\'"><b>Work Order</b></label> <label class="btn btn-primary" ng-model="type_export" ng-disabled="!order_id" ng-change="toggleExport(\'deliverables\', \'Deliverables\')" uib-btn-radio="\'deliverables\'"><b>Deliverables</b></label> <label class="btn btn-primary" ng-model="type_export" ng-disabled="!order_id" ng-change="toggleExport(\'requests\', \'Requests\')" uib-btn-radio="\'requests\'"><b>Requests</b></label> <label class="btn btn-primary" ng-model="type_export" ng-disabled="!order_id" ng-show="type_export==\'requests\' || type_export==\'newrequest\'" ng-change="toggleExport(\'newrequest\', \'Request\')" uib-btn-radio="\'newrequest\'"><b ng-show="!req_update">New Request</b> <b ng-show="req_update">Update Request</b></label></div><button type="button" ng-click="newOrder()" ng-show="order_id" style="float: right; margin-top: 10px!important; height: 43px;" class="btn btn-primary btn-raised no-m pull-right"><b>New Order</b></button></div></div></div></div></div><div class="row"><div class="col-lg-12 col-md-12 col-sm-12" style="z-index: 100;" ng-show="type_export==\'workorders\'"><div class="panel"><div class="panel-body"><h2 class="title-form font-weight-400">Work Order</h2><form name="form" ng-submit="saveOrder(form)" novalidate=""><div class="row"><div class="col-lg-4 col-md-4 col-sm-12"><div class="form-group mb-5"><label for="Order name">Title</label> <input type="text" class="form-control" id="ordername" name="ordername" ng-model="order.name" ng-required="true" placeholder=""> <span class="help-block sub-little-text" ng-class="{\'has-error\' : (form.ordername.$error.required && form.ordername.$touched) || (form.ordername.$error.required && form.$submitted)}">e.g. Summer Sales Event (required)</span></div></div><div class="col-lg-4 col-md-4 col-sm-5"><div class="form-group mb-5"><label>Status</label><selectize config="configSingleOne" placeholder="" ng-required="true" options="status" ng-model="order.status"></selectize></div></div><div class="col-lg-4 col-md-4 col-sm-5"><div class="row mb-15"><div class="col-lg-6 col-md-6"><label style="font-weight: normal;">Start Date</label><p class="input-group date-select"><input type="text" max-date="maxDateStart" min-date="minDateStart" class="select-date form-control" uib-datepicker-popup="{{format}}" datepicker-options="optionsStart" ng-model="dt" ng-change="setDateStart(dt)" is-open="opened" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false" readonly=""> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-lg-6 col-md-6"><label style="font-weight: normal;">End Date</label><p class="input-group date-select"><input type="text" class="select-date form-control" uib-datepicker-popup="{{format}}" datepicker-options="optionsEnd" ng-model="dt2" is-open="opened2" close-text="Close" ng-change="setDateEnd(dt2)" alt-input-formats="altInputFormats" show-button-bar="false" readonly=""> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open2()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div></div></div><div class="row"><div class="col-lg-6 col-md-6"></div></div><div class="row mb-10"><div class="col-lg-4 col-md-4"><div class="form-group mb-5" ng-hide="report==\'benchmark\'"><label>Choose Dealer</label><selectize config="configSingleOne" placeholder="" options="dealers" name="dealer" ng-required="true" ng-model="order.dealer"></selectize><span class="help-block sub-little-text" ng-class="{\'has-error\' : (form.dealer.$error.required && form.dealer.$touched) || (form.dealer.$error.required && form.$submitted)}">Select dealer is required!</span></div></div><div class="col-lg-2 col-md-2"><div class="btn-group btn-agroup pull-right type-btn" style="float: left !important; margin-top: 18px;"><label class="btn btn-sm btn-primary" ng-model="type" ng-change="toggleType(\'all\', false)" uib-btn-radio="\'all\'">All</label> <label class="btn btn-sm btn-primary" ng-model="type" ng-change="toggleType(\'new\', false)" uib-btn-radio="\'new\'">New</label> <label class="btn btn-sm btn-primary" ng-model="type" ng-change="toggleType(\'used\', false)" uib-btn-radio="\'used\'">Used</label> <label class="btn btn-sm btn-primary" ng-model="type" ng-change="toggleType(\'certified\', false)" uib-btn-radio="\'certified\'">Certified</label></div></div><div class="col-lg-6 col-md-6"><div class="form-group mb-5"><label for="Order name">Vehicles</label> <input type="text" class="form-control" id="ordervehicles" name="ordervehicles" ng-model="order.vehicles" ng-required="true" placeholder=""> <span class="help-block sub-little-text" ng-class="{\'has-error\' : (form.ordervehicles.$error.required && form.ordervehicles.$touched) || (form.ordervehicles.$error.required && form.$submitted)}">e.g. F-150 (Only 2019) and SUVS (from 2017 to 2019)</span></div></div></div><h3 class="title-form">Inventory Banners</h3><div class="row mb-15 select-banner"><div class="col-lg-3 col-md-3"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" value="" ng-model="solu.banner300x50" ng-true-value="true" ng-false-value="false"> <span class="font-weight-bold">300x50 (Mobile)</span></label><br><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" value="" ng-model="solu.banner300x250" ng-true-value="true" ng-false-value="false"> <span class="font-weight-bold">300x250 (Medium Rectangle)</span></label><br><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" value="" ng-model="solu.banner300x600" ng-true-value="true" ng-false-value="false"> <span class="font-weight-bold">300x600 (Half Page)</span></label><br><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" value="" ng-model="solu.banner728x90" ng-true-value="true" ng-false-value="false"> <span class="font-weight-bold">728x90 (Leaderboard)</span></label></div><div class="col-lg-3 col-md-3"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" value="" ng-model="solu.banner970x90" ng-true-value="true" ng-false-value="false"> <span class="font-weight-bold">970x90 (Expandible to 250)</span></label><br><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" value="" ng-model="solu.banner970x240" ng-true-value="true" ng-false-value="false"> <span class="font-weight-bold">970x240 (Responsive)</span></label><br><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" value="" ng-model="solu.banner970x250" ng-true-value="true" ng-false-value="false"> <span class="font-weight-bold">970x250 (Responsive)</span></label><br><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" value="" ng-model="solu.banner1280x220" ng-true-value="true" ng-false-value="false"> <span class="font-weight-bold">1280x220 (Responsive)</span></label></div><div class="col-lg-3 col-md-3"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" value="" ng-model="solu.banner1280x250" ng-true-value="true" ng-false-value="false"> <span class="font-weight-bold">1280x250 (Responsive)</span></label><br><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" value="" ng-model="solu.banner1280x600" ng-true-value="true" ng-false-value="false"> <span class="font-weight-bold">1280x600 (Lighthouse)</span></label></div><div class="col-lg-3 col-md-3"></div></div><h3>Facebook Campaign</h3><div class="row mb-15"><div class="col-lg-3 col-md-3"><div class="row"><div class="col-lg-3 col-md-3"><label class="contain">Yes <input type="radio" name="optsocial" ng-model="order.onsocial" ng-value="true"> <span class="checkmark"></span></label></div><div class="col-lg-3 col-md-3"><label class="contain">No <input type="radio" name="optsocial" ng-model="order.onsocial" ng-value="false" checked=""> <span class="checkmark"></span></label></div></div></div></div><div class="row mb-15" ng-show="order.onsocial"><div class="col-lg-2 col-md-2"><div class="form-group mb-5"><label for="Budget">Budget</label> <input type="text" class="form-control" id="socialbudget" name="socialbudget" ng-model="order.social.budget" placeholder=""></div></div><div class="col-lg-2 col-md-2"><div class="form-group mb-5"><label for="Audience City">Audience City</label> <input type="text" class="form-control" id="audiencecity" name="audiencecity" ng-model="order.social.audiencecity" placeholder=""></div></div><div class="col-lg-2 col-md-2"><div class="form-group mb-5"><label for="Audience State">Audience State</label> <input type="text" class="form-control" id="audiencestate" name="audiencestate" ng-model="order.social.audiencestate" placeholder=""></div></div><div class="col-lg-6 col-md-6"><div class="form-group mb-5"><label for="Additional Info">Additional Info</label> <input type="text" class="form-control" id="socialinfo" name="socialinfo" ng-model="order.social.info" placeholder=""></div></div></div><h3>Email</h3><div class="row mb-15"><div class="col-lg-3 col-md-3"><div class="row"><div class="col-lg-3 col-md-3"><label class="contain">Yes <input type="radio" name="optemail" ng-model="order.onemail" ng-value="true"> <span class="checkmark"></span></label></div><div class="col-lg-3 col-md-3"><label class="contain">No <input type="radio" name="optemail" ng-model="order.onemail" ng-value="false" checked=""> <span class="checkmark"></span></label></div></div></div></div><div class="row mb-15" ng-show="order.onemail"><div class="col-lg-6 col-md-6"><div class="form-group mb-5"><label for="Order name">Special Vehicles Info</label> <input type="text" class="form-control" id="emailvehicles" name="emailvehicles" ng-model="order.email.vehicles" placeholder=""></div></div><div class="col-lg-6 col-md-6"><div class="form-group mb-5"><label for="Order name">Additional Info</label> <input type="text" class="form-control" id="emailinfo" name="emailinfo" ng-model="order.email.info" placeholder=""></div></div></div><h3>Reverse Publishing</h3><div class="row mb-15"><div class="col-lg-3 col-md-3"><div class="row"><div class="col-lg-3 col-md-3"><label class="contain">Yes <input type="radio" name="optreverse" ng-model="order.onreverse" ng-value="true"> <span class="checkmark"></span></label></div><div class="col-lg-3 col-md-3"><label class="contain">No <input type="radio" name="optreverse" ng-model="order.onreverse" ng-value="false" checked=""> <span class="checkmark"></span></label></div></div></div></div><div class="row mb-15" ng-show="order.onreverse"><div class="col-lg-3 col-md-3"><span class="mb-5 d-block">Paper Orientation</span> <label class="contain">Portrait <input type="radio" name="optpaper" ng-model="order.reverse.paper_orientation" ng-value="\'portrait\'" checked=""> <span class="checkmark"></span></label> <label class="contain">Landscape <input type="radio" name="optpaper" ng-model="order.reverse.paper_orientation" ng-value="\'landscape\'"> <span class="checkmark"></span></label></div><div class="col-lg-3 col-md-3"><div class="form-group mb-5"><label for="Order name">Paper Size</label> <input type="text" class="form-control" id="paper_size" name="paper_size" ng-model="order.reverse.paper_size" placeholder="(in Inches e.g. 8x11)"></div></div><div class="col-lg-3 col-md-3"><div class="form-group mb-5"><label>Content Layout</label><selectize config="configSingleOne" placeholder="Templates" options="typetemplates" ng-model="typetemplate"></selectize></div></div><div class="col-lg-3 col-md-3"></div></div><div class="row mb-15" ng-show="order.onreverse"><div class="col-lg-6 col-md-6"><div class="form-group mb-5"><label for="Order name">Special Vehicles</label> <input type="text" class="form-control" id="reversevehicles" name="reversevehicles" ng-model="order.reverse.vehicles" placeholder=""></div></div><div class="col-lg-6 col-md-6"><div class="form-group mb-5"><label for="Order name">Additional Info</label> <input type="text" class="form-control" id="reverseinfo" name="reverseinfo" ng-model="order.reverse.info" placeholder=""></div></div></div><div class="row mb-15"><div class="col-lg-6 col-md-6"><h4>How will the graphics be designed?</h4><label class="contain">Wehaa free design based on dealer brand <input type="radio" name="optradio" ng-model="order.freedesign" ng-value="true" checked=""> <span class="checkmark"></span></label> <label class="contain">Wehaa design based on client graphics files <input type="radio" name="optradio" ng-model="order.freedesign" ng-value="false"> <span class="checkmark"></span></label><br><div class="form-group"><label for="textarea01">Additional info</label> <textarea placeholder="" class="form-control" id="infodesign" name="infodesign" ng-model="order.design.info"></textarea></div></div><div class="col-lg-6 col-md-6"><h4>Graphic files to helps help us in the design process</h4><div class="form-group mb-5"><label for="Order name">Online drive link</label> <input type="text" class="form-control" id="url_drive" name="url_drive" ng-model="order.design.drive_url" placeholder=""></div><br><span>Upload Files (Max 100mb)</span><div class="upload-box"><button type="button" style="float: left;" class="btn btn-primary btn-raised" ng-click="uploadFile(\'workorders\')"><b>Upload</b></button> <input type="file" ng-show="false" id="workorders" ng-file-select="onFileSelect($files)" item="workorders"> <span ng-repeat="file in order.files" class="file-attach"><a href="{{file.url}}">{{file.name}} {{file.size | Filesize}}</a></span></div></div></div><br><button type="submit" style="padding-left:20px; padding-right:20px;" ng-disabled="!dealers.length" pb-style="top-line" class="btn btn-primary btn-raised pull-right btn-md"><b>Save Order</b></button></form></div></div></div><div class="col-lg-12 col-md-12 col-sm-12" style="z-index: 100;" ng-show="type_export==\'deliverables\'"><div class="panel"><div class="panel-body"><h2 class="title-form font-weight-400">Deliverables</h2><h3 class="title-form">Inventory Banners</h3><form name="form2" ng-submit="saveOrder(form)" novalidate=""><div class="row"><div class="col-lg-12 col-md-12 col-sm-12"><div class="form-group mb-5"><input type="text" class="form-control" id="deliveryurl" name="deliveryurl" ng-model="order.deliverables.url" placeholder="Subject"></div></div></div><br><div class="row mb-10"><div class="col-lg-6 col-md-6"><div class="form-group"><label for="textarea01">For DFP implementation, distribute these tags</label> <textarea placeholder="" class="form-control" id="dfpsource" name="dfpsource" ng-model="order.deliverables.dfpsource"></textarea></div></div><div class="col-lg-6 col-md-6"><div class="form-group"><label for="textarea01">For Native implementation, distribute these tags</label> <textarea placeholder="" class="form-control" id="nativesource" name="nativesource" ng-model="order.deliverables.nativesource"></textarea></div></div></div><h3 class="title-form">Facebook Campaign</h3><div class="row"><div class="col-lg-12 col-md-12 col-sm-12"><div class="form-group mb-5"><input type="text" class="form-control" id="devfacebook" name="devfacebook" ng-model="order.deliverables.facebook" placeholder=""></div></div></div><br><h3>Email</h3><div class="row mb-10"><div class="col-lg-12 col-md-12"><div class="form-group"><textarea placeholder="" class="form-control" id="devemail" name="devemail" ng-model="order.deliverables.email"></textarea></div></div></div><h3>Report</h3><div class="row mb-10"><div class="col-lg-12 col-md-12"><div class="form-group"><textarea placeholder="" class="form-control" id="devreport" name="devreport" ng-model="order.deliverables.report"></textarea></div></div></div><button type="submit" style="padding-left:20px; padding-right:20px;" ng-disabled="!dealers.length" pb-style="top-line" class="btn btn-primary btn-raised pull-right btn-md"><b>Save Deliverys</b></button></form></div></div></div><div class="col-lg-12 col-md-12 col-sm-12" style="z-index: 100;" ng-show="type_export==\'requests\'"><div class="panel"><div class="panel-body" style="min-height: 350px;"><h1 style="font-weight: 400;">Request List</h1><form class="row form-inline searchdiff"><div class="form-group col-md-12 col-sm-12"><label>Search string</label> <input style="border-radius: 5px;" type="text" class="form-control" ng-model="searchdiff" id="searchdiff" placeholder="Search requets"></div></form><br><div class="row mb-10"><div class="col-lg-6 col-md-5 col-sm-4"><div class="btn-group btn-agroup pull-left type-btn"><label class="btn btn-primary" ng-model="statuses" ng-change="toggleStatus(\'all\')" uib-btn-radio="\'all\'"><span class="large">All</span> <span class="small">All</span></label> <label class="btn btn-primary" ng-model="statuses" ng-change="toggleStatus(\'progress\')" uib-btn-radio="\'progress\'"><span class="large">In Progress</span> <span class="small">Progress</span></label> <label class="btn btn-primary" ng-model="statuses" ng-change="toggleStatus(\'closed\')" uib-btn-radio="\'closed\'"><span class="large">Finished</span> <span class="small">Close</span></label></div></div><div class="col-lg-6 col-md-7 col-sm-8"><button type="button" ng-click="toggleExport(\'newrequest\', \'New Request\')" style="float: right; margin-top: 10px!important;" class="btn btn-primary btn-raised no-m"><b>New Request</b></button></div></div><br><div class="horizontal-scroll"><table class="table"><thead><tr><th><b>#</b></th><th>REQUEST TITLE</th><th class="align-center">STATUS</th><th class="align-center hidden-sm hidden-xs">CREATION DATE</th><th class="align-center hidden-sm hidden-xs">LAST MODIFIED</th><th class="align-center">REMOVE</th></tr></thead><tbody><tr ng-click="getRequest(request)" ng-repeat="request in requests | filter:customFilter" style="cursor: pointer;"><td>{{$index + 1}}</td><td>{{request.title}}</td><td class="align-center"><span ng-if="request.status==\'progress\'">In Progress</span> <span ng-if="request.status==\'closed\'">Closed</span></td><td class="align-center hidden-sm hidden-xs">{{request.created_at | date:"medium"}}</td><td class="align-center hidden-sm hidden-xs">{{request.updated_at | date:"medium"}}</td><td class="align-center"><i class="chart-icon ion-close" style="color: #EE6D60;" ng-click="$event.stopPropagation();openConfirm(request)"></i></td></tr></tbody></table></div></div></div></div><div class="col-lg-12 col-md-12 col-sm-12" style="z-index: 100;" ng-show="type_export==\'newrequest\'"><div class="panel"><div class="panel-body"><h2 class="title-form font-weight-400">Request</h2><form name="form5" ng-submit="saveRequest(form5)" novalidate=""><div class="row"><div class="col-lg-6 col-md-6 col-sm-6"><div class="form-group mb-5"><label for="textarea01">Title</label> <input type="text" class="form-control" id="titlerequest" name="titlerequest" ng-model="request.title" ng-required="true" placeholder=""></div></div><div class="col-lg-6 col-md-6 col-sm-5"><div class="form-group mb-5"><label>Status</label><selectize config="configSingleOne" placeholder="Select status" options="status" ng-model="request.status"></selectize></div></div></div><br><div class="row mb-10"><div class="col-lg-6 col-md-6"><div class="form-group"><label for="textarea01">Comments</label> <textarea placeholder="" class="form-control" id="comments" name="comments" ng-model="request.comments" ng-required="true"></textarea></div></div><div class="col-lg-6 col-md-6"><span>Upload Files (Max 100mb)</span><div class="upload-box"><button type="button" style="float: left;" class="btn btn-primary btn-raised" ng-click="uploadFile(\'requests\')"><b>Upload</b></button> <input type="file" ng-show="false" id="requests" ng-file-select="onFileSelect($files)" item="requests"><div class="center-ripple" ng-show="fileload"><div class="lds-ripple" style="position: absolute; margin-top: -10px;"><div></div><div></div></div></div><span ng-repeat="file in request.files" class="file-attach"><a href="{{file.url}}">{{file.name}} {{file.size | Filesize}}</a></span></div></div></div><br><button type="submit" style="padding-left:20px; padding-right:20px;" ng-disabled="form5.$invalid" pb-style="top-line" class="btn btn-primary btn-raised pull-right btn-md"><b ng-if="!req_update">Send</b> <b ng-if="req_update">Update</b></button> <button type="button" style="margin-right: 20px; padding-left:20px; padding-right:20px;" ng-if="req_update" ng-click="cancelRequest()" pb-style="top-line" class="btn btn-primary btn-raised pull-right btn-md"><b>Cancel</b></button></form></div></div></div></div></div>');
$templateCache.put('app/pages/export/editor/index.html','<div class="row"><div class="col-lg-12 col-md-12 col-sm-12" style="z-index: 100;" ba-panel="" ba-panel-title="Editor Template - Select Options" ba-panel-class=""><div ng-show="!create" id="iframe-container"><div class="row"><div class="col-lg-3 col-md-3 col-sm-3"><h3 class="pull-left">Template: <b>{{template.name}}</b></h3></div><div class="col-lg-6 col-md-6 col-sm-6"><button type="button" class="btn btn-primary btn-with-icon pull-left" ng-click="reload()"><i class="ion-refresh"></i> Reload</button></div><div class="col-lg-3 col-md-3 col-sm-3"><button type="button" class="btn btn-primary btn-with-icon pull-right" ng-click="goBackTemp()"><i class="ion-ios-compose"></i> Select Templates</button> <button type="button" class="btn btn-primary btn-with-icon pull-right" style="margin-right: 10px;" ng-click="goBack()"><i class="ion-ios-compose"></i> Choose Dealers</button></div></div><div class="row mt-10"><div id="menu-frame" class="col-lg-3 col-md-3 col-sm-12"><uib-tabset style="margin-top: 10px" active="$tabSetStatus.activeTab2" ng-if="template.ttype == \'dynamic\'"><uib-tab classes="tools-iframe" heading="Editor Tools"><div class="custom-tab-1" id="custom-tab-1" style="margin-left: -15px; margin-right: -15px;"><form name="form" style="padding: 10px; padding-top: 0;"><h4>Banners</h4><div class="row"><div class="col-sm-6 col-md-6 no-pr"><div class="form-group"><label for="inputFirstName">Select Background</label><color-picker options="options" ng-model="template.sec_color"></color-picker></div></div><div class="col-sm-6 col-md-6 no-pr"><div class="form-group"><label for="inputFirstName">Main Title</label><color-picker options="options" ng-model="template.extras.title_color"></color-picker></div></div></div><div class="row"><div class="col-sm-6 col-md-6"><label>Border Color</label><color-picker options="options" ng-model="template.extras.pages[0].item_border_color"></color-picker></div></div><h4>Banner 970x250</h4><div class="slider-box"><h5>Title</h5><div class="row"><div class="col-sm-6 col-md-6"><label>Text Color</label><color-picker options="options" ng-model="template.extras.pages[0].banner_970x250.title_color"></color-picker></div><div class="col-sm-6 col-md-6"></div></div></div><div class="slider-box"><h5>Sub Title</h5><div class="row"><div class="col-sm-6 col-md-6"><label>Text Color</label><color-picker options="options" ng-model="template.extras.pages[0].banner_970x250.subtitle_color"></color-picker></div><div class="col-sm-6 col-md-6"><div class="form-group"><label>Background Color</label><color-picker options="options" ng-model="template.extras.pages[0].banner_970x250.subtitle_bg"></color-picker></div></div></div></div><div class="slider-box"><h5>Third Title</h5><div class="row"><div class="col-sm-6 col-md-6"><label>Text Color</label><color-picker options="options" ng-model="template.extras.pages[0].banner_970x250.thirdtitle_color"></color-picker></div><div class="col-sm-6 col-md-6"><div class="form-group"><label>Background Color</label><color-picker options="options" ng-model="template.extras.pages[0].banner_970x250.thirdtitle_bg"></color-picker></div></div></div></div><h4>Banner 728x90</h4><div class="slider-box"><div class="row"><div class="col-sm-6 col-md-6"><label>Title Color</label><color-picker options="options" ng-model="template.extras.pages[0].banner_728x90.title_color"></color-picker></div><div class="col-sm-6 col-md-6"><label>Sub Title Color</label><color-picker options="options" ng-model="template.extras.pages[0].banner_728x90.subtitle_color"></color-picker></div></div></div><div class="slider-box"><div class="row"><div class="col-sm-6 col-md-6"><label>Third Title Color</label><color-picker options="options" ng-model="template.extras.pages[0].banner_728x90.thirdtitle_color"></color-picker></div></div></div><h4>Banner 300x600</h4><div class="slider-box"><h5>Title</h5><div class="row"><div class="col-sm-6 col-md-6"><label>Text Color</label><color-picker options="options" ng-model="template.extras.pages[0].banner_300x600.title_color"></color-picker></div><div class="col-sm-6 col-md-6"></div></div></div><div class="slider-box"><h5>Sub Title</h5><div class="row"><div class="col-sm-6 col-md-6"><label>Text Color</label><color-picker options="options" ng-model="template.extras.pages[0].banner_300x600.subtitle_color"></color-picker></div><div class="col-sm-6 col-md-6"><div class="form-group"><label>Background Color</label><color-picker options="options" ng-model="template.extras.pages[0].banner_300x600.subtitle_bg"></color-picker></div></div></div></div><div class="slider-box"><h5>Third Title</h5><div class="row"><div class="col-sm-6 col-md-6"><label>Text Color</label><color-picker options="options" ng-model="template.extras.pages[0].banner_300x600.thirdtitle_color"></color-picker></div><div class="col-sm-6 col-md-6"><div class="form-group"><label>Background Color</label><color-picker options="options" ng-model="template.extras.pages[0].banner_300x600.thirdtitle_bg"></color-picker></div></div></div></div><h4>Banner 300x250</h4><div class="slider-box"><div class="row"><div class="col-sm-6 col-md-6"><label>Title Color</label><color-picker options="options" ng-model="template.extras.pages[0].banner_300x250.title_color"></color-picker></div><div class="col-sm-6 col-md-6"><label>Sub Title Color</label><color-picker options="options" ng-model="template.extras.pages[0].banner_300x250.subtitle_color"></color-picker></div></div></div><div class="slider-box"><div class="row"><div class="col-sm-6 col-md-6"><label>Third Title Color</label><color-picker options="options" ng-model="template.extras.pages[0].banner_300x250.thirdtitle_color"></color-picker></div><div class="col-sm-6 col-md-6"></div></div></div><h4>Reverse / Email Template</h4><div class="slider-box"><h5>Title</h5><div class="row"><div class="col-sm-6 col-md-6"><label>Text Color</label><color-picker options="options" ng-model="template.extras.pages[1].title_color"></color-picker></div><div class="col-sm-6 col-md-6"><div class="form-group"><label>Background Color</label><color-picker options="options" ng-model="template.extras.pages[1].title_bg"></color-picker></div></div></div></div><div class="slider-box"><h5>Sub Title</h5><div class="row"><div class="col-sm-6 col-md-6"><label>Text Color</label><color-picker options="options" ng-model="template.extras.pages[1].subtitle_color"></color-picker></div><div class="col-sm-6 col-md-6"><div class="form-group"><label>Background Color</label><color-picker options="options" ng-model="template.extras.pages[1].subtitle_bg"></color-picker></div></div></div></div><div class="slider-box"><h5>Third Title</h5><div class="row"><div class="col-sm-6 col-md-6"><label>Text Color</label><color-picker options="options" ng-model="template.extras.pages[1].thirdtitle_color"></color-picker></div><div class="col-sm-6 col-md-6"><div class="form-group"><label>Background Color</label><color-picker options="options" ng-model="template.extras.pages[1].thirdtitle_bg"></color-picker></div></div></div></div></form></div></uib-tab><uib-tab classes="tools-iframe" heading="Set Solution Images"><div class="row"><div class="col-sm-12 col-md-12"><button class="btn btn-primary btn-sm btn-block" ng-click="uploadPictureSolution(\'banner_970x250\')">Banner 970x250</button> <img style="margin-top: 10px; margin-bottom: 10px" ng-src="{{template.images.banner_970x250}}" id="img_banner_970x250" class="img-responsive"></div><input type="file" ng-show="false" id="banner_970x250" ng-file-select="onFileSelect($files)" item="banner_970x250"></div><br><div class="row"><div class="col-sm-12 col-md-12"><button class="btn btn-primary btn-sm btn-block" ng-click="uploadPictureSolution(\'banner_728x90\')">Banner 728x90</button> <img style="margin-top: 10px; margin-bottom: 10px" ng-src="{{template.images.banner_728x90}}" id="img_banner_728x90" class="img-responsive"></div><input type="file" ng-show="false" id="banner_728x90" ng-file-select="onFileSelect($files)" item="banner_728x90"></div><br><div class="row"><div class="col-sm-12 col-md-12"><button class="btn btn-primary btn-sm btn-block" ng-click="uploadPictureSolution(\'banner_300x600\')">Banner 300x600</button> <img style="margin-top: 10px; margin-bottom: 10px" ng-src="{{template.images.banner_300x600}}" id="img_banner_300x600" class="img-responsive"></div><input type="file" ng-show="false" id="banner_300x600" ng-file-select="onFileSelect($files)" item="banner_300x600"></div><br><div class="row"><div class="col-sm-12 col-md-12"><button class="btn btn-primary btn-sm btn-block" ng-click="uploadPictureSolution(\'banner_300x250\')">Banner 300x250</button> <img style="margin-top: 10px; margin-bottom: 10px" ng-src="{{template.images.banner_300x250}}" id="img_banner_300x250" class="img-responsive"></div><input type="file" ng-show="false" id="banner_300x250" ng-file-select="onFileSelect($files)" item="banner_300x250"></div><br><div class="row"><div class="col-sm-12 col-md-12"><button class="btn btn-primary btn-sm btn-block" ng-click="uploadPictureSolution(\'email_header\')">Email Header</button> <img style="margin-top: 10px; margin-bottom: 10px" ng-src="{{template.images.email_header}}" id="img_email_header" class="img-responsive"></div><input type="file" ng-show="false" id="email_header" ng-file-select="onFileSelect($files)" item="email_header"></div><br><div class="row"><div class="col-sm-12 col-md-12"><button class="btn btn-primary btn-sm btn-block" ng-click="uploadPictureSolution(\'email_footer\')">Email Footer</button> <img style="margin-top: 10px; margin-bottom: 10px" ng-src="{{template.images.email_footer}}" id="img_email_footer" class="img-responsive"></div><input type="file" ng-show="false" id="email_footer" ng-file-select="onFileSelect($files)" item="email_footer"></div><br><div class="row"><div class="col-sm-12 col-md-12"><button class="btn btn-primary btn-sm btn-block" ng-click="uploadPictureSolution(\'reverse_header\')">Reverse Header</button> <img style="margin-top: 10px; margin-bottom: 10px" ng-src="{{template.images.reverse_header}}" id="img_reverse_header" class="img-responsive"></div><input type="file" ng-show="false" id="reverse_header" ng-file-select="onFileSelect($files)" item="reverse_header"></div><br><div class="row"><div class="col-sm-12 col-md-12"><button class="btn btn-primary btn-sm btn-block" ng-click="uploadPictureSolution(\'reverse_footer\')">Reverse Footer</button> <img style="margin-top: 10px; margin-bottom: 10px" ng-src="{{template.images.reverse_footer}}" id="img_reverse_footer" class="img-responsive"></div><input type="file" ng-show="false" id="reverse_footer" ng-file-select="onFileSelect($files)" item="reverse_footer"></div></uib-tab></uib-tabset><uib-tabset style="margin-top: 10px" active="$tabSetStatus.activeTab2" ng-if="template.ttype != \'dynamic\'"><uib-tab classes="tools-iframe" heading="Editor Tools"><div class="custom-tab-1" id="custom-tab-1" style="margin-left: -15px; margin-right: -15px;"><form name="form"><h4>Page</h4><div class="row"><div class="col-sm-6 col-md-6 no-pr"><div class="form-group"><label for="inputFirstName">Select Color</label><color-picker options="options" ng-model="template.page_bg"></color-picker></div></div></div><div class="row"><div class="col-sm-6 col-md-6"><div class="form-group"><label for="inputFirstName">Width "</label> <input type="number" string-to-number="" class="form-control input-sm" id="inputFirstName" ng-model="template.size_w" placeholder="Inch"></div></div><div class="col-md-6"><div class="form-group"><label for="inputLastName">Height "</label> <input type="number" string-to-number="" class="form-control input-sm" ng-model="template.size_h" ng-model-options="{ debounce: 1000 }" id="inputLastName" placeholder="Inch"></div></div></div><div class="row"><div class="col-md-6"><div class="form-group"><label for="inputLastName">Item on rows</label> <input type="number" string-to-number="" class="form-control input-sm" ng-model="template.item_by_page" ng-model-options="{ debounce: 1000 }" id="inputLastName" placeholder=""></div></div><div class="col-sm-6 col-md-6 no-pr"><div class="form-group"><label for="inputLastName">Show Dealers</label><br><ba-switcher switcher-style="primary" switcher-value="template.sec_col"></ba-switcher></div></div></div><h4>Header</h4><div class="row"><div class="col-sm-3 col-md-3 no-pr"><div class="form-group"><label for="inputFirstName">Width %</label> <input type="number" string-to-number="" class="form-control input-sm input-sm" id="inputFirstName" ng-model="template.header_w" placeholder="px"></div></div><div class="col-md-3 no-pr"><div class="form-group"><label for="inputLastName">Height px</label> <input type="number" string-to-number="" class="form-control input-sm input-sm" ng-model="template.header_h" id="inputLastName" placeholder="px"></div></div><div class="col-sm-6 col-md-6"><div class="form-group"><label for="colorSet">Select Color</label><color-picker options="options" ng-model="template.header_color"></color-picker></div></div></div><div class="row"><div class="col-sm-12 col-md-12"><button class="btn btn-primary btn-sm btn-block" ng-click="uploadPictureHeader()"><i class="ion-upload"></i> Upload new header image</button> <input type="file" ng-show="false" id="fileHeader" ng-file-select="onFileSelect($files)" item="header"></div></div><br><h4>Footer</h4><div class="row"><div class="col-sm-3 col-md-3 no-pr"><div class="form-group"><label for="inputFirstName">Width %</label> <input type="number" string-to-number="" class="form-control input-sm input-sm" id="inputFirstName" ng-model="template.footer_w" placeholder="px"></div></div><div class="col-sm-3 col-md-3 no-pr"><div class="form-group"><label for="inputLastName">Height px</label> <input type="number" string-to-number="" class="form-control input-sm input-sm" ng-model="template.footer_h" id="inputLastName" placeholder="px"></div></div><div class="col-sm-6 col-md-6 no-pr"><div class="form-group"><label for="inputFirstName">Select Color</label><color-picker options="options" ng-model="template.footer_color"></color-picker></div></div></div><div class="row"><div class="col-sm-12 col-md-12"><button class="btn btn-primary btn-sm btn-block" ng-click="uploadPictureFooter()">Upload new footer image</button> <input type="file" ng-show="false" id="fileFooter" ng-file-select="onFileSelect($files)" item="footer"></div></div><uib-tabset style="margin-top: 10px" active="$tabSetStatus.activeTab"><uib-tab classes="tools-iframe" heading="{{!template.hybrid && \'Template Options\' || \'Mosaic Dealers\'}}"><div class="custom-tab-1" id="custom-tab-1" style="margin-left: -15px; margin-right: -15px;"><h4>Dealers Container {{(!template.hybrid && \'Options\') || \'(Mosaic)\'}}</h4><div class="row"><div class="col-sm-3 col-md-3 no-pr"><div class="form-group"><label for="inputFirstName">Width px</label> <input type="number" string-to-number="" class="form-control input-sm input-sm" id="inputFirstName" ng-model="template.sec_w" placeholder="px"></div></div><div class="col-sm-3 col-md-3 no-pr"><div class="form-group"><label for="inputLastName">Height px</label> <input type="number" string-to-number="" class="form-control input-sm input-sm" ng-model="template.sec_h" id="inputLastName" placeholder="px"></div></div><div class="col-sm-6 col-md-6"><div class="form-group"><label for="inputFirstName">Select Color</label><color-picker options="options" ng-model="template.sec_color"></color-picker></div></div></div><h4>Cars Container Options</h4><div class="row"><div class="col-sm-6 col-md-6 no-pr"><div class="form-group"><label for="inputFirstName">Width px</label> <input type="number" string-to-number="" class="form-control input-sm input-sm" id="inputFirstName" ng-model="template.item_w" placeholder="px"></div></div><div class="col-md-6 no-pr"><div class="form-group"><label for="inputLastName">Height px</label> <input type="number" string-to-number="" class="form-control input-sm input-sm" ng-model="template.item_h" id="inputLastName" placeholder="auto"></div></div></div><div class="row"><div class="col-sm-6 col-md-6 no-pr"><div class="form-group"><label for="inputFirstName">Padding T-B px</label> <input type="number" string-to-number="" class="form-control input-sm input-sm" id="inputFirstName" ng-model="template.item_pt" placeholder="px"></div></div><div class="col-sm-6 col-md-6"><div class="form-group"><label for="inputFirstName">Select Color</label><color-picker options="options" ng-model="template.item_color"></color-picker></div></div></div><div class="slider-box"><h5>Title</h5><div class="row"><div class="col-sm-6 col-md-6"><label style="font-weight:normal;">Text Color</label><color-picker options="options" ng-model="template.item_title_color"></color-picker></div><div class="col-sm-6 col-md-6"><div class="form-group"><label>Background Color</label><color-picker options="options" ng-model="template.item_title_bg"></color-picker></div></div></div><div class="row"><div class="col-sm-6 col-md-6"><ion-slider type="single" grid="false" min="8" max="128" on-finish="rangeFinishTitle" from="template.item_title_size" disable="false"></ion-slider></div><div class="col-sm-6 col-md-6"><div class="form-group"><label for="inputFirstName">Position px</label> <input type="number" string-to-number="" class="form-control input-sm input-sm" id="inputFirstName" ng-model="template.item_title_top" placeholder="px"></div></div></div></div><div class="slider-box"><h5 class="mt-10">Sub Title</h5><div class="row"><div class="col-sm-6 col-md-6"><div class="form-group"><label>Text Color</label><color-picker options="options" ng-model="template.item_subtitle_color"></color-picker></div></div><div class="col-sm-6 col-md-6"><div class="form-group"><label>Background Color</label><color-picker options="options" ng-model="template.item_subtitle_bg"></color-picker></div></div></div><div class="row"><div class="col-sm-6 col-md-6"><ion-slider type="single" grid="false" min="8" max="128" on-finish="rangeFinishSubtitle" from="template.item_subtitle_size" disable="false"></ion-slider></div><div class="col-sm-6 col-md-6"><div class="form-group"><label for="inputFirstName">Position px</label> <input type="number" string-to-number="" class="form-control input-sm input-sm" id="inputFirstName" ng-model="template.item_subtitle_top" placeholder="px"></div></div></div></div><div class="slider-box"><h5 class="mt-10">Third Title</h5><div class="row"><div class="col-sm-6 col-md-6 no-pr"><div class="form-group"><label for="inputFirstName">Text Color</label><color-picker options="options" ng-model="template.item_extxt_color"></color-picker></div></div><div class="col-sm-6 col-md-6"><div class="form-group"><label for="inputFirstName">Background Color</label><color-picker options="options" ng-model="template.item_extxt_bg"></color-picker></div></div></div><div class="row"><div class="col-sm-6 col-md-6"><ion-slider type="single" grid="false" min="8" max="128" on-finish="rangeFinishExtitle" from="template.item_extxt_size" disable="false"></ion-slider></div><div class="col-sm-6 col-md-6"><div class="form-group"><label for="inputFirstName">Position px</label> <input type="number" string-to-number="" class="form-control input-sm input-sm" id="inputFirstName" ng-model="template.item_extxt_top" placeholder="px"></div></div></div></div></div></uib-tab><uib-tab heading="Linear Dealers" ng-show="template.hybrid"><div class="custom-tab-1" id="custom-tab-1" style="margin-left: -15px; margin-right: -15px;"><h4>Dealers Container (Linear)</h4><div class="row"><div class="col-md-6 no-pr"><div class="form-group"><label for="inputLastName">Height</label> <input type="number" string-to-number="" class="form-control input-sm input-sm" ng-model="template.sec_v" id="inputLastName" placeholder="auto"></div></div><div class="col-sm-6 col-md-6"><div class="form-group"><label for="inputFirstName">Select Color</label><color-picker options="options" ng-model="template.section_color2"></color-picker></div></div></div><div class="row"><div class="col-sm-6 col-md-6"><label style="font-weight:normal;">Text Color</label><color-picker options="options" ng-model="template.section_title_color2"></color-picker></div><div class="col-sm-6 col-md-6"><div class="form-group"><label>Background Color</label><color-picker options="options" ng-model="template.section_title_bg2"></color-picker></div></div></div><div class="row"><div class="col-sm-12 col-md-12"><ion-slider type="single" grid="false" min="8" max="128" on-finish="rangeFinishSectionTitle2" from="template.section_title_size2" disable="false"></ion-slider></div></div><br><div class="row"><div class="col-sm-12 col-md-12"><button class="btn btn-primary btn-sm btn-block" ng-click="uploadPictureSection()"><i class="ion-upload"></i> Upload new dealer image</button> <input type="file" ng-show="false" id="fileSection" ng-file-select="onFileSelect($files)" item="section"></div></div><br><h4>Cars Container Options</h4><div class="row"><div class="col-md-6 no-pr"><div class="form-group"><label for="inputLastName">Height</label> <input type="number" string-to-number="" class="form-control input-sm input-sm" ng-model="template.item_v" id="inputLastName" placeholder="auto"></div></div><div class="col-sm-6 col-md-6"><div class="form-group"><label for="inputFirstName">Select Color</label><color-picker options="options" ng-model="template.item_color2"></color-picker></div></div></div><div class="slider-box"><h5>Title</h5><div class="row"><div class="col-sm-6 col-md-6"><label style="font-weight:normal;">Text Color</label><color-picker options="options" ng-model="template.item_title_color2"></color-picker></div><div class="col-sm-6 col-md-6"><div class="form-group"><label>Background Color</label><color-picker options="options" ng-model="template.item_title_bg2"></color-picker></div></div></div><div class="row"><div class="col-sm-12 col-md-12"><ion-slider type="single" grid="false" min="8" max="128" on-finish="rangeFinishTitle2" from="template.item_title_size2" disable="false"></ion-slider></div></div></div><div class="slider-box"><h5 class="mt-10">Sub Title</h5><div class="row"><div class="col-sm-6 col-md-6"><div class="form-group"><label>Text Color</label><color-picker options="options" ng-model="template.item_subtitle_color2"></color-picker></div></div><div class="col-sm-6 col-md-6"><div class="form-group"><label>Background Color</label><color-picker options="options" ng-model="template.item_subtitle_bg2"></color-picker></div></div></div><div class="row"><div class="col-sm-12 col-md-12"><ion-slider type="single" grid="false" min="8" max="128" on-finish="rangeFinishSubtitle2" from="template.item_subtitle_size2" disable="false"></ion-slider></div></div></div><div class="slider-box"><h5 class="mt-10">Third Title</h5><div class="row"><div class="col-sm-6 col-md-6 no-pr"><div class="form-group"><label for="inputFirstName">Text Color</label><color-picker options="options" ng-model="template.item_extxt_color2"></color-picker></div></div><div class="col-sm-6 col-md-6"><div class="form-group"><label for="inputFirstName">Background Color</label><color-picker options="options" ng-model="template.item_extxt_bg2"></color-picker></div></div></div><div class="row"><div class="col-sm-12 col-md-12"><ion-slider type="single" grid="false" min="8" max="128" on-finish="rangeFinishExtitle2" from="template.item_extxt_size2" disable="false"></ion-slider></div></div></div></div><br></uib-tab></uib-tabset><div class="slider-box"><h5 class="mt-10">Separator</h5><div class="row"><div class="col-sm-6 col-md-6 no-pr"><ion-slider type="single" grid="false" min="0" max="15" on-finish="rangeFinishSeparator" from="template.sep_h" disable="false"></ion-slider></div><div class="col-sm-6 col-md-6 mt-10"><div class="form-group"><color-picker options="options" ng-model="template.sep_color"></color-picker></div></div></div></div></form></div></uib-tab><uib-tab classes="tools-iframe" heading="Set Dealer Image"><div class="row"><div class="col-sm-12 col-md-12" ng-repeat="section in sections"><button class="btn btn-primary btn-sm btn-block" ng-click="uploadPictureDealer(section.id)">Image for {{section.name}}</button> <img style="margin-top: 10px; margin-bottom: 10px" ng-src="{{section.section_image}}" id="dealer_image{{section.id}}" class="img-responsive"></div><input type="file" ng-show="false" id="sectionImage" ng-file-select="onFileSelect($files)" item="sectionImage"></div></uib-tab></uib-tabset></div><div class="col-lg-9 col-md-9 col-sm-12"><div class="h_iframe"><iframe name="Tester" height="1060" ng-src="{{pdfUrl | trustAsResourceUrl}}"></iframe></div></div></div></div><div ng-show="create"><div class="row"><div class="col-lg-12 col-md-12 col-sm-12"><form name="form"><div class="row"><div class="col-lg-6 col-md-6 col-sm-6"><h3 class="pull-left">Create new template</h3></div><div class="col-lg-6 col-md-6 col-sm-6"><button type="button" class="btn btn-primary btn-with-icon pull-right" ng-click="goBack2()"><i class="ion-ios-compose"></i> <b>Go Back</b></button></div></div><div class="form-group"><label for="inputLastName">Enter name</label> <input type="text" string-to-number="" class="form-control" ng-model="templateNew.name" id="inputLastName" placeholder="enter template name"></div><label for="inputLastName" style="font-weight: normal;">Select base template</label><div class="row pie-charts"><div ng-repeat="base in bases" style="cursor: pointer;" ng-click="selectTemplate(base.id)" class="pie-chart-item-container"><div class="icon-templ ion-ios-list-outline" style="text-align: center;" ng-class="{selectedTemp: base.id === selectedTemplate}"></div><label ng-class="{selectedTemp: base.id === selectedTemplate}" style="width: 100%;text-align: center;">{{base.name}}</label></div></div><div class="form-group mt-10"><button type="button" class="btn btn-primary btn-with-icon" ng-click="createTemplate()"><i class="ion-ios-compose"></i>Create Template</button></div></form></div></div></div></div><script type="text/javascript">\n  $(function () {\n      console.log($("#menu-frame").height());\n      $("#iframe-container iframe")[0].setAttribute("height", $("#menu-frame").height());      \n  });\n</script></div>');
$templateCache.put('app/pages/inventory/condChart/CondChart.html','<div class="channels-block" ng-class="{\'transparent\': transparent}"><div class="chart-bg"></div><div class="cond-chart" id="condChart"><div class="canvas-holder"><canvas id="chart-area" width="280" height="280"></canvas><div class="cond-text"></div></div></div><div><div><div class="row pl-50" ng-if="doughnutData.labels.length==1"><div class="col-lg-6 col-md-6 col-sm-6"><div class="legend-color" style="background-color: {{backcolor}}"></div><p>{{doughnutData.labels[0]}} {{doughnutData.datasets[0].percentage[0]}}%</p></div></div><div class="row pl-50" ng-if="doughnutData.labels.length==2"><div class="col-lg-6 col-md-6 col-sm-6"><div class="legend-color" style="background-color: {{::doughnutData.datasets[0].backgroundColor[0]}}"></div><p>{{doughnutData.labels[0]}} {{doughnutData.datasets[0].percentage[0]}}%</p></div><div class="col-lg-6 col-md-6 col-sm-6"><div class="legend-color" style="background-color: {{::doughnutData.datasets[0].backgroundColor[1]}}"></div><p>{{doughnutData.labels[1]}} <span class="channel-number">{{doughnutData.datasets[0].percentage[1]}}%</span></p></div></div></div></div></div>');
$templateCache.put('app/pages/modals/progressModal/progressModal.html','<div class="modal-content"><div class="modal-body"><progress-bar-round></progress-bar-round></div><div class="modal-footer"></div></div>');
$templateCache.put('app/pages/modals/modalTemplates/addSite.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" style="color: #000;" id="myModalLabel">{{title}}</h4></div><form name="form" id="sitectrl" novalidate="" ng-submit="addSite(form)"><div class="modal-body"><div class="row"><div class="col-md-12 no-margin"><div class="row"><div class="col-md-6"><div class="no-margin" ng-class="{ \'has-error\': form.host.$invalid && form.$submitted}"><div class="form-group"><label>URL Host</label><div class="input-group"><input type="text" name="host" ng-model="item.host" class="form-control" placeholder="Host - Eg. sample.com" required="" autofocus=""></div></div></div></div><div class="col-md-6"><div class="no-margin" ng-class="{ \'has-error\': form.sversion.$invalid && form.$submitted}"><div class="form-group"><label>Choose Version (Connection)</label><select id="optionsSelect" disabled="" class="form-control" ng-model="item.sversion" ng-options="option.value as option.label for option in versions"></select></div></div></div></div><div class="row"><div class="col-md-5"><div class="no-margin" ng-class="{ \'has-error\': form.name.$invalid && form.$submitted}"><div class="form-group"><label>Database name</label><div class="input-group"><input type="text" name="name" ng-model="item.name" class="form-control" ng-disabled="disabling" placeholder="Name Database - Eg. sample_ads" required=""></div></div></div></div><div class="col-md-5" style="padding-right: 0;"><div class="no-margin" ng-class="{ \'has-error\': form.alias.$invalid && form.$submitted}"><div class="form-group"><label>Alias</label><div class="input-group"><input type="text" name="alias" ng-model="item.alias" class="form-control" placeholder="Alias - Eg. sample" required=""></div></div></div></div><div class="col-md-2"><div class="form-group"><label>AI Reports</label> <button type="button" class="btn btn-sm btn-primary" style="width: 100%;" ng-model="item.export" uib-btn-checkbox="" btn-checkbox-true="true" btn-checkbox-false="false"><span class="text-white" ng-show="!item.export">Disabled</span> <span class="text-white" ng-show="item.export">Enabled</span></button></div></div></div><div ng-show="item.export && item.sversion == \'3.x\'" class="layout-aireports"><div class="row"><div class="col-md-5"><div class="no-margin"><div class="form-group"><label>Schedule - AI Reports</label><div class="input-group"><span class="input-group-addon"><i class="ion-clock"></i></span> <input type="text" name="cron" ng-model="item.cron" class="form-control" placeholder="* * * * *" ng-required="item.export && item.sversion == \'3.x\'"></div><p class="help-block">Example cron expression: 0 12 * * ? (Daily at noon)</p></div></div></div><div class="col-md-5"><div class="no-margin"><div class="form-group"><label>Group</label><div class="input-group"><input type="text" name="report" ng-model="item.report" class="form-control" placeholder="User group"></div></div></div></div></div></div></div></div><div class="row"><div class="col-md-12"><h4>Setting Global Scope</h4><json-tree json="item.settings"></json-tree><br><br><h4>Setting Site Scope</h4><json-tree json="item.extras"></json-tree><br><br></div></div><div class="row modal-site"><div class="col-md-12"><uib-accordion close-others="oneAtATime" ng-show="disabling"><uib-accordion-group is-disabled="true" is-open="status.open"><uib-accordion-heading><h4>Micro Sites</h4><i class="pull-right glyphicon" ng-click="status.open= (status.open)?0:1;" ng-class="{\'glyphicon-chevron-down\': status.open, \'glyphicon-chevron-right\': !status.open}"></i> <input type="button" value="Add new" class="pull-right btn btn-sm btn-default button-add-item" ng-click="addPromo(true)"></uib-accordion-heading><div class="widget"><div class="widget-body small white no-padding complements-table" style="clear: both;"><div class="widget-content"><div class="table-responsive ng-scope"><table class="table"><thead><tr><th style="max-width: 50px;">Id</th><th>Name</th><th>Group</th><th style="width: 50px;">AI Reports</th><th class="text-center">Delete</th></tr></thead><tbody><tr ng-repeat="elem in item.promotions" ng-click="selPromo(elem)"><td style="max-width: 50px;"><input type="text" style="max-width: 50px;" name="idpro" ng-model="elem.id" placeholder="Id" class="input-xpath" required=""></td><td><input type="text" name="namepro" ng-model="elem.name" placeholder="Name" class="input-xpath" required=""></td><td><input type="text" name="group" ng-model="elem.group" placeholder="Group" class="input-xpath" required=""></td><td><button type="button" class="btn btn-sm btn-primary" style="float: right; width: 100%;" ng-model="elem.export" uib-btn-checkbox="" btn-checkbox-true="true" btn-checkbox-false="false"><span ng-show="elem.export">Disabled</span> <span ng-show="!elem.export">Enabled</span></button></td><td class="text-center"><ion-icon ng-click="delPromo(elem)" style="font-size: 2.5em; cursor:pointer" class="ion-ios-close"></ion-icon></td></tr></tbody></table></div></div></div></div></uib-accordion-group></uib-accordion></div></div><div class="row"><div class="col-md-12"><h4 ng-show="!isObjectEmpty(microextras)">Access Admin Site</h4><json-tree ng-show="!isObjectEmpty(microextras)" json="microextras"></json-tree></div></div></div><div class="modal-footer"><br><button type="submit" class="btn btn-primary">Save Site</button></div></form></div>');
$templateCache.put('app/pages/modals/modalTemplates/basicModal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" id="myModalLabel">Modal title</h4></div><div class="modal-body">Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.</div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="$dismiss()">Save changes</button></div></div>');
$templateCache.put('app/pages/modals/modalTemplates/confirm.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" id="myModalLabel">Modal title</h4></div><div class="modal-body"></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="$dismiss()">Save changes</button></div></div>');
$templateCache.put('app/pages/modals/modalTemplates/customModal.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-android-warning modal-icon"></i><span>{{title}} <b>{{selectedItem.title}}?</b></span></div><div class="modal-body text-center">{{description}}</div><div class="modal-footer"><button type="button" class="btn bg-info" ng-click="close()">CLOSE</button> <button type="button" class="btn bg-info" ng-click="ok()">OK</button></div></div>');
$templateCache.put('app/pages/modals/modalTemplates/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Error</span></div><div class="modal-body text-center">Your information hasn\'t been saved!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$dismiss()">OK</button></div></div>');
$templateCache.put('app/pages/modals/modalTemplates/editorTemplate.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" id="myModalLabel">Editor Template</h4></div><div class="modal-body"></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="$dismiss()">Save changes</button></div></div>');
$templateCache.put('app/pages/modals/modalTemplates/infoModal.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Information</span></div><div class="modal-body text-center">You\'ve got a new email!</div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="$dismiss()">OK</button></div></div>');
$templateCache.put('app/pages/modals/modalTemplates/largeModal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title">Modal title</h4></div><div class="modal-body">Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.</div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="$dismiss()">Save changes</button></div></div>');
$templateCache.put('app/pages/modals/modalTemplates/smallModal.html','<div class="modal-content"><div class="modal-header" style="padding: 8px; background: #eee"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" style="text-align: center;">Select Target</h4></div><div class="modal-body" style="padding: 0"><table class="table table-hover"><tbody><tr ng-click="setGlobal({})" class="no-top-border item-table-md"><td style="text-align: justify;">Global Site</td></tr><tr ng-repeat="item in promotions" ng-click="setPromo(item)" class="no-top-border item-table-md"><td style="text-align: justify;">{{item.name}}</td></tr></tbody></table></div></div>');
$templateCache.put('app/pages/modals/modalTemplates/successModal.html','<div class="modal-content"><div class="modal-header bg-success"><i class="ion-checkmark modal-icon"></i><span>Success</span></div><div class="modal-body text-center">Your information has been saved successfully</div><div class="modal-footer"><button type="button" class="btn btn-success" ng-click="$dismiss()">OK</button></div></div>');
$templateCache.put('app/pages/modals/modalTemplates/warningModal.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-android-warning modal-icon"></i><span>Delete {{title}} <b>{{selectedItem.name}}?</b></span></div><div class="modal-body text-center">All {{title}} data will be lost!</div><div class="modal-footer"><button type="button" class="btn bg-info" ng-click="close()">CLOSE</button> <button type="button" class="btn bg-info" ng-click="ok()">OK</button></div></div>');
$templateCache.put('app/theme/components/baSidebar/ba-sidebar.html','<aside class="al-sidebar" ng-swipe-right="$baSidebarService.setMenuCollapsed(false)" ng-swipe-left="$baSidebarService.setMenuCollapsed(true)" ng-mouseleave="hoverElemTop=selectElemTop"><ul class="al-sidebar-list" slimscroll="{height: \'{{menuHeight}}px\'}" slimscroll-watch="menuHeight"><li ng-repeat="item in ::menuItems" class="al-sidebar-list-item" ng-class="::{\'with-sub-menu\': item.subMenu}" ui-sref-active="selected" ba-sidebar-toggling-item="item"><a ng-mouseenter="hoverItem($event, item)" ui-state="item.stateRef || \'\'" ng-href="{{::(item.fixedHref ? item.fixedHref: \'\')}}" ng-if="::!item.subMenu && item.title==\'Dashboard\'" class="al-sidebar-list-link"><i class="{{ ::item.icon }}"></i><span>{{ ::item.title }}</span></a><a ng-mouseenter="hoverItem($event, item)" ng-click="selecSite($event)" ui-state="item.stateRef || \'\'" ng-hide="extras.permissions.inventory===false && group_name != \'root\'" ng-href="{{::(item.fixedHref ? item.fixedHref: \'\')}}" ng-if="::!item.subMenu && item.title==\'Inventory Comparison\'" class="al-sidebar-list-link" ng-show="export"><i class="{{ ::item.icon }}"></i><span>{{ ::item.title }}</span></a> <a ng-mouseenter="hoverItem($event, item)" ng-click="selecSite($event)" ui-state="item.stateRef || \'\'" ng-hide="extras.permissions.sales===false && group_name != \'root\'" ng-href="{{::(item.fixedHref ? item.fixedHref: \'\')}}" ng-if="::!item.subMenu && item.title==\'Sales\'" class="al-sidebar-list-link" ng-show="export"><i class="{{ ::item.icon }}"></i><span>{{ ::item.title }}</span></a> <a ng-mouseenter="hoverItem($event, item)" ng-click="selecSite($event)" ui-state="item.stateRef || \'\'" ng-href="{{::(item.fixedHref ? item.fixedHref: \'\')}}" ng-if="::!item.subMenu && item.title==\'Work Orders\'" class="al-sidebar-list-link" ng-hide="extras.permissions.workorders===false && group_name != \'root\'"><i class="{{ ::item.icon }}"></i><span>{{ ::item.title }}</span></a> <a ng-mouseenter="hoverItem($event, item)" ng-click="selecSite($event)" ui-state="item.stateRef || \'\'" ng-href="{{::(item.fixedHref ? item.fixedHref: \'\')}}" ng-if="::!item.subMenu && item.title==\'Benchmark\'" ng-hide="extras.permissions.benchmark===false && group_name != \'root\'" class="al-sidebar-list-link" ng-show="metrics"><i class="{{ ::item.icon }}"></i><span>{{ ::item.title }}</span></a> <a ng-mouseenter="hoverItem($event, item)" ng-click="selecSite($event)" ui-state="item.stateRef || \'\'" ng-href="{{::(item.fixedHref ? item.fixedHref: \'\')}}" ng-if="::!item.subMenu && item.title==\'Reverse Publishing\'" ng-hide="extras.permissions.reverse===false && group_name != \'root\'" class="al-sidebar-list-link" ng-show="export"><i class="{{ ::item.icon }}"></i><span>{{ ::item.title }}</span></a> <a ng-mouseenter="hoverItem($event, item)" ng-click="selecSite($event)" ui-state="item.stateRef || \'\'" ng-href="{{::(item.fixedHref ? item.fixedHref: \'\')}}" ng-if="::!item.subMenu && item.title==\'Demos\'" class="al-sidebar-list-link" ng-hide="extras.permissions.demos===false && group_name != \'root\'"><i class="{{ ::item.icon }}"></i><span>{{ ::item.title }}</span></a> <a ng-mouseenter="hoverItem($event, item)" ng-click="selecSite($event)" ui-state="item.stateRef || \'\'" ng-href="{{::(item.fixedHref ? item.fixedHref: \'\')}}" ng-if="::!item.subMenu && item.title==\'Settings\'" class="al-sidebar-list-link" ng-show="group_name == \'root\'"><i class="{{ ::item.icon }}"></i><span>{{ ::item.title }}</span></a><a ng-mouseenter="hoverItem($event, item)" ng-if="::item.subMenu" class="al-sidebar-list-link" ba-ui-sref-toggler=""><i class="{{ ::item.icon }}"></i><span>{{ ::item.title }}</span> <b class="fa fa-angle-down" ui-sref-active="fa-angle-up" ng-if="::item.subMenu"></b></a><ul ng-if="::item.subMenu" class="al-sidebar-sublist" ng-class="{\'slide-right\': item.slideRight}" ba-ui-sref-toggling-submenu=""><li ng-repeat="subitem in ::item.subMenu" ng-class="::{\'with-sub-menu\': subitem.subMenu}" ui-sref-active="selected" ba-sidebar-toggling-item="subitem" class="ba-sidebar-sublist-item"><a ng-mouseenter="hoverItem($event, item)" ng-if="::subitem.subMenu" ba-ui-sref-toggler="" class="al-sidebar-list-link subitem-submenu-link"><span>{{ ::subitem.title }}</span> <b class="fa" ng-class="{\'fa-angle-up\': subitem.expanded, \'fa-angle-down\': !subitem.expanded}" ng-if="::subitem.subMenu"></b></a><ul ng-if="::subitem.subMenu" class="al-sidebar-sublist subitem-submenu-list" ng-class="{expanded: subitem.expanded, \'slide-right\': subitem.slideRight}" ba-ui-sref-toggling-submenu=""><li ng-mouseenter="hoverItem($event, item)" ng-repeat="subSubitem in ::subitem.subMenu" ui-sref-active="selected"><a ng-mouseenter="hoverItem($event, item)" href="" ng-if="::subSubitem.disabled" class="al-sidebar-list-link">{{ ::subSubitem.title }}</a> <a ng-mouseenter="hoverItem($event, item)" ui-state="subSubitem.stateRef || \'\'" ng-if="::!subSubitem.disabled" ng-href="{{::(subSubitem.fixedHref ? subSubitem.fixedHref: \'\')}}">{{::subSubitem.title }}</a></li></ul><a ng-mouseenter="hoverItem($event, item)" href="" ng-if="::(!subitem.subMenu && subitem.disabled)" class="al-sidebar-list-link">{{ ::subitem.title }}</a> <a ng-mouseenter="hoverItem($event, item)" target="{{::(subitem.blank ? \'_blank\' : \'_self\')}}" ng-if="::(!subitem.subMenu && !subitem.disabled)" ui-state="subitem.stateRef || \'\'" ng-href="{{::(subitem.fixedHref ? subitem.fixedHref: \'\')}}">{{ ::subitem.title}}</a></li></ul></li></ul><div class="sidebar-hover-elem" ng-style="{top: hoverElemTop + \'px\', height: hoverElemHeight + \'px\'}" ng-class="{\'show-hover-elem\': showHoverElem }"></div></aside>');
$templateCache.put('app/theme/components/baWizard/baWizard.html','<div class="ba-wizard"><div class="ba-wizard-navigation-container"><div ng-repeat="t in $baWizardController.tabs" class="ba-wizard-navigation {{$baWizardController.tabNum == $index ? \'active\' : \'\'}}" ng-click="$baWizardController.selectTab($index)">{{t.title}}</div></div><div class="progress ba-wizard-progress"><div class="progress-bar progress-bar-danger active" role="progressbar" aria-valuemin="0" aria-valuemax="100" ng-style="{width: $baWizardController.progress + \'%\'}"></div></div><div class="steps" ng-transclude=""></div><nav><ul class="pager ba-wizard-pager"><li class="previous"><button ng-disabled="$baWizardController.isFirstTab()" ng-click="$baWizardController.previousTab()" type="button" class="btn btn-primary"><span aria-hidden="true">&larr;</span> previous</button></li><li class="next"><button ng-disabled="$baWizardController.isLastTab()" ng-click="$baWizardController.nextTab()" type="button" class="btn btn-primary">next <span aria-hidden="true">&rarr;</span></button></li></ul></nav></div>');
$templateCache.put('app/theme/components/baWizard/baWizardStep.html','<section ng-show="selected" class="step" ng-transclude=""></section>');
$templateCache.put('app/theme/components/backTop/backTop.html','<i class="fa fa-angle-up back-top" id="backTop" title="Back to Top"></i>');
$templateCache.put('app/theme/components/contentTop/contentTop.html','<div class="content-top clearfix"><h1 class="al-title truncate-title"><span ng-show="domain==\'\'">Not selected website</span> <span ng-show="domain!=\'\'"><span class="hidden-sm hidden-xs">SELECTED:</span> {{title}}</span></h1><ul class="breadcrumb al-breadcrumb" ng-show="domain!=\'\'"><li><a href="#/" ng-click="showSites()"><b>CHOOSE SITE</b></a> <b></b></li></ul></div>');
$templateCache.put('app/theme/components/msgCenter/msgCenter.html','<ul class="al-msg-center clearfix"><li uib-dropdown=""><a href="" uib-dropdown-toggle=""><i class="fa fa-bell-o"></i><span>5</span><div class="notification-ring"></div></a><div uib-dropdown-menu="" class="top-dropdown-menu"><i class="dropdown-arr"></i><div class="header clearfix"><strong>Notifications</strong> <a href="">Mark All as Read</a> <a href="">Settings</a></div><div class="msg-list"><a href="" class="clearfix" ng-repeat="msg in notifications"><div class="img-area"><img ng-class="{\'photo-msg-item\' : !msg.image}" ng-src="{{::( msg.image || (users[msg.userId].name | profilePicture) )}}"></div><div class="msg-area"><div ng-bind-html="getMessage(msg)"></div><span>{{ msg.time }}</span></div></a></div><a href="">See all notifications</a></div></li><li uib-dropdown=""><a href="" class="msg" uib-dropdown-toggle=""><i class="fa fa-envelope-o"></i><span>5</span><div class="notification-ring"></div></a><div uib-dropdown-menu="" class="top-dropdown-menu"><i class="dropdown-arr"></i><div class="header clearfix"><strong>Messages</strong> <a href="">Mark All as Read</a> <a href="">Settings</a></div><div class="msg-list"><a href="" class="clearfix" ng-repeat="msg in messages"><div class="img-area"><img class="photo-msg-item" ng-src="{{::( users[msg.userId].name | profilePicture )}}"></div><div class="msg-area"><div>{{ msg.text }}</div><span>{{ msg.time }}</span></div></a></div><a href="">See all messages</a></div></li></ul>');
$templateCache.put('app/theme/components/pageTop/pageTop.html','<div class="page-top clearfix" scroll-position="scrolled" max-height="50" ng-class="{\'scrolled\': scrolled}"><a href="#/dashboard" class="al-logo clearfix"><span>{{app_name}}</span></a> <a href="" class="collapse-menu-link ion-navicon" ba-sidebar-toggle-menu=""></a><div class="user-profile clearfix"><div class="al-user-profile" uib-dropdown=""><a uib-dropdown-toggle="" class="profile-toggle-link"><img ng-src="{{::( \'no-photo\' | profilePicture )}}"></a><ul class="top-dropdown-menu profile-dropdown" uib-dropdown-menu=""><li><i class="dropdown-arr"></i></li><li><a href="" ng-click="logout()" class="signout"><i class="fa fa-power-off"></i>Sign out</a></li></ul></div></div></div>');
$templateCache.put('app/theme/components/progressBarRound/progressBarRound.html','<svg class="center-block progress-bar-round" width="200" height="200"><circle cx="100" cy="100" r="90" fill="none" stroke="#F8F8FF" stroke-width="8"></circle><circle cx="100" cy="100" r="90" fill="none" id="loader" class="" stroke="#209e91" stroke-width="8" stroke-dasharray="0,20000" transform="rotate(-90,100,100)" stroke-linecap="round"></circle><text text-anchor="middle" class="loading" x="100" y="90">Loading...</text><text class="percentage" text-anchor="middle" x="100" y="130">{{progress}}%</text></svg>');
$templateCache.put('app/theme/components/widgets/widgets.html','<div class="widgets"><div ng-repeat="widgetBlock in ngModel" ng-class="{\'row\': widgetBlock.widgets.length > 1}"><div ng-repeat="widgetCol in widgetBlock.widgets" ng-class="{\'col-md-6\': widgetBlock.widgets.length === 2}" ng-model="widgetCol" class="widgets-block"><div ba-panel="" ba-panel-title="{{::widget.title}}" ng-repeat="widget in widgetCol" ba-panel-class="with-scroll {{widget.panelClass}}"><div ng-include="widget.url"></div></div></div></div></div>');
$templateCache.put('app/theme/inputs/baSwitcher/baSwitcher.html','<label class="switcher-container"><input type="checkbox" ng-model="switcherValue"><div class="switcher" ng-class="::switcherStyle"><div class="handle-container"><span class="handle handle-on">ON</span> <span class="handle"></span> <span class="handle handle-off">OFF</span></div></div></label>');}]);